export const genesExp={
    O75376: 'NCOR1',
    A0A087X1C5: 'CYP2D7',
    A0A0B4J2F0: 'PIGBOS1',
    A0A0B4J2F2: 'SIK1B',
    A0A0C5B5G6: 'MT-RNR1',
    A0A0K2S4Q6: 'CD300H',
    A0A0U1RRE5: 'NBDY',
    A0A1B0GTW7: 'CIROP',
    A0AV02: 'SLC12A8',
    A0AV96: 'RBM47',
    A0AVF1: 'IFT56',
    A0AVI4: 'TMEM129',
    A0AVK6: 'E2F8',
    A0AVT1: 'UBA6',
    A0FGR8: 'ESYT2',
    A0FGR9: 'ESYT3',
    A0JLT2: 'MED19',
    A0JNW5: 'BLTP3B',
    A0JP26: 'POTEB3',
    A0M8Q6: 'IGLC7',
    A0MZ66: 'SHTN1',
    A0PJK1: 'SLC5A10',
    A0PJY2: 'FEZF1',
    A0PK00: 'TMEM120B',
    A0PK11: 'CLRN2',
    A1A4S6: 'ARHGAP10',
    A1A4Y4: 'IRGM',
    A1A519: 'FAM170A',
    A1A5B4: 'ANO9',
    A1A5C7: 'SLC22A23',
    A1E959: 'ODAM',
    A1KXE4: 'FAM168B',
    A1KZ92: 'PXDNL',
    A1L0T0: 'ILVBL',
    A1L167: 'UBE2QL1',
    A1L190: 'SYCE3',
    A1L390: 'PLEKHG3',
    A1L3X0: 'ELOVL7',
    A1L4H1: 'SSC5D',
    A1L4K1: 'FSD2',
    A1X283: 'SH3PXD2B',
    A1XBS5: 'CIBAR1',
    A1Z1Q3: 'MACROD2',
    A2A288: 'ZC3H12D',
    A2A2Y4: 'FRMD3',
    A2IDD5: 'CCDC78',
    A2PYH4: 'HFM1',
    A2RRP1: 'NBAS',
    A2RTX5: 'TARS3',
    A2RU14: 'TMEM218',
    A2RU30: 'TESPA1',
    A2RU49: 'HYKK',
    A2RUB1: 'MEIOC',
    A2RUB6: 'CCDC66',
    A2RUC4: 'TYW5',
    A2RUH7: 'MYBPHL',
    A2VDJ0: 'TMEM131L',
    A2VEC9: 'SSPOP',
    A3KMH1: 'VWA8',
    A4D0S4: 'LAMB4',
    A4D126: 'CRPPA',
    A4D161: 'FAM221A',
    A4D1B5: 'GSAP',
    A4D1E9: 'GTPBP10',
    A4D1P6: 'WDR91',
    A4D1T9: 'PRSS37',
    A4D256: 'CDC14C',
    A4D2B0: 'MBLAC1',
    A4D2B8: 'PMS2P1',
    A4GXA9: 'EME2',
    A4UGR9: 'XIRP2',
    A5D8T8: 'CLEC18A',
    A5D8V6: 'VPS37C',
    A5D8V7: 'ODAD3',
    A5D8W1: 'CFAP69',
    A5LHX3: 'PSMB11',
    A5PKW4: 'PSD',
    A5PLL7: 'PEDS1',
    A5PLN9: 'TRAPPC13',
    A5X5Y0: 'HTR3E',
    A5YKK6: 'CNOT1',
    A5YM72: 'CARNS1',
    A6BM72: 'MEGF11',
    A6H8Y1: 'BDP1',
    A6H8Z2: 'FAM221B',
    A6NC98: 'CCDC88B',
    A6NCS4: 'NKX2-6',
    A6ND01: 'IZUMO1R',
    A6ND36: 'FAM83G',
    A6NDB9: 'PALM3',
    A6NDE4: 'RBMY1B',
    A6NDG6: 'PGP',
    A6NDV4: 'TMEM8B',
    A6NED2: 'RCCD1',
    A6NEM1: 'GOLGA6L9',
    A6NFA1: 'TRABD2B',
    A6NFQ2: 'TCAF2',
    A6NFX1: 'MFSD2B',
    A6NFY7: 'SDHAF1',
    A6NGG8: 'PCARE',
    A6NGQ2: 'OOEP',
    A6NGU5: 'GGT3P',
    A6NHR9: 'SMCHD1',
    A6NI15: 'MSGN1',
    A6NI61: 'MYMK',
    A6NI73: 'LILRA5',
    A6NIH7: 'UNC119B',
    A6NIX2: 'WTIP',
    A6NJ46: 'NKX6-3',
    A6NJ78: 'METTL15',
    A6NK06: 'ACOD1',
    A6NK58: 'LIPT2',
    A6NK89: 'RASSF10',
    A6NKB5: 'PCNX2',
    A6NL88: 'SHISA7',
    A6NMY6: 'ANXA2P2',
    A6NMZ7: 'COL6A6',
    A6NNB3: 'IFITM5',
    A6NNM8: 'TTLL13',
    A6NNY8: 'USP27X',
    A6NNZ2: 'TUBB8B',
    A6PVC2: 'TTLL8',
    A7E2V4: 'ZSWIM8',
    A7E2Y1: 'MYH7B',
    A7KAX9: 'ARHGAP32',
    A7MCY6: 'TBKBP1',
    A7MD48: 'SRRM4',
    A7XYQ1: 'SOBP',
    A8CG34: 'POM121C',
    A8K0Z3: 'WASHC1',
    A8K2U0: 'A2ML1',
    A8K4G0: 'CD300LB',
    A8K7I4: 'CLCA1',
    A8K8P3: 'SFI1',
    A8K8V0: 'ZNF785',
    A8MPY1: 'GABRR3',
    A8MQ03: 'CYSRT1',
    A8MQ27: 'NEURL1B',
    A8MT69: 'CENPX',
    A8MTA8: 'CIMIP2B',
    A8MTJ3: 'GNAT3',
    A8MTQ0: 'NOTO',
    A8MTZ0: 'BBIP1',
    A8MU46: 'SMTNL1',
    A8MUP2: 'CSKMT',
    A8MV65: 'VGLL3',
    A8MVW5: 'HEPACAM2',
    A8MW95: 'BECN2',
    A8MW99: 'MEI4',
    A8MWX3: 'WASH4P',
    A8MXD5: 'GRXCR1',
    A8MXV4: 'NUDT19',
    A8MYU2: 'KCNU1',
    A8MZ59: 'LEUTX',
    A8TX70: 'COL6A5',
    A9UHW6: 'MIF4GD',
    A9YTQ3: 'AHRR',
    B0I1T2: 'MYO1G',
    B0L3A2: 'FBXW7-AS1',
    B0YJ81: 'HACD1',
    B1AK53: 'ESPN',
    B1AL88: 'NALF1',
    B2RTY4: 'MYO9A',
    B2RUY7: 'VWC2L',
    B2RUZ4: 'SMIM1',
    B2RXF5: 'ZBTB42',
    B2RXH2: 'KDM4E',
    B3KU38: 'IQCJ-SCHIP1',
    B6A8C7: 'TARM1',
    B7U540: 'KCNJ18',
    B7Z8K6: 'TRDC',
    B7ZAQ6: 'GPR89A',
    C4AMC7: 'WASH3P',
    C9JE40: 'PATL2',
    C9JLW8: 'MCRIP1',
    C9JR72: 'KBTBD13',
    C9JRZ8: 'AKR1B15',
    D3W0D1: 'KLRF2',
    D6RGH6: 'MCIDAS',
    E0CX11: 'STMP1',
    G2XKQ0: 'SUMO1P1',
    H0YL14: 'TMEM250',
    K7EJ46: 'SMIM22',
    K9M1U5: 'IFNL4',
    M0R2J8: 'DCDC1',
    O00115: 'DNASE2',
    O00116: 'AGPS',
    O00124: 'UBXN8',
    O00139: 'KIF2A',
    O00141: 'SGK1',
    O00142: 'TK2',
    O00144: 'FZD9',
    O00148: 'DDX39A',
    O00151: 'PDLIM1',
    O00154: 'ACOT7',
    O00155: 'GPR25',
    O00159: 'MYO1C',
    O00160: 'MYO1F',
    O00161: 'SNAP23',
    O00165: 'HAX1',
    O00167: 'EYA2',
    O00168: 'FXYD1',
    O00170: 'AIP',
    O00175: 'CCL24',
    O00180: 'KCNK1',
    O00182: 'LGALS9',
    O00186: 'STXBP3',
    O00187: 'MASP2',
    O00189: 'AP4M1',
    O00192: 'ARVCF',
    O00194: 'RAB27B',
    O00198: 'HRK',
    O00203: 'AP3B1',
    O00204: 'SULT2B1',
    O00206: 'TLR4',
    O00212: 'RHOD',
    O00213: 'APBB1',
    O00214: 'LGALS8',
    O00217: 'NDUFS8',
    O00219: 'HAS3',
    O00220: 'TNFRSF10A',
    O00221: 'NFKBIE',
    O00222: 'GRM8',
    O00230: 'CORT',
    O00231: 'PSMD11',
    O00232: 'PSMD12',
    O00233: 'PSMD9',
    O00237: 'RNF103',
    O00238: 'BMPR1B',
    O00241: 'SIRPB1',
    O00244: 'ATOX1',
    O00253: 'AGRP',
    O00254: 'F2RL2',
    O00255: 'MEN1',
    O00257: 'CBX4',
    O00258: 'GET1',
    O00264: 'PGRMC1',
    O00267: 'SUPT5H',
    O00268: 'TAF4',
    O00270: 'GPR31',
    O00273: 'DFFA',
    O00287: 'RFXAP',
    O00291: 'HIP1',
    O00292: 'LEFTY2',
    O00294: 'TULP1',
    O00299: 'CLIC1',
    O00300: 'TNFRSF11B',
    O00303: 'EIF3F',
    O00305: 'CACNB4',
    O00308: 'WWP2',
    O00311: 'CDC7',
    O00322: 'UPK1A',
    O00327: 'BMAL1',
    O00329: 'PIK3CD',
    O00330: 'PDHX',
    O00337: 'SLC28A1',
    O00338: 'SULT1C2',
    O00339: 'MATN2',
    O00341: 'SLC1A7',
    O00358: 'FOXE1',
    O00391: 'QSOX1',
    O00400: 'SLC33A1',
    O00401: 'WASL',
    O00408: 'PDE2A',
    O00409: 'FOXN3',
    O00410: 'IPO5',
    O00411: 'POLRMT',
    O00418: 'EEF2K',
    O00421: 'CCRL2',
    O00422: 'SAP18',
    O00423: 'EML1',
    O00425: 'IGF2BP3',
    O00429: 'DNM1L',
    O00442: 'RTCA',
    O00443: 'PIK3C2A',
    O00444: 'PLK4',
    O00445: 'SYT5',
    O00451: 'GFRA2',
    O00453: 'LST1',
    O00459: 'PIK3R2',
    O00461: 'GOLIM4',
    O00462: 'MANBA',
    O00463: 'TRAF5',
    O00468: 'AGRN',
    O00469: 'PLOD2',
    O00470: 'MEIS1',
    O00471: 'EXOC5',
    O00472: 'ELL2',
    O00476: 'SLC17A3',
    O00478: 'BTN3A3',
    O00481: 'BTN3A1',
    O00482: 'NR5A2',
    O00483: 'NDUFA4',
    O00487: 'PSMD14',
    O00488: 'ZNF593',
    O00499: 'BIN1',
    O00501: 'CLDN5',
    O00505: 'KPNA3',
    O00506: 'STK25',
    O00507: 'USP9Y',
    O00512: 'BCL9',
    O00519: 'FAAH',
    O00522: 'KRIT1',
    O00526: 'UPK2',
    O00533: 'CHL1',
    O00541: 'PES1',
    O00548: 'DLL1',
    O00555: 'CACNA1A',
    O00559: 'EBAG9',
    O00560: 'SDCBP',
    O00562: 'PITPNM1',
    O00566: 'MPHOSPH10',
    O00567: 'NOP56',
    O00571: 'DDX3X',
    O00574: 'CXCR6',
    O00584: 'RNASET2',
    O00585: 'CCL21',
    O00587: 'MFNG',
    O00590: 'ACKR2',
    O00591: 'GABRP',
    O00592: 'PODXL',
    O00602: 'FCN1',
    O00622: 'CCN1',
    O00623: 'PEX12',
    O00625: 'PIR',
    O00626: 'CCL22',
    O00628: 'PEX7',
    O00629: 'KPNA4',
    O00631: 'SLN',
    O00635: 'TRIM38',
    O00712: 'NFIB',
    O00716: 'E2F3',
    O00743: 'PPP6C',
    O00744: 'WNT10B',
    O00746: 'NME4',
    O00748: 'CES2',
    O00750: 'PIK3C2B',
    O00754: 'MAN2B1',
    O00755: 'WNT7A',
    O00757: 'FBP2',
    O00762: 'UBE2C',
    O00763: 'ACACB',
    O00764: 'PDXK',
    O00767: 'SCD',
    O14490: 'DLGAP1',
    O14492: 'SH2B2',
    O14493: 'CLDN4',
    O14494: 'PLPP1',
    O14495: 'PLPP3',
    O14497: 'ARID1A',
    O14503: 'BHLHE40',
    O14508: 'SOCS2',
    O14511: 'NRG2',
    O14512: 'SOCS7',
    O14514: 'ADGRB1',
    O14519: 'CDK2AP1',
    O14520: 'AQP7',
    O14521: 'SDHD',
    O14522: 'PTPRT',
    O14523: 'C2CD2L',
    O14524: 'NEMP1',
    O14525: 'ASTN1',
    O14526: 'FCHO1',
    O14529: 'CUX2',
    O14530: 'TXNDC9',
    O14531: 'DPYSL4',
    O14543: 'SOCS3',
    O14544: 'SOCS6',
    O14556: 'GAPDHS',
    O14558: 'HSPB6',
    O14559: 'ARHGAP33',
    O14561: 'NDUFAB1',
    O14569: 'CYB561D2',
    O14576: 'DYNC1I1',
    O14578: 'CIT',
    O14579: 'COPE',
    O14593: 'RFXANK',
    O14594: 'NCAN',
    O14595: 'CTDSP2',
    O14607: 'UTY',
    O14610: 'GNGT2',
    O14613: 'CDC42EP2',
    O14617: 'AP3D1',
    O14618: 'CCS',
    O14625: 'CXCL11',
    O14627: 'CDX4',
    O14628: 'ZNF195',
    O14633: 'LCE2B',
    O14638: 'ENPP3',
    O14639: 'ABLIM1',
    O14640: 'DVL1',
    O14641: 'DVL2',
    O14645: 'DNALI1',
    O14646: 'CHD1',
    O14647: 'CHD2',
    O14649: 'KCNK3',
    O14653: 'GOSR2',
    O14654: 'IRS4',
    O14656: 'TOR1A',
    O14657: 'TOR1B',
    O14662: 'STX16',
    O14669: 'PRRG2',
    O14672: 'ADAM10',
    O14678: 'ABCD4',
    O14681: 'EI24',
    O14682: 'ENC1',
    O14684: 'PTGES',
    O14686: 'KMT2D',
    O14713: 'ITGB1BP1',
    O14717: 'TRDMT1',
    O14727: 'APAF1',
    O14730: 'RIOK3',
    O14732: 'IMPA2',
    O14733: 'MAP2K7',
    O14734: 'ACOT8',
    O14735: 'CDIPT',
    O14737: 'PDCD5',
    O14744: 'PRMT5',
    O14745: 'NHERF1',
    O14746: 'TERT',
    O14756: 'HSD17B6',
    O14757: 'CHEK1',
    O14763: 'TNFRSF10B',
    O14764: 'GABRD',
    O14770: 'MEIS2',
    O14771: 'ZNF213',
    O14772: 'FPGT',
    O14773: 'TPP1',
    O14775: 'GNB5',
    O14776: 'TCERG1',
    O14777: 'NDC80',
    O14782: 'KIF3C',
    O14786: 'NRP1',
    O14787: 'TNPO2',
    O14788: 'TNFSF11',
    O14791: 'APOL1',
    O14792: 'HS3ST1',
    O14793: 'MSTN',
    O14795: 'UNC13B',
    O14796: 'SH2D1B',
    O14798: 'TNFRSF10C',
    O14802: 'POLR3A',
    O14807: 'MRAS',
    O14810: 'CPLX1',
    O14813: 'PHOX2A',
    O14815: 'CAPN9',
    O14817: 'TSPAN4',
    O14818: 'PSMA7',
    O14827: 'RASGRF2',
    O14828: 'SCAMP3',
    O14829: 'PPEF1',
    O14830: 'PPEF2',
    O14832: 'PHYH',
    O14836: 'TNFRSF13B',
    O14841: 'OPLAH',
    O14842: 'FFAR1',
    O14843: 'FFAR3',
    O14862: 'AIM2',
    O14863: 'SLC30A4',
    O14867: 'BACH1',
    O14874: 'BCKDK',
    O14879: 'IFIT3',
    O14880: 'MGST3',
    O14893: 'GEMIN2',
    O14894: 'TM4SF5',
    O14896: 'IRF6',
    O14901: 'KLF11',
    O14904: 'WNT9A',
    O14905: 'WNT9B',
    O14907: 'TAX1BP3',
    O14908: 'GIPC1',
    O14910: 'LIN7A',
    O14917: 'PCDH17',
    O14920: 'IKBKB',
    O14924: 'RGS12',
    O14925: 'TIMM23',
    O14926: 'FSCN2',
    O14929: 'HAT1',
    O14931: 'NCR3',
    O14933: 'UBE2L6',
    O14936: 'CASK',
    O14939: 'PLD2',
    O14944: 'EREG',
    O14948: 'TFEC',
    O14949: 'UQCRQ',
    O14950: 'MYL12B',
    O14957: 'UQCR11',
    O14958: 'CASQ2',
    O14960: 'LECT2',
    O14964: 'HGS',
    O14965: 'AURKA',
    O14966: 'RAB29',
    O14967: 'CLGN',
    O14972: 'VPS26C',
    O14974: 'PPP1R12A',
    O14975: 'SLC27A2',
    O14976: 'GAK',
    O14977: 'AZIN1',
    O14978: 'ZNF263',
    O14979: 'HNRNPDL',
    O14980: 'XPO1',
    O14981: 'BTAF1',
    O14983: 'ATP2A1',
    O14986: 'PIP5K1B',
    O14994: 'SYN3',
    O15013: 'ARHGEF10',
    O15014: 'ZNF609',
    O15015: 'ZNF646',
    O15018: 'PDZD2',
    O15020: 'SPTBN2',
    O15021: 'MAST4',
    O15027: 'SEC16A',
    O15031: 'PLXNB2',
    O15033: 'AREL1',
    O15040: 'TECPR2',
    O15041: 'SEMA3E',
    O15042: 'U2SURP',
    O15047: 'SETD1A',
    O15049: 'N4BP3',
    O15054: 'KDM6B',
    O15055: 'PER2',
    O15056: 'SYNJ2',
    O15060: 'ZBTB39',
    O15061: 'SYNM',
    O15062: 'ZBTB5',
    O15066: 'KIF3B',
    O15067: 'PFAS',
    O15068: 'MCF2L',
    O15072: 'ADAMTS3',
    O15075: 'DCLK1',
    O15078: 'CEP290',
    O15079: 'SNPH',
    O15083: 'ERC2',
    O15084: 'ANKRD28',
    O15085: 'ARHGEF11',
    O15091: 'PRORP',
    O15105: 'SMAD7',
    O15111: 'CHUK',
    O15116: 'LSM1',
    O15117: 'FYB1',
    O15118: 'NPC1',
    O15119: 'TBX3',
    O15120: 'AGPAT2',
    O15121: 'DEGS1',
    O15123: 'ANGPT2',
    O15126: 'SCAMP1',
    O15127: 'SCAMP2',
    O15130: 'NPFF',
    O15131: 'KPNA5',
    O15143: 'ARPC1B',
    O15144: 'ARPC2',
    O15145: 'ARPC3',
    O15146: 'MUSK',
    O15151: 'MDM4',
    O15155: 'BET1',
    O15156: 'ZBTB7B',
    O15160: 'POLR1C',
    O15162: 'PLSCR1',
    O15164: 'TRIM24',
    O15165: 'LDLRAD4',
    O15169: 'AXIN1',
    O15173: 'PGRMC2',
    O15178: 'TBXT',
    O15182: 'CETN3',
    O15194: 'CTDSPL',
    O15195: 'VILL',
    O15197: 'EPHB6',
    O15198: 'SMAD9',
    O15204: 'ADAMDEC1',
    O15205: 'UBD',
    O15209: 'ZBTB22',
    O15211: 'RGL2',
    O15212: 'PFDN6',
    O15217: 'GSTA4',
    O15226: 'NKRF',
    O15228: 'GNPAT',
    O15229: 'KMO',
    O15230: 'LAMA5',
    O15231: 'ZNF185',
    O15232: 'MATN3',
    O15234: 'CASC3',
    O15239: 'NDUFA1',
    O15240: 'VGF',
    O15243: 'LEPROT',
    O15244: 'SLC22A2',
    O15245: 'SLC22A1',
    O15247: 'CLIC2',
    O15254: 'ACOX3',
    O15258: 'RER1',
    O15259: 'NPHP1',
    O15260: 'SURF4',
    O15263: 'DEFB4A',
    O15263: 'DEFB4B',
    O15264: 'MAPK13',
    O15265: 'ATXN7',
    O15266: 'SHOX',
    O15269: 'SPTLC1',
    O15270: 'SPTLC2',
    O15273: 'TCAP',
    O15287: 'FANCG',
    O15294: 'OGT',
    O15296: 'ALOX15B',
    O15297: 'PPM1D',
    O15303: 'GRM6',
    O15304: 'SIVA1',
    O15305: 'PMM2',
    O15315: 'RAD51B',
    O15318: 'POLR3G',
    O15327: 'INPP4B',
    O15342: 'ATP6V0E1',
    O15344: 'MID1',
    O15347: 'HMGB3',
    O15350: 'TP73',
    O15353: 'FOXN1',
    O15354: 'GPR37',
    O15355: 'PPM1G',
    O15357: 'INPPL1',
    O15360: 'FANCA',
    O15370: 'SOX12',
    O15371: 'EIF3D',
    O15372: 'EIF3H',
    O15374: 'SLC16A4',
    O15379: 'HDAC3',
    O15381: 'NVL',
    O15382: 'BCAT2',
    O15389: 'SIGLEC5',
    O15391: 'YY2',
    O15392: 'BIRC5',
    O15393: 'TMPRSS2',
    O15394: 'NCAM2',
    O15397: 'IPO8',
    O15399: 'GRIN2D',
    O15400: 'STX7',
    O15405: 'TOX3',
    O15409: 'FOXP2',
    O15427: 'SLC16A3',
    O15431: 'SLC31A1',
    O15438: 'ABCC3',
    O15439: 'ABCC4',
    O15440: 'ABCC5',
    O15444: 'CCL25',
    O15446: 'POLR1G',
    O15455: 'TLR3',
    O15457: 'MSH4',
    O15460: 'P4HA2',
    O15466: 'ST8SIA5',
    O15467: 'CCL16',
    O15479: 'MAGEB2',
    O15481: 'MAGEB4',
    O15484: 'CAPN5',
    O15488: 'GYG2',
    O15492: 'RGS16',
    O15496: 'PLA2G10',
    O15498: 'YKT6',
    O15499: 'GSC2',
    O15503: 'INSIG1',
    O15504: 'NUP42',
    O15511: 'ARPC5',
    O15514: 'POLR2D',
    O15516: 'CLOCK',
    O15519: 'CFLAR',
    O15520: 'FGF10',
    O15522: 'NKX2-8',
    O15523: 'DDX3Y',
    O15524: 'SOCS1',
    O15525: 'MAFG',
    O15527: 'OGG1',
    O15528: 'CYP27B1',
    O15529: 'GPR42',
    O15530: 'PDPK1',
    O15533: 'TAPBP',
    O15534: 'PER1',
    O15535: 'ZSCAN9',
    O15537: 'RS1',
    O15540: 'FABP7',
    O15541: 'RNF113A',
    O15547: 'P2RX6',
    O15550: 'KDM6A',
    O15551: 'CLDN3',
    O15552: 'FFAR2',
    O15553: 'MEFV',
    O15554: 'KCNN4',
    O42043: 'ERVK-18',
    O43143: 'DHX15',
    O43147: 'SGSM2',
    O43148: 'RNMT',
    O43149: 'ZZEF1',
    O43150: 'ASAP2',
    O43151: 'TET3',
    O43155: 'FLRT2',
    O43156: 'TTI1',
    O43157: 'PLXNB1',
    O43159: 'RRP8',
    O43164: 'PJA2',
    O43166: 'SIPA1L1',
    O43167: 'ZBTB24',
    O43169: 'CYB5B',
    O43172: 'PRPF4',
    O43173: 'ST8SIA3',
    O43174: 'CYP26A1',
    O43175: 'PHGDH',
    O43181: 'NDUFS4',
    O43182: 'ARHGAP6',
    O43184: 'ADAM12',
    O43186: 'CRX',
    O43187: 'IRAK2',
    O43189: 'PHF1',
    O43193: 'MLNR',
    O43194: 'GPR39',
    O43196: 'MSH5',
    O43236: 'SEPTIN4',
    O43237: 'DYNC1LI2',
    O43240: 'KLK10',
    O43242: 'PSMD3',
    O43248: 'HOXC11',
    O43251: 'RBFOX2',
    O43252: 'PAPSS1',
    O43255: 'SIAH2',
    O43257: 'ZNHIT1',
    O43264: 'ZW10',
    O43272: 'PRODH',
    O43278: 'SPINT1',
    O43280: 'TREH',
    O43281: 'EFS',
    O43283: 'MAP3K13',
    O43286: 'B4GALT5',
    O43290: 'SART1',
    O43291: 'SPINT2',
    O43292: 'GPAA1',
    O43293: 'DAPK3',
    O43294: 'TGFB1I1',
    O43295: 'SRGAP3',
    O43296: 'ZNF264',
    O43298: 'ZBTB43',
    O43299: 'AP5Z1',
    O43300: 'LRRTM2',
    O43303: 'CCP110',
    O43306: 'ADCY6',
    O43307: 'ARHGEF9',
    O43309: 'ZSCAN12',
    O43310: 'CTIF',
    O43312: 'MTSS1',
    O43313: 'ATMIN',
    O43314: 'PPIP5K2',
    O43315: 'AQP9',
    O43316: 'PAX4',
    O43318: 'MAP3K7',
    O43320: 'FGF16',
    O43323: 'DHH',
    O43324: 'EEF1E1',
    O43353: 'RIPK2',
    O43364: 'HOXA2',
    O43365: 'HOXA3',
    O43374: 'RASA4',
    O43379: 'WDR62',
    O43390: 'HNRNPR',
    O43395: 'PRPF3',
    O43396: 'TXNL1',
    O43399: 'TPD52L2',
    O43402: 'EMC8',
    O43405: 'COCH',
    O43422: 'THAP12',
    O43424: 'GRID2',
    O43426: 'SYNJ1',
    O43427: 'FIBP',
    O43432: 'EIF4G3',
    O43435: 'TBX1',
    O43439: 'CBFA2T2',
    O43447: 'PPIH',
    O43451: 'MGAM',
    O43462: 'MBTPS2',
    O43463: 'SUV39H1',
    O43464: 'HTRA2',
    O43474: 'KLF4',
    O43482: 'OIP5',
    O43488: 'AKR7A2',
    O43490: 'PROM1',
    O43491: 'EPB41L2',
    O43493: 'TGOLN2',
    O43497: 'CACNA1G',
    O43502: 'RAD51C',
    O43504: 'LAMTOR5',
    O43505: 'B4GAT1',
    O43506: 'ADAM20',
    O43508: 'TNFSF12',
    O43511: 'SLC26A4',
    O43513: 'MED7',
    O43516: 'WIPF1',
    O43520: 'ATP8B1',
    O43521: 'BCL2L11',
    O43524: 'FOXO3',
    O43525: 'KCNQ3',
    O43526: 'KCNQ2',
    O43529: 'CHST10',
    O43541: 'SMAD6',
    O43542: 'XRCC3',
    O43543: 'XRCC2',
    O43548: 'TGM5',
    O43556: 'SGCE',
    O43557: 'TNFSF14',
    O43559: 'FRS3',
    O43561: 'LAT',
    O43566: 'RGS14',
    O43567: 'RNF13',
    O43570: 'CA12',
    O43572: 'AKAP10',
    O43581: 'SYT7',
    O43583: 'DENR',
    O43586: 'PSTPIP1',
    O43592: 'XPOT',
    O43593: 'HR',
    O43597: 'SPRY2',
    O43598: 'DNPH1',
    O43602: 'DCX',
    O43603: 'GALR2',
    O43609: 'SPRY1',
    O43610: 'SPRY3',
    O43612: 'HCRT',
    O43613: 'HCRTR1',
    O43614: 'HCRTR2',
    O43615: 'TIMM44',
    O43617: 'TRAPPC3',
    O43623: 'SNAI2',
    O43633: 'CHMP2A',
    O43639: 'NCK2',
    O43653: 'PSCA',
    O43660: 'PLRG1',
    O43663: 'PRC1',
    O43665: 'RGS10',
    O43670: 'ZNF207',
    O43674: 'NDUFB5',
    O43676: 'NDUFB3',
    O43678: 'NDUFA2',
    O43679: 'LDB2',
    O43680: 'TCF21',
    O43681: 'GET3',
    O43683: 'BUB1',
    O43684: 'BUB3',
    O43687: 'AKAP7',
    O43688: 'PLPP2',
    O43699: 'SIGLEC6',
    O43704: 'SULT1B1',
    O43707: 'ACTN4',
    O43708: 'GSTZ1',
    O43709: 'BUD23',
    O43711: 'TLX3',
    O43715: 'TRIAP1',
    O43716: 'GATC',
    O43719: 'HTATSF1',
    O43731: 'KDELR3',
    O43734: 'TRAF3IP2',
    O43739: 'CYTH3',
    O43741: 'PRKAB2',
    O43745: 'CHP2',
    O43747: 'AP1G1',
    O43749: 'OR1F1',
    O43752: 'STX6',
    O43759: 'SYNGR1',
    O43760: 'SYNGR2',
    O43761: 'SYNGR3',
    O43763: 'TLX2',
    O43765: 'SGTA',
    O43766: 'LIAS',
    O43768: 'ENSA',
    O43772: 'SLC25A20',
    O43776: 'NARS1',
    O43781: 'DYRK3',
    O43790: 'KRT86',
    O43791: 'SPOP',
    O43795: 'MYO1B',
    O43805: 'SSNA1',
    O43808: 'SLC25A17',
    O43809: 'NUDT21',
    O43813: 'LANCL1',
    O43815: 'STRN',
    O43818: 'RRP9',
    O43819: 'SCO2',
    O43820: 'HYAL3',
    O43822: 'CFAP410',
    O43823: 'AKAP8',
    O43825: 'B3GALT2',
    O43826: 'SLC37A4',
    O43827: 'ANGPTL7',
    O43829: 'ZBTB14',
    O43837: 'IDH3B',
    O43847: 'NRDC',
    O43852: 'CALU',
    O43854: 'EDIL3',
    O43861: 'ATP9B',
    O43865: 'AHCYL1',
    O43866: 'CD5L',
    O43868: 'SLC28A2',
    O43889: 'CREB3',
    O43895: 'XPNPEP2',
    O43896: 'KIF1C',
    O43897: 'TLL1',
    O43900: 'PRICKLE3',
    O43903: 'GAS2',
    O43909: 'EXTL3',
    O43913: 'ORC5',
    O43914: 'TYROBP',
    O43915: 'VEGFD',
    O43916: 'CHST1',
    O43918: 'AIRE',
    O43920: 'NDUFS5',
    O43921: 'EFNA2',
    O43924: 'PDE6D',
    O43927: 'CXCL13',
    O43929: 'ORC4',
    O43933: 'PEX1',
    O60216: 'RAD21',
    O60218: 'AKR1B10',
    O60220: 'TIMM8A',
    O60229: 'KALRN',
    O60231: 'DHX16',
    O60232: 'ZNRD2',
    O60235: 'TMPRSS11D',
    O60237: 'PPP1R12B',
    O60238: 'BNIP3L',
    O60239: 'SH3BP5',
    O60240: 'PLIN1',
    O60241: 'ADGRB2',
    O60242: 'ADGRB3',
    O60243: 'HS6ST1',
    O60244: 'MED14',
    O60248: 'SOX15',
    O60256: 'PRPSAP2',
    O60258: 'FGF17',
    O60259: 'KLK8',
    O60260: 'PRKN',
    O60264: 'SMARCA5',
    O60266: 'ADCY3',
    O60269: 'GPRIN2',
    O60271: 'SPAG9',
    O60281: 'ZNF292',
    O60282: 'KIF5C',
    O60284: 'ST18',
    O60285: 'NUAK1',
    O60291: 'MGRN1',
    O60292: 'SIPA1L3',
    O60293: 'ZFC3H1',
    O60294: 'LCMT2',
    O60296: 'TRAK2',
    O60303: 'KATNIP',
    O60304: 'ZNF500',
    O60306: 'AQR',
    O60307: 'MAST3',
    O60308: 'CEP104',
    O60312: 'ATP10A',
    O60313: 'OPA1',
    O60315: 'ZEB2',
    O60318: 'MCM3AP',
    O60331: 'PIP5K1C',
    O60333: 'KIF1B',
    O60336: 'MAPKBP1',
    O60337: 'MARCHF6',
    O60341: 'KDM1A',
    O60343: 'TBC1D4',
    O60346: 'PHLPP1',
    O60353: 'FZD6',
    O60356: 'NUPR1',
    O60359: 'CACNG3',
    O60381: 'HBP1',
    O60383: 'GDF9',
    O60391: 'GRIN3B',
    O60393: 'NOBOX',
    O60423: 'ATP8B3',
    O60427: 'FADS1',
    O60437: 'PPL',
    O60443: 'GSDME',
    O60447: 'EVI5',
    O60449: 'LY75',
    O60462: 'NRP2',
    O60469: 'DSCAM',
    O60476: 'MAN1A2',
    O60477: 'BRINP1',
    O60478: 'GPR137B',
    O60479: 'DLX3',
    O60481: 'ZIC3',
    O60486: 'PLXNC1',
    O60487: 'MPZL2',
    O60488: 'ACSL4',
    O60493: 'SNX3',
    O60494: 'CUBN',
    O60496: 'DOK2',
    O60499: 'STX10',
    O60500: 'NPHS1',
    O60502: 'OGA',
    O60503: 'ADCY9',
    O60504: 'SORBS3',
    O60506: 'SYNCRIP',
    O60507: 'TPST1',
    O60508: 'CDC40',
    O60512: 'B4GALT3',
    O60513: 'B4GALT4',
    O60519: 'CREBL2',
    O60524: 'NEMF',
    O60543: 'CIDEA',
    O60547: 'GMDS',
    O60548: 'FOXD2',
    O60551: 'NMT2',
    O60563: 'CCNT1',
    O60565: 'GREM1',
    O60566: 'BUB1B',
    O60568: 'PLOD3',
    O60573: 'EIF4E2',
    O60583: 'CCNT2',
    O60602: 'TLR5',
    O60603: 'TLR2',
    O60609: 'GFRA3',
    O60610: 'DIAPH1',
    O60613: 'SELENOF',
    O60635: 'TSPAN1',
    O60636: 'TSPAN2',
    O60641: 'SNAP91',
    O60645: 'EXOC3',
    O60656: 'UGT1A9',
    O60658: 'PDE8A',
    O60662: 'KLHL41',
    O60663: 'LMX1B',
    O60664: 'PLIN3',
    O60667: 'FCMR',
    O60669: 'SLC16A7',
    O60671: 'RAD1',
    O60673: 'REV3L',
    O60674: 'JAK2',
    O60675: 'MAFK',
    O60678: 'PRMT3',
    O60682: 'MSC',
    O60683: 'PEX10',
    O60684: 'KPNA6',
    O60687: 'SRPX2',
    O60701: 'UGDH',
    O60704: 'TPST2',
    O60706: 'ABCC9',
    O60711: 'LPXN',
    O60716: 'CTNND1',
    O60721: 'SLC24A1',
    O60725: 'ICMT',
    O60729: 'CDC14B',
    O60733: 'PLA2G6',
    O60741: 'HCN1',
    O60749: 'SNX2',
    O60755: 'GALR3',
    O60759: 'CYTIP',
    O60760: 'HPGDS',
    O60762: 'DPM1',
    O60763: 'USO1',
    O60779: 'SLC19A2',
    O60783: 'MRPS14',
    O60784: 'TOM1',
    O60806: 'TBX19',
    O60812: 'HNRNPCL1',
    O60814: 'H2BC12',
    O60825: 'PFKFB2',
    O60826: 'CCDC22',
    O60828: 'PQBP1',
    O60829: 'PAGE4',
    O60830: 'TIMM17B',
    O60831: 'PRAF2',
    O60832: 'DKC1',
    O60840: 'CACNA1F',
    O60841: 'EIF5B',
    O60844: 'ZG16',
    O60858: 'TRIM13',
    O60861: 'GAS7',
    O60869: 'EDF1',
    O60870: 'KIN',
    O60879: 'DIAPH2',
    O60880: 'SH2D1A',
    O60882: 'MMP20',
    O60883: 'GPR37L1',
    O60884: 'DNAJA2',
    O60885: 'BRD4',
    O60888: 'CUTA',
    O60890: 'OPHN1',
    O60894: 'RAMP1',
    O60895: 'RAMP2',
    O60896: 'RAMP3',
    O60902: 'SHOX2',
    O60906: 'SMPD2',
    O60907: 'TBL1X',
    O60909: 'B4GALT2',
    O60911: 'CTSV',
    O60921: 'HUS1',
    O60925: 'PFDN1',
    O60927: 'PPP1R11',
    O60928: 'KCNJ13',
    O60930: 'RNASEH1',
    O60931: 'CTNS',
    O60934: 'NBN',
    O60936: 'NOL3',
    O60938: 'KERA',
    O60939: 'SCN2B',
    O60941: 'DTNB',
    O60942: 'RNGTT',
    O75015: 'FCGR3B',
    O75019: 'LILRA1',
    O75022: 'LILRB3',
    O75023: 'LILRB5',
    O75027: 'ABCB7',
    O75030: 'MITF',
    O75031: 'HSF2BP',
    O75037: 'KIF21B',
    O75038: 'PLCH2',
    O75044: 'SRGAP2',
    O75051: 'PLXNA2',
    O75052: 'NOS1AP',
    O75054: 'IGSF3',
    O75056: 'SDC3',
    O75061: 'DNAJC6',
    O75063: 'FAM20B',
    O75069: 'TMCC2',
    O75072: 'FKTN',
    O75074: 'LRP3',
    O75077: 'ADAM23',
    O75078: 'ADAM11',
    O75081: 'CBFA2T3',
    O75083: 'WDR1',
    O75084: 'FZD7',
    O75093: 'SLIT1',
    O75094: 'SLIT3',
    O75096: 'LRP4',
    O75106: 'AOC2',
    O75110: 'ATP9A',
    O75112: 'LDB3',
    O75113: 'N4BP1',
    O75116: 'ROCK2',
    O75121: 'MFAP3L',
    O75122: 'CLASP2',
    O75127: 'PTCD1',
    O75128: 'COBL',
    O75129: 'ASTN2',
    O75131: 'CPNE3',
    O75132: 'ZBED4',
    O75140: 'DEPDC5',
    O75143: 'ATG13',
    O75144: 'ICOSLG',
    O75145: 'PPFIA3',
    O75146: 'HIP1R',
    O75147: 'OBSL1',
    O75150: 'RNF40',
    O75151: 'PHF2',
    O75152: 'ZC3H11A',
    O75154: 'RAB11FIP3',
    O75155: 'CAND2',
    O75159: 'SOCS5',
    O75161: 'NPHP4',
    O75164: 'KDM4A',
    O75165: 'DNAJC13',
    O75167: 'PHACTR2',
    O75170: 'PPP6R2',
    O75173: 'ADAMTS4',
    O75175: 'CNOT3',
    O75177: 'SS18L1',
    O75179: 'ANKRD17',
    O75182: 'SIN3B',
    O75185: 'ATP2C2',
    O75190: 'DNAJB6',
    O75191: 'XYLB',
    O75192: 'PEX11A',
    O75197: 'LRP5',
    O75204: 'TMEM127',
    O75208: 'COQ9',
    O75223: 'GGCT',
    O75251: 'NDUFS7',
    O75293: 'GADD45B',
    O75298: 'RTN2',
    O75306: 'NDUFS2',
    O75309: 'CDH16',
    O75310: 'UGT2B11',
    O75311: 'GLRA3',
    O75312: 'ZPR1',
    O75317: 'USP12',
    O75319: 'DUSP11',
    O75323: 'NIPSNAP2',
    O75324: 'SNN',
    O75326: 'SEMA7A',
    O75330: 'HMMR',
    O75334: 'PPFIA2',
    O75339: 'CILP',
    O75340: 'PDCD6',
    O75342: 'ALOX12B',
    O75343: 'GUCY1B2',
    O75344: 'FKBP6',
    O75347: 'TBCA',
    O75348: 'ATP6V1G1',
    O75351: 'VPS4B',
    O75354: 'ENTPD6',
    O75355: 'ENTPD3',
    O75356: 'ENTPD5',
    O75360: 'PROP1',
    O75362: 'ZNF217',
    O75364: 'PITX3',
    O75365: 'PTP4A3',
    O75366: 'AVIL',
    O75367: 'MACROH2A1',
    O75369: 'FLNB',
    O75376: 'NCOR1',
    O75379: 'VAMP4',
    O75380: 'NDUFS6',
    O75381: 'PEX14',
    O75382: 'TRIM3',
    O75385: 'ULK1',
    O75386: 'TULP3',
    O75387: 'SLC43A1',
    O75390: 'CS',
    O75396: 'SEC22B',
    O75398: 'DEAF1',
    O75400: 'PRPF40A',
    O75409: 'H2AP',
    O75410: 'TACC1',
    O75414: 'NME6',
    O75417: 'POLQ',
    O75419: 'CDC45',
    O75420: 'GIGYF1',
    O75425: 'MOSPD3',
    O75427: 'LRCH4',
    O75431: 'MTX2',
    O75436: 'VPS26A',
    O75438: 'NDUFB1',
    O75439: 'PMPCB',
    O75443: 'TECTA',
    O75444: 'MAF',
    O75445: 'USH2A',
    O75446: 'SAP30',
    O75448: 'MED24',
    O75449: 'KATNA1',
    O75452: 'RDH16',
    O75460: 'ERN1',
    O75461: 'E2F6',
    O75462: 'CRLF1',
    O75469: 'NR1I2',
    O75473: 'LGR5',
    O75475: 'PSIP1',
    O75477: 'ERLIN1',
    O75478: 'TADA2A',
    O75486: 'SUPT3H',
    O75487: 'GPC4',
    O75489: 'NDUFS3',
    O75494: 'SRSF10',
    O75496: 'GMNN',
    O75503: 'CLN5',
    O75506: 'HSBP1',
    O75508: 'CLDN11',
    O75509: 'TNFRSF21',
    O75521: 'ECI2',
    O75525: 'KHDRBS3',
    O75528: 'TADA3',
    O75529: 'TAF5L',
    O75530: 'EED',
    O75531: 'BANF1',
    O75533: 'SF3B1',
    O75534: 'CSDE1',
    O75553: 'DAB1',
    O75554: 'WBP4',
    O75556: 'SCGB2A1',
    O75558: 'STX11',
    O75563: 'SKAP2',
    O75564: 'JRK',
    O75569: 'PRKRA',
    O75575: 'CRCP',
    O75578: 'ITGA10',
    O75581: 'LRP6',
    O75582: 'RPS6KA5',
    O75586: 'MED6',
    O75592: 'MYCBP2',
    O75593: 'FOXH1',
    O75594: 'PGLYRP1',
    O75600: 'GCAT',
    O75602: 'SPAG6',
    O75603: 'GCM2',
    O75604: 'USP2',
    O75607: 'NPM3',
    O75608: 'LYPLA1',
    O75610: 'LEFTY1',
    O75616: 'ERAL1',
    O75618: 'DEDD',
    O75626: 'PRDM1',
    O75629: 'CREG1',
    O75631: 'UPK3A',
    O75636: 'FCN3',
    O75638: 'CTAG2',
    O75643: 'SNRNP200',
    O75648: 'TRMU',
    O75663: 'TIPRL',
    O75665: 'OFD1',
    O75674: 'TOM1L1',
    O75676: 'RPS6KA4',
    O75677: 'RFPL1',
    O75679: 'RFPL3',
    O75688: 'PPM1B',
    O75689: 'ADAP1',
    O75691: 'UTP20',
    O75694: 'NUP155',
    O75695: 'RP2',
    O75712: 'GJB3',
    O75716: 'STK16',
    O75717: 'WDHD1',
    O75718: 'CRTAP',
    O75746: 'SLC25A12',
    O75747: 'PIK3C2G',
    O75751: 'SLC22A3',
    O75752: 'B3GALNT1',
    O75762: 'TRPA1',
    O75771: 'RAD51D',
    O75781: 'PALM',
    O75783: 'RHBDL1',
    O75787: 'ATP6AP2',
    O75791: 'GRAP2',
    O75792: 'RNASEH2A',
    O75795: 'UGT2B17',
    O75800: 'ZMYND10',
    O75807: 'PPP1R15A',
    O75808: 'CAPN15',
    O75815: 'BCAR3',
    O75817: 'POP7',
    O75818: 'RPP40',
    O75821: 'EIF3G',
    O75822: 'EIF3J',
    O75828: 'CBR3',
    O75829: 'CNMD',
    O75832: 'PSMD10',
    O75838: 'CIB2',
    O75840: 'KLF7',
    O75841: 'UPK1B',
    O75843: 'AP1G2',
    O75844: 'ZMPSTE24',
    O75845: 'SC5D',
    O75864: 'PPP1R37',
    O75865: 'TRAPPC6A',
    O75871: 'CEACAM4',
    O75874: 'IDH1',
    O75879: 'GATB',
    O75880: 'SCO1',
    O75881: 'CYP7B1',
    O75882: 'ATRN',
    O75884: 'RBBP9',
    O75886: 'STAM2',
    O75888: 'TNFSF13',
    O75891: 'ALDH1L1',
    O75896: 'TUSC2',
    O75897: 'SULT1C4',
    O75899: 'GABBR2',
    O75900: 'MMP23B',
    O75907: 'DGAT1',
    O75908: 'SOAT2',
    O75909: 'CCNK',
    O75911: 'DHRS3',
    O75912: 'DGKI',
    O75914: 'PAK3',
    O75915: 'ARL6IP5',
    O75916: 'RGS9',
    O75920: 'SERF1A',
    O75920: 'SERF1B',
    O75923: 'DYSF',
    O75925: 'PIAS1',
    O75928: 'PIAS2',
    O75934: 'BCAS2',
    O75935: 'DCTN3',
    O75936: 'BBOX1',
    O75937: 'DNAJC8',
    O75940: 'SMNDC1',
    O75943: 'RAD17',
    O75951: 'LYZL6',
    O75952: 'CABYR',
    O75955: 'FLOT1',
    O75962: 'TRIO',
    O75969: 'AKAP3',
    O75970: 'MPDZ',
    O75971: 'SNAPC5',
    O75976: 'CPD',
    O76003: 'GLRX3',
    O76011: 'KRT34',
    O76013: 'KRT36',
    O76014: 'KRT37',
    O76015: 'KRT38',
    O76021: 'RSL1D1',
    O76024: 'WFS1',
    O76027: 'ANXA9',
    O76031: 'CLPX',
    O76036: 'NCR1',
    O76039: 'CDKL5',
    O76041: 'NEBL',
    O76050: 'NEURL1',
    O76054: 'SEC14L2',
    O76061: 'STC2',
    O76062: 'TM7SF2',
    O76064: 'RNF8',
    O76070: 'SNCG',
    O76071: 'CIAO1',
    O76074: 'PDE5A',
    O76075: 'DFFB',
    O76076: 'CCN5',
    O76080: 'ZFAND5',
    O76081: 'RGS20',
    O76082: 'SLC22A5',
    O76083: 'PDE9A',
    O76090: 'BEST1',
    O76093: 'FGF18',
    O76094: 'SRP72',
    O76095: 'JTB',
    O76096: 'CST7',
    O77932: 'DXO',
    O94759: 'TRPM2',
    O94760: 'DDAH1',
    O94761: 'RECQL4',
    O94762: 'RECQL5',
    O94763: 'URI1',
    O94766: 'B3GAT3',
    O94768: 'STK17B',
    O94769: 'ECM2',
    O94776: 'MTA2',
    O94777: 'DPM2',
    O94778: 'AQP8',
    O94779: 'CNTN5',
    O94782: 'USP1',
    O94788: 'ALDH1A2',
    O94804: 'STK10',
    O94805: 'ACTL6B',
    O94806: 'PRKD3',
    O94808: 'GFPT2',
    O94810: 'RGS11',
    O94811: 'TPPP',
    O94812: 'BAIAP3',
    O94813: 'SLIT2',
    O94817: 'ATG12',
    O94818: 'NOL4',
    O94822: 'LTN1',
    O94823: 'ATP10B',
    O94826: 'TOMM70',
    O94827: 'PLEKHG5',
    O94829: 'IPO13',
    O94830: 'DDHD2',
    O94832: 'MYO1D',
    O94842: 'TOX4',
    O94844: 'RHOBTB1',
    O94850: 'DDN',
    O94851: 'MICAL2',
    O94855: 'SEC24D',
    O94856: 'NFASC',
    O94864: 'SUPT7L',
    O94868: 'FCHSD2',
    O94874: 'UFL1',
    O94875: 'SORBS2',
    O94876: 'TMCC1',
    O94885: 'SASH1',
    O94886: 'TMEM63A',
    O94887: 'FARP2',
    O94888: 'UBXN7',
    O94898: 'LRIG2',
    O94900: 'TOX',
    O94901: 'SUN1',
    O94905: 'ERLIN2',
    O94906: 'PRPF6',
    O94907: 'DKK1',
    O94910: 'ADGRL1',
    O94911: 'ABCA8',
    O94915: 'FRYL',
    O94916: 'NFAT5',
    O94919: 'ENDOD1',
    O94921: 'CDK14',
    O94923: 'GLCE',
    O94925: 'GLS',
    O94927: 'HAUS5',
    O94929: 'ABLIM3',
    O94933: 'SLITRK3',
    O94941: 'UBOX5',
    O94953: 'KDM4B',
    O94955: 'RHOBTB3',
    O94956: 'SLCO2B1',
    O94964: 'SOGA1',
    O94966: 'USP19',
    O94972: 'TRIM37',
    O94973: 'AP2A2',
    O94979: 'SEC31A',
    O94983: 'CAMTA2',
    O94985: 'CLSTN1',
    O94986: 'CEP152',
    O94989: 'ARHGEF15',
    O94991: 'SLITRK5',
    O94992: 'HEXIM1',
    O94993: 'SOX30',
    O95045: 'UPP2',
    O95047: 'OR2A4',
    O95049: 'TJP3',
    O95050: 'INMT',
    O95057: 'DIRAS1',
    O95059: 'RPP14',
    O95067: 'CCNB2',
    O95069: 'KCNK2',
    O95070: 'YIF1A',
    O95071: 'UBR5',
    O95072: 'REC8',
    O95073: 'FSBP',
    O95096: 'NKX2-2',
    O95104: 'SCAF4',
    O95125: 'ZNF202',
    O95136: 'S1PR2',
    O95139: 'NDUFB6',
    O95140: 'MFN2',
    O95147: 'DUSP14',
    O95149: 'SNUPN',
    O95150: 'TNFSF15',
    O95153: 'TSPOAP1',
    O95154: 'AKR7A3',
    O95155: 'UBE4B',
    O95159: 'ZFPL1',
    O95163: 'ELP1',
    O95166: 'GABARAP',
    O95167: 'NDUFA3',
    O95168: 'NDUFB4',
    O95169: 'NDUFB8',
    O95171: 'SCEL',
    O95178: 'NDUFB2',
    O95180: 'CACNA1H',
    O95182: 'NDUFA7',
    O95183: 'VAMP5',
    O95185: 'UNC5C',
    O95196: 'CSPG5',
    O95197: 'RTN3',
    O95198: 'KLHL2',
    O95201: 'ZNF205',
    O95202: 'LETM1',
    O95206: 'PCDH8',
    O95208: 'EPN2',
    O95210: 'STBD1',
    O95214: 'LEPROTL1',
    O95218: 'ZRANB2',
    O95219: 'SNX4',
    O95229: 'ZWINT',
    O95231: 'VENTX',
    O95232: 'LUC7L3',
    O95235: 'KIF20A',
    O95236: 'APOL3',
    O95237: 'LRAT',
    O95238: 'SPDEF',
    O95239: 'KIF4A',
    O95243: 'MBD4',
    O95248: 'SBF1',
    O95249: 'GOSR1',
    O95251: 'KAT7',
    O95255: 'ABCC6',
    O95256: 'IL18RAP',
    O95257: 'GADD45G',
    O95258: 'SLC25A14',
    O95259: 'KCNH1',
    O95263: 'PDE8B',
    O95264: 'HTR3B',
    O95267: 'RASGRP1',
    O95271: 'TNKS',
    O95273: 'CCNDBP1',
    O95274: 'LYPD3',
    O95278: 'EPM2A',
    O95279: 'KCNK5',
    O95292: 'VAPB',
    O95294: 'RASAL1',
    O95295: 'SNAPIN',
    O95297: 'MPZL1',
    O95298: 'NDUFC2',
    O95299: 'NDUFA10',
    O95302: 'FKBP9',
    O95319: 'CELF2',
    O95340: 'PAPSS2',
    O95342: 'ABCB11',
    O95343: 'SIX3',
    O95347: 'SMC2',
    O95352: 'ATG7',
    O95359: 'TACC2',
    O95361: 'TRIM16',
    O95363: 'FARS2',
    O95365: 'ZBTB7A',
    O95372: 'LYPLA2',
    O95373: 'IPO7',
    O95376: 'ARIH2',
    O95377: 'GJB5',
    O95379: 'TNFAIP8',
    O95382: 'MAP3K6',
    O95388: 'CCN4',
    O95389: 'CCN6',
    O95390: 'GDF11',
    O95391: 'SLU7',
    O95393: 'BMP10',
    O95394: 'PGM3',
    O95395: 'GCNT3',
    O95396: 'MOCS3',
    O95398: 'RAPGEF3',
    O95399: 'UTS2',
    O95400: 'CD2BP2',
    O95402: 'MED26',
    O95405: 'ZFYVE9',
    O95406: 'CNIH1',
    O95407: 'TNFRSF6B',
    O95409: 'ZIC2',
    O95415: 'BRI3',
    O95416: 'SOX14',
    O95425: 'SVIL',
    O95427: 'PIGN',
    O95428: 'PAPLN',
    O95429: 'BAG4',
    O95433: 'AHSA1',
    O95436: 'SLC34A2',
    O95445: 'APOM',
    O95447: 'LCA5L',
    O95450: 'ADAMTS2',
    O95452: 'GJB6',
    O95453: 'PARN',
    O95456: 'PSMG1',
    O95460: 'MATN4',
    O95461: 'LARGE1',
    O95466: 'FMNL1',
    O95467: 'GNAS',
    O95470: 'SGPL1',
    O95471: 'CLDN7',
    O95475: 'SIX6',
    O95476: 'CTDNEP1',
    O95477: 'ABCA1',
    O95479: 'H6PD',
    O95484: 'CLDN9',
    O95486: 'SEC24A',
    O95487: 'SEC24B',
    O95490: 'ADGRL2',
    O95497: 'VNN1',
    O95498: 'VNN2',
    O95500: 'CLDN14',
    O95503: 'CBX6',
    O95528: 'SLC2A10',
    O95544: 'NADK',
    O95551: 'TDP2',
    O95562: 'SFT2D2',
    O95563: 'MPC2',
    O95568: 'METTL18',
    O95571: 'ETHE1',
    O95573: 'ACSL3',
    O95600: 'KLF8',
    O95602: 'POLR1A',
    O95613: 'PCNT',
    O95619: 'YEATS4',
    O95622: 'ADCY5',
    O95628: 'CNOT4',
    O95630: 'STAMBP',
    O95631: 'NTN1',
    O95633: 'FSTL3',
    O95639: 'CPSF4',
    O95644: 'NFATC1',
    O95665: 'NTSR2',
    O95670: 'ATP6V1G2',
    O95671: 'ASMTL',
    O95672: 'ECEL1',
    O95674: 'CDS2',
    O95677: 'EYA4',
    O95678: 'KRT75',
    O95684: 'CEP43',
    O95696: 'BRD1',
    O95704: 'APBB3',
    O95707: 'POP4',
    O95711: 'LY86',
    O95714: 'HERC2',
    O95715: 'CXCL14',
    O95716: 'RAB3D',
    O95718: 'ESRRB',
    O95721: 'SNAP29',
    O95727: 'CRTAM',
    O95741: 'CPNE6',
    O95747: 'OXSR1',
    O95749: 'GGPS1',
    O95750: 'FGF19',
    O95751: 'LDOC1',
    O95754: 'SEMA4F',
    O95758: 'PTBP3',
    O95760: 'IL33',
    O95772: 'STARD3NL',
    O95777: 'LSM8',
    O95782: 'AP2A1',
    O95785: 'WIZ',
    O95786: 'RIGI',
    O95789: 'ZMYM6',
    O95793: 'STAU1',
    O95801: 'TTC4',
    O95803: 'NDST3',
    O95807: 'TMEM50A',
    O95810: 'CAVIN2',
    O95813: 'CER1',
    O95816: 'BAG2',
    O95817: 'BAG3',
    O95819: 'MAP4K4',
    O95822: 'MLYCD',
    O95831: 'AIFM1',
    O95832: 'CLDN1',
    O95833: 'CLIC3',
    O95834: 'EML2',
    O95835: 'LATS1',
    O95837: 'GNA14',
    O95843: 'GUCA1C',
    O95848: 'NUDT14',
    O95858: 'TSPAN15',
    O95859: 'TSPAN12',
    O95861: 'BPNT1',
    O95863: 'SNAI1',
    O95864: 'FADS2',
    O95865: 'DDAH2',
    O95866: 'MPIG6B',
    O95867: 'LY6G6C',
    O95868: 'LY6G6D',
    O95870: 'ABHD16A',
    O95872: 'GPANK1',
    O95876: 'WDPCP',
    O95881: 'TXNDC12',
    O95886: 'DLGAP3',
    O95897: 'OLFM2',
    O95900: 'TRUB2',
    O95905: 'ECD',
    O95907: 'SLC16A8',
    O95922: 'TTLL1',
    O95925: 'EPPIN',
    O95926: 'SYF2',
    O95931: 'CBX7',
    O95932: 'TGM6',
    O95935: 'TBX18',
    O95936: 'EOMES',
    O95944: 'NCR2',
    O95947: 'TBX6',
    O95948: 'ONECUT2',
    O95954: 'FTCD',
    O95967: 'EFEMP2',
    O95968: 'SCGB1D1',
    O95970: 'LGI1',
    O95971: 'CD160',
    O95972: 'BMP15',
    O95977: 'S1PR4',
    O95980: 'RECK',
    O95983: 'MBD3',
    O95985: 'TOP3B',
    O95988: 'TCL1B',
    O95989: 'NUDT3',
    O95990: 'FAM107A',
    O95992: 'CH25H',
    O95994: 'AGR2',
    O95995: 'GAS8',
    O95996: 'APC2',
    O95997: 'PTTG1',
    O95998: 'IL18BP',
    O95999: 'BCL10',
    O96000: 'NDUFB10',
    O96004: 'HAND1',
    O96005: 'CLPTM1',
    O96006: 'ZBED1',
    O96007: 'MOCS2',
    O96008: 'TOMM40',
    O96009: 'NAPSA',
    O96011: 'PEX11B',
    O96013: 'PAK4',
    O96014: 'WNT11',
    O96015: 'DNAL4',
    O96017: 'CHEK2',
    O96018: 'APBA3',
    O96019: 'ACTL6A',
    O96020: 'CCNE2',
    O96024: 'B3GALT4',
    O96028: 'NSD2',
    O96033: 'MOCS2',
    O97980: 'HMHB1',
    P00156: 'MT-CYB',
    P00167: 'CYB5A',
    P00325: 'ADH1B',
    P00326: 'ADH1C',
    P00338: 'LDHA',
    P00352: 'ALDH1A1',
    P00367: 'GLUD1',
    P00374: 'DHFR',
    P00387: 'CYB5R3',
    P00390: 'GSR',
    P00395: 'MT-CO1',
    P00403: 'MT-CO2',
    P00414: 'MT-CO3',
    P00439: 'PAH',
    P00441: 'SOD1',
    P00450: 'CP',
    P00451: 'F8',
    P00480: 'OTC',
    P00488: 'F13A1',
    P00491: 'PNP',
    P00492: 'HPRT1',
    P00505: 'GOT2',
    P00519: 'ABL1',
    P00533: 'EGFR',
    P00540: 'MOS',
    P00558: 'PGK1',
    P00568: 'AK1',
    P00709: 'LALBA',
    P00734: 'F2',
    P00736: 'C1R',
    P00738: 'HP',
    P00739: 'HPR',
    P00740: 'F9',
    P00742: 'F10',
    P00746: 'CFD',
    P00747: 'PLG',
    P00748: 'F12',
    P00749: 'PLAU',
    P00750: 'PLAT',
    P00751: 'CFB',
    P00797: 'REN',
    P00813: 'ADA',
    P00846: 'MT-ATP6',
    P00915: 'CA1',
    P00918: 'CA2',
    P00966: 'ASS1',
    P00973: 'OAS1',
    P00995: 'SPINK1',
    P01008: 'SERPINC1',
    P01009: 'SERPINA1',
    P01011: 'SERPINA3',
    P01019: 'AGT',
    P01023: 'A2M',
    P01024: 'C3',
    P01031: 'C5',
    P01033: 'TIMP1',
    P01034: 'CST3',
    P01036: 'CST4',
    P01037: 'CST1',
    P01040: 'CSTA',
    P01042: 'KNG1',
    P01100: 'FOS',
    P01106: 'MYC',
    P01111: 'NRAS',
    P01112: 'HRAS',
    P01116: 'KRAS',
    P01127: 'PDGFB',
    P01130: 'LDLR',
    P01133: 'EGF',
    P01135: 'TGFA',
    P01137: 'TGFB1',
    P01138: 'NGF',
    P01148: 'GNRH1',
    P01160: 'NPPA',
    P01178: 'OXT',
    P01185: 'AVP',
    P01189: 'POMC',
    P01210: 'PENK',
    P01213: 'PDYN',
    P01215: 'CGA',
    P01222: 'TSHB',
    P01225: 'FSHB',
    P01229: 'LHB',
    P01236: 'PRL',
    P01241: 'GH1',
    P01242: 'GH2',
    P01258: 'CALCA',
    P01266: 'TG',
    P01270: 'PTH',
    P01275: 'GCG',
    P01282: 'VIP',
    P01286: 'GHRH',
    P01298: 'PPY',
    P01303: 'NPY',
    P01308: 'INS',
    P01344: 'IGF2',
    P01350: 'GAST',
    P01374: 'LTA',
    P01375: 'TNF',
    P01562: 'IFNA1',
    P01562: 'IFNA13',
    P01563: 'IFNA2',
    P01566: 'IFNA10',
    P01567: 'IFNA7',
    P01568: 'IFNA21',
    P01569: 'IFNA5',
    P01570: 'IFNA14',
    P01571: 'IFNA17',
    P01574: 'IFNB1',
    P01579: 'IFNG',
    P01583: 'IL1A',
    P01584: 'IL1B',
    P01588: 'EPO',
    P01589: 'IL2RA',
    P01591: 'JCHAIN',
    P01593: 'IGKV1D-33',
    P01597: 'IGKV1-39',
    P01602: 'IGKV1-5',
    P01611: 'IGKV1D-12',
    P01615: 'IGKV2D-28',
    P01619: 'IGKV3-20',
    P01699: 'IGLV1-44',
    P01700: 'IGLV1-47',
    P01701: 'IGLV1-51',
    P01704: 'IGLV2-14',
    P01705: 'IGLV2-23',
    P01706: 'IGLV2-11',
    P01709: 'IGLV2-8',
    P01721: 'IGLV6-57',
    P01730: 'CD4',
    P01732: 'CD8A',
    P01742: 'IGHV1-69',
    P01743: 'IGHV1-46',
    P01762: 'IGHV3-11',
    P01763: 'IGHV3-48',
    P01764: 'IGHV3-23',
    P01766: 'IGHV3-13',
    P01767: 'IGHV3-53',
    P01768: 'IGHV3-30',
    P01772: 'IGHV3-33',
    P01780: 'IGHV3-7',
    P01782: 'IGHV3-9',
    P01814: 'IGHV2-70',
    P01817: 'IGHV2-5',
    P01824: 'IGHV4-39',
    P01825: 'IGHV4-59',
    P01833: 'PIGR',
    P01834: 'IGKC',
    P01850: 'TRBC1',
    P01854: 'IGHE',
    P01859: 'IGHG2',
    P01860: 'IGHG3',
    P01861: 'IGHG4',
    P01871: 'IGHM',
    P01876: 'IGHA1',
    P01877: 'IGHA2',
    P01880: 'IGHD',
    P01889: 'HLA-B',
    P01893: 'HLA-H',
    P01903: 'HLA-DRA',
    P01906: 'HLA-DQA2',
    P01909: 'HLA-DQA1',
    P01911: 'HLA-DRB1',
    P01920: 'HLA-DQB1',
    P02008: 'HBZ',
    P02042: 'HBD',
    P02100: 'HBE1',
    P02144: 'MB',
    P02452: 'COL1A1',
    P02458: 'COL2A1',
    P02461: 'COL3A1',
    P02462: 'COL4A1',
    P02489: 'CRYAA',
    P02511: 'CRYAB',
    P02533: 'KRT14',
    P02538: 'KRT6A',
    P02545: 'LMNA',
    P02549: 'SPTA1',
    P02585: 'TNNC2',
    P02647: 'APOA1',
    P02649: 'APOE',
    P02652: 'APOA2',
    P02654: 'APOC1',
    P02655: 'APOC2',
    P02656: 'APOC3',
    P02671: 'FGA',
    P02675: 'FGB',
    P02679: 'FGG',
    P02686: 'MBP',
    P02689: 'PMP2',
    P02708: 'CHRNA1',
    P02724: 'GYPA',
    P02730: 'SLC4A1',
    P02741: 'CRP',
    P02743: 'APCS',
    P02745: 'C1QA',
    P02746: 'C1QB',
    P02747: 'C1QC',
    P02748: 'C9',
    P02749: 'APOH',
    P02750: 'LRG1',
    P02751: 'FN1',
    P02753: 'RBP4',
    P02760: 'AMBP',
    P02763: 'ORM1',
    P02765: 'AHSG',
    P02766: 'TTR',
    P02768: 'ALB',
    P02771: 'AFP',
    P02774: 'GC',
    P02775: 'PPBP',
    P02776: 'PF4',
    P02778: 'CXCL10',
    P02786: 'TFRC',
    P02787: 'TF',
    P02788: 'LTF',
    P02790: 'HPX',
    P02792: 'FTL',
    P02794: 'FTH1',
    P02795: 'MT2A',
    P02808: 'STATH',
    P02810: 'PRH1',
    P02810: 'PRH2',
    P02812: 'PRB2',
    P02814: 'SMR3B',
    P02818: 'BGLAP',
    P03372: 'ESR1',
    P03886: 'MT-ND1',
    P03891: 'MT-ND2',
    P03897: 'MT-ND3',
    P03901: 'MT-ND4L',
    P03905: 'MT-ND4',
    P03915: 'MT-ND5',
    P03923: 'MT-ND6',
    P03928: 'MT-ATP8',
    P03950: 'ANG',
    P03951: 'F11',
    P03952: 'KLKB1',
    P03956: 'MMP1',
    P03971: 'AMH',
    P03973: 'SLPI',
    P03999: 'OPN1SW',
    P04000: 'OPN1LW',
    P04001: 'OPN1MW',
    P04003: 'C4BPA',
    P04004: 'VTN',
    P04035: 'HMGCR',
    P04040: 'CAT',
    P04049: 'RAF1',
    P04053: 'DNTT',
    P04054: 'PLA2G1B',
    P04062: 'GBA1',
    P04066: 'FUCA1',
    P04070: 'PROC',
    P04075: 'ALDOA',
    P04080: 'CSTB',
    P04083: 'ANXA1',
    P04085: 'PDGFA',
    P04090: 'RLN2',
    P04114: 'APOB',
    P04118: 'CLPS',
    P04141: 'CSF2',
    P04150: 'NR3C1',
    P04155: 'TFF1',
    P04156: 'PRNP',
    P04179: 'SOD2',
    P04180: 'LCAT',
    P04181: 'OAT',
    P04183: 'TK1',
    P04196: 'HRG',
    P04198: 'MYCN',
    P04201: 'MAS1',
    P04216: 'THY1',
    P04217: 'A1BG',
    P04233: 'CD74',
    P04234: 'CD3D',
    P04259: 'KRT6B',
    P04264: 'KRT1',
    P04271: 'S100B',
    P04275: 'VWF',
    P04278: 'SHBG',
    P04279: 'SEMG1',
    P04280: 'PRB1',
    P04350: 'TUBB4A',
    P04406: 'GAPDH',
    P04424: 'ASL',
    P04439: 'HLA-A',
    P04440: 'HLA-DPB1',
    P04553: 'PRM1',
    P04554: 'PRM2',
    P04626: 'ERBB2',
    P04628: 'WNT1',
    P04629: 'NTRK1',
    P04632: 'CAPNS1',
    P04637: 'TP53',
    P04731: 'MT1A',
    P04732: 'MT1E',
    P04733: 'MT1F',
    P04746: 'AMY2A',
    P04792: 'HSPB1',
    P04798: 'CYP1A1',
    P04818: 'TYMS',
    P04839: 'CYBB',
    P04843: 'RPN1',
    P04844: 'RPN2',
    P04899: 'GNAI2',
    P04908: 'H2AC4',
    P04908: 'H2AC8',
    P04920: 'SLC4A2',
    P04921: 'GYPC',
    P05000: 'IFNW1',
    P05013: 'IFNA6',
    P05014: 'IFNA4',
    P05019: 'IGF1',
    P05023: 'ATP1A1',
    P05026: 'ATP1B1',
    P05060: 'CHGB',
    P05062: 'ALDOB',
    P05067: 'APP',
    P05089: 'ARG1',
    P05090: 'APOD',
    P05091: 'ALDH2',
    P05093: 'CYP17A1',
    P05106: 'ITGB3',
    P05107: 'ITGB2',
    P05108: 'CYP11A1',
    P05109: 'S100A8',
    P05111: 'INHA',
    P05112: 'IL4',
    P05113: 'IL5',
    P05114: 'HMGN1',
    P05120: 'SERPINB2',
    P05121: 'SERPINE1',
    P05129: 'PRKCG',
    P05141: 'SLC25A5',
    P05154: 'SERPINA5',
    P05155: 'SERPING1',
    P05156: 'CFI',
    P05160: 'F13B',
    P05161: 'ISG15',
    P05162: 'LGALS2',
    P05164: 'MPO',
    P05165: 'PCCA',
    P05166: 'PCCB',
    P05177: 'CYP1A2',
    P05181: 'CYP2E1',
    P05186: 'ALPL',
    P05187: 'ALPP',
    P05198: 'EIF2S1',
    P05204: 'HMGN2',
    P05230: 'FGF1',
    P05231: 'IL6',
    P05305: 'EDN1',
    P05362: 'ICAM1',
    P05386: 'RPLP1',
    P05387: 'RPLP2',
    P05388: 'RPLP0',
    P05408: 'SCG5',
    P05412: 'JUN',
    P05413: 'FABP3',
    P05423: 'POLR3D',
    P05451: 'REG1A',
    P05452: 'CLEC3B',
    P05455: 'SSB',
    P05496: 'ATP5MC1',
    P05538: 'HLA-DQB2',
    P05543: 'SERPINA7',
    P05546: 'SERPIND1',
    P05549: 'TFAP2A',
    P05556: 'ITGB1',
    P05771: 'PRKCB',
    P05783: 'KRT18',
    P05787: 'KRT8',
    P05813: 'CRYBA1',
    P05814: 'CSN2',
    P05937: 'CALB1',
    P05976: 'MYL1',
    P05981: 'HPN',
    P05997: 'COL5A2',
    P06028: 'GYPB',
    P06126: 'CD1A',
    P06127: 'CD5',
    P06132: 'UROD',
    P06133: 'UGT2B4',
    P06213: 'INSR',
    P06239: 'LCK',
    P06241: 'FYN',
    P06276: 'BCHE',
    P06280: 'GLA',
    P06307: 'CCK',
    P06312: 'IGKV4-1',
    P06331: 'IGHV4-34',
    P06340: 'HLA-DOA',
    P06396: 'GSN',
    P06400: 'RB1',
    P06401: 'PGR',
    P06454: 'PTMA',
    P06493: 'CDK1',
    P06576: 'ATP5F1B',
    P06681: 'C2',
    P06702: 'S100A9',
    P06703: 'S100A6',
    P06727: 'APOA4',
    P06729: 'CD2',
    P06730: 'EIF4E',
    P06731: 'CEACAM5',
    P06732: 'CKM',
    P06733: 'ENO1',
    P06734: 'FCER2',
    P06737: 'PYGL',
    P06744: 'GPI',
    P06746: 'POLB',
    P06748: 'NPM1',
    P06753: 'TPM3',
    P06756: 'ITGAV',
    P06850: 'CRH',
    P06858: 'LPL',
    P06865: 'HEXA',
    P06870: 'KLK1',
    P06881: 'CALCA',
    P06899: 'H2BC11',
    P07093: 'SERPINE2',
    P07098: 'LIPF',
    P07099: 'EPHX1',
    P07101: 'TH',
    P07108: 'DBI',
    P07148: 'FABP1',
    P07195: 'LDHB',
    P07196: 'NEFL',
    P07197: 'NEFM',
    P07199: 'CENPB',
    P07202: 'TPO',
    P07203: 'GPX1',
    P07204: 'THBD',
    P07205: 'PGK2',
    P07225: 'PROS1',
    P07237: 'P4HB',
    P07288: 'KLK3',
    P07305: 'H1-0',
    P07306: 'ASGR1',
    P07307: 'ASGR2',
    P07315: 'CRYGC',
    P07320: 'CRYGD',
    P07327: 'ADH1A',
    P07332: 'FES',
    P07333: 'CSF1R',
    P07339: 'CTSD',
    P07355: 'ANXA2',
    P07357: 'C8A',
    P07358: 'C8B',
    P07359: 'GP1BA',
    P07360: 'C8G',
    P07384: 'CAPN1',
    P07437: 'TUBB',
    P07438: 'MT1B',
    P07451: 'CA3',
    P07476: 'IVL',
    P07477: 'PRSS1',
    P07478: 'PRSS2',
    P07492: 'GRP',
    P07498: 'CSN3',
    P07510: 'CHRNG',
    P07550: 'ADRB2',
    P07585: 'DCN',
    P07602: 'PSAP',
    P07686: 'HEXB',
    P07711: 'CTSL',
    P07737: 'PFN1',
    P07738: 'BPGM',
    P07741: 'APRT',
    P07766: 'CD3E',
    P07814: 'EPRS1',
    P07858: 'CTSB',
    P07864: 'LDHC',
    P07900: 'HSP90AA1',
    P07902: 'GALT',
    P07910: 'HNRNPC',
    P07911: 'UMOD',
    P07919: 'UQCRH',
    P07942: 'LAMB1',
    P07947: 'YES1',
    P07948: 'LYN',
    P07949: 'RET',
    P07951: 'TPM2',
    P07954: 'FH',
    P07988: 'SFTPB',
    P07992: 'ERCC1',
    P07996: 'THBS1',
    P07998: 'RNASE1',
    P08034: 'GJB1',
    P08047: 'SP1',
    P08048: 'ZFY',
    P08069: 'IGF1R',
    P08100: 'RHO',
    P08118: 'MSMB',
    P08123: 'COL1A2',
    P08133: 'ANXA6',
    P08134: 'RHOC',
    P08138: 'NGFR',
    P08151: 'GLI1',
    P08172: 'CHRM2',
    P08173: 'CHRM4',
    P08174: 'CD55',
    P08183: 'ABCB1',
    P08185: 'SERPINA6',
    P08195: 'SLC3A2',
    P08217: 'CELA2A',
    P08218: 'CELA2B',
    P08235: 'NR3C2',
    P08236: 'GUSB',
    P08237: 'PFKM',
    P08238: 'HSP90AB1',
    P08240: 'SRPRA',
    P08243: 'ASNS',
    P08246: 'ELANE',
    P08247: 'SYP',
    P08253: 'MMP2',
    P08254: 'MMP3',
    P08263: 'GSTA1',
    P08294: 'SOD3',
    P08311: 'CTSG',
    P08319: 'ADH4',
    P08397: 'HMBS',
    P08473: 'MME',
    P08476: 'INHBA',
    P08493: 'MGP',
    P08514: 'ITGA2B',
    P08519: 'LPA',
    P08559: 'PDHA1',
    P08567: 'PLEK',
    P08571: 'CD14',
    P08572: 'COL4A2',
    P08574: 'CYC1',
    P08575: 'PTPRC',
    P08579: 'SNRPB2',
    P08581: 'MET',
    P08582: 'MELTF',
    P08588: 'ADRB1',
    P08590: 'MYL3',
    P08603: 'CFH',
    P08620: 'FGF4',
    P08621: 'SNRNP70',
    P08631: 'HCK',
    P08637: 'FCGR3A',
    P08648: 'ITGA5',
    P08651: 'NFIC',
    P08670: 'VIM',
    P08684: 'CYP3A4',
    P08686: 'CYP21A2',
    P08697: 'SERPINF2',
    P08700: 'IL3',
    P08708: 'RPS17',
    P08709: 'F7',
    P08727: 'KRT19',
    P08729: 'KRT7',
    P08754: 'GNAI3',
    P08758: 'ANXA5',
    P08779: 'KRT16',
    P08833: 'IGFBP1',
    P08842: 'STS',
    P08861: 'CELA3B',
    P08865: 'RPSA',
    P08887: 'IL6R',
    P08908: 'HTR1A',
    P08910: 'ABHD2',
    P08912: 'CHRM5',
    P08913: 'ADRA2A',
    P08922: 'ROS1',
    P08949: 'NMB',
    P08962: 'CD63',
    P08F94: 'PKHD1',
    P09012: 'SNRPA',
    P09016: 'HOXD4',
    P09017: 'HOXC4',
    P09038: 'FGF2',
    P09067: 'HOXB5',
    P09086: 'POU2F2',
    P09104: 'ENO2',
    P09110: 'ACAA1',
    P09132: 'SRP19',
    P09172: 'DBH',
    P09210: 'GSTA2',
    P09211: 'GSTP1',
    P09228: 'CST2',
    P09234: 'SNRPC',
    P09237: 'MMP7',
    P09238: 'MMP10',
    P09326: 'CD48',
    P09327: 'VIL1',
    P09341: 'CXCL1',
    P09382: 'LGALS1',
    P09417: 'QDPR',
    P09429: 'HMGB1',
    P09430: 'TNP1',
    P09455: 'RBP1',
    P09466: 'PAEP',
    P09467: 'FBP1',
    P09471: 'GNAO1',
    P09486: 'SPARC',
    P09488: 'GSTM1',
    P09493: 'TPM1',
    P09496: 'CLTA',
    P09497: 'CLTB',
    P09525: 'ANXA4',
    P09529: 'INHBB',
    P09543: 'CNP',
    P09544: 'WNT2',
    P09564: 'CD7',
    P09601: 'HMOX1',
    P09603: 'CSF1',
    P09619: 'PDGFRB',
    P09622: 'DLD',
    P09629: 'HOXB7',
    P09651: 'HNRNPA1',
    P09661: 'SNRPA1',
    P09668: 'CTSH',
    P09669: 'COX6C',
    P09681: 'GIP',
    P09683: 'SCT',
    P09693: 'CD3G',
    P09758: 'TACSTD2',
    P09769: 'FGR',
    P09848: 'LCT',
    P09871: 'C1S',
    P09874: 'PARP1',
    P09884: 'POLA1',
    P09912: 'IFI6',
    P09913: 'IFIT2',
    P09914: 'IFIT1',
    P09917: 'ALOX5',
    P09919: 'CSF3',
    P09923: 'ALPI',
    P09936: 'UCHL1',
    P09958: 'FURIN',
    P09960: 'LTA4H',
    P09972: 'ALDOC',
    P0C024: 'NUDT7',
    P0C0L4: 'C4A',
    P0C0L5: 'C4B',
    P0C0L5: 'C4B_2',
    P0C0S5: 'H2AZ1',
    P0C0S8: 'H2AC11',
    P0C0S8: 'H2AC13',
    P0C0S8: 'H2AC15',
    P0C0S8: 'H2AC16',
    P0C0S8: 'H2AC17',
    P0C1S8: 'WEE2',
    P0C1Z6: 'TFPT',
    P0C264: 'SBK3',
    P0C2W1: 'FBXO45',
    P0C5Y9: 'H2AB1',
    P0C5Z0: 'H2AB2',
    P0C5Z0: 'H2AB3',
    P0C7P0: 'CISD3',
    P0C7P3: 'SLFN14',
    P0C7T5: 'ATXN1L',
    P0C7W6: 'CCDC172',
    P0C7X2: 'ZNF688',
    P0C869: 'PLA2G4B',
    P0C870: 'JMJD7',
    P0CAP1: 'MYZAP',
    P0CAP2: 'POLR2M',
    P0CB47: 'UBTFL1',
    P0CF74: 'IGLC6',
    P0CG20: 'PRR35',
    P0CG30: 'GSTT2B',
    P0CG37: 'CFC1',
    P0CG47: 'UBB',
    P0CG48: 'UBC',
    P0CW18: 'PRSS56',
    P0DI81: 'TRAPPC2',
    P0DI83: 'RAB34',
    P0DJD3: 'RBMY1A1',
    P0DJD7: 'PGA4',
    P0DJD8: 'PGA3',
    P0DJD9: 'PGA5',
    P0DJI8: 'SAA1',
    P0DJI9: 'SAA2',
    P0DJJ0: 'SRGAP2C',
    P0DMC3: 'APELA',
    P0DME0: 'SETSIP',
    P0DML2: 'CSH1',
    P0DML3: 'CSH2',
    P0DMM9: 'SULT1A3',
    P0DMS8: 'ADORA3',
    P0DMS9: 'TMIGD3',
    P0DMV8: 'HSPA1A',
    P0DMW2: 'NLRP2B',
    P0DN84: 'STRIT1',
    P0DN86: 'CGB3',
    P0DN86: 'CGB5',
    P0DN86: 'CGB8',
    P0DOY2: 'IGLC2',
    P0DOY3: 'IGLC3',
    P0DP23: 'CALM1',
    P0DP57: 'SLURP2',
    P0DP58: 'LYNX1',
    P0DP91: 'ERCC6',
    P0DPB3: 'SCHIP1',
    P0DPB6: 'POLR1D',
    P0DPD6: 'ECE2',
    P0DPD7: 'EEF1AKMT4',
    P0DPD8: 'EEF1AKMT4-ECE2',
    P0DPH7: 'TUBA3C',
    P0DPK2: 'H3Y1',
    P0DPK3: 'NOTCH2NLB',
    P0DPK4: 'NOTCH2NLC',
    P0DPK5: 'H3Y2',
    P0DSE1: 'TRA',
    P0DSE2: 'TRB',
    P0DTE4: 'UGT2A1',
    P0DTE5: 'UGT2A2',
    P0DTE7: 'AMY1B',
    P0DTU3: 'TRA',
    P0DTU4: 'TRB',
    P10070: 'GLI2',
    P10071: 'GLI3',
    P10073: 'ZSCAN22',
    P10074: 'ZBTB48',
    P10082: 'PYY',
    P10092: 'CALCB',
    P10109: 'FDX1',
    P10114: 'RAP2A',
    P10124: 'SRGN',
    P10144: 'GZMB',
    P10145: 'CXCL8',
    P10147: 'CCL3',
    P10153: 'RNASE2',
    P10155: 'RO60',
    P10163: 'PRB4',
    P10176: 'COX8A',
    P10242: 'MYB',
    P10243: 'MYBL1',
    P10244: 'MYBL2',
    P10253: 'GAA',
    P10265: 'ERVK-10',
    P10275: 'AR',
    P10276: 'RARA',
    P10301: 'RRAS',
    P10321: 'HLA-C',
    P10323: 'ACR',
    P10398: 'ARAF',
    P10412: 'H1-4',
    P10415: 'BCL2',
    P10451: 'SPP1',
    P10515: 'DLAT',
    P10523: 'SAG',
    P10586: 'PTPRF',
    P10588: 'NR2F6',
    P10589: 'NR2F1',
    P10599: 'TXN',
    P10600: 'TGFB3',
    P10606: 'COX5B',
    P10619: 'CTSA',
    P10620: 'MGST1',
    P10632: 'CYP2C8',
    P10635: 'CYP2D6',
    P10636: 'MAPT',
    P10643: 'C7',
    P10644: 'PRKAR1A',
    P10645: 'CHGA',
    P10646: 'TFPI',
    P10696: 'ALPG',
    P10720: 'PF4V1',
    P10721: 'KIT',
    P10745: 'RBP3',
    P10746: 'UROS',
    P10747: 'CD28',
    P10767: 'FGF6',
    P10768: 'ESD',
    P10809: 'HSPD1',
    P10826: 'RARB',
    P10827: 'THRA',
    P10828: 'THRB',
    P10909: 'CLU',
    P10911: 'MCF2',
    P10912: 'GHR',
    P10914: 'IRF1',
    P10916: 'MYL2',
    P10966: 'CD8B',
    P10997: 'IAPP',
    P11021: 'HSPA5',
    P11047: 'LAMC1',
    P11049: 'CD37',
    P11055: 'MYH3',
    P11086: 'PNMT',
    P11117: 'ACP2',
    P11137: 'MAP2',
    P11142: 'HSPA8',
    P11150: 'LIPC',
    P11161: 'EGR2',
    P11166: 'SLC2A1',
    P11168: 'SLC2A2',
    P11169: 'SLC2A3',
    P11171: 'EPB41',
    P11172: 'UMPS',
    P11177: 'PDHB',
    P11182: 'DBT',
    P11215: 'ITGAM',
    P11216: 'PYGB',
    P11217: 'PYGM',
    P11226: 'MBL2',
    P11229: 'CHRM1',
    P11230: 'CHRNB1',
    P11233: 'RALA',
    P11234: 'RALB',
    P11245: 'NAT2',
    P11274: 'BCR',
    P11277: 'SPTB',
    P11279: 'LAMP1',
    P11308: 'ERG',
    P11309: 'PIM1',
    P11310: 'ACADM',
    P11362: 'FGFR1',
    P11387: 'TOP1',
    P11388: 'TOP2A',
    P11413: 'G6PD',
    P11441: 'UBL4A',
    P11464: 'PSG1',
    P11473: 'VDR',
    P11474: 'ESRRA',
    P11487: 'FGF3',
    P11488: 'GNAT1',
    P11498: 'PC',
    P11509: 'CYP2A6',
    P11511: 'CYP19A1',
    P11532: 'DMD',
    P11586: 'MTHFD1',
    P11597: 'CETP',
    P11678: 'EPX',
    P11684: 'SCGB1A1',
    P11686: 'SFTPC',
    P11712: 'CYP2C9',
    P11717: 'IGF2R',
    P11766: 'ADH5',
    P11801: 'PSKH1',
    P11802: 'CDK4',
    P11831: 'SRF',
    P11836: 'MS4A1',
    P11908: 'PRPS2',
    P11912: 'CD79A',
    P11926: 'ODC1',
    P11940: 'PABPC1',
    P12004: 'PCNA',
    P12018: 'VPREB1',
    P12034: 'FGF5',
    P12035: 'KRT3',
    P12036: 'NEFH',
    P12074: 'COX6A1',
    P12081: 'HARS1',
    P12104: 'FABP2',
    P12107: 'COL11A1',
    P12109: 'COL6A1',
    P12110: 'COL6A2',
    P12111: 'COL6A3',
    P12235: 'SLC25A4',
    P12236: 'SLC25A6',
    P12259: 'F5',
    P12268: 'IMPDH2',
    P12270: 'TPR',
    P12271: 'RLBP1',
    P12272: 'PTHLH',
    P12273: 'PIP',
    P12277: 'CKB',
    P12314: 'FCGR1A',
    P12318: 'FCGR2A',
    P12319: 'FCER1A',
    P12429: 'ANXA3',
    P12524: 'MYCL',
    P12532: 'CKMT1A',
    P12532: 'CKMT1B',
    P12544: 'GZMA',
    P12643: 'BMP2',
    P12644: 'BMP4',
    P12645: 'BMP3',
    P12694: 'BCKDHA',
    P12724: 'RNASE3',
    P12755: 'SKI',
    P12757: 'SKIL',
    P12814: 'ACTN1',
    P12821: 'ACE',
    P12829: 'MYL4',
    P12830: 'CDH1',
    P12838: 'DEFA4',
    P12882: 'MYH1',
    P12883: 'MYH7',
    P12931: 'SRC',
    P12955: 'PEPD',
    P12956: 'XRCC6',
    P12980: 'LYL1',
    P13010: 'XRCC5',
    P13051: 'UNG',
    P13056: 'NR2C1',
    P13073: 'COX4I1',
    P13164: 'IFITM1',
    P13196: 'ALAS1',
    P13224: 'GP1BB',
    P13232: 'IL7',
    P13236: 'CCL4',
    P13284: 'IFI30',
    P13349: 'MYF5',
    P13378: 'HOXD8',
    P13385: 'TDGF1',
    P13473: 'LAMP2',
    P13489: 'RNH1',
    P13497: 'BMP1',
    P13498: 'CYBA',
    P13500: 'CCL2',
    P13501: 'CCL5',
    P13521: 'SCG2',
    P13533: 'MYH6',
    P13535: 'MYH8',
    P13569: 'CFTR',
    P13584: 'CYP4B1',
    P13591: 'NCAM1',
    P13598: 'ICAM2',
    P13611: 'VCAN',
    P13612: 'ITGA4',
    P13631: 'RARG',
    P13637: 'ATP1A3',
    P13639: 'EEF2',
    P13640: 'MT1G',
    P13645: 'KRT10',
    P13646: 'KRT13',
    P13647: 'KRT5',
    P13667: 'PDIA4',
    P13671: 'C6',
    P13674: 'P4HA1',
    P13682: 'ZNF35',
    P13686: 'ACP5',
    P13688: 'CEACAM1',
    P13693: 'TPT1',
    P13716: 'ALAD',
    P13725: 'OSM',
    P13726: 'F3',
    P13727: 'PRG2',
    P13747: 'HLA-E',
    P13762: 'HLA-DRB4',
    P13765: 'HLA-DOB',
    P13796: 'LCP1',
    P13797: 'PLS3',
    P13798: 'APEH',
    P13804: 'ETFA',
    P13805: 'TNNT1',
    P13807: 'GYS1',
    P13861: 'PRKAR2A',
    P13866: 'SLC5A1',
    P13928: 'ANXA8',
    P13929: 'ENO3',
    P13942: 'COL11A2',
    P13945: 'ADRB3',
    P13984: 'GTF2F2',
    P13987: 'CD59',
    P13994: 'YJU2B',
    P13995: 'MTHFD2',
    P14060: 'HSD3B1',
    P14061: 'HSD17B1',
    P14091: 'CTSE',
    P14136: 'GFAP',
    P14138: 'EDN3',
    P14151: 'SELL',
    P14174: 'MIF',
    P14207: 'FOLR2',
    P14209: 'CD99',
    P14210: 'HGF',
    P14222: 'PRF1',
    P14314: 'PRKCSH',
    P14316: 'IRF2',
    P14317: 'HCLS1',
    P14324: 'FDPS',
    P14373: 'TRIM27',
    P14384: 'CPM',
    P14406: 'COX7A2',
    P14410: 'SI',
    P14415: 'ATP1B2',
    P14416: 'DRD2',
    P14543: 'NID1',
    P14550: 'AKR1A1',
    P14555: 'PLA2G2A',
    P14598: 'NCF1',
    P14616: 'INSRR',
    P14618: 'PKM',
    P14625: 'HSP90B1',
    P14635: 'CCNB1',
    P14649: 'MYL6B',
    P14651: 'HOXB3',
    P14652: 'HOXB2',
    P14653: 'HOXB1',
    P14672: 'SLC2A4',
    P14678: 'SNRPB',
    P14679: 'TYR',
    P14735: 'IDE',
    P14770: 'GP9',
    P14778: 'IL1R1',
    P14780: 'MMP9',
    P14784: 'IL2RB',
    P14854: 'COX6B1',
    P14859: 'POU2F1',
    P14866: 'HNRNPL',
    P14867: 'GABRA1',
    P14868: 'DARS1',
    P14902: 'IDO1',
    P14920: 'DAO',
    P14921: 'ETS1',
    P14923: 'JUP',
    P14927: 'UQCRB',
    P15018: 'LIF',
    P15036: 'ETS2',
    P15056: 'BRAF',
    P15085: 'CPA1',
    P15086: 'CPB1',
    P15090: 'FABP4',
    P15104: 'GLUL',
    P15121: 'AKR1B1',
    P15144: 'ANPEP',
    P15151: 'PVR',
    P15153: 'RAC2',
    P15169: 'CPN1',
    P15170: 'GSPT1',
    P15172: 'MYOD1',
    P15173: 'MYOG',
    P15248: 'IL9',
    P15259: 'PGAM2',
    P15260: 'IFNGR1',
    P15289: 'ARSA',
    P15291: 'B4GALT1',
    P15309: 'ACP3',
    P15311: 'EZR',
    P15313: 'ATP6V1B1',
    P15328: 'FOLR1',
    P15336: 'ATF2',
    P15374: 'UCHL3',
    P15382: 'KCNE1',
    P15391: 'CD19',
    P15407: 'FOSL1',
    P15408: 'FOSL2',
    P15428: 'HPGD',
    P15498: 'VAV1',
    P15502: 'ELN',
    P15509: 'CSF2RA',
    P15514: 'AREG',
    P15515: 'HTN1',
    P15516: 'HTN3',
    P15529: 'CD46',
    P15531: 'NME1',
    P15538: 'CYP11B1',
    P15559: 'NQO1',
    P15586: 'GNS',
    P15622: 'ZNF250',
    P15692: 'VEGFA',
    P15735: 'PHKG2',
    P15812: 'CD1E',
    P15813: 'CD1D',
    P15814: 'IGLL1',
    P15822: 'HIVEP1',
    P15848: 'ARSB',
    P15863: 'PAX1',
    P15880: 'RPS2',
    P15882: 'CHN1',
    P15884: 'TCF4',
    P15907: 'ST6GAL1',
    P15918: 'RAG1',
    P15923: 'TCF3',
    P15924: 'DSP',
    P15927: 'RPA2',
    P15941: 'MUC1',
    P15954: 'COX7C',
    P15976: 'GATA1',
    P16035: 'TIMP2',
    P16050: 'ALOX15',
    P16066: 'NPR1',
    P16070: 'CD44',
    P16083: 'NQO2',
    P16104: 'H2AX',
    P16109: 'SELP',
    P16112: 'ACAN',
    P16118: 'PFKFB1',
    P16144: 'ITGB4',
    P16150: 'SPN',
    P16152: 'CBR1',
    P16157: 'ANK1',
    P16219: 'ACADS',
    P16220: 'CREB1',
    P16233: 'PNLIP',
    P16234: 'PDGFRA',
    P16278: 'GLB1',
    P16284: 'PECAM1',
    P16298: 'PPP3CB',
    P16333: 'NCK1',
    P16383: 'GCFC2',
    P16389: 'KCNA2',
    P16401: 'H1-5',
    P16402: 'H1-3',
    P16403: 'H1-2',
    P16410: 'CTLA4',
    P16422: 'EPCAM',
    P16435: 'POR',
    P16442: 'ABO',
    P16444: 'DPEP1',
    P16452: 'EPB42',
    P16455: 'MGMT',
    P16471: 'PRLR',
    P16473: 'TSHR',
    P16499: 'PDE6A',
    P16519: 'PCSK2',
    P16520: 'GNB3',
    P16581: 'SELE',
    P16591: 'FER',
    P16615: 'ATP2A2',
    P16619: 'CCL3L1',
    P16619: 'CCL3L3',
    P16662: 'UGT2B7',
    P16671: 'CD36',
    P16860: 'NPPB',
    P16870: 'CPE',
    P16871: 'IL7R',
    P16885: 'PLCG2',
    P16930: 'FAH',
    P16949: 'STMN1',
    P16989: 'YBX3',
    P17010: 'ZFX',
    P17014: 'ZNF12',
    P17020: 'ZNF16',
    P17021: 'ZNF17',
    P17022: 'ZNF18',
    P17023: 'ZNF19',
    P17024: 'ZNF20',
    P17027: 'ZNF23',
    P17028: 'ZNF24',
    P17036: 'ZNF3',
    P17040: 'ZSCAN20',
    P17041: 'ZNF32',
    P17050: 'NAGA',
    P17066: 'HSPA6',
    P17081: 'RHOQ',
    P17096: 'HMGA1',
    P17152: 'TMEM11',
    P17174: 'GOT1',
    P17181: 'IFNAR1',
    P17213: 'BPI',
    P17252: 'PRKCA',
    P17275: 'JUNB',
    P17301: 'ITGA2',
    P17302: 'GJA1',
    P17342: 'NPR3',
    P17405: 'SMPD1',
    P17480: 'UBTF',
    P17481: 'HOXB8',
    P17482: 'HOXB9',
    P17483: 'HOXB4',
    P17509: 'HOXB6',
    P17516: 'AKR1C4',
    P17535: 'JUND',
    P17540: 'CKMT2',
    P17542: 'TAL1',
    P17544: 'ATF7',
    P17568: 'NDUFB7',
    P17600: 'SYN1',
    P17612: 'PRKACA',
    P17643: 'TYRP1',
    P17655: 'CAPN2',
    P17658: 'KCNA6',
    P17661: 'DES',
    P17676: 'CEBPB',
    P17677: 'GAP43',
    P17693: 'HLA-G',
    P17706: 'PTPN2',
    P17707: 'AMD1',
    P17735: 'TAT',
    P17752: 'TPH1',
    P17787: 'CHRNB2',
    P17812: 'CTPS1',
    P17813: 'ENG',
    P17844: 'DDX5',
    P17858: 'PFKL',
    P17861: 'XBP1',
    P17900: 'GM2A',
    P17927: 'CR1',
    P17931: 'LGALS3',
    P17936: 'IGFBP3',
    P17947: 'SPI1',
    P17948: 'FLT1',
    P17980: 'PSMC3',
    P17987: 'TCP1',
    P18031: 'PTPN1',
    P18054: 'ALOX12',
    P18065: 'IGFBP2',
    P18074: 'ERCC2',
    P18075: 'BMP7',
    P18077: 'RPL35A',
    P18084: 'ITGB5',
    P18085: 'ARF4',
    P18089: 'ADRA2B',
    P18124: 'RPL7',
    P18146: 'EGR1',
    P18206: 'VCL',
    P18283: 'GPX2',
    P18405: 'SRD5A1',
    P18428: 'LBP',
    P18433: 'PTPRA',
    P18440: 'NAT1',
    P18505: 'GABRB1',
    P18507: 'GABRG2',
    P18509: 'ADCYAP1',
    P18510: 'IL1RN',
    P18545: 'PDE6G',
    P18564: 'ITGB6',
    P18577: 'RHCE',
    P18583: 'SON',
    P18615: 'NELFE',
    P18621: 'RPL17',
    P18627: 'LAG3',
    P18669: 'PGAM1',
    P18754: 'RCC1',
    P18825: 'ADRA2C',
    P18827: 'SDC1',
    P18846: 'ATF1',
    P18847: 'ATF3',
    P18848: 'ATF4',
    P18850: 'ATF6',
    P18858: 'LIG1',
    P18859: 'ATP5PF',
    P18887: 'XRCC1',
    P19012: 'KRT15',
    P19013: 'KRT4',
    P19021: 'PAM',
    P19022: 'CDH2',
    P19075: 'TSPAN8',
    P19086: 'GNAZ',
    P19087: 'GNAT2',
    P19099: 'CYP11B2',
    P19105: 'MYL12A',
    P19113: 'HDC',
    P19174: 'PLCG1',
    P19224: 'UGT1A6',
    P19235: 'EPOR',
    P19237: 'TNNI1',
    P19256: 'CD58',
    P19320: 'VCAM1',
    P19338: 'NCL',
    P19367: 'HK1',
    P19387: 'POLR2C',
    P19388: 'POLR2E',
    P19397: 'CD53',
    P19404: 'NDUFV2',
    P19419: 'ELK1',
    P19429: 'TNNI3',
    P19438: 'TNFRSF1A',
    P19440: 'GGT1',
    P19447: 'ERCC3',
    P19474: 'TRIM21',
    P19484: 'TFEB',
    P19525: 'EIF2AK2',
    P19526: 'FUT1',
    P19532: 'TFE3',
    P19544: 'WT1',
    P19622: 'EN2',
    P19623: 'SRM',
    P19634: 'SLC9A1',
    P19652: 'ORM2',
    P19784: 'CSNK2A2',
    P19793: 'RXRA',
    P19801: 'AOC1',
    P19823: 'ITIH2',
    P19827: 'ITIH1',
    P19835: 'CEL',
    P19838: 'NFKB1',
    P19875: 'CXCL2',
    P19876: 'CXCL3',
    P19878: 'NCF2',
    P19883: 'FST',
    P19957: 'PI3',
    P19971: 'TYMP',
    P20020: 'ATP2B1',
    P20023: 'CR2',
    P20036: 'HLA-DPA1',
    P20042: 'EIF2S2',
    P20061: 'TCN1',
    P20062: 'TCN2',
    P20073: 'ANXA7',
    P20132: 'SDS',
    P20138: 'CD33',
    P20142: 'PGC',
    P20151: 'KLK2',
    P20155: 'SPINK2',
    P20160: 'AZU1',
    P20226: 'TBP',
    P20231: 'TPSB2',
    P20248: 'CCNA2',
    P20264: 'POU3F3',
    P20265: 'POU3F2',
    P20273: 'CD22',
    P20290: 'BTF3',
    P20292: 'ALOX5AP',
    P20309: 'CHRM3',
    P20333: 'TNFRSF1B',
    P20336: 'RAB3A',
    P20337: 'RAB3B',
    P20338: 'RAB4A',
    P20339: 'RAB5A',
    P20340: 'RAB6A',
    P20366: 'TAC1',
    P20393: 'NR1D1',
    P20396: 'TRH',
    P20472: 'PVALB',
    P20585: 'MSH3',
    P20591: 'MX1',
    P20592: 'MX2',
    P20594: 'NPR2',
    P20618: 'PSMB1',
    P20645: 'M6PR',
    P20648: 'ATP4A',
    P20671: 'H2AC7',
    P20674: 'COX5A',
    P20700: 'LMNB1',
    P20701: 'ITGAL',
    P20702: 'ITGAX',
    P20711: 'DDC',
    P20718: 'GZMH',
    P20719: 'HOXA5',
    P20742: 'PZP',
    P20749: 'BCL3',
    P20774: 'OGN',
    P20783: 'NTF3',
    P20794: 'MAK',
    P20800: 'EDN2',
    P20807: 'CAPN3',
    P20809: 'IL11',
    P20810: 'CAST',
    P20813: 'CYP2B6',
    P20815: 'CYP3A5',
    P20823: 'HNF1A',
    P20827: 'EFNA1',
    P20839: 'IMPDH1',
    P20848: 'SERPINA2',
    P20849: 'COL9A1',
    P20851: 'C4BPB',
    P20853: 'CYP2A7',
    P20908: 'COL5A1',
    P20916: 'MAG',
    P20929: 'NEB',
    P20930: 'FLG',
    P20933: 'AGA',
    P20936: 'RASA1',
    P20941: 'PDC',
    P20963: 'CD247',
    P21108: 'PRPS1L1',
    P21127: 'CDK11B',
    P21128: 'ENDOU',
    P21145: 'MAL',
    P21217: 'FUT3',
    P21246: 'PTN',
    P21266: 'GSTM3',
    P21281: 'ATP6V1B2',
    P21283: 'ATP6V1C1',
    P21291: 'CSRP1',
    P21333: 'FLNA',
    P21359: 'NF1',
    P21397: 'MAOA',
    P21399: 'ACO1',
    P21439: 'ABCB4',
    P21452: 'TACR2',
    P21453: 'S1PR1',
    P21462: 'FPR1',
    P21549: 'AGXT',
    P21554: 'CNR1',
    P21579: 'SYT1',
    P21580: 'TNFAIP3',
    P21583: 'KITLG',
    P21589: 'NT5E',
    P21673: 'SAT1',
    P21675: 'TAF1',
    P21695: 'GPD1',
    P21709: 'EPHA1',
    P21728: 'DRD1',
    P21730: 'C5AR1',
    P21731: 'TBXA2R',
    P21741: 'MDK',
    P21754: 'ZP3',
    P21757: 'MSR1',
    P21781: 'FGF7',
    P21796: 'VDAC1',
    P21802: 'FGFR2',
    P21810: 'BGN',
    P21815: 'IBSP',
    P21817: 'RYR1',
    P21854: 'CD72',
    P21860: 'ERBB3',
    P21912: 'SDHB',
    P21917: 'DRD4',
    P21918: 'DRD5',
    P21926: 'CD9',
    P21941: 'MATN1',
    P21953: 'BCKDHB',
    P21964: 'COMT',
    P21980: 'TGM2',
    P22001: 'KCNA3',
    P22003: 'BMP5',
    P22004: 'BMP6',
    P22033: 'MMUT',
    P22059: 'OSBP',
    P22061: 'PCMT1',
    P22079: 'LPO',
    P22083: 'FUT4',
    P22087: 'FBL',
    P22102: 'GART',
    P22105: 'TNXB',
    P22223: 'CDH3',
    P22234: 'PAICS',
    P22301: 'IL10',
    P22303: 'ACHE',
    P22304: 'IDS',
    P22307: 'SCP2',
    P22309: 'UGT1A1',
    P22310: 'UGT1A4',
    P22314: 'UBA1',
    P22352: 'GPX3',
    P22362: 'CCL1',
    P22392: 'NME2',
    P22413: 'ENPP1',
    P22415: 'USF1',
    P22455: 'FGFR4',
    P22459: 'KCNA4',
    P22460: 'KCNA5',
    P22466: 'GAL',
    P22492: 'H1-6',
    P22528: 'SPRR1B',
    P22557: 'ALAS2',
    P22570: 'FDXR',
    P22607: 'FGFR3',
    P22612: 'PRKACG',
    P22626: 'HNRNPA2B1',
    P22670: 'RFX1',
    P22674: 'CCNO',
    P22680: 'CYP7A1',
    P22681: 'CBL',
    P22692: 'IGFBP4',
    P22694: 'PRKACB',
    P22695: 'UQCRC2',
    P22732: 'SLC2A5',
    P22735: 'TGM1',
    P22736: 'NR4A1',
    P22748: 'CA4',
    P22749: 'GNLY',
    P22760: 'AADAC',
    P22792: 'CPN2',
    P22794: 'EVI2A',
    P22830: 'FECH',
    P22888: 'LHCGR',
    P22891: 'PROZ',
    P22894: 'MMP8',
    P22897: 'MRC1',
    P22914: 'CRYGS',
    P23025: 'XPA',
    P23083: 'IGHV1-2',
    P23109: 'AMPD1',
    P23141: 'CES1',
    P23142: 'FBLN1',
    P23193: 'TCEA1',
    P23219: 'PTGS1',
    P23229: 'ITGA6',
    P23246: 'SFPQ',
    P23258: 'TUBG1',
    P23276: 'KEL',
    P23280: 'CA6',
    P23284: 'PPIB',
    P23297: 'S100A1',
    P23327: 'HRC',
    P23352: 'ANOS1',
    P23368: 'ME2',
    P23378: 'GLDC',
    P23381: 'WARS1',
    P23396: 'RPS3',
    P23409: 'MYF6',
    P23415: 'GLRA1',
    P23416: 'GLRA2',
    P23434: 'GCSH',
    P23435: 'CBLN1',
    P23443: 'RPS6KB1',
    P23458: 'JAK1',
    P23467: 'PTPRB',
    P23468: 'PTPRD',
    P23469: 'PTPRE',
    P23470: 'PTPRG',
    P23471: 'PTPRZ1',
    P23490: 'LORICRIN',
    P23497: 'SP100',
    P23508: 'MCC',
    P23510: 'TNFSF4',
    P23511: 'NFYA',
    P23515: 'OMG',
    P23526: 'AHCY',
    P23527: 'H2BC17',
    P23528: 'CFL1',
    P23560: 'BDNF',
    P23582: 'NPPC',
    P23588: 'EIF4B',
    P23610: 'F8A1',
    P23610: 'F8A2',
    P23610: 'F8A3',
    P23634: 'ATP2B4',
    P23677: 'ITPKA',
    P23743: 'DGKA',
    P23759: 'PAX7',
    P23760: 'PAX3',
    P23763: 'VAMP1',
    P23769: 'GATA2',
    P23771: 'GATA3',
    P23786: 'CPT2',
    P23919: 'DTYMK',
    P23921: 'RRM1',
    P23942: 'PRPH2',
    P23945: 'FSHR',
    P23946: 'CMA1',
    P23975: 'SLC6A2',
    P24001: 'IL32',
    P24043: 'LAMA2',
    P24046: 'GABRR1',
    P24071: 'FCAR',
    P24158: 'PRTN3',
    P24278: 'ZBTB25',
    P24298: 'GPT',
    P24310: 'COX7A1',
    P24311: 'COX7B',
    P24347: 'MMP11',
    P24385: 'CCND1',
    P24386: 'CHM',
    P24387: 'CRHBP',
    P24390: 'KDELR1',
    P24394: 'IL4R',
    P24462: 'CYP3A7',
    P24468: 'NR2F2',
    P24522: 'GADD45A',
    P24530: 'EDNRB',
    P24534: 'EEF1B2',
    P24539: 'ATP5PB',
    P24557: 'TBXAS1',
    P24588: 'AKAP5',
    P24592: 'IGFBP6',
    P24593: 'IGFBP5',
    P24666: 'ACP1',
    P24723: 'PRKCH',
    P24752: 'ACAT1',
    P24821: 'TNC',
    P24844: 'MYL9',
    P24855: 'DNASE1',
    P24863: 'CCNC',
    P24864: 'CCNE1',
    P24903: 'CYP2F1',
    P24928: 'POLR2A',
    P24941: 'CDK2',
    P25021: 'HRH2',
    P25024: 'CXCR1',
    P25025: 'CXCR2',
    P25054: 'APC',
    P25063: 'CD24',
    P25067: 'COL8A2',
    P25089: 'FPR3',
    P25090: 'FPR2',
    P25092: 'GUCY2C',
    P25098: 'GRK2',
    P25100: 'ADRA1D',
    P25101: 'EDNRA',
    P25103: 'TACR1',
    P25105: 'PTAFR',
    P25106: 'ACKR3',
    P25116: 'F2R',
    P25189: 'MPZ',
    P25205: 'MCM3',
    P25208: 'NFYB',
    P25311: 'AZGP1',
    P25325: 'MPST',
    P25391: 'LAMA1',
    P25398: 'RPS12',
    P25440: 'BRD2',
    P25445: 'FAS',
    P25490: 'YY1',
    P25685: 'DNAJB1',
    P25686: 'DNAJB2',
    P25705: 'ATP5F1A',
    P25713: 'MT3',
    P25774: 'CTSS',
    P25786: 'PSMA1',
    P25787: 'PSMA2',
    P25788: 'PSMA3',
    P25789: 'PSMA4',
    P25791: 'LMO2',
    P25800: 'LMO1',
    P25815: 'S100P',
    P25874: 'UCP1',
    P25929: 'NPY1R',
    P25940: 'COL5A3',
    P25942: 'CD40',
    P25963: 'NFKBIA',
    P26006: 'ITGA3',
    P26010: 'ITGB7',
    P26012: 'ITGB8',
    P26022: 'PTX3',
    P26038: 'MSN',
    P26045: 'PTPN3',
    P26196: 'DDX6',
    P26232: 'CTNNA2',
    P26358: 'DNMT1',
    P26367: 'PAX6',
    P26368: 'U2AF2',
    P26371: 'KRTAP5-9',
    P26373: 'RPL13',
    P26374: 'CHML',
    P26378: 'ELAVL4',
    P26436: 'ACRV1',
    P26439: 'HSD3B2',
    P26440: 'IVD',
    P26441: 'CNTF',
    P26447: 'S100A4',
    P26572: 'MGAT1',
    P26583: 'HMGB2',
    P26599: 'PTBP1',
    P26639: 'TARS1',
    P26640: 'VARS1',
    P26641: 'EEF1G',
    P26651: 'ZFP36',
    P26678: 'PLN',
    P26715: 'KLRC1',
    P26717: 'KLRC2',
    P26718: 'KLRK1',
    P26842: 'CD27',
    P26885: 'FKBP2',
    P26927: 'MST1',
    P26951: 'IL3RA',
    P26992: 'CNTFR',
    P26998: 'CRYBB3',
    P27037: 'ACVR2A',
    P27105: 'STOM',
    P27144: 'AK4',
    P27169: 'PON1',
    P27216: 'ANXA13',
    P27338: 'MAOB',
    P27348: 'YWHAQ',
    P27352: 'CBLIF',
    P27361: 'MAPK3',
    P27448: 'MARK3',
    P27449: 'ATP6V0C',
    P27469: 'G0S2',
    P27487: 'DPP4',
    P27539: 'GDF1',
    P27540: 'ARNT',
    P27544: 'CERS1',
    P27635: 'RPL10',
    P27658: 'COL8A1',
    P27694: 'RPA1',
    P27695: 'APEX1',
    P27701: 'CD82',
    P27707: 'DCK',
    P27708: 'CAD',
    P27797: 'CALR',
    P27815: 'PDE4A',
    P27816: 'MAP4',
    P27824: 'CANX',
    P27918: 'CFP',
    P27930: 'IL1R2',
    P27986: 'PIK3R1',
    P27987: 'ITPKB',
    P28039: 'AOAH',
    P28062: 'PSMB8',
    P28065: 'PSMB9',
    P28066: 'PSMA5',
    P28067: 'HLA-DMA',
    P28068: 'HLA-DMB',
    P28069: 'POU1F1',
    P28070: 'PSMB4',
    P28072: 'PSMB6',
    P28074: 'PSMB5',
    P28161: 'GSTM2',
    P28221: 'HTR1D',
    P28222: 'HTR1B',
    P28223: 'HTR2A',
    P28288: 'ABCD3',
    P28289: 'TMOD1',
    P28290: 'ITPRID2',
    P28300: 'LOX',
    P28324: 'ELK4',
    P28325: 'CST5',
    P28328: 'PEX2',
    P28329: 'CHAT',
    P28330: 'ACADL',
    P28331: 'NDUFS1',
    P28332: 'ADH6',
    P28335: 'HTR2C',
    P28336: 'NMBR',
    P28340: 'POLD1',
    P28347: 'TEAD1',
    P28356: 'HOXD9',
    P28358: 'HOXD10',
    P28360: 'MSX1',
    P28370: 'SMARCA1',
    P28472: 'GABRB3',
    P28476: 'GABRR2',
    P28482: 'MAPK1',
    P28562: 'DUSP1',
    P28566: 'HTR1E',
    P28676: 'GCA',
    P28698: 'MZF1',
    P28702: 'RXRB',
    P28715: 'ERCC5',
    P28749: 'RBL1',
    P28799: 'GRN',
    P28827: 'PTPRM',
    P28838: 'LAP3',
    P28845: 'HSD11B1',
    P28906: 'CD34',
    P28907: 'CD38',
    P28908: 'TNFRSF8',
    P29016: 'CD1B',
    P29017: 'CD1C',
    P29033: 'GJB2',
    P29034: 'S100A2',
    P29074: 'PTPN4',
    P29083: 'GTF2E1',
    P29084: 'GTF2E2',
    P29120: 'PCSK1',
    P29122: 'PCSK6',
    P29144: 'TPP2',
    P29218: 'IMPA1',
    P29274: 'ADORA2A',
    P29275: 'ADORA2B',
    P29279: 'CCN2',
    P29317: 'EPHA2',
    P29320: 'EPHA3',
    P29322: 'EPHA8',
    P29323: 'EPHB2',
    P29350: 'PTPN6',
    P29353: 'SHC1',
    P29371: 'TACR3',
    P29372: 'MPG',
    P29373: 'CRABP2',
    P29374: 'ARID4A',
    P29375: 'KDM5A',
    P29376: 'LTK',
    P29400: 'COL4A5',
    P29401: 'TKT',
    P29459: 'IL12A',
    P29460: 'IL12B',
    P29466: 'CASP1',
    P29474: 'NOS3',
    P29475: 'NOS1',
    P29508: 'SERPINB3',
    P29536: 'LMOD1',
    P29558: 'RBMS1',
    P29590: 'PML',
    P29597: 'TYK2',
    P29622: 'SERPINA4',
    P29692: 'EEF1D',
    P29728: 'OAS2',
    P29803: 'PDHA2',
    P29965: 'CD40LG',
    P29966: 'MARCKS',
    P29972: 'AQP1',
    P29973: 'CNGA1',
    P29992: 'GNA11',
    P30038: 'ALDH4A1',
    P30039: 'PBLD',
    P30040: 'ERP29',
    P30041: 'PRDX6',
    P30043: 'BLVRB',
    P30044: 'PRDX5',
    P30046: 'DDT',
    P30047: 'GCHFR',
    P30048: 'PRDX3',
    P30049: 'ATP5F1D',
    P30050: 'RPL12',
    P30084: 'ECHS1',
    P30085: 'CMPK1',
    P30086: 'PEBP1',
    P30101: 'PDIA3',
    P30153: 'PPP2R1A',
    P30154: 'PPP2R1B',
    P30203: 'CD6',
    P30260: 'CDC27',
    P30273: 'FCER1G',
    P30279: 'CCND2',
    P30281: 'CCND3',
    P30291: 'WEE1',
    P30301: 'MIP',
    P30304: 'CDC25A',
    P30305: 'CDC25B',
    P30307: 'CDC25C',
    P30405: 'PPIF',
    P30411: 'BDKRB2',
    P30414: 'NKTR',
    P30419: 'NMT1',
    P30511: 'HLA-F',
    P30518: 'AVPR2',
    P30519: 'HMOX2',
    P30520: 'ADSS2',
    P30530: 'AXL',
    P30531: 'SLC6A1',
    P30532: 'CHRNA5',
    P30533: 'LRPAP1',
    P30536: 'TSPO',
    P30542: 'ADORA1',
    P30550: 'GRPR',
    P30556: 'AGTR1',
    P30559: 'OXTR',
    P30566: 'ADSL',
    P30613: 'PKLR',
    P30622: 'CLIP1',
    P30626: 'SRI',
    P30679: 'GNA15',
    P30711: 'GSTT1',
    P30740: 'SERPINB1',
    P30793: 'GCH1',
    P30825: 'SLC7A1',
    P30837: 'ALDH1B1',
    P30838: 'ALDH3A1',
    P30872: 'SSTR1',
    P30874: 'SSTR2',
    P30876: 'POLR2B',
    P30926: 'CHRNB4',
    P30939: 'HTR1F',
    P30968: 'GNRHR',
    P30988: 'CALCR',
    P30989: 'NTSR1',
    P30990: 'NTS',
    P31025: 'LCN1',
    P31040: 'SDHA',
    P31146: 'CORO1A',
    P31150: 'GDI1',
    P31151: 'S100A7',
    P31152: 'MAPK4',
    P31153: 'MAT2A',
    P31213: 'SRD5A2',
    P31249: 'HOXD3',
    P31260: 'HOXA10',
    P31268: 'HOXA7',
    P31269: 'HOXA9',
    P31270: 'HOXA11',
    P31271: 'HOXA13',
    P31273: 'HOXC8',
    P31274: 'HOXC9',
    P31276: 'HOXC13',
    P31314: 'TLX1',
    P31321: 'PRKAR1B',
    P31323: 'PRKAR2B',
    P31327: 'CPS1',
    P31350: 'RRM2',
    P31358: 'CD52',
    P31371: 'FGF9',
    P31391: 'SSTR4',
    P31415: 'CASQ1',
    P31431: 'SDC4',
    P31483: 'TIA1',
    P31512: 'FMO4',
    P31513: 'FMO3',
    P31629: 'HIVEP2',
    P31639: 'SLC5A2',
    P31641: 'SLC6A6',
    P31644: 'GABRA5',
    P31645: 'SLC6A4',
    P31689: 'DNAJA1',
    P31749: 'AKT1',
    P31751: 'AKT2',
    P31785: 'IL2RG',
    P31930: 'UQCRC1',
    P31937: 'HIBADH',
    P31939: 'ATIC',
    P31941: 'APOBEC3A',
    P31942: 'HNRNPH3',
    P31943: 'HNRNPH1',
    P31944: 'CASP14',
    P31946: 'YWHAB',
    P31947: 'SFN',
    P31948: 'STIP1',
    P31949: 'S100A11',
    P31994: 'FCGR2B',
    P31995: 'FCGR2C',
    P31997: 'CEACAM8',
    P32004: 'L1CAM',
    P32019: 'INPP5B',
    P32119: 'PRDX2',
    P32121: 'ARRB2',
    P32189: 'GK',
    P32238: 'CCKAR',
    P32239: 'CCKBR',
    P32241: 'VIPR1',
    P32242: 'OTX1',
    P32243: 'OTX2',
    P32245: 'MC4R',
    P32246: 'CCR1',
    P32247: 'BRS3',
    P32248: 'CCR7',
    P32249: 'GPR183',
    P32297: 'CHRNA3',
    P32298: 'GRK4',
    P32302: 'CXCR5',
    P32320: 'CDA',
    P32321: 'DCTD',
    P32322: 'PYCR1',
    P32418: 'SLC8A1',
    P32455: 'GBP1',
    P32456: 'GBP2',
    P32519: 'ELF1',
    P32745: 'SSTR3',
    P32754: 'HPD',
    P32780: 'GTF2H1',
    P32856: 'STX2',
    P32881: 'IFNA8',
    P32926: 'DSG3',
    P32927: 'CSF2RB',
    P32929: 'CTH',
    P32942: 'ICAM3',
    P32969: 'RPL9',
    P32969: 'RPL9P7',
    P32969: 'RPL9P8',
    P32969: 'RPL9P9',
    P32970: 'CD70',
    P32971: 'TNFSF8',
    P33032: 'MC5R',
    P33076: 'CIITA',
    P33121: 'ACSL1',
    P33151: 'CDH5',
    P33176: 'KIF5B',
    P33240: 'CSTF2',
    P33241: 'LSP1',
    P33260: 'CYP2C18',
    P33261: 'CYP2C19',
    P33316: 'DUT',
    P33402: 'GUCY1A2',
    P33527: 'ABCC1',
    P33681: 'CD80',
    P33763: 'S100A5',
    P33764: 'S100A3',
    P33778: 'H2BC3',
    P33897: 'ABCD1',
    P33908: 'MAN1A1',
    P33947: 'KDELR2',
    P33981: 'TTK',
    P33991: 'MCM4',
    P33992: 'MCM5',
    P33993: 'MCM7',
    P34059: 'GALNS',
    P34096: 'RNASE4',
    P34130: 'NTF4',
    P34741: 'SDC2',
    P34810: 'CD68',
    P34896: 'SHMT1',
    P34897: 'SHMT2',
    P34903: 'GABRA3',
    P34910: 'EVI2B',
    P34913: 'EPHX2',
    P34925: 'RYK',
    P34931: 'HSPA1L',
    P34932: 'HSPA4',
    P34947: 'GRK5',
    P34949: 'MPI',
    P34969: 'HTR7',
    P34972: 'CNR2',
    P34981: 'TRHR',
    P34982: 'OR1D2',
    P34995: 'PTGER1',
    P34998: 'CRHR1',
    P35030: 'PRSS3',
    P35052: 'GPC1',
    P35070: 'BTC',
    P35080: 'PFN2',
    P35125: 'USP6',
    P35212: 'GJA4',
    P35218: 'CA5A',
    P35219: 'CA8',
    P35221: 'CTNNA1',
    P35222: 'CTNNB1',
    P35225: 'IL13',
    P35226: 'BMI1',
    P35227: 'PCGF2',
    P35228: 'NOS2',
    P35232: 'PHB1',
    P35236: 'PTPN7',
    P35237: 'SERPINB6',
    P35240: 'NF2',
    P35241: 'RDX',
    P35243: 'RCVRN',
    P35244: 'RPA3',
    P35247: 'SFTPD',
    P35249: 'RFC4',
    P35250: 'RFC2',
    P35251: 'RFC1',
    P35268: 'RPL22',
    P35269: 'GTF2F1',
    P35270: 'SPR',
    P35318: 'ADM',
    P35321: 'SPRR1A',
    P35326: 'SPRR2A',
    P35346: 'SSTR5',
    P35348: 'ADRA1A',
    P35354: 'PTGS2',
    P35367: 'HRH1',
    P35368: 'ADRA1B',
    P35372: 'OPRM1',
    P35398: 'RORA',
    P35408: 'PTGER4',
    P35414: 'APLNR',
    P35442: 'THBS2',
    P35443: 'THBS4',
    P35452: 'HOXD12',
    P35453: 'HOXD13',
    P35462: 'DRD3',
    P35475: 'IDUA',
    P35498: 'SCN1A',
    P35499: 'SCN4A',
    P35503: 'UGT1A3',
    P35504: 'UGT1A5',
    P35520: 'CBS',
    P35523: 'CLCN1',
    P35527: 'KRT9',
    P35548: 'MSX2',
    P35555: 'FBN1',
    P35556: 'FBN2',
    P35557: 'GCK',
    P35558: 'PCK1',
    P35568: 'IRS1',
    P35573: 'AGL',
    P35575: 'G6PC1',
    P35579: 'MYH9',
    P35580: 'MYH10',
    P35590: 'TIE1',
    P35606: 'COPB2',
    P35609: 'ACTN2',
    P35610: 'SOAT1',
    P35611: 'ADD1',
    P35612: 'ADD2',
    P35613: 'BSG',
    P35625: 'TIMP3',
    P35626: 'GRK3',
    P35637: 'FUS',
    P35638: 'DDIT3',
    P35658: 'NUP214',
    P35659: 'DEK',
    P35670: 'ATP7B',
    P35680: 'HNF1B',
    P35711: 'SOX5',
    P35712: 'SOX6',
    P35713: 'SOX18',
    P35716: 'SOX11',
    P35749: 'MYH11',
    P35754: 'GLRX',
    P35789: 'ZNF93',
    P35790: 'CHKA',
    P35813: 'PPM1A',
    P35858: 'IGFALS',
    P35869: 'AHR',
    P35900: 'KRT20',
    P35908: 'KRT2',
    P35913: 'PDE6B',
    P35914: 'HMGCL',
    P35916: 'FLT4',
    P35968: 'KDR',
    P35998: 'PSMC2',
    P36021: 'SLC16A2',
    P36222: 'CHI3L1',
    P36268: 'GGT2P',
    P36269: 'GGT5',
    P36382: 'GJA5',
    P36383: 'GJC1',
    P36402: 'TCF7',
    P36404: 'ARL2',
    P36405: 'ARL3',
    P36406: 'TRIM23',
    P36507: 'MAP2K2',
    P36508: 'ZNF76',
    P36542: 'ATP5F1C',
    P36543: 'ATP6V1E1',
    P36544: 'CHRNA7',
    P36551: 'CPOX',
    P36575: 'ARR3',
    P36578: 'RPL4',
    P36639: 'NUDT1',
    P36776: 'LONP1',
    P36871: 'PGM1',
    P36873: 'PPP1CC',
    P36888: 'FLT3',
    P36894: 'BMPR1A',
    P36896: 'ACVR1B',
    P36897: 'TGFBR1',
    P36941: 'LTBR',
    P36952: 'SERPINB5',
    P36954: 'POLR2I',
    P36955: 'SERPINF1',
    P36956: 'SREBF1',
    P36957: 'DLST',
    P36959: 'GMPR',
    P36969: 'GPX4',
    P36980: 'CFHR2',
    P37023: 'ACVRL1',
    P37058: 'HSD17B3',
    P37059: 'HSD17B2',
    P37088: 'SCNN1A',
    P37108: 'SRP14',
    P37173: 'TGFBR2',
    P37198: 'NUP62',
    P37231: 'PPARG',
    P37235: 'HPCAL1',
    P37268: 'FDFT1',
    P37275: 'ZEB1',
    P37287: 'PIGA',
    P37288: 'AVPR1A',
    P37802: 'TAGLN2',
    P37837: 'TALDO1',
    P37840: 'SNCA',
    P38117: 'ETFB',
    P38159: 'RBMX',
    P38398: 'BRCA1',
    P38405: 'GNAL',
    P38432: 'COIL',
    P38435: 'GGCX',
    P38484: 'IFNGR2',
    P38567: 'SPAM1',
    P38570: 'ITGAE',
    P38571: 'LIPA',
    P38606: 'ATP6V1A',
    P38646: 'HSPA9',
    P38919: 'EIF4A3',
    P38935: 'IGHMBP2',
    P38936: 'CDKN1A',
    P39019: 'RPS19',
    P39023: 'RPL3',
    P39059: 'COL15A1',
    P39060: 'COL18A1',
    P39086: 'GRIK1',
    P39210: 'MPV17',
    P39656: 'DDOST',
    P39687: 'ANP32A',
    P39748: 'FEN1',
    P39877: 'PLA2G5',
    P39880: 'CUX1',
    P39900: 'MMP12',
    P39905: 'GDNF',
    P40121: 'CAPG',
    P40123: 'CAP2',
    P40126: 'DCT',
    P40145: 'ADCY8',
    P40189: 'IL6ST',
    P40197: 'GP5',
    P40198: 'CEACAM3',
    P40199: 'CEACAM6',
    P40200: 'CD96',
    P40222: 'TXLNA',
    P40225: 'THPO',
    P40227: 'CCT6A',
    P40238: 'MPL',
    P40259: 'CD79B',
    P40261: 'NNMT',
    P40305: 'IFI27',
    P40306: 'PSMB10',
    P40337: 'VHL',
    P40394: 'ADH7',
    P40424: 'PBX1',
    P40425: 'PBX2',
    P40426: 'PBX3',
    P40429: 'RPL13A',
    P40616: 'ARL1',
    P40617: 'ARL4A',
    P40692: 'MLH1',
    P40763: 'STAT3',
    P40818: 'USP8',
    P40855: 'PEX19',
    P40879: 'SLC26A3',
    P40925: 'MDH1',
    P40926: 'MDH2',
    P40933: 'IL15',
    P40937: 'RFC5',
    P40938: 'RFC3',
    P40939: 'HADHA',
    P40967: 'PMEL',
    P41002: 'CCNF',
    P41091: 'EIF2S3',
    P41134: 'ID1',
    P41143: 'OPRD1',
    P41145: 'OPRK1',
    P41146: 'OPRL1',
    P41159: 'LEP',
    P41161: 'ETV5',
    P41162: 'ETV3',
    P41180: 'CASR',
    P41181: 'AQP2',
    P41182: 'BCL6',
    P41208: 'CETN2',
    P41212: 'ETV6',
    P41214: 'EIF2D',
    P41217: 'CD200',
    P41218: 'MNDA',
    P41219: 'PRPH',
    P41220: 'RGS2',
    P41221: 'WNT5A',
    P41222: 'PTGDS',
    P41223: 'BUD31',
    P41225: 'SOX3',
    P41226: 'UBA7',
    P41227: 'NAA10',
    P41229: 'KDM5C',
    P41231: 'P2RY2',
    P41235: 'HNF4A',
    P41236: 'PPP1R2',
    P41238: 'APOBEC1',
    P41240: 'CSK',
    P41247: 'PNPLA4',
    P41250: 'GARS1',
    P41252: 'IARS1',
    P41271: 'NBL1',
    P41273: 'TNFSF9',
    P41279: 'MAP3K8',
    P41439: 'FOLR3',
    P41440: 'SLC19A1',
    P41567: 'EIF1',
    P41586: 'ADCYAP1R1',
    P41587: 'VIPR2',
    P41594: 'GRM5',
    P41595: 'HTR2B',
    P41597: 'CCR2',
    P41732: 'TSPAN7',
    P41743: 'PRKCI',
    P41968: 'MC3R',
    P41970: 'ELK3',
    P42025: 'ACTR1B',
    P42081: 'CD86',
    P42126: 'ECI1',
    P42127: 'ASIP',
    P42166: 'TMPO',
    P42167: 'TMPO',
    P42224: 'STAT1',
    P42226: 'STAT6',
    P42229: 'STAT5A',
    P42261: 'GRIA1',
    P42262: 'GRIA2',
    P42263: 'GRIA3',
    P42285: 'MTREX',
    P42330: 'AKR1C3',
    P42331: 'ARHGAP25',
    P42336: 'PIK3CA',
    P42338: 'PIK3CB',
    P42345: 'MTOR',
    P42356: 'PI4KA',
    P42357: 'HAL',
    P42566: 'EPS15',
    P42568: 'MLLT3',
    P42574: 'CASP3',
    P42575: 'CASP2',
    P42658: 'DPP6',
    P42677: 'RPS27',
    P42679: 'MATK',
    P42680: 'TEC',
    P42681: 'TXK',
    P42684: 'ABL2',
    P42685: 'FRK',
    P42694: 'HELZ',
    P42695: 'NCAPD3',
    P42701: 'IL12RB1',
    P42702: 'LIFR',
    P42704: 'LRPPRC',
    P42765: 'ACAA2',
    P42766: 'RPL35',
    P42768: 'WAS',
    P42771: 'CDKN2A',
    P42772: 'CDKN2B',
    P42773: 'CDKN2C',
    P42785: 'PRCP',
    P42830: 'CXCL5',
    P42857: 'NSG1',
    P42858: 'HTT',
    P42892: 'ECE1',
    P42898: 'MTHFR',
    P43003: 'SLC1A3',
    P43004: 'SLC1A2',
    P43005: 'SLC1A1',
    P43007: 'SLC1A4',
    P43026: 'GDF5',
    P43034: 'PAFAH1B1',
    P43080: 'GUCA1A',
    P43088: 'PTGFR',
    P43115: 'PTGER3',
    P43119: 'PTGIR',
    P43121: 'MCAM',
    P43146: 'DCC',
    P43155: 'CRAT',
    P43166: 'CA7',
    P43220: 'GLP1R',
    P43234: 'CTSO',
    P43235: 'CTSK',
    P43243: 'MATR3',
    P43246: 'MSH2',
    P43250: 'GRK6',
    P43251: 'BTD',
    P43268: 'ETV4',
    P43304: 'GPD2',
    P43307: 'SSR1',
    P43320: 'CRYBB2',
    P43351: 'RAD52',
    P43353: 'ALDH3B1',
    P43354: 'NR4A2',
    P43355: 'MAGEA1',
    P43356: 'MAGEA2',
    P43356: 'MAGEA2B',
    P43357: 'MAGEA3',
    P43358: 'MAGEA4',
    P43360: 'MAGEA6',
    P43361: 'MAGEA8',
    P43364: 'MAGEA11',
    P43365: 'MAGEA12',
    P43378: 'PTPN9',
    P43403: 'ZAP70',
    P43405: 'SYK',
    P43487: 'RANBP1',
    P43489: 'TNFRSF4',
    P43490: 'NAMPT',
    P43626: 'KIR2DL1',
    P43628: 'KIR2DL3',
    P43629: 'KIR3DL1',
    P43630: 'KIR3DL2',
    P43631: 'KIR2DS2',
    P43632: 'KIR2DS4',
    P43652: 'AFM',
    P43657: 'LPAR6',
    P43681: 'CHRNA4',
    P43686: 'PSMC4',
    P43694: 'GATA4',
    P43699: 'NKX2-1',
    P43897: 'TSFM',
    P45378: 'TNNT3',
    P45379: 'TNNT2',
    P45381: 'ASPA',
    P45452: 'MMP13',
    P45844: 'ABCG1',
    P45877: 'PPIC',
    P45880: 'VDAC2',
    P45954: 'ACADSB',
    P45973: 'CBX5',
    P45974: 'USP5',
    P45983: 'MAPK8',
    P45984: 'MAPK9',
    P45985: 'MAP2K4',
    P46013: 'MKI67',
    P46019: 'PHKA2',
    P46020: 'PHKA1',
    P46059: 'SLC15A1',
    P46060: 'RANGAP1',
    P46063: 'RECQL',
    P46087: 'NOP2',
    P46089: 'GPR3',
    P46091: 'CMKLR2',
    P46092: 'CCR10',
    P46093: 'GPR4',
    P46094: 'XCR1',
    P46098: 'HTR3A',
    P46100: 'ATRX',
    P46108: 'CRK',
    P46109: 'CRKL',
    P46199: 'MTIF2',
    P46379: 'BAG6',
    P46439: 'GSTM5',
    P46459: 'NSF',
    P46527: 'CDKN1B',
    P46531: 'NOTCH1',
    P46597: 'ASMT',
    P46663: 'BDKRB1',
    P46695: 'IER3',
    P46721: 'SLCO1A2',
    P46734: 'MAP2K3',
    P46736: 'BRCC3',
    P46776: 'RPL27A',
    P46777: 'RPL5',
    P46778: 'RPL21',
    P46779: 'RPL28',
    P46781: 'RPS9',
    P46782: 'RPS5',
    P46783: 'RPS10',
    P46821: 'MAP1B',
    P46926: 'GNPDA1',
    P46934: 'NEDD4',
    P46937: 'YAP1',
    P46939: 'UTRN',
    P46940: 'IQGAP1',
    P46952: 'HAAO',
    P46976: 'GYG1',
    P46977: 'STT3A',
    P47211: 'GALR1',
    P47224: 'RABIF',
    P47710: 'CSN1S1',
    P47712: 'PLA2G4A',
    P47736: 'RAP1GAP',
    P47755: 'CAPZA2',
    P47756: 'CAPZB',
    P47804: 'RGR',
    P47813: 'EIF1AX',
    P47869: 'GABRA2',
    P47870: 'GABRB2',
    P47871: 'GCGR',
    P47872: 'SCTR',
    P47895: 'ALDH1A3',
    P47897: 'QARS1',
    P47898: 'HTR5A',
    P47900: 'P2RY1',
    P47901: 'AVPR1B',
    P47902: 'CDX1',
    P47914: 'RPL29',
    P47928: 'ID4',
    P47929: 'LGALS7',
    P47929: 'LGALS7B',
    P47974: 'ZFP36L2',
    P47985: 'UQCRFS1',
    P47989: 'XDH',
    P47992: 'XCL1',
    P48023: 'FASLG',
    P48029: 'SLC6A8',
    P48039: 'MTNR1A',
    P48047: 'ATP5PO',
    P48048: 'KCNJ1',
    P48050: 'KCNJ4',
    P48051: 'KCNJ6',
    P48052: 'CPA2',
    P48058: 'GRIA4',
    P48059: 'LIMS1',
    P48061: 'CXCL12',
    P48065: 'SLC6A12',
    P48066: 'SLC6A11',
    P48067: 'SLC6A9',
    P48145: 'NPBWR1',
    P48146: 'NPBWR2',
    P48147: 'PREP',
    P48163: 'ME1',
    P48165: 'GJA8',
    P48167: 'GLRB',
    P48169: 'GABRA4',
    P48200: 'IREB2',
    P48201: 'ATP5MC3',
    P48230: 'TM4SF4',
    P48304: 'REG1B',
    P48307: 'TFPI2',
    P48357: 'LEPR',
    P48378: 'RFX2',
    P48380: 'RFX3',
    P48382: 'RFX5',
    P48426: 'PIP4K2A',
    P48431: 'SOX2',
    P48436: 'SOX9',
    P48443: 'RXRG',
    P48444: 'ARCN1',
    P48448: 'ALDH3B2',
    P48449: 'LSS',
    P48454: 'PPP3CC',
    P48506: 'GCLC',
    P48507: 'GCLM',
    P48509: 'CD151',
    P48539: 'PCP4',
    P48544: 'KCNJ5',
    P48546: 'GIPR',
    P48547: 'KCNC1',
    P48549: 'KCNJ3',
    P48551: 'IFNAR2',
    P48552: 'NRIP1',
    P48553: 'TRAPPC10',
    P48556: 'PSMD8',
    P48594: 'SERPINB4',
    P48595: 'SERPINB10',
    P48634: 'PRRC2A',
    P48637: 'GSS',
    P48643: 'CCT5',
    P48645: 'NMU',
    P48651: 'PTDSS1',
    P48664: 'SLC1A6',
    P48668: 'KRT6C',
    P48681: 'NES',
    P48723: 'HSPA13',
    P48728: 'AMT',
    P48729: 'CSNK1A1',
    P48730: 'CSNK1D',
    P48735: 'IDH2',
    P48736: 'PIK3CG',
    P48739: 'PITPNB',
    P48740: 'MASP1',
    P48742: 'LHX1',
    P48745: 'CCN3',
    P48751: 'SLC4A3',
    P48764: 'SLC9A3',
    P48775: 'TDO2',
    P48788: 'TNNI2',
    P48960: 'ADGRE5',
    P48995: 'TRPC1',
    P49005: 'POLD2',
    P49006: 'MARCKSL1',
    P49019: 'HCAR3',
    P49023: 'PXN',
    P49069: 'CAMLG',
    P49116: 'NR2C2',
    P49137: 'MAPKAPK2',
    P49146: 'NPY2R',
    P49184: 'DNASE1L1',
    P49189: 'ALDH9A1',
    P49190: 'PTH2R',
    P49207: 'RPL34',
    P49221: 'TGM4',
    P49238: 'CX3CR1',
    P49247: 'RPIA',
    P49257: 'LMAN1',
    P49279: 'SLC11A1',
    P49281: 'SLC11A2',
    P49286: 'MTNR1B',
    P49321: 'NASP',
    P49326: 'FMO5',
    P49327: 'FASN',
    P49335: 'POU3F4',
    P49336: 'CDK8',
    P49354: 'FNTA',
    P49356: 'FNTB',
    P49366: 'DHPS',
    P49368: 'CCT3',
    P49407: 'ARRB1',
    P49411: 'TUFM',
    P49418: 'AMPH',
    P49419: 'ALDH7A1',
    P49427: 'CDC34',
    P49441: 'INPP1',
    P49447: 'CYB561',
    P49448: 'GLUD2',
    P49450: 'CENPA',
    P49454: 'CENPF',
    P49458: 'SRP9',
    P49459: 'UBE2A',
    P49585: 'PCYT1A',
    P49588: 'AARS1',
    P49589: 'CARS1',
    P49590: 'HARS2',
    P49591: 'SARS1',
    P49593: 'PPM1F',
    P49619: 'DGKG',
    P49638: 'TTPA',
    P49639: 'HOXA1',
    P49640: 'EVX1',
    P49641: 'MAN2A2',
    P49642: 'PRIM1',
    P49643: 'PRIM2',
    P49662: 'CASP4',
    P49674: 'CSNK1E',
    P49675: 'STAR',
    P49682: 'CXCR3',
    P49683: 'PRLHR',
    P49685: 'GPR15',
    P49703: 'ARL4D',
    P49711: 'CTCF',
    P49715: 'CEBPA',
    P49716: 'CEBPD',
    P49720: 'PSMB3',
    P49721: 'PSMB2',
    P49736: 'MCM2',
    P49746: 'THBS3',
    P49747: 'COMP',
    P49748: 'ACADVL',
    P49750: 'YLPM1',
    P49753: 'ACOT2',
    P49754: 'VPS41',
    P49755: 'TMED10',
    P49756: 'RBM25',
    P49757: 'NUMB',
    P49758: 'RGS6',
    P49759: 'CLK1',
    P49760: 'CLK2',
    P49761: 'CLK3',
    P49763: 'PGF',
    P49765: 'VEGFB',
    P49767: 'VEGFC',
    P49768: 'PSEN1',
    P49770: 'EIF2B2',
    P49771: 'FLT3LG',
    P49773: 'HINT1',
    P49788: 'RARRES1',
    P49789: 'FHIT',
    P49790: 'NUP153',
    P49792: 'RANBP2',
    P49795: 'RGS19',
    P49796: 'RGS3',
    P49798: 'RGS4',
    P49802: 'RGS7',
    P49810: 'PSEN2',
    P49815: 'TSC2',
    P49821: 'NDUFV1',
    P49840: 'GSK3A',
    P49841: 'GSK3B',
    P49842: 'STK19',
    P49848: 'TAF6',
    P49862: 'KLK7',
    P49863: 'GZMK',
    P49888: 'SULT1E1',
    P49895: 'DIO1',
    P49901: 'SMCP',
    P49902: 'NT5C2',
    P49903: 'SEPHS1',
    P49908: 'SELENOP',
    P49910: 'ZNF165',
    P49913: 'CAMP',
    P49914: 'MTHFS',
    P49915: 'GMPS',
    P49916: 'LIG3',
    P49917: 'LIG4',
    P49918: 'CDKN1C',
    P49959: 'MRE11',
    P49961: 'ENTPD1',
    P50052: 'AGTR2',
    P50053: 'KHK',
    P50135: 'HNMT',
    P50148: 'GNAQ',
    P50150: 'GNG4',
    P50151: 'GNG10',
    P50213: 'IDH3A',
    P50219: 'MNX1',
    P50221: 'MEOX1',
    P50222: 'MEOX2',
    P50225: 'SULT1A1',
    P50226: 'SULT1A2',
    P50238: 'CRIP1',
    P50281: 'MMP14',
    P50336: 'PPOX',
    P50391: 'NPY4R',
    P50395: 'GDI2',
    P50402: 'EMD',
    P50406: 'HTR6',
    P50416: 'CPT1A',
    P50440: 'GATM',
    P50443: 'SLC26A2',
    P50452: 'SERPINB8',
    P50453: 'SERPINB9',
    P50454: 'SERPINH1',
    P50458: 'LHX2',
    P50461: 'CSRP3',
    P50479: 'PDLIM4',
    P50502: 'ST13',
    P50539: 'MXI1',
    P50542: 'PEX5',
    P50548: 'ERF',
    P50549: 'ETV1',
    P50552: 'VASP',
    P50553: 'ASCL1',
    P50570: 'DNM2',
    P50579: 'METAP2',
    P50583: 'NUDT2',
    P50591: 'TNFSF10',
    P50607: 'TUB',
    P50613: 'CDK7',
    P50616: 'TOB1',
    P50747: 'HLCS',
    P50748: 'KNTC1',
    P50749: 'RASSF2',
    P50750: 'CDK9',
    P50851: 'LRBA',
    P50876: 'RNF144A',
    P50895: 'BCAM',
    P50897: 'PPT1',
    P50914: 'RPL14',
    P50990: 'CCT8',
    P50991: 'CCT4',
    P50993: 'ATP1A2',
    P50995: 'ANXA11',
    P51003: 'PAPOLA',
    P51114: 'FXR1',
    P51116: 'FXR2',
    P51124: 'GZMM',
    P51148: 'RAB5C',
    P51149: 'RAB7A',
    P51151: 'RAB9A',
    P51153: 'RAB13',
    P51157: 'RAB28',
    P51159: 'RAB27A',
    P51160: 'PDE6C',
    P51161: 'FABP6',
    P51164: 'ATP4B',
    P51168: 'SCNN1B',
    P51170: 'SCNN1G',
    P51172: 'SCNN1D',
    P51178: 'PLCD1',
    P51397: 'DAP',
    P51398: 'DAP3',
    P51449: 'RORC',
    P51451: 'BLK',
    P51452: 'DUSP3',
    P51460: 'INSL3',
    P51511: 'MMP15',
    P51512: 'MMP16',
    P51513: 'NOVA1',
    P51530: 'DNA2',
    P51531: 'SMARCA2',
    P51532: 'SMARCA4',
    P51553: 'IDH3G',
    P51570: 'GALK1',
    P51571: 'SSR4',
    P51572: 'BCAP31',
    P51575: 'P2RX1',
    P51580: 'TPMT',
    P51582: 'P2RY4',
    P51587: 'BRCA2',
    P51589: 'CYP2J2',
    P51606: 'RENBP',
    P51608: 'MECP2',
    P51610: 'HCFC1',
    P51617: 'IRAK1',
    P51636: 'CAV2',
    P51648: 'ALDH3A2',
    P51649: 'ALDH5A1',
    P51654: 'GPC3',
    P51659: 'HSD17B4',
    P51665: 'PSMD7',
    P51668: 'UBE2D1',
    P51671: 'CCL11',
    P51674: 'GPM6A',
    P51677: 'CCR3',
    P51679: 'CCR4',
    P51681: 'CCR5',
    P51684: 'CCR6',
    P51685: 'CCR8',
    P51686: 'CCR9',
    P51687: 'SUOX',
    P51688: 'SGSH',
    P51690: 'ARSL',
    P51692: 'STAT5B',
    P51693: 'APLP1',
    P51784: 'USP11',
    P51787: 'KCNQ1',
    P51788: 'CLCN2',
    P51790: 'CLCN3',
    P51793: 'CLCN4',
    P51795: 'CLCN5',
    P51797: 'CLCN6',
    P51798: 'CLCN7',
    P51800: 'CLCNKA',
    P51801: 'CLCNKB',
    P51805: 'PLXNA3',
    P51808: 'DYNLT3',
    P51809: 'VAMP7',
    P51810: 'GPR143',
    P51811: 'XK',
    P51812: 'RPS6KA3',
    P51813: 'BMX',
    P51814: 'ZNF41',
    P51816: 'AFF2',
    P51817: 'PRKX',
    P51825: 'AFF1',
    P51826: 'AFF3',
    P51828: 'ADCY7',
    P51841: 'GUCY2F',
    P51843: 'NR0B1',
    P51854: 'TKTL1',
    P51857: 'AKR1D1',
    P51858: 'HDGF',
    P51864: 'TDGF1P3',
    P51878: 'CASP5',
    P51884: 'LUM',
    P51888: 'PRELP',
    P51946: 'CCNH',
    P51948: 'MNAT1',
    P51955: 'NEK2',
    P51956: 'NEK3',
    P51957: 'NEK4',
    P51959: 'CCNG1',
    P51965: 'UBE2E1',
    P51970: 'NDUFA8',
    P51991: 'HNRNPA3',
    P51993: 'FUT6',
    P52179: 'MYOM1',
    P52198: 'RND2',
    P52209: 'PGD',
    P52272: 'HNRNPM',
    P52292: 'KPNA2',
    P52294: 'KPNA1',
    P52298: 'NCBP2',
    P52306: 'RAP1GDS1',
    P52333: 'JAK3',
    P52429: 'DGKE',
    P52434: 'POLR2H',
    P52435: 'POLR2J',
    P52564: 'MAP2K6',
    P52565: 'ARHGDIA',
    P52566: 'ARHGDIB',
    P52569: 'SLC7A2',
    P52594: 'AGFG1',
    P52597: 'HNRNPF',
    P52630: 'STAT2',
    P52655: 'GTF2A1',
    P52657: 'GTF2A2',
    P52701: 'MSH6',
    P52732: 'KIF11',
    P52735: 'VAV2',
    P52736: 'ZNF133',
    P52738: 'ZNF140',
    P52739: 'ZNF131',
    P52742: 'ZNF135',
    P52744: 'ZNF138',
    P52747: 'ZNF143',
    P52756: 'RBM5',
    P52757: 'CHN2',
    P52758: 'RIDA',
    P52788: 'SMS',
    P52789: 'HK2',
    P52790: 'HK3',
    P52797: 'EFNA3',
    P52798: 'EFNA4',
    P52799: 'EFNB2',
    P52803: 'EFNA5',
    P52815: 'MRPL12',
    P52823: 'STC1',
    P52824: 'DGKQ',
    P52848: 'NDST1',
    P52849: 'NDST2',
    P52888: 'THOP1',
    P52895: 'AKR1C2',
    P52907: 'CAPZA1',
    P52926: 'HMGA2',
    P52945: 'PDX1',
    P52948: 'NUP98',
    P52951: 'GBX2',
    P52952: 'NKX2-5',
    P52954: 'LBX1',
    P52961: 'ART1',
    P53004: 'BLVRA',
    P53007: 'SLC25A1',
    P53041: 'PPP5C',
    P53350: 'PLK1',
    P53355: 'DAPK1',
    P53365: 'ARFIP2',
    P53367: 'ARFIP1',
    P53370: 'NUDT6',
    P53384: 'NUBP1',
    P53396: 'ACLY',
    P53420: 'COL4A4',
    P53539: 'FOSB',
    P53567: 'CEBPG',
    P53582: 'METAP1',
    P53597: 'SUCLG1',
    P53602: 'MVD',
    P53609: 'PGGT1B',
    P53611: 'RABGGTB',
    P53618: 'COPB1',
    P53621: 'COPA',
    P53634: 'CTSC',
    P53667: 'LIMK1',
    P53671: 'LIMK2',
    P53672: 'CRYBA2',
    P53673: 'CRYBA4',
    P53674: 'CRYBB1',
    P53675: 'CLTCL1',
    P53677: 'AP3M2',
    P53680: 'AP2S1',
    P53701: 'HCCS',
    P53708: 'ITGA8',
    P53778: 'MAPK12',
    P53779: 'MAPK10',
    P53794: 'SLC5A3',
    P53801: 'PTTG1IP',
    P53803: 'POLR2K',
    P53804: 'TTC3',
    P53805: 'RCAN1',
    P53814: 'SMTN',
    P53816: 'PLAAT3',
    P53985: 'SLC16A1',
    P53990: 'IST1',
    P53992: 'SEC24C',
    P53999: 'SUB1',
    P54098: 'POLG',
    P54105: 'CLNS1A',
    P54107: 'CRISP1',
    P54108: 'CRISP3',
    P54132: 'BLM',
    P54136: 'RARS1',
    P54198: 'HIRA',
    P54219: 'SLC18A1',
    P54252: 'ATXN3',
    P54253: 'ATXN1',
    P54257: 'HAP1',
    P54259: 'ATN1',
    P54274: 'TERF1',
    P54277: 'PMS1',
    P54278: 'PMS2',
    P54284: 'CACNB3',
    P54289: 'CACNA2D1',
    P54296: 'MYOM2',
    P54315: 'PNLIPRP1',
    P54317: 'PNLIPRP2',
    P54368: 'OAZ1',
    P54577: 'YARS1',
    P54578: 'USP14',
    P54619: 'PRKAG1',
    P54646: 'PRKAA2',
    P54652: 'HSPA2',
    P54687: 'BCAT1',
    P54707: 'ATP12A',
    P54709: 'ATP1B3',
    P54710: 'FXYD2',
    P54725: 'RAD23A',
    P54727: 'RAD23B',
    P54750: 'PDE1A',
    P54753: 'EPHB3',
    P54756: 'EPHA5',
    P54760: 'EPHB4',
    P54762: 'EPHB1',
    P54764: 'EPHA4',
    P54802: 'NAGLU',
    P54803: 'GALC',
    P54819: 'AK2',
    P54821: 'PRRX1',
    P54829: 'PTPN5',
    P54840: 'GYS2',
    P54845: 'NRL',
    P54849: 'EMP1',
    P54851: 'EMP2',
    P54852: 'EMP3',
    P54855: 'UGT2B15',
    P54868: 'HMGCS2',
    P54886: 'ALDH18A1',
    P54920: 'NAPA',
    P54922: 'ADPRH',
    P55000: 'SLURP1',
    P55001: 'MFAP2',
    P55008: 'AIF1',
    P55010: 'EIF5',
    P55011: 'SLC12A2',
    P55017: 'SLC12A3',
    P55036: 'PSMD4',
    P55039: 'DRG2',
    P55040: 'GEM',
    P55042: 'RRAD',
    P55055: 'NR1H2',
    P55056: 'APOC4',
    P55058: 'PLTP',
    P55060: 'CSE1L',
    P55061: 'TMBIM6',
    P55064: 'AQP5',
    P55072: 'VCP',
    P55073: 'DIO3',
    P55075: 'FGF8',
    P55081: 'MFAP1',
    P55083: 'MFAP4',
    P55084: 'HADHB',
    P55085: 'F2RL1',
    P55087: 'AQP4',
    P55089: 'UCN',
    P55107: 'GDF10',
    P55145: 'MANF',
    P55157: 'MTTP',
    P55160: 'NCKAP1L',
    P55196: 'AFDN',
    P55197: 'MLLT10',
    P55198: 'MLLT6',
    P55199: 'ELL',
    P55201: 'BRPF1',
    P55209: 'NAP1L1',
    P55210: 'CASP7',
    P55211: 'CASP9',
    P55212: 'CASP6',
    P55259: 'GP2',
    P55263: 'ADK',
    P55265: 'ADAR',
    P55268: 'LAMB2',
    P55273: 'CDKN2D',
    P55283: 'CDH4',
    P55285: 'CDH6',
    P55286: 'CDH8',
    P55287: 'CDH11',
    P55289: 'CDH12',
    P55290: 'CDH13',
    P55291: 'CDH15',
    P55316: 'FOXG1',
    P55317: 'FOXA1',
    P55318: 'FOXA3',
    P55327: 'TPD52',
    P55344: 'LIM2',
    P55345: 'PRMT2',
    P55347: 'PKNOX1',
    P55735: 'SEC13',
    P55769: 'SNU13',
    P55771: 'PAX9',
    P55773: 'CCL23',
    P55774: 'CCL18',
    P55786: 'NPEPPS',
    P55789: 'GFER',
    P55795: 'HNRNPH2',
    P55809: 'OXCT1',
    P55851: 'UCP2',
    P55854: 'SUMO3',
    P55884: 'EIF3B',
    P55895: 'RAG2',
    P55899: 'FCGRT',
    P55916: 'UCP3',
    P55957: 'BID',
    P56134: 'ATP5MF',
    P56159: 'GFRA1',
    P56177: 'DLX1',
    P56178: 'DLX5',
    P56180: 'TPTE',
    P56181: 'NDUFV3',
    P56182: 'RRP1',
    P56192: 'MARS1',
    P56199: 'ITGA1',
    P56202: 'CTSW',
    P56211: 'ARPP19',
    P56270: 'MAZ',
    P56278: 'MTCP1',
    P56279: 'TCL1A',
    P56282: 'POLE2',
    P56373: 'P2RX3',
    P56377: 'AP1S2',
    P56381: 'ATP5F1E',
    P56470: 'LGALS4',
    P56524: 'HDAC4',
    P56537: 'EIF6',
    P56539: 'CAV3',
    P56545: 'CTBP2',
    P56556: 'NDUFA6',
    P56557: 'TMEM50B',
    P56559: 'ARL4C',
    P56589: 'PEX3',
    P56597: 'NME5',
    P56645: 'PER3',
    P56693: 'SOX10',
    P56696: 'KCNQ4',
    P56703: 'WNT3',
    P56704: 'WNT3A',
    P56705: 'WNT4',
    P56706: 'WNT7B',
    P56715: 'RP1',
    P56730: 'PRSS12',
    P56746: 'CLDN15',
    P56747: 'CLDN6',
    P56748: 'CLDN8',
    P56750: 'CLDN17',
    P56817: 'BACE1',
    P56851: 'EDDM3B',
    P56856: 'CLDN18',
    P56915: 'GSC',
    P56937: 'HSD17B7',
    P56945: 'BCAR1',
    P56962: 'STX17',
    P56975: 'NRG3',
    P57052: 'RBM11',
    P57053: 'H2BC12L',
    P57054: 'PIGP',
    P57055: 'RIPPLY3',
    P57057: 'SLC37A1',
    P57059: 'SIK1',
    P57071: 'PRDM15',
    P57073: 'SOX8',
    P57075: 'UBASH3A',
    P57076: 'CFAP298',
    P57078: 'RIPK4',
    P57081: 'WDR4',
    P57082: 'TBX4',
    P57086: 'SCAND1',
    P57087: 'JAM2',
    P57088: 'TMEM33',
    P57103: 'SLC8A3',
    P57105: 'SYNJ2BP',
    P57678: 'GEMIN4',
    P57679: 'EVC',
    P57682: 'KLF3',
    P57721: 'PCBP3',
    P57727: 'TMPRSS3',
    P57729: 'RAB38',
    P57730: 'CARD18',
    P57735: 'RAB25',
    P57737: 'CORO7',
    P57739: 'CLDN2',
    P57740: 'NUP107',
    P57764: 'GSDMD',
    P57768: 'SNX16',
    P57771: 'RGS8',
    P57772: 'EEFSEC',
    P57789: 'KCNK10',
    P57796: 'CABP4',
    P58004: 'SESN2',
    P58005: 'SESN3',
    P58012: 'FOXL2',
    P58107: 'EPPK1',
    P58215: 'LOXL3',
    P58304: 'VSX2',
    P58335: 'ANTXR2',
    P58340: 'MLF1',
    P58397: 'ADAMTS12',
    P58400: 'NRXN1',
    P58401: 'NRXN2',
    P58418: 'CLRN1',
    P58499: 'FAM3B',
    P58546: 'MTPN',
    P58743: 'SLC26A5',
    P58753: 'TIRAP',
    P58876: 'H2BC5',
    P59044: 'NLRP6',
    P59046: 'NLRP12',
    P59047: 'NLRP5',
    P59103: 'DAOA',
    P59190: 'RAB15',
    P59510: 'ADAMTS20',
    P59542: 'TAS2R19',
    P59665: 'DEFA1',
    P59665: 'DEFA1B',
    P59666: 'DEFA3',
    P59780: 'AP3S2',
    P59817: 'ZNF280A',
    P59827: 'BPIFB4',
    P59861: 'DEFB131A',
    P59901: 'LILRA4',
    P59910: 'DNAJB13',
    P59923: 'ZNF445',
    P59942: 'MCCD1',
    P59990: 'KRTAP12-1',
    P59991: 'KRTAP12-2',
    P59998: 'ARPC4',
    P60006: 'ANAPC15',
    P60008: 'H1-9P',
    P60014: 'KRTAP10-10',
    P60022: 'DEFB1',
    P60033: 'CD81',
    P60059: 'SEC61G',
    P60174: 'TPI1',
    P60201: 'PLP1',
    P60228: 'EIF3E',
    P60321: 'NANOS2',
    P60323: 'NANOS3',
    P60328: 'KRTAP12-3',
    P60329: 'KRTAP12-4',
    P60368: 'KRTAP10-2',
    P60370: 'KRTAP10-5',
    P60371: 'KRTAP10-6',
    P60372: 'KRTAP10-4',
    P60409: 'KRTAP10-7',
    P60410: 'KRTAP10-8',
    P60411: 'KRTAP10-9',
    P60412: 'KRTAP10-11',
    P60468: 'SEC61B',
    P60484: 'PTEN',
    P60507: 'ERVFC1',
    P60508: 'ERVFRD-1',
    P60510: 'PPP4C',
    P60520: 'GABARAPL2',
    P60568: 'IL2',
    P60602: 'ROMO1',
    P60604: 'UBE2G2',
    P60660: 'MYL6',
    P60709: 'ACTB',
    P60763: 'RAC3',
    P60842: 'EIF4A1',
    P60852: 'ZP1',
    P60866: 'RPS20',
    P60880: 'SNAP25',
    P60891: 'PRPS1',
    P60896: 'SEM1',
    P60900: 'PSMA6',
    P60903: 'S100A10',
    P60953: 'CDC42',
    P60981: 'DSTN',
    P61006: 'RAB8A',
    P61009: 'SPCS3',
    P61011: 'SRP54',
    P61018: 'RAB4B',
    P61019: 'RAB2A',
    P61020: 'RAB5B',
    P61024: 'CKS1B',
    P61026: 'RAB10',
    P61073: 'CXCR4',
    P61077: 'UBE2D3',
    P61081: 'UBE2M',
    P61086: 'UBE2K',
    P61088: 'UBE2N',
    P61106: 'RAB14',
    P61158: 'ACTR3',
    P61160: 'ACTR2',
    P61163: 'ACTR1A',
    P61165: 'TMEM258',
    P61201: 'COPS2',
    P61204: 'ARF3',
    P61218: 'POLR2F',
    P61221: 'ABCE1',
    P61224: 'RAP1B',
    P61225: 'RAP2B',
    P61244: 'MAX',
    P61247: 'RPS3A',
    P61254: 'RPL26',
    P61266: 'STX1B',
    P61278: 'SST',
    P61289: 'PSME3',
    P61296: 'HAND2',
    P61313: 'RPL15',
    P61326: 'MAGOH',
    P61328: 'FGF12',
    P61353: 'RPL27',
    P61371: 'ISL1',
    P61421: 'ATP6V0D1',
    P61457: 'PCBD1',
    P61513: 'RPL37A',
    P61586: 'RHOA',
    P61587: 'RND3',
    P61599: 'NAA20',
    P61601: 'NCALD',
    P61604: 'HSPE1',
    P61619: 'SEC61A1',
    P61626: 'LYZ',
    P61647: 'ST8SIA6',
    P61758: 'VBP1',
    P61764: 'STXBP1',
    P61769: 'B2M',
    P61803: 'DAD1',
    P61812: 'TGFB2',
    P61916: 'NPC2',
    P61923: 'COPZ1',
    P61925: 'PKIA',
    P61927: 'RPL37',
    P61952: 'GNG11',
    P61956: 'SUMO2',
    P61960: 'UFM1',
    P61962: 'DCAF7',
    P61964: 'WDR5',
    P61966: 'AP1S1',
    P61968: 'LMO4',
    P61970: 'NUTF2',
    P61978: 'HNRNPK',
    P61981: 'YWHAG',
    P62068: 'USP46',
    P62070: 'RRAS2',
    P62072: 'TIMM10',
    P62079: 'TSPAN5',
    P62081: 'RPS7',
    P62136: 'PPP1CA',
    P62140: 'PPP1CB',
    P62166: 'NCS1',
    P62191: 'PSMC1',
    P62195: 'PSMC5',
    P62241: 'RPS8',
    P62244: 'RPS15A',
    P62249: 'RPS16',
    P62253: 'UBE2G1',
    P62256: 'UBE2H',
    P62258: 'YWHAE',
    P62263: 'RPS14',
    P62266: 'RPS23',
    P62269: 'RPS18',
    P62273: 'RPS29',
    P62277: 'RPS13',
    P62280: 'RPS11',
    P62304: 'SNRPE',
    P62306: 'SNRPF',
    P62308: 'SNRPG',
    P62310: 'LSM3',
    P62312: 'LSM6',
    P62314: 'SNRPD1',
    P62316: 'SNRPD2',
    P62318: 'SNRPD3',
    P62324: 'BTG1',
    P62328: 'TMSB4X',
    P62330: 'ARF6',
    P62333: 'PSMC6',
    P62341: 'SELENOT',
    P62380: 'TBPL1',
    P62424: 'RPL7A',
    P62487: 'POLR2G',
    P62491: 'RAB11A',
    P62495: 'ETF1',
    P62508: 'ESRRG',
    P62633: 'CNBP',
    P62699: 'YPEL5',
    P62701: 'RPS4X',
    P62714: 'PPP2CB',
    P62736: 'ACTA2',
    P62745: 'RHOB',
    P62750: 'RPL23A',
    P62753: 'RPS6',
    P62760: 'VSNL1',
    P62805: 'H4C1',
    P62805: 'H4C11',
    P62805: 'H4C12',
    P62805: 'H4C13',
    P62805: 'H4C14',
    P62805: 'H4C15',
    P62805: 'H4C16',
    P62805: 'H4C2',
    P62805: 'H4C3',
    P62805: 'H4C4',
    P62805: 'H4C5',
    P62805: 'H4C6',
    P62805: 'H4C8',
    P62805: 'H4C9',
    P62807: 'H2BC10',
    P62807: 'H2BC4',
    P62807: 'H2BC6',
    P62807: 'H2BC7',
    P62807: 'H2BC8',
    P62820: 'RAB1A',
    P62826: 'RAN',
    P62829: 'RPL23',
    P62834: 'RAP1A',
    P62837: 'UBE2D2',
    P62841: 'RPS15',
    P62847: 'RPS24',
    P62851: 'RPS25',
    P62854: 'RPS26',
    P62857: 'RPS28',
    P62861: 'FAU',
    P62873: 'GNB1',
    P62875: 'POLR2L',
    P62877: 'RBX1',
    P62879: 'GNB2',
    P62888: 'RPL30',
    P62891: 'RPL39',
    P62899: 'RPL31',
    P62906: 'RPL10A',
    P62910: 'RPL32',
    P62913: 'RPL11',
    P62917: 'RPL8',
    P62937: 'PPIA',
    P62942: 'FKBP1A',
    P62945: 'RPL41',
    P62952: 'BLCAP',
    P62955: 'CACNG7',
    P62979: 'RPS27A',
    P62987: 'UBA52',
    P62993: 'GRB2',
    P62995: 'TRA2B',
    P63000: 'RAC1',
    P63010: 'AP2B1',
    P63027: 'VAMP2',
    P63092: 'GNAS',
    P63096: 'GNAI1',
    P63098: 'PPP3R1',
    P63104: 'YWHAZ',
    P63128: 'ERVK-9',
    P63146: 'UBE2B',
    P63151: 'PPP2R2A',
    P63162: 'SNRPN',
    P63165: 'SUMO1',
    P63167: 'DYNLL1',
    P63172: 'DYNLT1',
    P63173: 'RPL38',
    P63208: 'SKP1',
    P63211: 'GNGT1',
    P63218: 'GNG5',
    P63220: 'RPS21',
    P63241: 'EIF5A',
    P63244: 'RACK1',
    P63252: 'KCNJ2',
    P63261: 'ACTG1',
    P63267: 'ACTG2',
    P63272: 'SUPT4H1',
    P63279: 'UBE2I',
    P63316: 'TNNC1',
    P67775: 'PPP2CA',
    P67809: 'YBX1',
    P67812: 'SEC11A',
    P67870: 'CSNK2B',
    P67936: 'TPM4',
    P68032: 'ACTC1',
    P68036: 'UBE2L3',
    P68104: 'EEF1A1',
    P68106: 'FKBP1B',
    P68133: 'ACTA1',
    P68363: 'TUBA1B',
    P68366: 'TUBA4A',
    P68371: 'TUBB4B',
    P68400: 'CSNK2A1',
    P68402: 'PAFAH1B2',
    P68431: 'H3C1',
    P68431: 'H3C10',
    P68431: 'H3C11',
    P68431: 'H3C12',
    P68431: 'H3C2',
    P68431: 'H3C3',
    P68431: 'H3C4',
    P68431: 'H3C6',
    P68431: 'H3C7',
    P68431: 'H3C8',
    P68871: 'HBB',
    P69891: 'HBG1',
    P69892: 'HBG2',
    P69905: 'HBA1',
    P69905: 'HBA2',
    P78310: 'CXADR',
    P78314: 'SH3BP2',
    P78316: 'NOP14',
    P78317: 'RNF4',
    P78318: 'IGBP1',
    P78324: 'SIRPA',
    P78325: 'ADAM8',
    P78329: 'CYP4F2',
    P78330: 'PSPH',
    P78332: 'RBM6',
    P78333: 'GPC5',
    P78334: 'GABRE',
    P78337: 'PITX1',
    P78344: 'EIF4G2',
    P78345: 'RPP38',
    P78346: 'RPP30',
    P78347: 'GTF2I',
    P78348: 'ASIC1',
    P78352: 'DLG4',
    P78356: 'PIP4K2B',
    P78357: 'CNTNAP1',
    P78358: 'CTAG1A',
    P78358: 'CTAG1B',
    P78362: 'SRPK2',
    P78363: 'ABCA4',
    P78364: 'PHC1',
    P78367: 'NKX3-2',
    P78368: 'CSNK1G2',
    P78369: 'CLDN10',
    P78371: 'CCT2',
    P78380: 'OLR1',
    P78381: 'SLC35A2',
    P78382: 'SLC35A1',
    P78383: 'SLC35B1',
    P78385: 'KRT83',
    P78386: 'KRT85',
    P78395: 'PRAME',
    P78396: 'CCNA1',
    P78406: 'RAE1',
    P78410: 'BTN3A2',
    P78411: 'IRX5',
    P78412: 'IRX6',
    P78413: 'IRX4',
    P78415: 'IRX3',
    P78417: 'GSTO1',
    P78423: 'CX3CL1',
    P78424: 'POU6F2',
    P78426: 'NKX6-1',
    P78504: 'JAG1',
    P78508: 'KCNJ10',
    P78509: 'RELN',
    P78524: 'DENND2B',
    P78527: 'PRKDC',
    P78536: 'ADAM17',
    P78537: 'BLOC1S1',
    P78539: 'SRPX',
    P78540: 'ARG2',
    P78543: 'BTG2',
    P78545: 'ELF3',
    P78549: 'NTHL1',
    P78552: 'IL13RA1',
    P78556: 'CCL20',
    P78559: 'MAP1A',
    P78560: 'CRADD',
    P78562: 'PHEX',
    P78563: 'ADARB1',
    P79483: 'HLA-DRB3',
    P79522: 'PRR3',
    P80075: 'CCL8',
    P80098: 'CCL7',
    P80108: 'GPLD1',
    P80162: 'CXCL6',
    P80188: 'LCN2',
    P80192: 'MAP3K9',
    P80217: 'IFI35',
    P80294: 'MT1H',
    P80297: 'MT1X',
    P80303: 'NUCB2',
    P80365: 'HSD11B2',
    P80370: 'DLK1',
    P80404: 'ABAT',
    P80511: 'S100A12',
    P80723: 'BASP1',
    P81172: 'HAMP',
    P81274: 'GPSM2',
    P81277: 'PRLH',
    P81534: 'DEFB103A',
    P81534: 'DEFB103B',
    P81605: 'DCD',
    P82094: 'TMF1',
    P82251: 'SLC7A9',
    P82279: 'CRB1',
    P82650: 'MRPS22',
    P82912: 'MRPS11',
    P82930: 'MRPS34',
    P82979: 'SARNP',
    P82987: 'ADAMTSL3',
    P83105: 'HTRA4',
    P83110: 'HTRA3',
    P83111: 'LACTB',
    P83369: 'LSM11',
    P83436: 'COG7',
    P83731: 'RPL24',
    P83876: 'TXNL4A',
    P83881: 'RPL36A',
    P83916: 'CBX1',
    P84022: 'SMAD3',
    P84074: 'HPCA',
    P84077: 'ARF1',
    P84085: 'ARF5',
    P84090: 'ERH',
    P84095: 'RHOG',
    P84098: 'RPL19',
    P84103: 'SRSF3',
    P84243: 'H3-3A',
    P84243: 'H3-3B',
    P84550: 'SKOR1',
    P84996: 'GNAS',
    P85037: 'FOXK1',
    P85298: 'ARHGAP8',
    P85299: 'PRR5',
    P86397: 'HTD2',
    P86452: 'ZBED6',
    P86479: 'PRR20C',
    P98066: 'TNFAIP6',
    P98073: 'TMPRSS15',
    P98077: 'SHC2',
    P98082: 'DAB2',
    P98088: 'MUC5AC',
    P98095: 'FBLN2',
    P98153: 'DGCR2',
    P98155: 'VLDLR',
    P98160: 'HSPG2',
    P98161: 'PKD1',
    P98164: 'LRP2',
    P98168: 'ZXDA',
    P98170: 'XIAP',
    P98171: 'ARHGAP4',
    P98172: 'EFNB1',
    P98174: 'FGD1',
    P98175: 'RBM10',
    P98177: 'FOXO4',
    P98179: 'RBM3',
    P98187: 'CYP4F8',
    P98194: 'ATP2C1',
    P98196: 'ATP11A',
    P98198: 'ATP8B2',
    P99999: 'CYCS',
    Q00005: 'PPP2R2B',
    Q00013: 'MPP1',
    Q00056: 'HOXA4',
    Q00059: 'TFAM',
    Q00169: 'PITPNA',
    Q00266: 'MAT1A',
    Q00325: 'SLC25A3',
    Q00341: 'HDLBP',
    Q00403: 'GTF2B',
    Q00444: 'HOXC5',
    Q00526: 'CDK3',
    Q00532: 'CDKL1',
    Q00534: 'CDK6',
    Q00535: 'CDK5',
    Q00536: 'CDK16',
    Q00537: 'CDK17',
    Q00577: 'PURA',
    Q00587: 'CDC42EP1',
    Q00597: 'FANCC',
    Q00604: 'NDP',
    Q00610: 'CLTC',
    Q00613: 'HSF1',
    Q00653: 'NFKB2',
    Q00688: 'FKBP3',
    Q00722: 'PLCB2',
    Q00765: 'REEP5',
    Q00796: 'SORD',
    Q00839: 'HNRNPU',
    Q00872: 'MYBPC1',
    Q00887: 'PSG9',
    Q00888: 'PSG4',
    Q00889: 'PSG6',
    Q00973: 'B4GALNT1',
    Q00975: 'CACNA1B',
    Q00978: 'IRF9',
    Q00987: 'MDM2',
    Q00994: 'BEX3',
    Q00G26: 'PLIN5',
    Q00LT1: 'PRCD',
    Q01064: 'PDE1B',
    Q01081: 'U2AF1',
    Q01082: 'SPTBN1',
    Q01085: 'TIAL1',
    Q01094: 'E2F1',
    Q01101: 'INSM1',
    Q01105: 'SET',
    Q01113: 'IL9R',
    Q01118: 'SCN7A',
    Q01130: 'SRSF2',
    Q01151: 'CD83',
    Q01167: 'FOXK2',
    Q01196: 'RUNX1',
    Q01201: 'RELB',
    Q01344: 'IL5RA',
    Q01362: 'MS4A2',
    Q01415: 'GALK2',
    Q01432: 'AMPD3',
    Q01433: 'AMPD2',
    Q01449: 'MYL7',
    Q01453: 'PMP22',
    Q01469: 'FABP5',
    Q01484: 'ANK2',
    Q01518: 'CAP1',
    Q01523: 'DEFA5',
    Q01524: 'DEFA6',
    Q01534: 'TSPY1',
    Q01538: 'MYT1',
    Q01543: 'FLI1',
    Q01546: 'KRT76',
    Q01581: 'HMGCS1',
    Q01628: 'IFITM3',
    Q01629: 'IFITM2',
    Q01638: 'IL1RL1',
    Q01650: 'SLC7A5',
    Q01658: 'DR1',
    Q01664: 'TFAP4',
    Q01668: 'CACNA1D',
    Q01718: 'MC2R',
    Q01726: 'MC1R',
    Q01740: 'FMO1',
    Q01780: 'EXOSC10',
    Q01804: 'OTUD4',
    Q01813: 'PFKP',
    Q01814: 'ATP2B2',
    Q01826: 'SATB1',
    Q01831: 'XPC',
    Q01844: 'EWSR1',
    Q01850: 'CDR2',
    Q01851: 'POU4F1',
    Q01860: 'POU5F1',
    Q01892: 'SPIB',
    Q01954: 'BNC1',
    Q01955: 'COL4A3',
    Q01959: 'SLC6A3',
    Q01968: 'OCRL',
    Q01970: 'PLCB3',
    Q01973: 'ROR1',
    Q01974: 'ROR2',
    Q02040: 'AKAP17A',
    Q02078: 'MEF2A',
    Q02080: 'MEF2B',
    Q02083: 'NAAA',
    Q02086: 'SP2',
    Q02094: 'RHAG',
    Q02108: 'GUCY1A1',
    Q02127: 'DHODH',
    Q02153: 'GUCY1B1',
    Q02156: 'PRKCE',
    Q02161: 'RHD',
    Q02218: 'OGDH',
    Q02221: 'COX6A2',
    Q02223: 'TNFRSF17',
    Q02224: 'CENPE',
    Q02241: 'KIF23',
    Q02246: 'CNTN2',
    Q02252: 'ALDH6A1',
    Q02297: 'NRG1',
    Q02318: 'CYP27A1',
    Q02363: 'ID2',
    Q02383: 'SEMG2',
    Q02388: 'COL7A1',
    Q02410: 'APBA1',
    Q02413: 'DSG1',
    Q02446: 'SP4',
    Q02447: 'SP3',
    Q02487: 'DSC2',
    Q02505: 'MUC3A',
    Q02535: 'ID3',
    Q02539: 'H1-1',
    Q02543: 'RPL18A',
    Q02548: 'PAX5',
    Q02556: 'IRF8',
    Q02575: 'NHLH1',
    Q02577: 'NHLH2',
    Q02641: 'CACNB1',
    Q02643: 'GHRHR',
    Q02742: 'GCNT1',
    Q02747: 'GUCA2A',
    Q02750: 'MAP2K1',
    Q02763: 'TEK',
    Q02779: 'MAP3K10',
    Q02790: 'FKBP4',
    Q02809: 'PLOD1',
    Q02817: 'MUC2',
    Q02818: 'NUCB1',
    Q02833: 'RASSF7',
    Q02846: 'GUCY2D',
    Q02878: 'RPL6',
    Q02880: 'TOP2B',
    Q02928: 'CYP4A11',
    Q02930: 'CREB5',
    Q02952: 'AKAP12',
    Q02962: 'PAX2',
    Q02978: 'SLC25A11',
    Q02985: 'CFHR3',
    Q03001: 'DST',
    Q03013: 'GSTM4',
    Q03014: 'HHEX',
    Q03052: 'POU3F1',
    Q03060: 'CREM',
    Q03111: 'MLLT1',
    Q03112: 'MECOM',
    Q03113: 'GNA12',
    Q03135: 'CAV1',
    Q03154: 'ACY1',
    Q03164: 'KMT2A',
    Q03167: 'TGFBR3',
    Q03181: 'PPARD',
    Q03188: 'CENPC',
    Q03252: 'LMNB2',
    Q03393: 'PTS',
    Q03395: 'ROM1',
    Q03403: 'TFF2',
    Q03405: 'PLAUR',
    Q03426: 'MVK',
    Q03431: 'PTH1R',
    Q03468: 'ERCC6',
    Q03518: 'TAP1',
    Q03519: 'TAP2',
    Q03591: 'CFHR1',
    Q03692: 'COL10A1',
    Q03721: 'KCNC4',
    Q03923: 'ZNF85',
    Q03933: 'HSF2',
    Q03989: 'ARID5A',
    Q04118: 'PRB3',
    Q04206: 'RELA',
    Q04323: 'UBXN1',
    Q04446: 'GBE1',
    Q04609: 'FOLH1',
    Q04637: 'EIF4G1',
    Q04656: 'ATP7A',
    Q04671: 'OCA2',
    Q04695: 'KRT17',
    Q04721: 'NOTCH2',
    Q04724: 'TLE1',
    Q04725: 'TLE2',
    Q04726: 'TLE3',
    Q04727: 'TLE4',
    Q04741: 'EMX1',
    Q04743: 'EMX2',
    Q04756: 'HGFAC',
    Q04759: 'PRKCQ',
    Q04760: 'GLO1',
    Q04771: 'ACVR1',
    Q04828: 'AKR1C1',
    Q04837: 'SSBP1',
    Q04844: 'CHRNE',
    Q04864: 'REL',
    Q04900: 'CD164',
    Q04912: 'MST1R',
    Q04917: 'YWHAH',
    Q04941: 'PLP2',
    Q05066: 'SRY',
    Q05084: 'ICA1',
    Q05086: 'UBE3A',
    Q05193: 'DNM1',
    Q05195: 'MXD1',
    Q05209: 'PTPN12',
    Q05215: 'EGR4',
    Q05315: 'CLC',
    Q05329: 'GAD2',
    Q05397: 'PTK2',
    Q05469: 'LIPE',
    Q05481: 'ZNF91',
    Q05513: 'PRKCZ',
    Q05516: 'ZBTB16',
    Q05519: 'SRSF11',
    Q05586: 'GRIN1',
    Q05639: 'EEF1A2',
    Q05655: 'PRKCD',
    Q05682: 'CALD1',
    Q05707: 'COL14A1',
    Q05823: 'RNASEL',
    Q05901: 'CHRNB3',
    Q05923: 'DUSP2',
    Q05925: 'EN1',
    Q05932: 'FPGS',
    Q05940: 'SLC18A2',
    Q05996: 'ZP2',
    Q05BQ5: 'MBTD1',
    Q05D60: 'DEUP1',
    Q06033: 'ITIH3',
    Q06055: 'ATP5MC2',
    Q06124: 'PTPN11',
    Q06136: 'KDSR',
    Q06141: 'REG3A',
    Q06187: 'BTK',
    Q06190: 'PPP2R3A',
    Q06203: 'PPAT',
    Q06210: 'GFPT1',
    Q06265: 'EXOSC9',
    Q06278: 'AOX1',
    Q06323: 'PSME1',
    Q06330: 'RBPJ',
    Q06413: 'MEF2C',
    Q06416: 'POU5F1B',
    Q06418: 'TYRO3',
    Q06432: 'CACNG1',
    Q06455: 'RUNX1T1',
    Q06481: 'APLP2',
    Q06495: 'SLC34A1',
    Q06520: 'SULT2A1',
    Q06546: 'GABPA',
    Q06547: 'GABPB1',
    Q06587: 'RING1',
    Q06609: 'RAD51',
    Q06643: 'LTB',
    Q06710: 'PAX8',
    Q06730: 'ZNF33A',
    Q06787: 'FMR1',
    Q06828: 'FMOD',
    Q06830: 'PRDX1',
    Q06889: 'EGR3',
    Q06945: 'SOX4',
    Q07001: 'CHRND',
    Q07002: 'CDK18',
    Q07011: 'TNFRSF9',
    Q07020: 'RPL18',
    Q07021: 'C1QBP',
    Q07065: 'CKAP4',
    Q07075: 'ENPEP',
    Q07092: 'COL16A1',
    Q07108: 'CD69',
    Q07157: 'TJP1',
    Q07283: 'TCHH',
    Q07325: 'CXCL9',
    Q07326: 'PIGF',
    Q07343: 'PDE4B',
    Q07352: 'ZFP36L1',
    Q07444: 'KLRC3',
    Q07617: 'SPAG1',
    Q07627: 'KRTAP1-1',
    Q07654: 'TFF3',
    Q07666: 'KHDRBS1',
    Q07687: 'DLX2',
    Q07699: 'SCN1B',
    Q07812: 'BAX',
    Q07817: 'BCL2L1',
    Q07820: 'MCL1',
    Q07837: 'SLC3A1',
    Q07864: 'POLE',
    Q07866: 'KLC1',
    Q07869: 'PPARA',
    Q07889: 'SOS1',
    Q07890: 'SOS2',
    Q07912: 'TNK2',
    Q07954: 'LRP1',
    Q07955: 'SRSF1',
    Q07960: 'ARHGAP1',
    Q07973: 'CYP24A1',
    Q08043: 'ACTN3',
    Q08050: 'FOXM1',
    Q08116: 'RGS1',
    Q08117: 'TLE5',
    Q08170: 'SRSF4',
    Q08174: 'PCDH1',
    Q08188: 'TGM3',
    Q08209: 'PPP3CA',
    Q08211: 'DHX9',
    Q08257: 'CRYZ',
    Q08289: 'CACNB2',
    Q08334: 'IL10RB',
    Q08345: 'DDR1',
    Q08357: 'SLC20A2',
    Q08378: 'GOLGA3',
    Q08379: 'GOLGA2',
    Q08380: 'LGALS3BP',
    Q08397: 'LOXL1',
    Q08426: 'EHHADH',
    Q08431: 'MFGE8',
    Q08462: 'ADCY2',
    Q08477: 'CYP4F3',
    Q08493: 'PDE4C',
    Q08495: 'DMTN',
    Q08499: 'PDE4D',
    Q08554: 'DSC1',
    Q08623: 'PUDP',
    Q08629: 'SPOCK1',
    Q08648: 'SPAG11B',
    Q08708: 'CD300C',
    Q08722: 'CD47',
    Q08752: 'PPID',
    Q08828: 'ADCY1',
    Q08830: 'FGL1',
    Q08881: 'ITK',
    Q08945: 'SSRP1',
    Q08999: 'RBL2',
    Q08AD1: 'CAMSAP2',
    Q08AE8: 'SPIRE1',
    Q08AF8: 'GOLGA8F',
    Q08AF8: 'GOLGA8G',
    Q08AG5: 'ZNF844',
    Q08AG7: 'MZT1',
    Q08AH1: 'ACSM1',
    Q08AH3: 'ACSM2A',
    Q08AM6: 'VAC14',
    Q08ET2: 'SIGLEC14',
    Q08J23: 'NSUN2',
    Q09013: 'DMPK',
    Q09028: 'RBBP4',
    Q09161: 'NCBP1',
    Q09327: 'MGAT3',
    Q09328: 'MGAT5',
    Q09428: 'ABCC8',
    Q09470: 'KCNA1',
    Q09472: 'EP300',
    Q09666: 'AHNAK',
    Q09FC8: 'ZNF415',
    Q0D2H9: 'GOLGA8DP',
    Q0D2I5: 'IFFO1',
    Q0D2K0: 'NIPAL4',
    Q0D2K3: 'RIPPLY1',
    Q0GE19: 'SLC10A7',
    Q0IIM8: 'TBC1D8B',
    Q0JRZ9: 'FCHO2',
    Q0P5N6: 'ARL16',
    Q0PNE2: 'ELP6',
    Q0VAK6: 'LMOD3',
    Q0VAM2: 'RASGEF1B',
    Q0VAQ4: 'SMAGP',
    Q0VD83: 'APOBR',
    Q0VD86: 'INCA1',
    Q0VDD7: 'BRME1',
    Q0VDD8: 'DNAH14',
    Q0VDF9: 'HSPA14',
    Q0VF96: 'CGNL1',
    Q0VG06: 'FAAP100',
    Q0VG99: 'MESP2',
    Q0VGL1: 'LAMTOR4',
    Q0WX57: 'USP17L24',
    Q0WX57: 'USP17L25',
    Q0WX57: 'USP17L26',
    Q0WX57: 'USP17L27',
    Q0WX57: 'USP17L28',
    Q0WX57: 'USP17L29',
    Q0WX57: 'USP17L30',
    Q0ZGT2: 'NEXN',
    Q0ZLH3: 'PJVK',
    Q10469: 'MGAT2',
    Q10471: 'GALNT2',
    Q10472: 'GALNT1',
    Q10567: 'AP1B1',
    Q10570: 'CPSF1',
    Q10571: 'MN1',
    Q10586: 'DBP',
    Q10587: 'TEF',
    Q10588: 'BST1',
    Q10589: 'BST2',
    Q10713: 'PMPCA',
    Q10981: 'FUT2',
    Q11128: 'FUT5',
    Q11130: 'FUT7',
    Q11201: 'ST3GAL1',
    Q11203: 'ST3GAL3',
    Q11206: 'ST3GAL4',
    Q12756: 'KIF1A',
    Q12768: 'WASHC5',
    Q12769: 'NUP160',
    Q12770: 'SCAP',
    Q12772: 'SREBF2',
    Q12774: 'ARHGEF5',
    Q12778: 'FOXO1',
    Q12789: 'GTF3C1',
    Q12791: 'KCNMA1',
    Q12792: 'TWF1',
    Q12794: 'HYAL1',
    Q12797: 'ASPH',
    Q12798: 'CETN1',
    Q12800: 'TFCP2',
    Q12802: 'AKAP13',
    Q12805: 'EFEMP1',
    Q12809: 'KCNH2',
    Q12815: 'TROAP',
    Q12816: 'TRO',
    Q12824: 'SMARCB1',
    Q12830: 'BPTF',
    Q12834: 'CDC20',
    Q12836: 'ZP4',
    Q12837: 'POU4F2',
    Q12840: 'KIF5A',
    Q12841: 'FSTL1',
    Q12846: 'STX4',
    Q12849: 'GRSF1',
    Q12851: 'MAP4K2',
    Q12852: 'MAP3K12',
    Q12857: 'NFIA',
    Q12860: 'CNTN1',
    Q12864: 'CDH17',
    Q12866: 'MERTK',
    Q12870: 'TCF15',
    Q12873: 'CHD3',
    Q12874: 'SF3A3',
    Q12879: 'GRIN2A',
    Q12882: 'DPYD',
    Q12884: 'FAP',
    Q12887: 'COX10',
    Q12888: 'TP53BP1',
    Q12889: 'OVGP1',
    Q12891: 'HYAL2',
    Q12893: 'TMEM115',
    Q12899: 'TRIM26',
    Q12901: 'ZNF155',
    Q12904: 'AIMP1',
    Q12905: 'ILF2',
    Q12906: 'ILF3',
    Q12907: 'LMAN2',
    Q12908: 'SLC10A2',
    Q12912: 'IRAG2',
    Q12913: 'PTPRJ',
    Q12918: 'KLRB1',
    Q12923: 'PTPN13',
    Q12929: 'EPS8',
    Q12931: 'TRAP1',
    Q12933: 'TRAF2',
    Q12934: 'BFSP1',
    Q12946: 'FOXF1',
    Q12947: 'FOXF2',
    Q12948: 'FOXC1',
    Q12951: 'FOXI1',
    Q12952: 'FOXL1',
    Q12955: 'ANK3',
    Q12959: 'DLG1',
    Q12962: 'TAF10',
    Q12965: 'MYO1E',
    Q12967: 'RALGDS',
    Q12968: 'NFATC3',
    Q12972: 'PPP1R8',
    Q12974: 'PTP4A2',
    Q12979: 'ABR',
    Q12980: 'NPRL3',
    Q12981: 'BNIP1',
    Q12982: 'BNIP2',
    Q12983: 'BNIP3',
    Q12986: 'NFX1',
    Q12996: 'CSTF3',
    Q13002: 'GRIK2',
    Q13003: 'GRIK3',
    Q13007: 'IL24',
    Q13009: 'TIAM1',
    Q13011: 'ECH1',
    Q13015: 'MLLT11',
    Q13017: 'ARHGAP5',
    Q13018: 'PLA2R1',
    Q13021: 'MALL',
    Q13023: 'AKAP6',
    Q13029: 'PRDM2',
    Q13033: 'STRN3',
    Q13042: 'CDC16',
    Q13043: 'STK4',
    Q13045: 'FLII',
    Q13049: 'TRIM32',
    Q13057: 'COASY',
    Q13061: 'TRDN',
    Q13064: 'MKRN3',
    Q13075: 'NAIP',
    Q13077: 'TRAF1',
    Q13084: 'MRPL28',
    Q13085: 'ACACA',
    Q13087: 'PDIA2',
    Q13093: 'PLA2G7',
    Q13094: 'LCP2',
    Q13098: 'GPS1',
    Q13099: 'IFT88',
    Q13105: 'ZBTB17',
    Q13107: 'USP4',
    Q13111: 'CHAF1A',
    Q13112: 'CHAF1B',
    Q13113: 'PDZK1IP1',
    Q13114: 'TRAF3',
    Q13115: 'DUSP4',
    Q13117: 'DAZ2',
    Q13118: 'KLF10',
    Q13123: 'IK',
    Q13126: 'MTAP',
    Q13127: 'REST',
    Q13129: 'RLF',
    Q13131: 'PRKAA1',
    Q13133: 'NR1H3',
    Q13136: 'PPFIA1',
    Q13137: 'CALCOCO2',
    Q13144: 'EIF2B5',
    Q13145: 'BAMBI',
    Q13148: 'TARDBP',
    Q13151: 'HNRNPA0',
    Q13153: 'PAK1',
    Q13155: 'AIMP2',
    Q13156: 'RPA4',
    Q13158: 'FADD',
    Q13162: 'PRDX4',
    Q13163: 'MAP2K5',
    Q13164: 'MAPK7',
    Q13177: 'PAK2',
    Q13183: 'SLC13A2',
    Q13185: 'CBX3',
    Q13188: 'STK3',
    Q13190: 'STX5',
    Q13191: 'CBLB',
    Q13200: 'PSMD2',
    Q13201: 'MMRN1',
    Q13202: 'DUSP8',
    Q13206: 'DDX10',
    Q13207: 'TBX2',
    Q13214: 'SEMA3B',
    Q13216: 'ERCC8',
    Q13217: 'DNAJC3',
    Q13219: 'PAPPA',
    Q13224: 'GRIN2B',
    Q13227: 'GPS2',
    Q13228: 'SELENBP1',
    Q13231: 'CHIT1',
    Q13232: 'NME3',
    Q13233: 'MAP3K1',
    Q13237: 'PRKG2',
    Q13239: 'SLA',
    Q13241: 'KLRD1',
    Q13242: 'SRSF9',
    Q13243: 'SRSF5',
    Q13247: 'SRSF6',
    Q13253: 'NOG',
    Q13255: 'GRM1',
    Q13257: 'MAD2L1',
    Q13258: 'PTGDR',
    Q13261: 'IL15RA',
    Q13263: 'TRIM28',
    Q13268: 'DHRS2',
    Q13275: 'SEMA3F',
    Q13277: 'STX3',
    Q13283: 'G3BP1',
    Q13285: 'NR5A1',
    Q13286: 'CLN3',
    Q13287: 'NMI',
    Q13291: 'SLAMF1',
    Q13303: 'KCNAB2',
    Q13304: 'GPR17',
    Q13308: 'PTK7',
    Q13309: 'SKP2',
    Q13310: 'PABPC4',
    Q13315: 'ATM',
    Q13316: 'DMP1',
    Q13319: 'CDK5R2',
    Q13322: 'GRB10',
    Q13323: 'BIK',
    Q13324: 'CRHR2',
    Q13325: 'IFIT5',
    Q13326: 'SGCG',
    Q13330: 'MTA1',
    Q13332: 'PTPRS',
    Q13336: 'SLC14A1',
    Q13342: 'SP140',
    Q13347: 'EIF3I',
    Q13349: 'ITGAD',
    Q13351: 'KLF1',
    Q13352: 'ITGB3BP',
    Q13356: 'PPIL2',
    Q13360: 'ZNF177',
    Q13361: 'MFAP5',
    Q13362: 'PPP2R5C',
    Q13363: 'CTBP1',
    Q13367: 'AP3B2',
    Q13370: 'PDE3B',
    Q13371: 'PDCL',
    Q13387: 'MAPK8IP2',
    Q13393: 'PLD1',
    Q13394: 'MAB21L1',
    Q13395: 'TARBP1',
    Q13398: 'ZNF211',
    Q13402: 'MYO7A',
    Q13404: 'UBE2V1',
    Q13405: 'MRPL49',
    Q13409: 'DYNC1I2',
    Q13410: 'BTN1A1',
    Q13415: 'ORC1',
    Q13416: 'ORC2',
    Q13418: 'ILK',
    Q13421: 'MSLN',
    Q13422: 'IKZF1',
    Q13423: 'NNT',
    Q13424: 'SNTA1',
    Q13425: 'SNTB2',
    Q13426: 'XRCC4',
    Q13427: 'PPIG',
    Q13428: 'TCOF1',
    Q13432: 'UNC119',
    Q13433: 'SLC39A6',
    Q13435: 'SF3B2',
    Q13438: 'OS9',
    Q13439: 'GOLGA4',
    Q13443: 'ADAM9',
    Q13444: 'ADAM15',
    Q13445: 'TMED1',
    Q13449: 'LSAMP',
    Q13451: 'FKBP5',
    Q13454: 'TUSC3',
    Q13459: 'MYO9B',
    Q13461: 'FOXE3',
    Q13464: 'ROCK1',
    Q13467: 'FZD5',
    Q13469: 'NFATC2',
    Q13470: 'TNK1',
    Q13472: 'TOP3A',
    Q13474: 'DRP2',
    Q13477: 'MADCAM1',
    Q13478: 'IL18R1',
    Q13480: 'GAB1',
    Q13485: 'SMAD4',
    Q13487: 'SNAPC2',
    Q13488: 'TCIRG1',
    Q13489: 'BIRC3',
    Q13490: 'BIRC2',
    Q13491: 'GPM6B',
    Q13492: 'PICALM',
    Q13495: 'MAMLD1',
    Q13496: 'MTM1',
    Q13501: 'SQSTM1',
    Q13503: 'MED21',
    Q13505: 'MTX1',
    Q13506: 'NAB1',
    Q13507: 'TRPC3',
    Q13508: 'ART3',
    Q13509: 'TUBB3',
    Q13510: 'ASAH1',
    Q13515: 'BFSP2',
    Q13516: 'OLIG2',
    Q13519: 'PNOC',
    Q13520: 'AQP6',
    Q13522: 'PPP1R1A',
    Q13523: 'PRPF4B',
    Q13526: 'PIN1',
    Q13530: 'SERINC3',
    Q13535: 'ATR',
    Q13541: 'EIF4EBP1',
    Q13542: 'EIF4EBP2',
    Q13546: 'RIPK1',
    Q13547: 'HDAC1',
    Q13554: 'CAMK2B',
    Q13555: 'CAMK2G',
    Q13557: 'CAMK2D',
    Q13561: 'DCTN2',
    Q13562: 'NEUROD1',
    Q13563: 'PKD2',
    Q13564: 'NAE1',
    Q13568: 'IRF5',
    Q13569: 'TDG',
    Q13571: 'LAPTM5',
    Q13572: 'ITPK1',
    Q13573: 'SNW1',
    Q13574: 'DGKZ',
    Q13576: 'IQGAP2',
    Q13585: 'GPR50',
    Q13586: 'STIM1',
    Q13588: 'GRAP',
    Q13591: 'SEMA5A',
    Q13595: 'TRA2A',
    Q13596: 'SNX1',
    Q13601: 'KRR1',
    Q13608: 'PEX6',
    Q13609: 'DNASE1L3',
    Q13610: 'PWP1',
    Q13613: 'MTMR1',
    Q13614: 'MTMR2',
    Q13615: 'MTMR3',
    Q13616: 'CUL1',
    Q13617: 'CUL2',
    Q13618: 'CUL3',
    Q13619: 'CUL4A',
    Q13620: 'CUL4B',
    Q13621: 'SLC12A1',
    Q13625: 'TP53BP2',
    Q13627: 'DYRK1A',
    Q13630: 'GFUS',
    Q13634: 'CDH18',
    Q13635: 'PTCH1',
    Q13636: 'RAB31',
    Q13637: 'RAB32',
    Q13639: 'HTR4',
    Q13641: 'TPBG',
    Q13642: 'FHL1',
    Q13643: 'FHL3',
    Q13651: 'IL10RA',
    Q13671: 'RIN1',
    Q13683: 'ITGA7',
    Q13685: 'AAMP',
    Q13686: 'ALKBH1',
    Q13698: 'CACNA1S',
    Q13702: 'RAPSN',
    Q13705: 'ACVR2B',
    Q13724: 'MOGS',
    Q13733: 'ATP1A4',
    Q13740: 'ALCAM',
    Q13751: 'LAMB3',
    Q13753: 'LAMC2',
    Q13761: 'RUNX3',
    Q13765: 'NACA',
    Q13769: 'THOC5',
    Q13772: 'NCOA4',
    Q13790: 'APOF',
    Q13794: 'PMAIP1',
    Q13795: 'ARFRP1',
    Q13796: 'SHROOM2',
    Q13797: 'ITGA9',
    Q13813: 'SPTAN1',
    Q13822: 'ENPP2',
    Q13823: 'GNL2',
    Q13825: 'AUH',
    Q13829: 'TNFAIP1',
    Q13835: 'PKP1',
    Q13838: 'DDX39B',
    Q13867: 'BLMH',
    Q13868: 'EXOSC2',
    Q13873: 'BMPR2',
    Q13875: 'MOBP',
    Q13882: 'PTK6',
    Q13884: 'SNTB1',
    Q13885: 'TUBB2A',
    Q13886: 'KLF9',
    Q13887: 'KLF5',
    Q13888: 'GTF2H2',
    Q13889: 'GTF2H3',
    Q13895: 'BYSL',
    Q13901: 'C1D',
    Q13905: 'RAPGEF1',
    Q13907: 'IDI1',
    Q13936: 'CACNA1C',
    Q13946: 'PDE7A',
    Q13948: 'CUX1',
    Q13950: 'RUNX2',
    Q13951: 'CBFB',
    Q13952: 'NFYC',
    Q13956: 'PDE6H',
    Q13972: 'RASGRF1',
    Q13976: 'PRKG1',
    Q14002: 'CEACAM7',
    Q14003: 'KCNC3',
    Q14004: 'CDK13',
    Q14005: 'IL16',
    Q14008: 'CKAP5',
    Q14011: 'CIRBP',
    Q14012: 'CAMK1',
    Q14019: 'COTL1',
    Q14028: 'CNGB1',
    Q14031: 'COL4A6',
    Q14032: 'BAAT',
    Q14050: 'COL9A3',
    Q14055: 'COL9A2',
    Q14061: 'COX17',
    Q14088: 'RAB33A',
    Q14103: 'HNRNPD',
    Q14106: 'TOB2',
    Q14108: 'SCARB2',
    Q14112: 'NID2',
    Q14114: 'LRP8',
    Q14116: 'IL18',
    Q14117: 'DPYS',
    Q14118: 'DAG1',
    Q14119: 'VEZF1',
    Q14123: 'PDE1C',
    Q14126: 'DSG2',
    Q14129: 'DGCR6',
    Q14134: 'TRIM29',
    Q14135: 'VGLL4',
    Q14137: 'BOP1',
    Q14139: 'UBE4A',
    Q14140: 'SERTAD2',
    Q14141: 'SEPTIN6',
    Q14142: 'TRIM14',
    Q14145: 'KEAP1',
    Q14147: 'DHX34',
    Q14149: 'MORC3',
    Q14151: 'SAFB2',
    Q14152: 'EIF3A',
    Q14153: 'FAM53B',
    Q14154: 'DELE1',
    Q14155: 'ARHGEF7',
    Q14156: 'EFR3A',
    Q14157: 'UBAP2L',
    Q14159: 'SPIDR',
    Q14160: 'SCRIB',
    Q14161: 'GIT2',
    Q14162: 'SCARF1',
    Q14164: 'IKBKE',
    Q14165: 'MLEC',
    Q14166: 'TTLL12',
    Q14168: 'MPP2',
    Q14181: 'POLA2',
    Q14183: 'DOC2A',
    Q14184: 'DOC2B',
    Q14185: 'DOCK1',
    Q14186: 'TFDP1',
    Q14188: 'TFDP2',
    Q14190: 'SIM2',
    Q14191: 'WRN',
    Q14192: 'FHL2',
    Q14194: 'CRMP1',
    Q14195: 'DPYSL3',
    Q14197: 'MRPL58',
    Q14202: 'ZMYM3',
    Q14203: 'DCTN1',
    Q14204: 'DYNC1H1',
    Q14207: 'NPAT',
    Q14209: 'E2F2',
    Q14210: 'LY6D',
    Q14213: 'EBI3',
    Q14232: 'EIF2B1',
    Q14240: 'EIF4A2',
    Q14241: 'ELOA',
    Q14242: 'SELPLG',
    Q14244: 'MAP7',
    Q14246: 'ADGRE1',
    Q14247: 'CTTN',
    Q14249: 'ENDOG',
    Q14254: 'FLOT2',
    Q14257: 'RCN2',
    Q14258: 'TRIM25',
    Q14264: 'ERV3-1',
    Q14289: 'PTK2B',
    Q14296: 'FASTK',
    Q14314: 'FGL2',
    Q14315: 'FLNC',
    Q14318: 'FKBP8',
    Q14320: 'FAM50A',
    Q14330: 'GPR18',
    Q14331: 'FRG1',
    Q14332: 'FZD2',
    Q14344: 'GNA13',
    Q14353: 'GAMT',
    Q14376: 'GALE',
    Q14392: 'LRRC32',
    Q14393: 'GAS6',
    Q14397: 'GCKR',
    Q14406: 'CSHL1',
    Q14410: 'GK2',
    Q14416: 'GRM2',
    Q14432: 'PDE3A',
    Q14435: 'GALNT3',
    Q14442: 'PIGH',
    Q14444: 'CAPRIN1',
    Q14449: 'GRB14',
    Q14451: 'GRB7',
    Q14457: 'BECN1',
    Q14469: 'HES1',
    Q14493: 'SLBP',
    Q14494: 'NFE2L1',
    Q14498: 'RBM39',
    Q14500: 'KCNJ12',
    Q14508: 'WFDC2',
    Q14511: 'NEDD9',
    Q14512: 'FGFBP1',
    Q14515: 'SPARCL1',
    Q14517: 'FAT1',
    Q14520: 'HABP2',
    Q14524: 'SCN5A',
    Q14525: 'KRT33B',
    Q14526: 'HIC1',
    Q14527: 'HLTF',
    Q14532: 'KRT32',
    Q14533: 'KRT81',
    Q14534: 'SQLE',
    Q14541: 'HNF4G',
    Q14542: 'SLC29A2',
    Q14554: 'PDIA5',
    Q14558: 'PRPSAP1',
    Q14562: 'DHX8',
    Q14563: 'SEMA3A',
    Q14565: 'DMC1',
    Q14566: 'MCM6',
    Q14571: 'ITPR2',
    Q14573: 'ITPR3',
    Q14574: 'DSC3',
    Q14584: 'ZNF266',
    Q14585: 'ZNF345',
    Q14587: 'ZNF268',
    Q14592: 'ZNF460',
    Q14596: 'NBR1',
    Q14623: 'IHH',
    Q14624: 'ITIH4',
    Q14626: 'IL11RA',
    Q14627: 'IL13RA2',
    Q14642: 'INPP5A',
    Q14643: 'ITPR1',
    Q14644: 'RASA3',
    Q14651: 'PLS1',
    Q14653: 'IRF3',
    Q14654: 'KCNJ11',
    Q14656: 'TMEM187',
    Q14657: 'LAGE3',
    Q14669: 'TRIP12',
    Q14671: 'PUM1',
    Q14674: 'ESPL1',
    Q14676: 'MDC1',
    Q14677: 'CLINT1',
    Q14678: 'KANK1',
    Q14679: 'TTLL4',
    Q14680: 'MELK',
    Q14683: 'SMC1A',
    Q14684: 'RRP1B',
    Q14686: 'NCOA6',
    Q14687: 'GSE1',
    Q14689: 'DIP2A',
    Q14690: 'PDCD11',
    Q14691: 'GINS1',
    Q14692: 'BMS1',
    Q14693: 'LPIN1',
    Q14694: 'USP10',
    Q14696: 'MESD',
    Q14697: 'GANAB',
    Q14699: 'RFTN1',
    Q14703: 'MBTPS1',
    Q14714: 'SSPN',
    Q14721: 'KCNB1',
    Q14722: 'KCNAB1',
    Q14738: 'PPP2R5D',
    Q14739: 'LBR',
    Q14746: 'COG2',
    Q14749: 'GNMT',
    Q14764: 'MVP',
    Q14765: 'STAT4',
    Q14766: 'LTBP1',
    Q14767: 'LTBP2',
    Q14773: 'ICAM4',
    Q14774: 'HLX',
    Q14781: 'CBX2',
    Q14789: 'GOLGB1',
    Q14790: 'CASP8',
    Q147X3: 'NAA30',
    Q14802: 'FXYD3',
    Q14807: 'KIF22',
    Q14814: 'MEF2D',
    Q14831: 'GRM7',
    Q14832: 'GRM3',
    Q14833: 'GRM4',
    Q14839: 'CHD4',
    Q14847: 'LASP1',
    Q14849: 'STARD3',
    Q14863: 'POU6F1',
    Q14865: 'ARID5B',
    Q14872: 'MTF1',
    Q14894: 'CRYM',
    Q14896: 'MYBPC3',
    Q14914: 'PTGR1',
    Q14916: 'SLC17A1',
    Q14919: 'DRAP1',
    Q14929: 'ZNF169',
    Q14934: 'NFATC4',
    Q14938: 'NFIX',
    Q14940: 'SLC9A5',
    Q14943: 'KIR3DS1',
    Q14953: 'KIR2DS5',
    Q14954: 'KIR2DS1',
    Q14956: 'GPNMB',
    Q14957: 'GRIN2C',
    Q14964: 'RAB39A',
    Q14966: 'ZNF638',
    Q14973: 'SLC10A1',
    Q14974: 'KPNB1',
    Q14978: 'NOLC1',
    Q14980: 'NUMA1',
    Q14982: 'OPCML',
    Q14990: 'ODF1',
    Q14993: 'COL19A1',
    Q14994: 'NR1I3',
    Q14995: 'NR1D2',
    Q14997: 'PSME4',
    Q14999: 'CUL7',
    Q149M9: 'NWD1',
    Q149N8: 'SHPRH',
    Q14BN4: 'SLMAP',
    Q14C86: 'GAPVD1',
    Q14CB8: 'ARHGAP19',
    Q14CM0: 'FRMPD4',
    Q14CN2: 'CLCA4',
    Q14CN4: 'KRT72',
    Q14CS0: 'UBXN2B',
    Q14CW9: 'ATXN7L3',
    Q14CX7: 'NAA25',
    Q14CZ7: 'FASTKD3',
    Q14CZ8: 'HEPACAM',
    Q14D04: 'VEPH1',
    Q14D33: 'RTP5',
    Q15003: 'NCAPH',
    Q15004: 'PCLAF',
    Q15005: 'SPCS2',
    Q15006: 'EMC2',
    Q15007: 'WTAP',
    Q15008: 'PSMD6',
    Q15011: 'HERPUD1',
    Q15012: 'LAPTM4A',
    Q15013: 'MAD2L1BP',
    Q15014: 'MORF4L2',
    Q15018: 'ABRAXAS2',
    Q15019: 'SEPTIN2',
    Q15020: 'SART3',
    Q15021: 'NCAPD2',
    Q15022: 'SUZ12',
    Q15024: 'EXOSC7',
    Q15025: 'TNIP1',
    Q15027: 'ACAP1',
    Q15029: 'EFTUD2',
    Q15031: 'LARS2',
    Q15036: 'SNX17',
    Q15038: 'DAZAP2',
    Q15040: 'JOSD1',
    Q15041: 'ARL6IP1',
    Q15042: 'RAB3GAP1',
    Q15043: 'SLC39A14',
    Q15046: 'KARS1',
    Q15047: 'SETDB1',
    Q15049: 'MLC1',
    Q15050: 'RRS1',
    Q15051: 'IQCB1',
    Q15052: 'ARHGEF6',
    Q15054: 'POLD3',
    Q15056: 'EIF4H',
    Q15057: 'ACAP2',
    Q15058: 'KIF14',
    Q15059: 'BRD3',
    Q15061: 'WDR43',
    Q15063: 'POSTN',
    Q15067: 'ACOX1',
    Q15070: 'OXA1L',
    Q15072: 'ZNF146',
    Q15075: 'EEA1',
    Q15077: 'P2RY6',
    Q15078: 'CDK5R1',
    Q15080: 'NCF4',
    Q15084: 'PDIA6',
    Q15102: 'PAFAH1B3',
    Q15109: 'AGER',
    Q15111: 'PLCL1',
    Q15113: 'PCOLCE',
    Q15116: 'PDCD1',
    Q15118: 'PDK1',
    Q15119: 'PDK2',
    Q15120: 'PDK3',
    Q15121: 'PEA15',
    Q15124: 'PGM5',
    Q15125: 'EBP',
    Q15126: 'PMVK',
    Q15131: 'CDK10',
    Q15139: 'PRKD1',
    Q15147: 'PLCB4',
    Q15149: 'PLEC',
    Q15154: 'PCM1',
    Q15155: 'NOMO1',
    Q15165: 'PON2',
    Q15166: 'PON3',
    Q15170: 'TCEAL1',
    Q15172: 'PPP2R5A',
    Q15173: 'PPP2R5B',
    Q15185: 'PTGES3',
    Q15208: 'STK38',
    Q15223: 'NECTIN1',
    Q15233: 'NONO',
    Q15256: 'PTPRR',
    Q15257: 'PTPA',
    Q15262: 'PTPRK',
    Q15274: 'QPRT',
    Q15276: 'RABEP1',
    Q15283: 'RASA2',
    Q15286: 'RAB35',
    Q15287: 'RNPS1',
    Q15291: 'RBBP5',
    Q15293: 'RCN1',
    Q15303: 'ERBB4',
    Q15306: 'IRF4',
    Q15311: 'RALBP1',
    Q15319: 'POU4F3',
    Q15323: 'KRT31',
    Q15326: 'ZMYND11',
    Q15327: 'ANKRD1',
    Q15329: 'E2F5',
    Q15334: 'LLGL1',
    Q15345: 'LRRC41',
    Q15349: 'RPS6KA2',
    Q15361: 'TTF1',
    Q15363: 'TMED2',
    Q15365: 'PCBP1',
    Q15366: 'PCBP2',
    Q15369: 'ELOC',
    Q15370: 'ELOB',
    Q15375: 'EPHA7',
    Q15382: 'RHEB',
    Q15386: 'UBE3C',
    Q15388: 'TOMM20',
    Q15389: 'ANGPT1',
    Q15392: 'DHCR24',
    Q15393: 'SF3B3',
    Q15397: 'PUM3',
    Q15398: 'DLGAP5',
    Q15399: 'TLR1',
    Q15406: 'NR6A1',
    Q15413: 'RYR3',
    Q15415: 'RBMY1F',
    Q15415: 'RBMY1J',
    Q15417: 'CNN3',
    Q15418: 'RPS6KA1',
    Q15424: 'SAFB',
    Q15427: 'SF3B4',
    Q15428: 'SF3A2',
    Q15431: 'SYCP1',
    Q15435: 'PPP1R7',
    Q15436: 'SEC23A',
    Q15437: 'SEC23B',
    Q15438: 'CYTH1',
    Q15459: 'SF3A1',
    Q15464: 'SHB',
    Q15465: 'SHH',
    Q15466: 'NR0B2',
    Q15468: 'STIL',
    Q15475: 'SIX1',
    Q15477: 'SKIC2',
    Q15485: 'FCN2',
    Q15493: 'RGN',
    Q15506: 'SPA17',
    Q15517: 'CDSN',
    Q15526: 'SURF1',
    Q15528: 'MED22',
    Q15532: 'SS18',
    Q15542: 'TAF5',
    Q15543: 'TAF13',
    Q15544: 'TAF11',
    Q15545: 'TAF7',
    Q15546: 'MMD',
    Q15554: 'TERF2',
    Q15555: 'MAPRE2',
    Q15560: 'TCEA2',
    Q15561: 'TEAD4',
    Q15562: 'TEAD2',
    Q15569: 'TESK1',
    Q15572: 'TAF1C',
    Q15573: 'TAF1A',
    Q15582: 'TGFBI',
    Q15583: 'TGIF1',
    Q15596: 'NCOA2',
    Q15599: 'NHERF2',
    Q155Q3: 'DIXDC1',
    Q15628: 'TRADD',
    Q15629: 'TRAM1',
    Q15631: 'TSN',
    Q15633: 'TARBP2',
    Q15637: 'SF1',
    Q15642: 'TRIP10',
    Q15643: 'TRIP11',
    Q15645: 'TRIP13',
    Q15646: 'OASL',
    Q15648: 'MED1',
    Q15649: 'ZNHIT3',
    Q15650: 'TRIP4',
    Q15651: 'HMGN3',
    Q15652: 'JMJD1C',
    Q15653: 'NFKBIB',
    Q15654: 'TRIP6',
    Q15669: 'RHOH',
    Q15672: 'TWIST1',
    Q15678: 'PTPN14',
    Q15691: 'MAPRE1',
    Q15696: 'ZRSR2',
    Q15697: 'ZNF174',
    Q15699: 'ALX1',
    Q15700: 'DLG2',
    Q15714: 'TSC22D1',
    Q15717: 'ELAVL1',
    Q15722: 'LTB4R',
    Q15723: 'ELF2',
    Q15726: 'KISS1',
    Q15735: 'INPP5J',
    Q15738: 'NSDHL',
    Q15742: 'NAB2',
    Q15743: 'GPR68',
    Q15744: 'CEBPE',
    Q15746: 'MYLK',
    Q15750: 'TAB1',
    Q15751: 'HERC1',
    Q15758: 'SLC1A5',
    Q15759: 'MAPK11',
    Q15761: 'NPY5R',
    Q15762: 'CD226',
    Q15768: 'EFNB3',
    Q15771: 'RAB30',
    Q15772: 'SPEG',
    Q15776: 'ZKSCAN8',
    Q15777: 'MPPED2',
    Q15782: 'CHI3L2',
    Q15784: 'NEUROD2',
    Q15785: 'TOMM34',
    Q15788: 'NCOA1',
    Q15796: 'SMAD2',
    Q15797: 'SMAD1',
    Q15800: 'MSMO1',
    Q15811: 'ITSN1',
    Q15813: 'TBCE',
    Q15814: 'TBCC',
    Q15818: 'NPTX1',
    Q15819: 'UBE2V2',
    Q15822: 'CHRNA2',
    Q15825: 'CHRNA6',
    Q15828: 'CST6',
    Q15831: 'STK11',
    Q15833: 'STXBP2',
    Q15834: 'CCDC85B',
    Q15835: 'GRK1',
    Q15836: 'VAMP3',
    Q15842: 'KCNJ8',
    Q15843: 'NEDD8',
    Q15848: 'ADIPOQ',
    Q15849: 'SLC14A2',
    Q15853: 'USF2',
    Q15858: 'SCN9A',
    Q15878: 'CACNA1E',
    Q15904: 'ATP6AP1',
    Q15906: 'VPS72',
    Q15907: 'RAB11B',
    Q15910: 'EZH2',
    Q15911: 'ZFHX3',
    Q15915: 'ZIC1',
    Q15916: 'ZBTB6',
    Q15928: 'ZNF141',
    Q15935: 'ZNF77',
    Q15942: 'ZYX',
    Q15973: 'ZNF124',
    Q16082: 'HSPB2',
    Q16099: 'GRIK4',
    Q16134: 'ETFDH',
    Q16143: 'SNCB',
    Q16181: 'SEPTIN7',
    Q16186: 'ADRM1',
    Q16204: 'CCDC6',
    Q16206: 'ENOX2',
    Q16222: 'UAP1',
    Q16236: 'NFE2L2',
    Q16254: 'E2F4',
    Q16270: 'IGFBP7',
    Q16280: 'CNGA2',
    Q16281: 'CNGA3',
    Q16288: 'NTRK3',
    Q16322: 'KCNA10',
    Q16342: 'PDCD2',
    Q16348: 'SLC15A2',
    Q16352: 'INA',
    Q16363: 'LAMA4',
    Q16384: 'SSX1',
    Q16385: 'SSX2',
    Q16385: 'SSX2B',
    Q16394: 'EXT1',
    Q16401: 'PSMD5',
    Q16445: 'GABRA6',
    Q16478: 'GRIK5',
    Q16512: 'PKN1',
    Q16513: 'PKN2',
    Q16514: 'TAF12',
    Q16515: 'ASIC2',
    Q16518: 'RPE65',
    Q16520: 'BATF',
    Q16526: 'CRY1',
    Q16527: 'CSRP2',
    Q16531: 'DDB1',
    Q16533: 'SNAPC1',
    Q16534: 'HLF',
    Q16537: 'PPP2R5E',
    Q16539: 'MAPK14',
    Q16540: 'MRPL23',
    Q16543: 'CDC37',
    Q16548: 'BCL2A1',
    Q16549: 'PCSK7',
    Q16552: 'IL17A',
    Q16553: 'LY6E',
    Q16555: 'DPYSL2',
    Q16558: 'KCNMB1',
    Q16560: 'SNRNP35',
    Q16563: 'SYPL1',
    Q16566: 'CAMK4',
    Q16568: 'CARTPT',
    Q16570: 'ACKR1',
    Q16572: 'SLC18A3',
    Q16576: 'RBBP7',
    Q16581: 'C3AR1',
    Q16584: 'MAP3K11',
    Q16585: 'SGCB',
    Q16586: 'SGCA',
    Q16587: 'ZNF74',
    Q16594: 'TAF9',
    Q16595: 'FXN',
    Q16600: 'ZNF239',
    Q16602: 'CALCRL',
    Q16610: 'ECM1',
    Q16611: 'BAK1',
    Q16612: 'NREP',
    Q16613: 'AANAT',
    Q16617: 'NKG7',
    Q16619: 'CTF1',
    Q16620: 'NTRK2',
    Q16621: 'NFE2',
    Q16623: 'STX1A',
    Q16625: 'OCLN',
    Q16627: 'CCL14',
    Q16629: 'SRSF7',
    Q16630: 'CPSF6',
    Q16633: 'POU2AF1',
    Q16635: 'TAFAZZIN',
    Q16637: 'SMN1',
    Q16637: 'SMN2',
    Q16643: 'DBN1',
    Q16644: 'MAPKAPK3',
    Q16647: 'PTGIS',
    Q16649: 'NFIL3',
    Q16650: 'TBR1',
    Q16651: 'PRSS8',
    Q16653: 'MOG',
    Q16654: 'PDK4',
    Q16655: 'MLANA',
    Q16656: 'NRF1',
    Q16658: 'FSCN1',
    Q16659: 'MAPK6',
    Q16663: 'CCL15',
    Q16665: 'HIF1A',
    Q16666: 'IFI16',
    Q16667: 'CDKN3',
    Q16670: 'ZSCAN26',
    Q16671: 'AMHR2',
    Q16674: 'MIA',
    Q16676: 'FOXD1',
    Q16678: 'CYP1B1',
    Q16690: 'DUSP5',
    Q16695: 'H3-4',
    Q16696: 'CYP2A13',
    Q16698: 'DECR1',
    Q16706: 'MAN2A1',
    Q16718: 'NDUFA5',
    Q16719: 'KYNU',
    Q16720: 'ATP2B3',
    Q16739: 'UGCG',
    Q16740: 'CLPP',
    Q16760: 'DGKD',
    Q16762: 'TST',
    Q16763: 'UBE2S',
    Q16769: 'QPCT',
    Q16772: 'GSTA3',
    Q16773: 'KYAT1',
    Q16774: 'GUK1',
    Q16775: 'HAGH',
    Q16777: 'H2AC20',
    Q16778: 'H2BC21',
    Q16787: 'LAMA3',
    Q16790: 'CA9',
    Q16795: 'NDUFA9',
    Q16798: 'ME3',
    Q16799: 'RTN1',
    Q16816: 'PHKG1',
    Q16819: 'MEP1A',
    Q16820: 'MEP1B',
    Q16821: 'PPP1R3A',
    Q16822: 'PCK2',
    Q16825: 'PTPN21',
    Q16827: 'PTPRO',
    Q16828: 'DUSP6',
    Q16829: 'DUSP7',
    Q16831: 'UPP1',
    Q16832: 'DDR2',
    Q16836: 'HADH',
    Q16842: 'ST3GAL2',
    Q16849: 'PTPRN',
    Q16850: 'CYP51A1',
    Q16851: 'UGP2',
    Q16853: 'AOC3',
    Q16854: 'DGUOK',
    Q16864: 'ATP6V1F',
    Q16873: 'LTC4S',
    Q16875: 'PFKFB3',
    Q16877: 'PFKFB4',
    Q16878: 'CDO1',
    Q16880: 'UGT8',
    Q16881: 'TXNRD1',
    Q16890: 'TPD52L1',
    Q16891: 'IMMT',
    Q17R60: 'IMPG1',
    Q17R89: 'ARHGAP44',
    Q17R98: 'ZNF827',
    Q17RB8: 'LONRF1',
    Q17RD7: 'SYT16',
    Q17RS7: 'GEN1',
    Q17RW2: 'COL24A1',
    Q17RY0: 'CPEB4',
    Q18PE1: 'DOK7',
    Q19T08: 'ECSCR',
    Q1EHB4: 'SLC5A12',
    Q1HG43: 'DUOXA1',
    Q1HG44: 'DUOXA2',
    Q1L5Z9: 'LONRF2',
    Q1MSJ5: 'CSPP1',
    Q1MX18: 'INSC',
    Q1RMZ1: 'BMT2',
    Q1W6H9: 'FAM110C',
    Q24JP5: 'TMEM132A',
    Q27J81: 'INF2',
    Q29980: 'MICB',
    Q29983: 'MICA',
    Q29RF7: 'PDS5A',
    Q2HXU8: 'CLEC12B',
    Q2I0M4: 'LRRC26',
    Q2I0M5: 'RSPO4',
    Q2KHM9: 'KIAA0753',
    Q2KHN1: 'RNF151',
    Q2KHR2: 'RFX7',
    Q2KHT3: 'CLEC16A',
    Q2KHT4: 'GSG1',
    Q2LD37: 'BLTP1',
    Q2M1K9: 'ZNF423',
    Q2M1P5: 'KIF7',
    Q2M1Z3: 'ARHGAP31',
    Q2M2E3: 'ODF4',
    Q2M2I5: 'KRT24',
    Q2M2I8: 'AAK1',
    Q2M2Z5: 'KIZ',
    Q2M385: 'MPEG1',
    Q2M389: 'WASHC4',
    Q2M3C6: 'TMEM266',
    Q2M3C7: 'SPHKAP',
    Q2M3G0: 'ABCB5',
    Q2M3M2: 'SLC5A9',
    Q2M3R5: 'SLC35G1',
    Q2M3T9: 'HYAL4',
    Q2MKA7: 'RSPO1',
    Q2MV58: 'TCTN1',
    Q2NKJ3: 'CTC1',
    Q2NKQ1: 'SGSM1',
    Q2NKX8: 'ERCC6L',
    Q2NL67: 'PARP6',
    Q2PPJ7: 'RALGAPA2',
    Q2Q1W2: 'TRIM71',
    Q2QGD7: 'ZXDC',
    Q2QL34: 'MPV17L',
    Q2T9J0: 'TYSND1',
    Q2TAA5: 'ALG11',
    Q2TAC2: 'CCDC57',
    Q2TAK8: 'PWWP3A',
    Q2TAL6: 'VWC2',
    Q2TAL8: 'QRICH1',
    Q2TAY7: 'SMU1',
    Q2TAZ0: 'ATG2A',
    Q2TB90: 'HKDC1',
    Q2TBA0: 'KLHL40',
    Q2TBE0: 'CWF19L2',
    Q2UY09: 'COL28A1',
    Q2V2M9: 'FHOD3',
    Q2VIQ3: 'KIF4B',
    Q2VPA4: 'CR1L',
    Q2VPK5: 'CTU2',
    Q2VWA4: 'SKOR2',
    Q2WEN9: 'CEACAM16',
    Q2WGJ6: 'KLHL38',
    Q2Y0W8: 'SLC4A8',
    Q2YD98: 'UVSSA',
    Q30154: 'HLA-DRB5',
    Q30201: 'HFE',
    Q30KQ6: 'DEFB114',
    Q32M45: 'ANO4',
    Q32M88: 'PGGHG',
    Q32MK0: 'MYLK3',
    Q32MQ0: 'ZNF750',
    Q32MZ4: 'LRRFIP1',
    Q32NB8: 'PGS1',
    Q32P28: 'P3H1',
    Q32P41: 'TRMT5',
    Q32P44: 'EML3',
    Q330K2: 'NDUFAF6',
    Q33E94: 'RFX4',
    Q38SD2: 'LRRK1',
    Q3B7T1: 'EDRF1',
    Q3B820: 'FAM161A',
    Q3KNS1: 'PTCHD3',
    Q3KNS6: 'ZNF829',
    Q3KNV8: 'PCGF3',
    Q3KNW5: 'SLC10A6',
    Q3KP44: 'ANKRD55',
    Q3KP66: 'INAVA',
    Q3KQV3: 'ZNF792',
    Q3KR16: 'PLEKHG6',
    Q3KR37: 'GRAMD1B',
    Q3KRA9: 'ALKBH6',
    Q3KRB8: 'ARHGAP11B',
    Q3L8U1: 'CHD9',
    Q3LHN2: 'KRTAP19-2',
    Q3LI59: 'KRTAP21-2',
    Q3LI64: 'KRTAP6-1',
    Q3LI66: 'KRTAP6-2',
    Q3LI70: 'KRTAP19-6',
    Q3LI72: 'KRTAP19-5',
    Q3LI76: 'KRTAP15-1',
    Q3LXA3: 'TKFC',
    Q3MHD2: 'LSM12',
    Q3MII6: 'TBC1D25',
    Q3MIR4: 'TMEM30B',
    Q3MIT2: 'PUS10',
    Q3MIW9: 'MUCL3',
    Q3MJ16: 'PLA2G4E',
    Q3MJ62: 'ZSCAN23',
    Q3MUY2: 'PIGY',
    Q3SXM5: 'HSDL1',
    Q3SXP7: 'SHISAL1',
    Q3SXR2: 'C3orf36',
    Q3SXY7: 'LRIT3',
    Q3SXY8: 'ARL13B',
    Q3SXZ7: 'TTLL9',
    Q3SY00: 'TSGA10IP',
    Q3SY46: 'KRTAP13-3',
    Q3SY56: 'SP6',
    Q3SY69: 'ALDH1L2',
    Q3SY84: 'KRT71',
    Q3SYB3: 'FOXD4L6',
    Q3SYC2: 'MOGAT2',
    Q3SYF9: 'KRTAP19-7',
    Q3SYG4: 'BBS9',
    Q3T8J9: 'GON4L',
    Q3T906: 'GNPTAB',
    Q3V5L5: 'MGAT5B',
    Q3V6T2: 'CCDC88A',
    Q3YBM2: 'TMEM176B',
    Q3YBR2: 'TBRG1',
    Q3YEC7: 'RABL6',
    Q3ZAQ7: 'VMA21',
    Q3ZCM7: 'TUBB8',
    Q3ZCQ8: 'TIMM50',
    Q401N2: 'ZACN',
    Q460N3: 'PARP15',
    Q460N5: 'PARP14',
    Q494R4: 'CCDC153',
    Q494U1: 'PLEKHN1',
    Q494V2: 'CFAP100',
    Q495A1: 'TIGIT',
    Q495C1: 'RNF212',
    Q495M3: 'SLC36A2',
    Q495M9: 'USH1G',
    Q495T6: 'MMEL1',
    Q495W5: 'FUT11',
    Q496A3: 'SPATS1',
    Q496F6: 'CD300E',
    Q496J9: 'SV2C',
    Q496M5: 'PLK5',
    Q49A17: 'GALNTL6',
    Q49A26: 'GLYR1',
    Q49A88: 'CCDC14',
    Q49AJ0: 'FAM135B',
    Q49AM1: 'MTERF2',
    Q49AN0: 'CRY2',
    Q49MG5: 'MAP9',
    Q49MI3: 'CERKL',
    Q4AC94: 'C2CD3',
    Q4ADV7: 'RIC1',
    Q4FZB7: 'KMT5B',
    Q4G0J3: 'LARP7',
    Q4G0N4: 'NADK2',
    Q4G0N8: 'SLC9C1',
    Q4G0P3: 'HYDIN',
    Q4G0S4: 'CYP27C1',
    Q4G0U5: 'CFAP221',
    Q4G0W2: 'DUSP28',
    Q4G0X4: 'KCTD21',
    Q4G0X9: 'CCDC40',
    Q4G163: 'FBXO43',
    Q4G176: 'ACSF3',
    Q4J6C6: 'PREPL',
    Q4JDL3: 'PTPN20',
    Q4KMG0: 'CDON',
    Q4KMG9: 'TMEM52B',
    Q4KMP7: 'TBC1D10B',
    Q4KMQ1: 'TPRN',
    Q4KMQ2: 'ANO6',
    Q4KWH8: 'PLCH1',
    Q4L180: 'FILIP1L',
    Q4L235: 'AASDH',
    Q4LDE5: 'SVEP1',
    Q4LDG9: 'DNAL1',
    Q4LDR2: 'CTXN3',
    Q4LE39: 'ARID4B',
    Q4U2R8: 'SLC22A6',
    Q4V328: 'GRIPAP1',
    Q4V9L6: 'TMEM119',
    Q4VC05: 'BCL7A',
    Q4VC12: 'MSS51',
    Q4VC44: 'FLYWCH1',
    Q4VCS5: 'AMOT',
    Q4VNC1: 'ATP13A4',
    Q4ZG55: 'GREB1',
    Q4ZHG4: 'FNDC1',
    Q4ZJI4: 'SLC9B1',
    Q502W6: 'VWA3B',
    Q504Q3: 'PAN2',
    Q504Y0: 'SLC39A12',
    Q504Y2: 'PKDCC',
    Q504Y3: 'ZCWPW2',
    Q52LG2: 'KRTAP13-2',
    Q52LJ0: 'FAM98B',
    Q52LR7: 'EPC2',
    Q52LW3: 'ARHGAP29',
    Q53EL6: 'PDCD4',
    Q53EL9: 'SEZ6',
    Q53EP0: 'FNDC3B',
    Q53ET0: 'CRTC2',
    Q53EU6: 'GPAT3',
    Q53EZ4: 'CEP55',
    Q53F19: 'NCBP3',
    Q53F39: 'MPPE1',
    Q53FA7: 'TP53I3',
    Q53FD0: 'ZC2HC1C',
    Q53FP2: 'TMEM35A',
    Q53FT3: 'HIKESHI',
    Q53FV1: 'ORMDL2',
    Q53FZ2: 'ACSM3',
    Q53G59: 'KLHL12',
    Q53GA4: 'PHLDA2',
    Q53GD3: 'SLC44A4',
    Q53GG5: 'PDLIM3',
    Q53GL0: 'PLEKHO1',
    Q53GL7: 'PARP10',
    Q53GQ0: 'HSD17B12',
    Q53GS7: 'GLE1',
    Q53GS9: 'USP39',
    Q53GT1: 'KLHL22',
    Q53H12: 'AGK',
    Q53H47: 'SETMAR',
    Q53H54: 'TRMT12',
    Q53H76: 'PLA1A',
    Q53H80: 'AKIRIN2',
    Q53H82: 'LACTB2',
    Q53H96: 'PYCR3',
    Q53HC0: 'CCDC92',
    Q53HC9: 'EIPR1',
    Q53HI1: 'UNC50',
    Q53HL2: 'CDCA8',
    Q53HV7: 'SMUG1',
    Q53QV2: 'LBH',
    Q53R12: 'TM4SF20',
    Q53R41: 'FASTKD1',
    Q53RT3: 'ASPRV1',
    Q53S33: 'BOLA3',
    Q53T94: 'TAF1B',
    Q53TN4: 'CYBRD1',
    Q53TQ3: 'INO80D',
    Q53TS8: 'C2CD6',
    Q562E7: 'WDR81',
    Q562F6: 'SGO2',
    Q567U6: 'CCDC93',
    Q569K4: 'ZNF385B',
    Q56NI9: 'ESCO2',
    Q56P03: 'EAPP',
    Q56P42: 'PYDC2',
    Q56UN5: 'MAP3K19',
    Q587J8: 'KHDC3L',
    Q58A45: 'PAN3',
    Q58DX5: 'NAALADL2',
    Q58EX2: 'SDK2',
    Q58EX7: 'PLEKHG4',
    Q58F21: 'BRDT',
    Q58HT5: 'AWAT1',
    Q58WW2: 'DCAF6',
    Q59EK9: 'RUNDC3A',
    Q59H18: 'TNNI3K',
    Q5BJD5: 'TMEM41B',
    Q5BJF2: 'TMEM97',
    Q5BJF6: 'ODF2',
    Q5BJH2: 'TMEM128',
    Q5BJH7: 'YIF1B',
    Q5BKT4: 'ALG10',
    Q5BKX5: 'ACTMAP',
    Q5BKX8: 'CAVIN4',
    Q5BKZ1: 'ZNF326',
    Q5BVD1: 'TTMP',
    Q5C9Z4: 'NOM1',
    Q5CZC0: 'FSIP2',
    Q5D0E6: 'DALRD3',
    Q5D1E8: 'ZC3H12A',
    Q5D862: 'FLG2',
    Q5DID0: 'UMODL1',
    Q5DX21: 'IGSF11',
    Q5EB52: 'MEST',
    Q5EBL4: 'RILPL1',
    Q5EBL8: 'PDZD11',
    Q5EBM0: 'CMPK2',
    Q5EE01: 'CENPW',
    Q5EG05: 'CARD16',
    Q5F1R6: 'DNAJC21',
    Q5FBB7: 'SGO1',
    Q5FVE4: 'ACSBG2',
    Q5FWF4: 'ZRANB3',
    Q5FWF5: 'ESCO1',
    Q5FYB1: 'ARSI',
    Q5GFL6: 'VWA2',
    Q5GH76: 'XKR4',
    Q5GJ75: 'TNFAIP8L3',
    Q5GLZ8: 'HERC4',
    Q5H8A4: 'PIGG',
    Q5H8C1: 'FREM1',
    Q5H9F3: 'BCORL1',
    Q5H9I0: 'TFDP3',
    Q5H9J7: 'BEX5',
    Q5H9R7: 'PPP6R3',
    Q5H9S7: 'DCAF17',
    Q5HYA8: 'TMEM67',
    Q5HYI8: 'RABL3',
    Q5HYJ3: 'FAM76B',
    Q5HYK3: 'COQ5',
    Q5HYK7: 'SH3D19',
    Q5HYN5: 'CT45A1',
    Q5HYW2: 'NHSL2',
    Q5I7T1: 'ALG10B',
    Q5IJ48: 'CRB2',
    Q5J8M3: 'EMC4',
    Q5J8X5: 'MS4A13',
    Q5JPE7: 'NOMO2',
    Q5JPH6: 'EARS2',
    Q5JPI9: 'EEF1AKMT2',
    Q5JQC9: 'AKAP4',
    Q5JR59: 'MTUS2',
    Q5JR98: 'DYNLT4',
    Q5JRA6: 'MIA3',
    Q5JRX3: 'PITRM1',
    Q5JS13: 'RALGPS1',
    Q5JSH3: 'WDR44',
    Q5JSP0: 'FGD3',
    Q5JST6: 'EFHC2',
    Q5JT25: 'RAB41',
    Q5JTC6: 'AMER1',
    Q5JTD0: 'TJAP1',
    Q5JTH9: 'RRP12',
    Q5JTJ3: 'COA6',
    Q5JTV8: 'TOR1AIP1',
    Q5JTW2: 'CEP78',
    Q5JTZ9: 'AARS2',
    Q5JU85: 'IQSEC2',
    Q5JUK2: 'SOHLH1',
    Q5JUK3: 'KCNT1',
    Q5JVF3: 'PCID2',
    Q5JVL4: 'EFHC1',
    Q5JVS0: 'HABP4',
    Q5JWF2: 'GNAS',
    Q5JX71: 'FAM209A',
    Q5JXC2: 'MIIP',
    Q5JY77: 'GPRASP1',
    Q5JZY3: 'EPHA10',
    Q5K4E3: 'PRSS36',
    Q5K4L6: 'SLC27A3',
    Q5K651: 'SAMD9',
    Q5KSL6: 'DGKK',
    Q5KU26: 'COLEC12',
    Q5M775: 'SPECC1',
    Q5M7Z0: 'RNFT1',
    Q5MIZ7: 'PPP4R3B',
    Q5MJ10: 'SPANXN2',
    Q5MJ70: 'SPDYA',
    Q5MNZ6: 'WDR45B',
    Q5MNZ9: 'WIPI1',
    Q5MY95: 'ENTPD8',
    Q5NDL2: 'EOGT',
    Q5NUL3: 'FFAR4',
    Q5PRF9: 'SAMD4B',
    Q5PSV4: 'BRMS1L',
    Q5QGS0: 'NEXMIF',
    Q5QGT7: 'RTP2',
    Q5QGZ9: 'CLEC12A',
    Q5QJE6: 'DNTTIP2',
    Q5QJU3: 'ACER2',
    Q5QNW6: 'H2BC18',
    Q5QP82: 'DCAF10',
    Q5R372: 'RABGAP1L',
    Q5R3F8: 'ELFN2',
    Q5RI15: 'COX20',
    Q5RKV6: 'EXOSC6',
    Q5RL73: 'RBM48',
    Q5S007: 'LRRK2',
    Q5SGD2: 'PPM1L',
    Q5SNT2: 'TMEM201',
    Q5SQ64: 'LY6G6F',
    Q5SQI0: 'ATAT1',
    Q5SQN1: 'SNAP47',
    Q5SQQ9: 'VAX1',
    Q5SR56: 'MFSD14B',
    Q5SRE5: 'NUP188',
    Q5SRE7: 'PHYHD1',
    Q5SRR4: 'LY6G5C',
    Q5SSG8: 'MUC21',
    Q5SSJ5: 'HP1BP3',
    Q5ST30: 'VARS2',
    Q5SVS4: 'SLC25A30',
    Q5SW24: 'DACT2',
    Q5SW79: 'CEP170',
    Q5SW96: 'LDLRAP1',
    Q5SWA1: 'PPP1R15B',
    Q5SWW7: 'C10orf55',
    Q5SXH7: 'PLEKHS1',
    Q5SXM2: 'SNAPC4',
    Q5SY16: 'NOL9',
    Q5SYB0: 'FRMPD1',
    Q5SYC1: 'CLVS2',
    Q5SZK8: 'FREM2',
    Q5SZL2: 'CEP85L',
    Q5SZQ8: 'CELF3',
    Q5T011: 'SZT2',
    Q5T0F9: 'CC2D1B',
    Q5T0J7: 'TEX35',
    Q5T0N1: 'CFAP70',
    Q5T0N5: 'FNBP1L',
    Q5T0T0: 'MARCHF8',
    Q5T0W9: 'FAM83B',
    Q5T124: 'UBXN11',
    Q5T160: 'RARS2',
    Q5T197: 'DCST1',
    Q5T1C6: 'THEM4',
    Q5T1H1: 'EYS',
    Q5T1M5: 'FKBP15',
    Q5T1R4: 'HIVEP3',
    Q5T1V6: 'DDX59',
    Q5T200: 'ZC3H13',
    Q5T230: 'UTF1',
    Q5T280: 'SPOUT1',
    Q5T2D2: 'TREML2',
    Q5T2D3: 'OTUD3',
    Q5T2R2: 'PDSS1',
    Q5T2S8: 'ODAD2',
    Q5T2T1: 'MPP7',
    Q5T2W1: 'PDZK1',
    Q5T3J3: 'LRIF1',
    Q5T3U5: 'ABCC10',
    Q5T440: 'IBA57',
    Q5T442: 'GJC2',
    Q5T447: 'HECTD3',
    Q5T481: 'RBM20',
    Q5T4B2: 'CERCAM',
    Q5T4D3: 'TMTC4',
    Q5T4F4: 'ZFYVE27',
    Q5T4F7: 'SFRP5',
    Q5T4S7: 'UBR4',
    Q5T4W7: 'ARTN',
    Q5T5A8: 'LCE3C',
    Q5T5B0: 'LCE3E',
    Q5T5C0: 'STXBP5',
    Q5T5P2: 'KIAA1217',
    Q5T5U3: 'ARHGAP21',
    Q5T5X7: 'BEND3',
    Q5T5Y3: 'CAMSAP1',
    Q5T601: 'ADGRF1',
    Q5T619: 'ZNF648',
    Q5T655: 'CFAP58',
    Q5T686: 'AVPI1',
    Q5T6F0: 'DCAF12',
    Q5T6F2: 'UBAP2',
    Q5T6S3: 'PHF19',
    Q5T6X5: 'GPRC6A',
    Q5T700: 'LDLRAD1',
    Q5T749: 'KPRP',
    Q5T751: 'LCE1C',
    Q5T752: 'LCE1D',
    Q5T753: 'LCE1E',
    Q5T754: 'LCE1F',
    Q5T7B8: 'KIF24',
    Q5T7M4: 'C1QTNF12',
    Q5T7N3: 'KANK4',
    Q5T7P2: 'LCE1A',
    Q5T7P3: 'LCE1B',
    Q5T7P8: 'SYT6',
    Q5T7V8: 'GORAB',
    Q5T7W0: 'ZNF618',
    Q5T7W7: 'TSTD2',
    Q5T890: 'ERCC6L2',
    Q5T8A7: 'PPP1R26',
    Q5T8D3: 'ACBD5',
    Q5T8I9: 'HENMT1',
    Q5T9A4: 'ATAD3B',
    Q5T9C9: 'PIP5KL1',
    Q5T9G4: 'ARMC12',
    Q5T9L3: 'WLS',
    Q5TA31: 'RNF187',
    Q5TA45: 'INTS11',
    Q5TA50: 'CPTP',
    Q5TA76: 'LCE3A',
    Q5TA77: 'LCE3B',
    Q5TA78: 'LCE4A',
    Q5TA79: 'LCE2A',
    Q5TA81: 'LCE2C',
    Q5TA82: 'LCE2D',
    Q5TA89: 'HES5',
    Q5TAB7: 'RIPPLY2',
    Q5TAP6: 'UTP14C',
    Q5TAQ9: 'DCAF8',
    Q5TAT6: 'COL13A1',
    Q5TAX3: 'TUT4',
    Q5TB30: 'DEPDC1',
    Q5TB80: 'CEP162',
    Q5TBA9: 'FRY',
    Q5TBB1: 'RNASEH2B',
    Q5TC82: 'RC3H1',
    Q5TCH4: 'CYP4A22',
    Q5TCM9: 'LCE5A',
    Q5TCQ9: 'MAGI3',
    Q5TCS8: 'AK9',
    Q5TCX8: 'MAP3K21',
    Q5TCY1: 'TTBK1',
    Q5TCZ1: 'SH3PXD2A',
    Q5TD94: 'RSPH4A',
    Q5TD97: 'FHL5',
    Q5TDH0: 'DDI2',
    Q5TEJ8: 'THEMIS2',
    Q5TEU4: 'NDUFAF5',
    Q5TGU0: 'TSPO2',
    Q5TGZ0: 'MICOS10',
    Q5TH69: 'ARFGEF3',
    Q5THJ4: 'VPS13D',
    Q5THR3: 'EFCAB6',
    Q5TKA1: 'LIN9',
    Q5TZA2: 'CROCC',
    Q5TZF3: 'ANKRD45',
    Q5TZK3: 'FAM74A4',
    Q5TZK3: 'FAM74A6',
    Q5U5Q3: 'MEX3C',
    Q5U5X0: 'LYRM7',
    Q5U5Z8: 'AGBL2',
    Q5U651: 'RASIP1',
    Q5UCC4: 'EMC10',
    Q5UE93: 'PIK3R6',
    Q5UIP0: 'RIF1',
    Q5VIR6: 'VPS53',
    Q5VSL9: 'STRIP1',
    Q5VST6: 'ABHD17B',
    Q5VST9: 'OBSCN',
    Q5VSY0: 'GKAP1',
    Q5VT06: 'CEP350',
    Q5VT25: 'CDC42BPA',
    Q5VT52: 'RPRD2',
    Q5VT66: 'MTARC1',
    Q5VT99: 'LRRC38',
    Q5VTB9: 'RNF220',
    Q5VTD9: 'GFI1B',
    Q5VTR2: 'RNF20',
    Q5VTT5: 'MYOM3',
    Q5VTY9: 'HHAT',
    Q5VU43: 'PDE4DIP',
    Q5VU57: 'AGBL4',
    Q5VUA4: 'ZNF318',
    Q5VUB5: 'FAM171A1',
    Q5VUG0: 'SFMBT2',
    Q5VV41: 'ARHGEF16',
    Q5VV42: 'CDKAL1',
    Q5VV43: 'KIAA0319',
    Q5VV67: 'PPRC1',
    Q5VVJ2: 'MYSM1',
    Q5VVQ6: 'YOD1',
    Q5VVX9: 'UBE2U',
    Q5VVY1: 'NTMT2',
    Q5VW38: 'GPR107',
    Q5VWC8: 'HACD4',
    Q5VWG9: 'TAF3',
    Q5VWJ9: 'SNX30',
    Q5VWK5: 'IL23R',
    Q5VWN6: 'TASOR2',
    Q5VWP2: 'TENT5C',
    Q5VWP3: 'MLIP',
    Q5VWQ8: 'DAB2IP',
    Q5VWT5: 'FYB2',
    Q5VWX1: 'KHDRBS2',
    Q5VWZ2: 'LYPLAL1',
    Q5VX71: 'SUSD4',
    Q5VXI9: 'LIPN',
    Q5VXU9: 'SHOC1',
    Q5VY09: 'IER5',
    Q5VY43: 'PEAR1',
    Q5VY80: 'RAET1L',
    Q5VYJ5: 'MALRD1',
    Q5VYK3: 'ECPAS',
    Q5VYS8: 'TUT7',
    Q5VYX0: 'RNLS',
    Q5VZ89: 'DENND4C',
    Q5VZE5: 'NAA35',
    Q5VZF2: 'MBNL2',
    Q5VZK9: 'CARMIL1',
    Q5VZL5: 'ZMYM4',
    Q5VZM2: 'RRAGB',
    Q5VZV1: 'METTL21C',
    Q5VZY2: 'PLPP4',
    Q5W0B1: 'OBI1',
    Q5W0Q7: 'USPL1',
    Q5W0Z9: 'ZDHHC20',
    Q5W111: 'SPRYD7',
    Q5W5X9: 'TTC23',
    Q5XG87: 'TENT4A',
    Q5XKE5: 'KRT79',
    Q5XKP0: 'MICOS13',
    Q5XKR4: 'OTP',
    Q5XLA6: 'CARD17P',
    Q5XPI4: 'RNF123',
    Q5XUX0: 'FBXO31',
    Q5XXA6: 'ANO1',
    Q5ZPR3: 'CD276',
    Q60I27: 'ALS2CL',
    Q63HK5: 'TSHZ3',
    Q63HN8: 'RNF213',
    Q63HQ0: 'AP1AR',
    Q63HQ2: 'EGFLAM',
    Q63HR2: 'TNS2',
    Q63ZY3: 'KANK2',
    Q63ZY6: 'NSUN5P2',
    Q641Q2: 'WASHC2A',
    Q643R3: 'LPCAT4',
    Q64LD2: 'WDR25',
    Q658P3: 'STEAP3',
    Q659A1: 'ICE2',
    Q659C4: 'LARP1B',
    Q66GS9: 'CEP135',
    Q66K64: 'DCAF15',
    Q66K74: 'MAP1S',
    Q66K79: 'CPZ',
    Q66K80: 'RUSC1-AS1',
    Q66K89: 'E4F1',
    Q66PJ3: 'ARL6IP4',
    Q674R7: 'ATG9B',
    Q674X7: 'KAZN',
    Q676U5: 'ATG16L1',
    Q684P5: 'RAP1GAP2',
    Q685J3: 'MUC17',
    Q687X5: 'STEAP4',
    Q68CJ6: 'NUGGC',
    Q68CJ9: 'CREB3L3',
    Q68CK6: 'ACSM2B',
    Q68CL5: 'TPGS2',
    Q68CP4: 'HGSNAT',
    Q68CP9: 'ARID2',
    Q68CQ1: 'MROH7',
    Q68CQ4: 'UTP25',
    Q68CZ1: 'RPGRIP1L',
    Q68CZ2: 'TNS3',
    Q68CZ6: 'HAUS3',
    Q68D06: 'SLFN13',
    Q68D10: 'SPTY2D1',
    Q68D85: 'NCR3LG1',
    Q68D86: 'CCDC102B',
    Q68D91: 'MBLAC2',
    Q68DA7: 'FMN1',
    Q68DC2: 'ANKS6',
    Q68DD2: 'PLA2G4F',
    Q68DE3: 'USF3',
    Q68DK2: 'ZFYVE26',
    Q68DK7: 'MSL1',
    Q68DQ2: 'CRYBG3',
    Q68DV7: 'RNF43',
    Q68DX3: 'FRMPD2',
    Q68E01: 'INTS3',
    Q68EA5: 'ZNF57',
    Q68EM7: 'ARHGAP17',
    Q68G74: 'LHX8',
    Q68G75: 'LEMD1',
    Q68J44: 'DUSP29',
    Q69383: 'ERVK-6',
    Q69384: 'ERVK-6',
    Q693B1: 'KCTD11',
    Q695T7: 'SLC6A19',
    Q69YG0: 'TMEM42',
    Q69YH5: 'CDCA2',
    Q69YI7: 'NAIF1',
    Q69YN4: 'VIRMA',
    Q69YQ0: 'SPECC1L',
    Q6A162: 'KRT40',
    Q6A163: 'KRT39',
    Q6AI14: 'SLC9A4',
    Q6AI39: 'BICRAL',
    Q6AWC2: 'WWC2',
    Q6AZY7: 'SCARA3',
    Q6AZZ1: 'TRIM68',
    Q6B0I6: 'KDM4D',
    Q6B8I1: 'DUSP13A',
    Q6BAA4: 'FCRLB',
    Q6BCY4: 'CYB5R2',
    Q6BDI9: 'REP15',
    Q6DD88: 'ATL3',
    Q6DHV7: 'ADAL',
    Q6DJT9: 'PLAG1',
    Q6DKI2: 'LGALS9C',
    Q6DKI7: 'PVRIG',
    Q6DKJ4: 'NXN',
    Q6DKK2: 'TTC19',
    Q6DN03: 'H2BC20P',
    Q6DN12: 'MCTP2',
    Q6DN14: 'MCTP1',
    Q6DN72: 'FCRL6',
    Q6DN90: 'IQSEC1',
    Q6DRA6: 'H2BC19P',
    Q6DT37: 'CDC42BPG',
    Q6E0U4: 'DMKN',
    Q6E213: 'AWAT2',
    Q6EEV6: 'SUMO4',
    Q6EIG7: 'CLEC6A',
    Q6EMB2: 'TTLL5',
    Q6EMK4: 'VASN',
    Q6F5E8: 'CARMIL2',
    Q6FHJ7: 'SFRP4',
    Q6FI13: 'H2AC18',
    Q6FI13: 'H2AC19',
    Q6FI81: 'CIAPIN1',
    Q6FIF0: 'ZFAND6',
    Q6GMR7: 'FAAH2',
    Q6GMV2: 'SMYD5',
    Q6GPH4: 'XAF1',
    Q6GQQ9: 'OTUD7B',
    Q6GTS8: 'PM20D1',
    Q6GTX8: 'LAIR1',
    Q6GYQ0: 'RALGAPA1',
    Q6H3X3: 'RAET1G',
    Q6H8Q1: 'ABLIM2',
    Q6HA08: 'ASTL',
    Q6I9Y2: 'THOC7',
    Q6IA17: 'SIGIRR',
    Q6IA69: 'NADSYN1',
    Q6IA86: 'ELP2',
    Q6IAA8: 'LAMTOR1',
    Q6IAN0: 'DHRS7B',
    Q6IB77: 'GLYAT',
    Q6IBS0: 'TWF2',
    Q6IBW4: 'NCAPH2',
    Q6IC98: 'GRAMD4',
    Q6ICB0: 'DESI1',
    Q6ICB4: 'PHETA2',
    Q6ICG8: 'WBP2NL',
    Q6ICL3: 'TANGO2',
    Q6ICL7: 'SLC35E4',
    Q6IE81: 'JADE1',
    Q6IEG0: 'SNRNP48',
    Q6IMI6: 'SULT1C3',
    Q6IMN6: 'CAPRIN2',
    Q6IN84: 'MRM1',
    Q6IN85: 'PPP4R3A',
    Q6IPM2: 'IQCE',
    Q6IPU0: 'CENPP',
    Q6IQ16: 'SPOPL',
    Q6IQ19: 'CCSAP',
    Q6IQ20: 'NAPEPLD',
    Q6IQ22: 'RAB12',
    Q6IQ23: 'PLEKHA7',
    Q6IQ26: 'DENND5A',
    Q6IQ49: 'SDE2',
    Q6IQ55: 'TTBK2',
    Q6IS24: 'GALNT17',
    Q6ISB3: 'GRHL2',
    Q6ISU1: 'PTCRA',
    Q6IV72: 'ZNF425',
    Q6IWH7: 'ANO7',
    Q6J4K2: 'SLC8B1',
    Q6J9G0: 'STYK1',
    Q6JBY9: 'RCSD1',
    Q6JQN1: 'ACAD10',
    Q6K0P9: 'PYHIN1',
    Q6KB66: 'KRT80',
    Q6KC79: 'NIPBL',
    Q6KCM7: 'SLC25A25',
    Q6KF10: 'GDF6',
    Q6L8G4: 'KRTAP5-11',
    Q6L8G8: 'KRTAP5-7',
    Q6L8G9: 'KRTAP5-6',
    Q6L8H1: 'KRTAP5-4',
    Q6L8H2: 'KRTAP5-3',
    Q6L8H4: 'KRTAP5-1',
    Q6L8Q7: 'PDE12',
    Q6L9W6: 'B4GALNT3',
    Q6MZM0: 'HEPHL1',
    Q6MZP7: 'LIN54',
    Q6MZQ0: 'PRR5L',
    Q6N021: 'TET2',
    Q6N022: 'TENM4',
    Q6N043: 'ZNF280D',
    Q6N069: 'NAA16',
    Q6N075: 'MFSD5',
    Q6NS38: 'ALKBH2',
    Q6NSI4: 'RADX',
    Q6NSJ0: 'MYORG',
    Q6NSJ5: 'LRRC8E',
    Q6NSW7: 'NANOGP8',
    Q6NT55: 'CYP4F22',
    Q6NT76: 'HMBOX1',
    Q6NTE8: 'MRNIP',
    Q6NTF7: 'APOBEC3H',
    Q6NTF9: 'RHBDD2',
    Q6NUI2: 'GPAT2',
    Q6NUI6: 'CHADL',
    Q6NUJ2: 'C11orf87',
    Q6NUJ5: 'PWWP2B',
    Q6NUK1: 'SLC25A24',
    Q6NUN0: 'ACSM5',
    Q6NUN9: 'ZNF746',
    Q6NUP7: 'PPP4R4',
    Q6NUQ1: 'RINT1',
    Q6NUQ4: 'TMEM214',
    Q6NUS6: 'TCTN3',
    Q6NUT2: 'DPY19L2',
    Q6NUT3: 'MFSD12',
    Q6NVH7: 'SWSAP1',
    Q6NVU6: 'UFSP1',
    Q6NVY1: 'HIBCH',
    Q6NW40: 'RGMB',
    Q6NWY9: 'PRPF40B',
    Q6NX45: 'ZNF774',
    Q6NXG1: 'ESRP1',
    Q6NXR4: 'TTI2',
    Q6NXS1: 'PPP1R2B',
    Q6NXT2: 'H3-5',
    Q6NXT4: 'SLC30A6',
    Q6NXT6: 'TAPT1',
    Q6NYC1: 'JMJD6',
    Q6NYC8: 'PPP1R18',
    Q6NZ36: 'FAAP20',
    Q6NZI2: 'CAVIN1',
    Q6NZY4: 'ZCCHC8',
    Q6NZY7: 'CDC42EP5',
    Q6P050: 'FBXL22',
    Q6P087: 'RPUSD3',
    Q6P0N0: 'MIS18BP1',
    Q6P0Q8: 'MAST2',
    Q6P158: 'DHX57',
    Q6P179: 'ERAP2',
    Q6P1A2: 'LPCAT3',
    Q6P1J6: 'PLB1',
    Q6P1J9: 'CDC73',
    Q6P1K1: 'SLC48A1',
    Q6P1K2: 'PMF1',
    Q6P1L5: 'FAM117B',
    Q6P1L6: 'ZNF343',
    Q6P1M0: 'SLC27A4',
    Q6P1M3: 'LLGL2',
    Q6P1N0: 'CC2D1A',
    Q6P1Q0: 'LETMD1',
    Q6P1Q9: 'METTL2B',
    Q6P1W5: 'C1orf94',
    Q6P1X5: 'TAF2',
    Q6P2C8: 'MED27',
    Q6P2D0: 'ZFP1',
    Q6P2D8: 'XRRA1',
    Q6P2E9: 'EDC4',
    Q6P2H3: 'CEP85',
    Q6P2M8: 'PNCK',
    Q6P2P2: 'PRMT9',
    Q6P2Q9: 'PRPF8',
    Q6P3S1: 'DENND1B',
    Q6P3W2: 'DNAJC24',
    Q6P3W7: 'SCYL2',
    Q6P4A7: 'SFXN4',
    Q6P4A8: 'PLBD1',
    Q6P4F1: 'FUT10',
    Q6P4F2: 'FDX2',
    Q6P4H8: 'ATPSCKMT',
    Q6P4I2: 'WDR73',
    Q6P4Q7: 'CNNM4',
    Q6P4R8: 'NFRKB',
    Q6P531: 'GGT6',
    Q6P587: 'FAHD1',
    Q6P597: 'KLC3',
    Q6P5Q4: 'LMOD2',
    Q6P5S7: 'RNASEK',
    Q6P5W5: 'SLC39A4',
    Q6P5X5: 'C22orf39',
    Q6P5Z2: 'PKN3',
    Q6P6C2: 'ALKBH5',
    Q6P988: 'NOTUM',
    Q6P9A2: 'GALNT18',
    Q6P9B6: 'MEAK7',
    Q6P9B9: 'INTS5',
    Q6P9F0: 'CCDC62',
    Q6P9F5: 'TRIM40',
    Q6P9F7: 'LRRC8B',
    Q6P9G9: 'ZNF449',
    Q6P9H4: 'CNKSR3',
    Q6PCB0: 'VWA1',
    Q6PCB6: 'ABHD17C',
    Q6PCB7: 'SLC27A1',
    Q6PCD5: 'RFWD3',
    Q6PCE3: 'PGM2L1',
    Q6PCT2: 'FBXL19',
    Q6PD62: 'CTR9',
    Q6PD74: 'AAGAB',
    Q6PEW1: 'ZCCHC12',
    Q6PEX3: 'KRTAP26-1',
    Q6PEY1: 'TMEM88',
    Q6PEY2: 'TUBA3E',
    Q6PF05: 'TTC23L',
    Q6PF06: 'TRMT10B',
    Q6PF18: 'MORN3',
    Q6PFW1: 'PPIP5K1',
    Q6PGN9: 'PSRC1',
    Q6PGP7: 'SKIC3',
    Q6PGQ7: 'BORA',
    Q6PH85: 'DCUN1D2',
    Q6PHR2: 'ULK3',
    Q6PHW0: 'IYD',
    Q6PI25: 'CNIH2',
    Q6PI26: 'SHQ1',
    Q6PI48: 'DARS2',
    Q6PI77: 'GPRASP3',
    Q6PI78: 'TMEM65',
    Q6PI98: 'INO80C',
    Q6PID8: 'KLHDC10',
    Q6PIF2: 'SYCE2',
    Q6PIF6: 'MYO7B',
    Q6PIJ6: 'FBXO38',
    Q6PIL6: 'KCNIP4',
    Q6PIU1: 'KCNV1',
    Q6PIU2: 'NCEH1',
    Q6PIV2: 'FOXR1',
    Q6PIW4: 'FIGNL1',
    Q6PIY7: 'TENT2',
    Q6PIZ9: 'TRAT1',
    Q6PJF5: 'RHBDF2',
    Q6PJG6: 'BRAT1',
    Q6PJG9: 'LRFN4',
    Q6PJI9: 'WDR59',
    Q6PJP8: 'DCLRE1A',
    Q6PJT7: 'ZC3H14',
    Q6PJW8: 'CNST',
    Q6PKC3: 'TXNDC11',
    Q6PKG0: 'LARP1',
    Q6PKX4: 'DOK6',
    Q6PL18: 'ATAD2',
    Q6PL24: 'TMED8',
    Q6PL45: 'BRICD5',
    Q6PML9: 'SLC30A9',
    Q6PRD1: 'GPR179',
    Q6PRD7: 'CEMP1',
    Q6PUV4: 'CPLX2',
    Q6PXP3: 'SLC2A7',
    Q6Q0C0: 'TRAF7',
    Q6Q4G3: 'LVRN',
    Q6Q759: 'SPAG17',
    Q6Q788: 'APOA5',
    Q6QHC5: 'DEGS2',
    Q6QHF9: 'PAOX',
    Q6QHK4: 'FIGLA',
    Q6QN14: 'USP17L6P',
    Q6QNK2: 'ADGRD1',
    Q6QNY0: 'BLOC1S3',
    Q6QNY1: 'BLOC1S2',
    Q6R327: 'RICTOR',
    Q6R6M4: 'USP17L2',
    Q6RFH5: 'WDR74',
    Q6RFH8: 'DUX4L9',
    Q6RI45: 'BRWD3',
    Q6RVD6: 'SPATA8',
    Q6RW13: 'AGTRAP',
    Q6S5L8: 'SHC4',
    Q6S9Z5: 'ZNF474',
    Q6SA08: 'TSSK4',
    Q6SJ93: 'FAM111B',
    Q6SPF0: 'SAMD1',
    Q6STE5: 'SMARCD3',
    Q6SZW1: 'SARM1',
    Q6T4R5: 'NHS',
    Q6TCH4: 'PAQR6',
    Q6TCH7: 'PAQR3',
    Q6TFL4: 'KLHL24',
    Q6TGC4: 'PADI6',
    Q6U736: 'OPN5',
    Q6U7Q0: 'ZNF322',
    Q6U841: 'SLC4A10',
    Q6UB28: 'METAP1D',
    Q6UB35: 'MTHFD1L',
    Q6UB98: 'ANKRD12',
    Q6UB99: 'ANKRD11',
    Q6ULP2: 'AFTPH',
    Q6UN15: 'FIP1L1',
    Q6UUV7: 'CRTC3',
    Q6UUV9: 'CRTC1',
    Q6UVJ0: 'SASS6',
    Q6UVK1: 'CSPG4',
    Q6UVM3: 'KCNT2',
    Q6UVW9: 'CLEC2A',
    Q6UVY6: 'MOXD1',
    Q6UW15: 'REG3G',
    Q6UW56: 'ATRAID',
    Q6UW60: 'PCSK4',
    Q6UW63: 'POGLUT2',
    Q6UW68: 'TMEM205',
    Q6UW78: 'UQCC3',
    Q6UW88: 'EPGN',
    Q6UWB1: 'IL27RA',
    Q6UWB4: 'PRSS55',
    Q6UWE0: 'LRSAM1',
    Q6UWF3: 'SCIMP',
    Q6UWI2: 'PARM1',
    Q6UWK7: 'GPR15LG',
    Q6UWL6: 'KIRREL2',
    Q6UWN5: 'LYPD5',
    Q6UWP2: 'DHRS11',
    Q6UWP7: 'LCLAT1',
    Q6UWR7: 'ENPP6',
    Q6UWU4: 'C6orf89',
    Q6UWV6: 'ENPP7',
    Q6UWW8: 'CES3',
    Q6UWY0: 'ARSK',
    Q6UWY2: 'PRSS57',
    Q6UWZ7: 'ABRAXAS1',
    Q6UX01: 'LMBR1L',
    Q6UX04: 'CWC27',
    Q6UX06: 'OLFM4',
    Q6UX15: 'LAYN',
    Q6UX27: 'VSTM1',
    Q6UX34: 'SNORC',
    Q6UX39: 'AMTN',
    Q6UX40: 'TMEM107',
    Q6UX41: 'BTNL8',
    Q6UX46: 'ALKAL2',
    Q6UX65: 'DRAM2',
    Q6UX71: 'PLXDC2',
    Q6UX98: 'ZDHHC24',
    Q6UXB2: 'CXCL17',
    Q6UXB4: 'CLEC4G',
    Q6UXB8: 'PI16',
    Q6UXD5: 'SEZ6L2',
    Q6UXF1: 'TMEM108',
    Q6UXG2: 'ELAPOR1',
    Q6UXG3: 'CD300LG',
    Q6UXG8: 'BTNL9',
    Q6UXH0: 'ANGPTL8',
    Q6UXH1: 'CRELD2',
    Q6UXH8: 'CCBE1',
    Q6UXI9: 'NPNT',
    Q6UXK2: 'ISLR2',
    Q6UXL0: 'IL20RB',
    Q6UXM1: 'LRIG3',
    Q6UXN8: 'CLEC9A',
    Q6UXN9: 'WDR82',
    Q6UXS9: 'CASP12',
    Q6UXT8: 'ALKAL1',
    Q6UXV0: 'GFRAL',
    Q6UXV4: 'APOOL',
    Q6UXX9: 'RSPO2',
    Q6UXY1: 'BAIAP2L2',
    Q6UXZ0: 'TMIGD1',
    Q6UXZ3: 'CD300LD',
    Q6UXZ4: 'UNC5D',
    Q6UY09: 'CEACAM20',
    Q6UY14: 'ADAMTSL4',
    Q6V0I7: 'FAT4',
    Q6V0L0: 'CYP26C1',
    Q6V1X1: 'DPP8',
    Q6VAB6: 'KSR2',
    Q6VB84: 'FOXD4L3',
    Q6VEQ5: 'WASH2P',
    Q6VMQ6: 'ATF7IP',
    Q6VN20: 'RANBP10',
    Q6VVB1: 'NHLRC1',
    Q6VVX0: 'CYP2R1',
    Q6VY07: 'PACS1',
    Q6W0C5: 'DPPA3',
    Q6W2J9: 'BCOR',
    Q6W4X9: 'MUC6',
    Q6W5P4: 'NPSR1',
    Q6WCQ1: 'MPRIP',
    Q6WKZ4: 'RAB11FIP1',
    Q6WN34: 'CHRDL2',
    Q6WRI0: 'IGSF10',
    Q6X4U4: 'SOSTDC1',
    Q6X4W1: 'NSMF',
    Q6XD76: 'ASCL4',
    Q6XE24: 'RBMS3',
    Q6XPS3: 'TPTE2',
    Q6XQN6: 'NAPRT',
    Q6XR72: 'SLC30A10',
    Q6XUX3: 'DSTYK',
    Q6XYQ8: 'SYT10',
    Q6XZB0: 'LIPI',
    Q6XZF7: 'DNMBP',
    Q6Y1H2: 'HACD2',
    Q6Y288: 'B3GLCT',
    Q6Y7W6: 'GIGYF2',
    Q6YBV0: 'SLC36A4',
    Q6YHK3: 'CD109',
    Q6YHU6: 'THADA',
    Q6YN16: 'HSDL2',
    Q6YP21: 'KYAT3',
    Q6ZMB0: 'B3GNT6',
    Q6ZMC9: 'SIGLEC15',
    Q6ZMG9: 'CERS6',
    Q6ZMH5: 'SLC39A5',
    Q6ZMI0: 'PPP1R21',
    Q6ZMI3: 'GLDN',
    Q6ZMJ2: 'SCARA5',
    Q6ZMJ4: 'IL34',
    Q6ZMM2: 'ADAMTSL5',
    Q6ZMQ8: 'AATK',
    Q6ZMR5: 'TMPRSS11A',
    Q6ZMS7: 'ZNF783',
    Q6ZMT1: 'STAC2',
    Q6ZMT4: 'KDM7A',
    Q6ZMU5: 'TRIM72',
    Q6ZMZ0: 'RNF19B',
    Q6ZMZ3: 'SYNE3',
    Q6ZN04: 'MEX3B',
    Q6ZN16: 'MAP3K15',
    Q6ZN17: 'LIN28B',
    Q6ZN18: 'AEBP2',
    Q6ZN30: 'BNC2',
    Q6ZN44: 'UNC5A',
    Q6ZN55: 'ZNF574',
    Q6ZN57: 'ZFP2',
    Q6ZNA4: 'RNF111',
    Q6ZNB7: 'AGMO',
    Q6ZNC8: 'MBOAT1',
    Q6ZNE5: 'ATG14',
    Q6ZNE9: 'RUFY4',
    Q6ZNG0: 'ZNF620',
    Q6ZNH5: 'ZNF497',
    Q6ZNJ1: 'NBEAL2',
    Q6ZNK6: 'TIFAB',
    Q6ZNL6: 'FGD5',
    Q6ZNX1: 'SHLD3',
    Q6ZP29: 'SLC66A1',
    Q6ZP80: 'TMEM182',
    Q6ZP82: 'CCDC141',
    Q6ZPD8: 'DGAT2L6',
    Q6ZQN7: 'SLCO4C1',
    Q6ZQW0: 'IDO2',
    Q6ZQX7: 'LIAT1',
    Q6ZQY3: 'GADL1',
    Q6ZR08: 'DNAH12',
    Q6ZR37: 'PLEKHG7',
    Q6ZRF8: 'RNF207',
    Q6ZRI0: 'OTOG',
    Q6ZRP7: 'QSOX2',
    Q6ZRQ5: 'MMS22L',
    Q6ZRS2: 'SRCAP',
    Q6ZRV2: 'FAM83H',
    Q6ZRY4: 'RBPMS2',
    Q6ZS10: 'CLEC17A',
    Q6ZS17: 'RIPOR1',
    Q6ZSA7: 'LRRC55',
    Q6ZSB9: 'ZBTB49',
    Q6ZSG1: 'ARK2C',
    Q6ZSJ9: 'SHISA6',
    Q6ZSM3: 'SLC16A12',
    Q6ZSS7: 'MFSD6',
    Q6ZSY5: 'PPP1R3F',
    Q6ZSZ5: 'ARHGEF18',
    Q6ZSZ6: 'TSHZ1',
    Q6ZT12: 'UBR3',
    Q6ZT21: 'TMPPE',
    Q6ZT62: 'BARGIN',
    Q6ZT89: 'SLC25A48',
    Q6ZT98: 'TTLL7',
    Q6ZTN6: 'ANKRD13D',
    Q6ZTQ4: 'CDHR3',
    Q6ZTR5: 'CFAP47',
    Q6ZU15: 'SEPTIN14',
    Q6ZU35: 'CRACD',
    Q6ZU52: 'KIAA0408',
    Q6ZU64: 'CFAP65',
    Q6ZU80: 'CEP128',
    Q6ZUI0: 'TPRG1',
    Q6ZUJ8: 'PIK3AP1',
    Q6ZUM4: 'ARHGAP27',
    Q6ZUT1: 'NKAPD1',
    Q6ZUT3: 'FRMD7',
    Q6ZUX7: 'LHFPL2',
    Q6ZV29: 'PNPLA7',
    Q6ZV65: 'FAM47E',
    Q6ZV73: 'FGD6',
    Q6ZVD7: 'STOX1',
    Q6ZVD8: 'PHLPP2',
    Q6ZVE7: 'GOLT1A',
    Q6ZVK8: 'NUDT18',
    Q6ZVM7: 'TOM1L2',
    Q6ZVN8: 'HJV',
    Q6ZVT0: 'TTLL10',
    Q6ZW31: 'SYDE1',
    Q6ZW49: 'PAXIP1',
    Q6ZW61: 'BBS12',
    Q6ZW76: 'ANKS3',
    Q6ZWH5: 'NEK10',
    Q6ZWJ1: 'STXBP4',
    Q6ZWK4: 'RHEX',
    Q6ZWL3: 'CYP4V2',
    Q6ZWT7: 'MBOAT2',
    Q6ZXV5: 'TMTC3',
    Q6ZYL4: 'GTF2H5',
    Q701N4: 'KRTAP5-2',
    Q702N8: 'XIRP1',
    Q709C8: 'VPS13C',
    Q709F0: 'ACAD11',
    Q70CQ1: 'USP49',
    Q70CQ2: 'USP34',
    Q70CQ3: 'USP30',
    Q70CQ4: 'USP31',
    Q70E73: 'RAPH1',
    Q70EK9: 'USP51',
    Q70EL1: 'USP54',
    Q70EL2: 'USP45',
    Q70EL3: 'USP50',
    Q70EL4: 'USP43',
    Q70HW3: 'SLC25A26',
    Q70IA6: 'MOB2',
    Q70IA8: 'MOB3C',
    Q70J99: 'UNC13D',
    Q70JA7: 'CHSY3',
    Q70SY1: 'CREB3L2',
    Q70UQ0: 'IKBIP',
    Q70YC4: 'ZNF365',
    Q70YC5: 'ZNF365',
    Q70Z35: 'PREX2',
    Q70Z44: 'HTR3D',
    Q712K3: 'UBE2R2',
    Q719H9: 'KCTD1',
    Q71DI3: 'H3C13',
    Q71DI3: 'H3C14',
    Q71DI3: 'H3C15',
    Q71F23: 'CENPU',
    Q71F56: 'MED13L',
    Q71H61: 'ILDR2',
    Q71RC2: 'LARP4',
    Q71RG4: 'TMUB2',
    Q71RH2: 'TLCD3B',
    Q71RS6: 'SLC24A5',
    Q71SY5: 'MED25',
    Q71U36: 'TUBA1A',
    Q71UI9: 'H2AZ2',
    Q71UM5: 'RPS27L',
    Q75N03: 'CBLL1',
    Q75N90: 'FBN3',
    Q75QN2: 'INTS8',
    Q75T13: 'PGAP1',
    Q75V66: 'ANO5',
    Q75WM6: 'H1-7',
    Q765P7: 'MTSS2',
    Q76EJ3: 'SLC35D2',
    Q76FK4: 'NOL8',
    Q76I76: 'SSH2',
    Q76L83: 'ASXL2',
    Q76LX8: 'ADAMTS13',
    Q76M96: 'CCDC80',
    Q76MJ5: 'ERN2',
    Q76N32: 'CEP68',
    Q76N89: 'HECW1',
    Q76NI1: 'KNDC1',
    Q7KYR7: 'BTN2A1',
    Q7KZ85: 'SUPT6H',
    Q7KZF4: 'SND1',
    Q7KZI7: 'MARK2',
    Q7KZN9: 'COX15',
    Q7L014: 'DDX46',
    Q7L099: 'RUFY3',
    Q7L0J3: 'SV2A',
    Q7L0Q8: 'RHOU',
    Q7L0X0: 'TRIL',
    Q7L0Y3: 'TRMT10C',
    Q7L190: 'DPPA4',
    Q7L1I2: 'SV2B',
    Q7L1Q6: 'BZW1',
    Q7L1S5: 'CHST9',
    Q7L1T6: 'CYB5R4',
    Q7L1W4: 'LRRC8D',
    Q7L266: 'ASRGL1',
    Q7L273: 'KCTD9',
    Q7L2E3: 'DHX30',
    Q7L2H7: 'EIF3M',
    Q7L2J0: 'MEPCE',
    Q7L2R6: 'ZNF765',
    Q7L2Z9: 'CENPQ',
    Q7L3B6: 'CDC37L1',
    Q7L3V2: 'RTL10',
    Q7L4E1: 'MIGA2',
    Q7L4I2: 'RSRC2',
    Q7L4P6: 'BEND5',
    Q7L513: 'FCRLA',
    Q7L523: 'RRAGA',
    Q7L576: 'CYFIP1',
    Q7L590: 'MCM10',
    Q7L591: 'DOK3',
    Q7L592: 'NDUFAF7',
    Q7L5A3: 'ATOSB',
    Q7L5A8: 'FA2H',
    Q7L5D6: 'GET4',
    Q7L5L3: 'GDPD3',
    Q7L5N1: 'COPS6',
    Q7L5N7: 'LPCAT2',
    Q7L5Y1: 'ENOSF1',
    Q7L5Y6: 'DET1',
    Q7L5Y9: 'MAEA',
    Q7L622: 'G2E3',
    Q7L775: 'EPM2AIP1',
    Q7L7L0: 'H2AC25',
    Q7L7V1: 'DHX32',
    Q7L7X3: 'TAOK1',
    Q7L804: 'RAB11FIP2',
    Q7L8A9: 'VASH1',
    Q7L8C5: 'SYT13',
    Q7L8J4: 'SH3BP5L',
    Q7L8L6: 'FASTKD5',
    Q7L8S5: 'OTUD6A',
    Q7L8W6: 'DPH6',
    Q7L9L4: 'MOB1B',
    Q7LBC6: 'KDM3B',
    Q7LBE3: 'SLC26A9',
    Q7LBR1: 'CHMP1B',
    Q7LC44: 'ARC',
    Q7LDG7: 'RASGRP2',
    Q7LFL8: 'CXXC5',
    Q7LFX5: 'CHST15',
    Q7LG56: 'RRM2B',
    Q7LGA3: 'HS2ST1',
    Q7LGC8: 'CHST3',
    Q7RTN6: 'STRADA',
    Q7RTP0: 'NIPA1',
    Q7RTP6: 'MICAL3',
    Q7RTR0: 'NLRP9',
    Q7RTR2: 'NLRC3',
    Q7RTS1: 'BHLHA15',
    Q7RTS3: 'PTF1A',
    Q7RTS7: 'KRT74',
    Q7RTS9: 'DYM',
    Q7RTT9: 'SLC29A4',
    Q7RTU1: 'TCF23',
    Q7RTU3: 'OLIG3',
    Q7RTU4: 'BHLHA9',
    Q7RTU7: 'SCX',
    Q7RTV0: 'PHF5A',
    Q7RTW8: 'OTOA',
    Q7RTX0: 'TAS1R3',
    Q7RTX1: 'TAS1R1',
    Q7RTX7: 'CATSPER4',
    Q7RTY0: 'SLC16A13',
    Q7RTY1: 'SLC16A9',
    Q7RTZ1: 'OVCH2',
    Q7Z2D5: 'PLPPR4',
    Q7Z2E3: 'APTX',
    Q7Z2H8: 'SLC36A1',
    Q7Z2K6: 'ERMP1',
    Q7Z2W4: 'ZC3HAV1',
    Q7Z2W7: 'TRPM8',
    Q7Z2X4: 'PID1',
    Q7Z2Y5: 'NRK',
    Q7Z2Z1: 'TICRR',
    Q7Z2Z2: 'EFL1',
    Q7Z333: 'SETX',
    Q7Z353: 'HDX',
    Q7Z392: 'TRAPPC11',
    Q7Z3B1: 'NEGR1',
    Q7Z3B3: 'KANSL1',
    Q7Z3B4: 'NUP54',
    Q7Z3C6: 'ATG9A',
    Q7Z3E1: 'TIPARP',
    Q7Z3E5: 'ARMC9',
    Q7Z3H0: 'ANKRD33',
    Q7Z3I7: 'ZNF572',
    Q7Z3J2: 'VPS35L',
    Q7Z3K3: 'POGZ',
    Q7Z3K6: 'MIER3',
    Q7Z3S7: 'CACNA2D4',
    Q7Z3T8: 'ZFYVE16',
    Q7Z3U7: 'MON2',
    Q7Z3Y7: 'KRT28',
    Q7Z3Y8: 'KRT27',
    Q7Z3Y9: 'KRT26',
    Q7Z3Z0: 'KRT25',
    Q7Z3Z2: 'RD3',
    Q7Z3Z4: 'PIWIL4',
    Q7Z401: 'DENND4A',
    Q7Z403: 'TMC6',
    Q7Z406: 'MYH14',
    Q7Z407: 'CSMD3',
    Q7Z410: 'TMPRSS9',
    Q7Z412: 'PEX26',
    Q7Z417: 'NUFIP2',
    Q7Z418: 'KCNK18',
    Q7Z419: 'RNF144B',
    Q7Z429: 'GRINA',
    Q7Z434: 'MAVS',
    Q7Z442: 'PKD1L2',
    Q7Z443: 'PKD1L3',
    Q7Z449: 'CYP2U1',
    Q7Z460: 'CLASP1',
    Q7Z465: 'BNIPL',
    Q7Z478: 'DHX29',
    Q7Z494: 'NPHP3',
    Q7Z4F1: 'LRP10',
    Q7Z4G1: 'COMMD6',
    Q7Z4H4: 'ADM2',
    Q7Z4H7: 'HAUS6',
    Q7Z4H8: 'POGLUT3',
    Q7Z4I7: 'LIMS2',
    Q7Z4K8: 'TRIM46',
    Q7Z4L5: 'TTC21B',
    Q7Z4N2: 'TRPM1',
    Q7Z4N8: 'P4HA3',
    Q7Z4P5: 'GDF7',
    Q7Z4S6: 'KIF21A',
    Q7Z4T8: 'GALNTL5',
    Q7Z4T9: 'CFAP91',
    Q7Z4V0: 'ZNF438',
    Q7Z4V5: 'HDGFL2',
    Q7Z4W1: 'DCXR',
    Q7Z4W3: 'KRTAP19-3',
    Q7Z569: 'BRAP',
    Q7Z570: 'ZNF804A',
    Q7Z589: 'EMSY',
    Q7Z591: 'AKNA',
    Q7Z5A7: 'TAFA5',
    Q7Z5B4: 'RIC3',
    Q7Z5G4: 'GOLGA7',
    Q7Z5H3: 'ARHGAP22',
    Q7Z5J1: 'HSD11B1L',
    Q7Z5J4: 'RAI1',
    Q7Z5K2: 'WAPL',
    Q7Z5L2: 'R3HCC1L',
    Q7Z5L7: 'PODN',
    Q7Z5L9: 'IRF2BP2',
    Q7Z5N4: 'SDK1',
    Q7Z5P4: 'HSD17B13',
    Q7Z5P9: 'MUC19',
    Q7Z5Q1: 'CPEB2',
    Q7Z5Q5: 'POLN',
    Q7Z5R6: 'APBB1IP',
    Q7Z5V6: 'SAXO4',
    Q7Z5W3: 'BCDIN3D',
    Q7Z5Y6: 'BMP8A',
    Q7Z602: 'GPR141',
    Q7Z614: 'SNX20',
    Q7Z624: 'CAMKMT',
    Q7Z628: 'NET1',
    Q7Z698: 'SPRED2',
    Q7Z699: 'SPRED1',
    Q7Z6A9: 'BTLA',
    Q7Z6B0: 'CCDC91',
    Q7Z6B7: 'SRGAP1',
    Q7Z6E9: 'RBBP6',
    Q7Z6G3: 'NECAB2',
    Q7Z6G8: 'ANKS1B',
    Q7Z6I5: 'SPATA12',
    Q7Z6I6: 'ARHGAP30',
    Q7Z6J0: 'SH3RF1',
    Q7Z6J4: 'FGD2',
    Q7Z6J6: 'FRMD5',
    Q7Z6J8: 'UBE3D',
    Q7Z6J9: 'TSEN54',
    Q7Z6K1: 'THAP5',
    Q7Z6K5: 'ARPIN',
    Q7Z6L0: 'PRRT2',
    Q7Z6L1: 'TECPR1',
    Q7Z6M1: 'RABEPK',
    Q7Z6M3: 'MILR1',
    Q7Z6M4: 'MTERF4',
    Q7Z6R9: 'TFAP2D',
    Q7Z6V5: 'ADAT2',
    Q7Z6Z7: 'HUWE1',
    Q7Z739: 'YTHDF3',
    Q7Z769: 'SLC35E3',
    Q7Z794: 'KRT77',
    Q7Z7A1: 'CNTRL',
    Q7Z7A4: 'PXK',
    Q7Z7B0: 'FILIP1',
    Q7Z7B1: 'PIGW',
    Q7Z7C7: 'STRA8',
    Q7Z7C8: 'TAF8',
    Q7Z7D3: 'VTCN1',
    Q7Z7E8: 'UBE2Q1',
    Q7Z7F0: 'KHDC4',
    Q7Z7G0: 'ABI3BP',
    Q7Z7G1: 'CLNK',
    Q7Z7G2: 'CPLX4',
    Q7Z7G8: 'VPS13B',
    Q7Z7H3: 'CATIP',
    Q7Z7H5: 'TMED4',
    Q7Z7H8: 'MRPL10',
    Q7Z7K6: 'CENPV',
    Q7Z7L1: 'SLFN11',
    Q7Z7M0: 'MEGF8',
    Q7Z7M8: 'B3GNT8',
    Q7Z7M9: 'GALNT5',
    Q7Z7N9: 'TMEM179B',
    Q86SE5: 'RALYL',
    Q86SE8: 'NPM2',
    Q86SE9: 'PCGF5',
    Q86SF2: 'GALNT7',
    Q86SG2: 'ANKRD23',
    Q86SG3: 'DAZ4',
    Q86SG5: 'S100A7A',
    Q86SG6: 'NEK8',
    Q86SJ2: 'AMIGO2',
    Q86SJ6: 'DSG4',
    Q86SK9: 'SCD5',
    Q86SQ0: 'PHLDB2',
    Q86SQ3: 'ADGRE4P',
    Q86SQ4: 'ADGRG6',
    Q86SQ6: 'ADGRA1',
    Q86SQ7: 'SDCCAG8',
    Q86SQ9: 'DHDDS',
    Q86SR1: 'GALNT10',
    Q86SS6: 'SYT9',
    Q86SU0: 'ILDR1',
    Q86SX6: 'GLRX5',
    Q86SZ2: 'TRAPPC6B',
    Q86T03: 'PIP4P1',
    Q86T13: 'CLEC14A',
    Q86T24: 'ZBTB33',
    Q86T26: 'TMPRSS11B',
    Q86T65: 'DAAM2',
    Q86T82: 'USP37',
    Q86T90: 'KIAA1328',
    Q86T96: 'RNF180',
    Q86TB3: 'ALPK2',
    Q86TB9: 'PATL1',
    Q86TC9: 'MYPN',
    Q86TG1: 'TMEM150A',
    Q86TG7: 'PEG10',
    Q86TH1: 'ADAMTSL2',
    Q86TI0: 'TBC1D1',
    Q86TI2: 'DPP9',
    Q86TJ2: 'TADA2B',
    Q86TL0: 'ATG4D',
    Q86TL2: 'STIMATE',
    Q86TM3: 'DDX53',
    Q86TM6: 'SYVN1',
    Q86TP1: 'PRUNE1',
    Q86TS9: 'MRPL52',
    Q86TU7: 'SETD3',
    Q86TV6: 'TTC7B',
    Q86TW2: 'ADCK1',
    Q86TX2: 'ACOT1',
    Q86U06: 'RBM23',
    Q86U10: 'ASPG',
    Q86U28: 'ISCA2',
    Q86U42: 'PABPN1',
    Q86U44: 'METTL3',
    Q86U70: 'LDB1',
    Q86U86: 'PBRM1',
    Q86U90: 'YRDC',
    Q86UA6: 'RPAIN',
    Q86UC2: 'RSPH3',
    Q86UD0: 'SAPCD2',
    Q86UD3: 'MARCHF3',
    Q86UD4: 'ZNF329',
    Q86UD5: 'SLC9B2',
    Q86UE4: 'MTDH',
    Q86UE6: 'LRRTM1',
    Q86UE8: 'TLK2',
    Q86UF1: 'TSPAN33',
    Q86UG4: 'SLCO6A1',
    Q86UK0: 'ABCA12',
    Q86UK5: 'EVC2',
    Q86UK7: 'ZNF598',
    Q86UL3: 'GPAT4',
    Q86UL8: 'MAGI2',
    Q86UN2: 'RTN4RL1',
    Q86UN3: 'RTN4RL2',
    Q86UN6: 'AKAP14',
    Q86UP0: 'CDH24',
    Q86UP2: 'KTN1',
    Q86UP3: 'ZFHX4',
    Q86UQ0: 'ZNF589',
    Q86UQ4: 'ABCA13',
    Q86UQ8: 'NFE4',
    Q86UR1: 'NOXA1',
    Q86UR5: 'RIMS1',
    Q86US8: 'SMG6',
    Q86UT5: 'NHERF4',
    Q86UT6: 'NLRX1',
    Q86UT8: 'CENATAC',
    Q86UU0: 'BCL9L',
    Q86UU1: 'PHLDB1',
    Q86UU5: 'GGN',
    Q86UU9: 'TAC4',
    Q86UV5: 'USP48',
    Q86UV6: 'TRIM74',
    Q86UW1: 'SLC51A',
    Q86UW2: 'SLC51B',
    Q86UW6: 'N4BP2',
    Q86UW7: 'CADPS2',
    Q86UW9: 'DTX2',
    Q86UX2: 'ITIH5',
    Q86UX6: 'STK32C',
    Q86UX7: 'FERMT3',
    Q86UY5: 'FAM83A',
    Q86UY6: 'NAA40',
    Q86UZ6: 'ZBTB46',
    Q86V15: 'CASZ1',
    Q86V20: 'SHLD2',
    Q86V24: 'ADIPOR2',
    Q86V25: 'VASH2',
    Q86V40: 'TRABD2A',
    Q86V42: 'FAM124A',
    Q86V48: 'LUZP1',
    Q86V81: 'ALYREF',
    Q86V86: 'PIM3',
    Q86V97: 'KBTBD6',
    Q86VB7: 'CD163',
    Q86VD1: 'MORC1',
    Q86VD7: 'SLC25A42',
    Q86VD9: 'PIGZ',
    Q86VE0: 'MYPOP',
    Q86VE9: 'SERINC5',
    Q86VF2: 'IGFN1',
    Q86VF5: 'MOGAT3',
    Q86VF7: 'NRAP',
    Q86VH2: 'KIF27',
    Q86VH5: 'LRRTM3',
    Q86VI3: 'IQGAP3',
    Q86VI4: 'LAPTM4B',
    Q86VK4: 'ZNF410',
    Q86VL8: 'SLC47A2',
    Q86VM9: 'ZC3H18',
    Q86VN1: 'VPS36',
    Q86VP1: 'TAX1BP1',
    Q86VP3: 'PACS2',
    Q86VP6: 'CAND1',
    Q86VQ0: 'LCA5',
    Q86VQ3: 'TXNDC2',
    Q86VQ6: 'TXNRD3',
    Q86VR2: 'RETREG3',
    Q86VS8: 'HOOK3',
    Q86VV4: 'RANBP3L',
    Q86VV8: 'RTTN',
    Q86VW0: 'SESTD1',
    Q86VW1: 'SLC22A16',
    Q86VW2: 'ARHGEF25',
    Q86VX9: 'MON1A',
    Q86VY4: 'TSPYL5',
    Q86VZ4: 'LRP11',
    Q86VZ5: 'SGMS1',
    Q86VZ6: 'JAZF1',
    Q86W10: 'CYP4Z1',
    Q86W24: 'NLRP14',
    Q86W26: 'NLRP10',
    Q86W42: 'THOC6',
    Q86W47: 'KCNMB4',
    Q86W50: 'METTL16',
    Q86W54: 'SPATA24',
    Q86W56: 'PARG',
    Q86W74: 'ANKRD46',
    Q86W92: 'PPFIBP1',
    Q86WA6: 'BPHL',
    Q86WA8: 'LONP2',
    Q86WA9: 'SLC26A11',
    Q86WB0: 'ZC3HC1',
    Q86WB7: 'UNC93A',
    Q86WC4: 'OSTM1',
    Q86WD7: 'SERPINA9',
    Q86WG3: 'ATCAY',
    Q86WG5: 'SBF2',
    Q86WH2: 'RASSF3',
    Q86WI1: 'PKHD1L1',
    Q86WI3: 'NLRC5',
    Q86WJ1: 'CHD1L',
    Q86WK6: 'AMIGO1',
    Q86WN1: 'FCHSD1',
    Q86WP2: 'GPBP1',
    Q86WQ0: 'NR2C2AP',
    Q86WR0: 'CCDC25',
    Q86WT6: 'TRIM69',
    Q86WU2: 'LDHD',
    Q86WV1: 'SKAP1',
    Q86WV5: 'TEN1',
    Q86WV6: 'STING1',
    Q86WX3: 'RPS19BP1',
    Q86X02: 'CDR2L',
    Q86X24: 'HORMAD1',
    Q86X29: 'LSR',
    Q86X45: 'DNAAF11',
    Q86X51: 'EZHIP',
    Q86X52: 'CHSY1',
    Q86X55: 'CARM1',
    Q86X67: 'NUDT13',
    Q86X95: 'CIR1',
    Q86XA0: 'METTL23',
    Q86XE0: 'SNX32',
    Q86XE5: 'HOGA1',
    Q86XF0: 'DHFR2',
    Q86XF7: 'ZNF575',
    Q86XI2: 'NCAPG2',
    Q86XJ1: 'GAS2L3',
    Q86XK2: 'FBXO11',
    Q86XK3: 'SFR1',
    Q86XK7: 'VSIG1',
    Q86XL3: 'ANKLE2',
    Q86XM0: 'CATSPERD',
    Q86XN8: 'MEX3D',
    Q86XP0: 'PLA2G4D',
    Q86XP1: 'DGKH',
    Q86XP3: 'DDX42',
    Q86XQ3: 'CATSPER3',
    Q86XR7: 'TICAM2',
    Q86XR8: 'CEP57',
    Q86XS8: 'RNF130',
    Q86XT2: 'VPS37D',
    Q86XT4: 'TRIM50',
    Q86XX4: 'FRAS1',
    Q86Y01: 'DTX1',
    Q86Y07: 'VRK2',
    Q86Y13: 'DZIP3',
    Q86Y26: 'NUTM1',
    Q86Y33: 'CDC20B',
    Q86Y34: 'ADGRG3',
    Q86Y37: 'CACUL1',
    Q86Y38: 'XYLT1',
    Q86Y39: 'NDUFA11',
    Q86Y46: 'KRT73',
    Q86Y56: 'DNAAF5',
    Q86Y78: 'LYPD6',
    Q86Y82: 'STX12',
    Q86Y91: 'KIF18B',
    Q86Y97: 'KMT5C',
    Q86YA3: 'ZGRF1',
    Q86YB8: 'ERO1B',
    Q86YC2: 'PALB2',
    Q86YC3: 'NRROS',
    Q86YD1: 'PTOV1',
    Q86YD3: 'TMEM25',
    Q86YD5: 'LDLRAD3',
    Q86YD7: 'FAM90A1',
    Q86YF9: 'DZIP1',
    Q86YH6: 'PDSS2',
    Q86YI8: 'PHF13',
    Q86YJ5: 'MARCHF9',
    Q86YJ6: 'THNSL2',
    Q86YJ7: 'ANKRD13B',
    Q86YL7: 'PDPN',
    Q86YM7: 'HOMER1',
    Q86YN6: 'PPARGC1B',
    Q86YP4: 'GATAD2A',
    Q86YR5: 'GPSM1',
    Q86YR7: 'MCF2L2',
    Q86YS3: 'RAB11FIP4',
    Q86YS6: 'RAB43',
    Q86YS7: 'C2CD5',
    Q86YT5: 'SLC13A5',
    Q86YT6: 'MIB1',
    Q86YT9: 'JAML',
    Q86YV0: 'RASAL3',
    Q86YV5: 'PRAG1',
    Q86YV9: 'HPS6',
    Q86YW0: 'PLCZ1',
    Q86YW5: 'TREML1',
    Q86YW7: 'GPHB5',
    Q86YW9: 'MED12L',
    Q86YZ3: 'HRNR',
    Q86Z02: 'HIPK1',
    Q86Z14: 'KLB',
    Q86Z20: 'CCDC125',
    Q86Z23: 'C1QL4',
    Q8HWS3: 'RFX6',
    Q8IU54: 'IFNL1',
    Q8IU57: 'IFNLR1',
    Q8IU60: 'DCP2',
    Q8IU68: 'TMC8',
    Q8IU80: 'TMPRSS6',
    Q8IU81: 'IRF2BP1',
    Q8IU85: 'CAMK1D',
    Q8IU89: 'CERS3',
    Q8IU99: 'CALHM1',
    Q8IUA7: 'ABCA9',
    Q8IUB9: 'KRTAP19-1',
    Q8IUC1: 'KRTAP11-1',
    Q8IUC2: 'KRTAP8-1',
    Q8IUC3: 'KRTAP7-1',
    Q8IUC4: 'RHPN2',
    Q8IUC6: 'TICAM1',
    Q8IUC8: 'GALNT13',
    Q8IUD2: 'ERC1',
    Q8IUD6: 'RNF135',
    Q8IUE6: 'H2AC21',
    Q8IUF8: 'RIOX2',
    Q8IUG1: 'KRTAP1-3',
    Q8IUG5: 'MYO18B',
    Q8IUH3: 'RBM45',
    Q8IUH4: 'ZDHHC13',
    Q8IUH5: 'ZDHHC17',
    Q8IUH8: 'SPPL2C',
    Q8IUI8: 'CRLF3',
    Q8IUK5: 'PLXDC1',
    Q8IUM7: 'NPAS4',
    Q8IUN9: 'CLEC10A',
    Q8IUQ0: 'CLVS1',
    Q8IUQ4: 'SIAH1',
    Q8IUR0: 'TRAPPC5',
    Q8IUR5: 'TMTC1',
    Q8IUR6: 'CREBRF',
    Q8IUR7: 'ARMC8',
    Q8IUW3: 'SPATA2L',
    Q8IUW5: 'RELL1',
    Q8IUX1: 'TMEM126B',
    Q8IUX4: 'APOBEC3F',
    Q8IUX7: 'AEBP1',
    Q8IUX8: 'EGFL6',
    Q8IUY3: 'GRAMD2A',
    Q8IUZ5: 'PHYKPL',
    Q8IV01: 'SYT12',
    Q8IV04: 'TBC1D10C',
    Q8IV08: 'PLD3',
    Q8IV16: 'GPIHBP1',
    Q8IV20: 'LACC1',
    Q8IV31: 'TMEM139',
    Q8IV36: 'HID1',
    Q8IV45: 'UNC5CL',
    Q8IV48: 'ERI1',
    Q8IV53: 'DENND1C',
    Q8IV61: 'RASGRP3',
    Q8IV63: 'VRK3',
    Q8IV76: 'PASD1',
    Q8IV77: 'CNGA4',
    Q8IVB4: 'SLC9A9',
    Q8IVD9: 'NUDCD3',
    Q8IVE3: 'PLEKHH2',
    Q8IVF2: 'AHNAK2',
    Q8IVF4: 'DNAH10',
    Q8IVF5: 'TIAM2',
    Q8IVF7: 'FMNL3',
    Q8IVG5: 'SAMD9L',
    Q8IVG9: 'MT-RNR2',
    Q8IVH2: 'FOXP4',
    Q8IVH4: 'MMAA',
    Q8IVH8: 'MAP4K3',
    Q8IVI9: 'NOSTRIN',
    Q8IVJ1: 'SLC41A1',
    Q8IVL0: 'NAV3',
    Q8IVL1: 'NAV2',
    Q8IVL5: 'P3H2',
    Q8IVL6: 'P3H3',
    Q8IVL8: 'CPO',
    Q8IVM0: 'CCDC50',
    Q8IVM8: 'SLC22A9',
    Q8IVP5: 'FUNDC1',
    Q8IVP9: 'ZNF547',
    Q8IVQ6: 'ZDHHC21',
    Q8IVS2: 'MCAT',
    Q8IVS8: 'GLYCTK',
    Q8IVT2: 'MISP',
    Q8IVT5: 'KSR1',
    Q8IVU3: 'HERC6',
    Q8IVV7: 'GID4',
    Q8IVW4: 'CDKL3',
    Q8IVW6: 'ARID3B',
    Q8IVW8: 'SPNS2',
    Q8IW00: 'VSTM4',
    Q8IW19: 'APLF',
    Q8IW35: 'CEP97',
    Q8IW40: 'CCDC103',
    Q8IW41: 'MAPKAPK5',
    Q8IW45: 'NAXD',
    Q8IW52: 'SLITRK4',
    Q8IW75: 'SERPINA12',
    Q8IWA4: 'MFN1',
    Q8IWA5: 'SLC44A2',
    Q8IWB1: 'ITPRIP',
    Q8IWB6: 'TEX14',
    Q8IWB7: 'WDFY1',
    Q8IWC1: 'MAP7D3',
    Q8IWD4: 'CCDC117',
    Q8IWE2: 'FAM114A1',
    Q8IWE4: 'DCUN1D3',
    Q8IWE5: 'PLEKHM2',
    Q8IWF2: 'FOXRED2',
    Q8IWG1: 'DNAI3',
    Q8IWI9: 'MGA',
    Q8IWJ2: 'GCC2',
    Q8IWK6: 'ADGRA3',
    Q8IWL1: 'SFTPA2',
    Q8IWL2: 'SFTPA1',
    Q8IWL3: 'HSCB',
    Q8IWL8: 'STH',
    Q8IWN7: 'RP1L1',
    Q8IWQ3: 'BRSK2',
    Q8IWR1: 'TRIM59',
    Q8IWS0: 'PHF6',
    Q8IWT0: 'ZBTB8OS',
    Q8IWT1: 'SCN4B',
    Q8IWT3: 'CUL9',
    Q8IWT6: 'LRRC8A',
    Q8IWU2: 'LMTK2',
    Q8IWU4: 'SLC30A8',
    Q8IWU5: 'SULF2',
    Q8IWU6: 'SULF1',
    Q8IWU9: 'TPH2',
    Q8IWV1: 'LAX1',
    Q8IWV2: 'CNTN4',
    Q8IWV7: 'UBR1',
    Q8IWV8: 'UBR2',
    Q8IWW6: 'ARHGAP12',
    Q8IWW8: 'ADHFE1',
    Q8IWX5: 'SGPP2',
    Q8IWX7: 'UNC45B',
    Q8IWX8: 'CHERP',
    Q8IWY4: 'SCUBE1',
    Q8IWY9: 'CDAN1',
    Q8IWZ3: 'ANKHD1',
    Q8IWZ4: 'TRIM48',
    Q8IWZ5: 'TRIM42',
    Q8IWZ6: 'BBS7',
    Q8IWZ8: 'SUGP1',
    Q8IX01: 'SUGP2',
    Q8IX03: 'WWC1',
    Q8IX04: 'UEVLD',
    Q8IX05: 'CD302',
    Q8IX07: 'ZFPM1',
    Q8IX12: 'CCAR1',
    Q8IX15: 'HOMEZ',
    Q8IX19: 'MCEMP1',
    Q8IX21: 'SLF2',
    Q8IX30: 'SCUBE3',
    Q8IX90: 'SKA3',
    Q8IXA5: 'SPACA3',
    Q8IXB1: 'DNAJC10',
    Q8IXB3: 'TRARG1',
    Q8IXF0: 'NPAS3',
    Q8IXH6: 'TP53INP2',
    Q8IXH7: 'NELFCD',
    Q8IXH8: 'CDH26',
    Q8IXI1: 'RHOT2',
    Q8IXI2: 'RHOT1',
    Q8IXJ6: 'SIRT2',
    Q8IXJ9: 'ASXL1',
    Q8IXK0: 'PHC2',
    Q8IXK2: 'GALNT12',
    Q8IXL6: 'FAM20C',
    Q8IXL7: 'MSRB3',
    Q8IXM2: 'BAP18',
    Q8IXM3: 'MRPL41',
    Q8IXM6: 'NRM',
    Q8IXN7: 'RIMKLA',
    Q8IXQ5: 'KLHL7',
    Q8IXQ6: 'PARP9',
    Q8IXQ9: 'ETFBKMT',
    Q8IXS2: 'CCDC65',
    Q8IXT2: 'DMRTC2',
    Q8IXV7: 'KLHDC8B',
    Q8IXW0: 'LMNTD2',
    Q8IXW5: 'RPAP2',
    Q8IXZ2: 'ZC3H3',
    Q8IY17: 'PNPLA6',
    Q8IY18: 'SMC5',
    Q8IY21: 'DDX60',
    Q8IY22: 'CMIP',
    Q8IY26: 'PLPP6',
    Q8IY31: 'IFT20',
    Q8IY33: 'MICALL2',
    Q8IY34: 'SLC15A3',
    Q8IY37: 'DHX37',
    Q8IY49: 'MMD2',
    Q8IY57: 'YAF2',
    Q8IY63: 'AMOTL1',
    Q8IY81: 'FTSJ3',
    Q8IY82: 'DRC7',
    Q8IY84: 'NIM1K',
    Q8IY92: 'SLX4',
    Q8IY95: 'TMEM192',
    Q8IYA6: 'CKAP2L',
    Q8IYA8: 'IHO1',
    Q8IYB1: 'MB21D2',
    Q8IYB3: 'SRRM1',
    Q8IYB4: 'PEX5L',
    Q8IYB5: 'SMAP1',
    Q8IYB7: 'DIS3L2',
    Q8IYB8: 'SUPV3L1',
    Q8IYD1: 'GSPT2',
    Q8IYD8: 'FANCM',
    Q8IYE0: 'CCDC146',
    Q8IYE1: 'CCDC13',
    Q8IYF1: 'ELOA2',
    Q8IYF3: 'TEX11',
    Q8IYG6: 'LRRC56',
    Q8IYH5: 'ZZZ3',
    Q8IYI0: 'SHLD1',
    Q8IYI6: 'EXOC8',
    Q8IYI8: 'ZNF440',
    Q8IYJ0: 'PIANP',
    Q8IYJ1: 'CPNE9',
    Q8IYJ2: 'C10orf67',
    Q8IYJ3: 'SYTL1',
    Q8IYK4: 'COLGALT2',
    Q8IYL9: 'GPR65',
    Q8IYM1: 'SEPTIN12',
    Q8IYM2: 'SLFN12',
    Q8IYM9: 'TRIM22',
    Q8IYP9: 'ZDHHC23',
    Q8IYR0: 'CFAP206',
    Q8IYR2: 'SMYD4',
    Q8IYR6: 'TMEFF1',
    Q8IYS1: 'PM20D2',
    Q8IYS5: 'OSCAR',
    Q8IYT2: 'CMTR2',
    Q8IYT3: 'CCDC170',
    Q8IYT4: 'KATNAL2',
    Q8IYT8: 'ULK2',
    Q8IYU2: 'HACE1',
    Q8IYU8: 'MICU2',
    Q8IYV9: 'IZUMO1',
    Q8IYW5: 'RNF168',
    Q8IYX1: 'TBC1D21',
    Q8IYX3: 'CCDC116',
    Q8IYX4: 'DND1',
    Q8IYX7: 'SAXO1',
    Q8IYX8: 'CEP57L1',
    Q8IYY4: 'DZIP1L',
    Q8IZ07: 'ANKRD13A',
    Q8IZ20: 'ZNF683',
    Q8IZ21: 'PHACTR4',
    Q8IZ41: 'RASEF',
    Q8IZ52: 'CHPF',
    Q8IZ69: 'TRMT2A',
    Q8IZ96: 'CMTM1',
    Q8IZA0: 'KIAA0319L',
    Q8IZC4: 'RTKN2',
    Q8IZC6: 'COL27A1',
    Q8IZC7: 'ZNF101',
    Q8IZD2: 'KMT2E',
    Q8IZD4: 'DCP1B',
    Q8IZD9: 'DOCK3',
    Q8IZE3: 'SCYL3',
    Q8IZF0: 'NALCN',
    Q8IZF2: 'ADGRF5',
    Q8IZF3: 'ADGRF4',
    Q8IZF6: 'ADGRG4',
    Q8IZH2: 'XRN1',
    Q8IZI9: 'IFNL3',
    Q8IZJ0: 'IFNL2',
    Q8IZJ1: 'UNC5B',
    Q8IZJ3: 'CPAMD8',
    Q8IZK6: 'MCOLN2',
    Q8IZL2: 'MAML2',
    Q8IZL8: 'PELP1',
    Q8IZL9: 'CDK20',
    Q8IZN3: 'ZDHHC14',
    Q8IZP0: 'ABI1',
    Q8IZP1: 'TBC1D3',
    Q8IZP9: 'ADGRG2',
    Q8IZQ1: 'WDFY3',
    Q8IZQ8: 'MYOCD',
    Q8IZR5: 'CMTM4',
    Q8IZT6: 'ASPM',
    Q8IZT8: 'HS3ST5',
    Q8IZU0: 'FAM9B',
    Q8IZU1: 'FAM9A',
    Q8IZU3: 'SYCP3',
    Q8IZU9: 'KIRREL3',
    Q8IZV5: 'RDH10',
    Q8IZW8: 'TNS4',
    Q8IZX4: 'TAF1L',
    Q8IZY2: 'ABCA7',
    Q8J025: 'APCDD1',
    Q8N0S2: 'SYCE1',
    Q8N0U8: 'VKORC1L1',
    Q8N0V3: 'RBFA',
    Q8N0V5: 'GCNT2',
    Q8N0W3: 'FCSK',
    Q8N0W4: 'NLGN4X',
    Q8N0X2: 'SPAG16',
    Q8N0X4: 'CLYBL',
    Q8N0X7: 'SPART',
    Q8N0Y2: 'ZNF444',
    Q8N0Z3: 'SPICE1',
    Q8N0Z6: 'TTC5',
    Q8N100: 'ATOH7',
    Q8N104: 'DEFB106A',
    Q8N104: 'DEFB106B',
    Q8N108: 'MIER1',
    Q8N114: 'SHISA5',
    Q8N119: 'MMP21',
    Q8N122: 'RPTOR',
    Q8N126: 'CADM3',
    Q8N130: 'SLC34A3',
    Q8N131: 'TMEM123',
    Q8N135: 'LGI4',
    Q8N137: 'CNTROB',
    Q8N138: 'ORMDL3',
    Q8N139: 'ABCA6',
    Q8N140: 'EID3',
    Q8N142: 'ADSS1',
    Q8N144: 'GJD3',
    Q8N149: 'LILRA2',
    Q8N157: 'AHI1',
    Q8N158: 'GPC2',
    Q8N159: 'NAGS',
    Q8N163: 'CCAR2',
    Q8N165: 'PDIK1L',
    Q8N183: 'NDUFAF2',
    Q8N187: 'CARF',
    Q8N196: 'SIX5',
    Q8N1A0: 'KRT222',
    Q8N1B3: 'CCNQ',
    Q8N1B4: 'VPS52',
    Q8N1C3: 'GABRG1',
    Q8N1E6: 'FBXL14',
    Q8N1F7: 'NUP93',
    Q8N1F8: 'STK11IP',
    Q8N1G0: 'ZNF687',
    Q8N1G1: 'REXO1',
    Q8N1G2: 'CMTR1',
    Q8N1H7: 'SIX6OS1',
    Q8N1I0: 'DOCK4',
    Q8N1K5: 'THEMIS',
    Q8N1L9: 'BATF2',
    Q8N1M1: 'BEST3',
    Q8N1N2: 'DYNAP',
    Q8N1N4: 'KRT78',
    Q8N1Q1: 'CA13',
    Q8N1Q8: 'THEM5',
    Q8N1V2: 'CFAP52',
    Q8N1W1: 'ARHGEF28',
    Q8N201: 'INTS1',
    Q8N205: 'SYNE4',
    Q8N257: 'H2BC26',
    Q8N264: 'ARHGAP24',
    Q8N271: 'PROM2',
    Q8N2A8: 'PLD6',
    Q8N2C7: 'UNC80',
    Q8N2E6: 'TOR2A',
    Q8N2F6: 'ARMC10',
    Q8N2G4: 'LYPD1',
    Q8N2G8: 'GHDC',
    Q8N2H4: 'SYS1',
    Q8N2H9: 'PELI3',
    Q8N2I9: 'STK40',
    Q8N2K0: 'ABHD12',
    Q8N2K1: 'UBE2J2',
    Q8N2M4: 'TMEM86A',
    Q8N2M8: 'CLASRP',
    Q8N2N9: 'ANKRD36B',
    Q8N2Q7: 'NLGN1',
    Q8N2R0: 'OSR2',
    Q8N2S1: 'LTBP4',
    Q8N2U9: 'SLC66A2',
    Q8N2W9: 'PIAS4',
    Q8N2Y8: 'RUSC2',
    Q8N2Z9: 'CENPS',
    Q8N300: 'SVBP',
    Q8N302: 'AGGF1',
    Q8N307: 'MUC20',
    Q8N335: 'GPD1L',
    Q8N339: 'MT1M',
    Q8N344: 'MIER2',
    Q8N350: 'CBARP',
    Q8N357: 'SLC35F6',
    Q8N370: 'SLC43A2',
    Q8N371: 'KDM8',
    Q8N386: 'LRRC25',
    Q8N387: 'MUC15',
    Q8N392: 'ARHGAP18',
    Q8N393: 'ZNF786',
    Q8N394: 'TMTC2',
    Q8N3A8: 'PARP8',
    Q8N3C0: 'ASCC3',
    Q8N3C7: 'CLIP4',
    Q8N3E9: 'PLCD3',
    Q8N3F0: 'MTURN',
    Q8N3F8: 'MICALL1',
    Q8N3G9: 'TMEM130',
    Q8N3I7: 'BBS5',
    Q8N3J2: 'METTL4',
    Q8N3J3: 'HROB',
    Q8N3J5: 'PPM1K',
    Q8N3J6: 'CADM2',
    Q8N3K9: 'CMYA5',
    Q8N3L3: 'TXLNB',
    Q8N3P4: 'VPS8',
    Q8N3R9: 'PALS1',
    Q8N3T1: 'GALNT15',
    Q8N3U4: 'STAG2',
    Q8N3V7: 'SYNPO',
    Q8N3Y1: 'FBXW8',
    Q8N3Y3: 'LARGE2',
    Q8N3Y7: 'SDR16C5',
    Q8N3Z6: 'ZCCHC7',
    Q8N414: 'PGBD5',
    Q8N423: 'LILRB2',
    Q8N427: 'NME8',
    Q8N428: 'GALNT16',
    Q8N441: 'FGFRL1',
    Q8N443: 'RIBC1',
    Q8N448: 'LNX2',
    Q8N465: 'D2HGDH',
    Q8N474: 'SFRP1',
    Q8N488: 'RYBP',
    Q8N490: 'PNKD',
    Q8N4A0: 'GALNT4',
    Q8N4B1: 'PHETA1',
    Q8N4C6: 'NIN',
    Q8N4C7: 'STX19',
    Q8N4C8: 'MINK1',
    Q8N4E7: 'FTMT',
    Q8N4F0: 'BPIFB2',
    Q8N4F4: 'SLC22A24',
    Q8N4J0: 'CARNMT1',
    Q8N4L2: 'PIP4P2',
    Q8N4L8: 'CCDC24',
    Q8N4M1: 'SLC44A3',
    Q8N4N3: 'KLHL36',
    Q8N4N8: 'KIF2B',
    Q8N4P3: 'HDDC3',
    Q8N4Q1: 'CHCHD4',
    Q8N4S9: 'MARVELD2',
    Q8N4T0: 'CPA6',
    Q8N4T8: 'CBR4',
    Q8N4V1: 'MMGT1',
    Q8N4X5: 'AFAP1L2',
    Q8N4Y2: 'CRACR2B',
    Q8N511: 'TMEM199',
    Q8N539: 'FIBCD1',
    Q8N543: 'OGFOD1',
    Q8N554: 'ZNF276',
    Q8N556: 'AFAP1',
    Q8N565: 'MREG',
    Q8N568: 'DCLK2',
    Q8N573: 'OXR1',
    Q8N594: 'MPND',
    Q8N5A5: 'ZGPAT',
    Q8N5B7: 'CERS5',
    Q8N5C8: 'TAB3',
    Q8N5D0: 'WDTC1',
    Q8N5D6: 'GBGT1',
    Q8N5F7: 'NKAP',
    Q8N5G0: 'SMIM20',
    Q8N5G2: 'MACO1',
    Q8N5H7: 'SH2D3C',
    Q8N5I2: 'ARRDC1',
    Q8N5I4: 'DHRSX',
    Q8N5J2: 'MINDY1',
    Q8N5K1: 'CISD2',
    Q8N5M1: 'ATPAF2',
    Q8N5M9: 'JAGN1',
    Q8N5P1: 'ZC3H8',
    Q8N5S9: 'CAMKK1',
    Q8N5U6: 'RNF10',
    Q8N5V2: 'NGEF',
    Q8N5Y2: 'MSL3',
    Q8N5Y8: 'PARP16',
    Q8N5Z0: 'AADAT',
    Q8N5Z5: 'KCTD17',
    Q8N608: 'DPP10',
    Q8N609: 'TRAM1L1',
    Q8N612: 'FHIP1B',
    Q8N635: 'MEIOB',
    Q8N653: 'LZTR1',
    Q8N661: 'TMEM86B',
    Q8N668: 'COMMD1',
    Q8N680: 'ZBTB2',
    Q8N682: 'DRAM1',
    Q8N684: 'CPSF7',
    Q8N690: 'DEFB119',
    Q8N693: 'ESX1',
    Q8N695: 'SLC5A8',
    Q8N697: 'SLC15A4',
    Q8N6C5: 'IGSF1',
    Q8N6C8: 'LILRA3',
    Q8N6D2: 'RNF182',
    Q8N6F1: 'CLDN19',
    Q8N6F7: 'GCSAM',
    Q8N6F8: 'METTL27',
    Q8N6G5: 'CSGALNACT2',
    Q8N6G6: 'ADAMTSL1',
    Q8N6H7: 'ARFGAP2',
    Q8N6I1: 'EID2',
    Q8N6K0: 'TEX29',
    Q8N6K7: 'SAMD3',
    Q8N6L0: 'KASH5',
    Q8N6L1: 'KRTCAP2',
    Q8N6M0: 'OTUD6B',
    Q8N6M3: 'FITM2',
    Q8N6M6: 'AOPEP',
    Q8N6P7: 'IL22RA1',
    Q8N6Q3: 'CD177',
    Q8N6R0: 'METTL13',
    Q8N6R1: 'SERP2',
    Q8N6S4: 'ANKRD13C',
    Q8N6T3: 'ARFGAP1',
    Q8N6T7: 'SIRT6',
    Q8N6U8: 'GPR161',
    Q8N6W0: 'CELF5',
    Q8N6Y0: 'USHBP1',
    Q8N715: 'CCDC185',
    Q8N720: 'ZNF655',
    Q8N726: 'CDKN2A',
    Q8N743: 'KIR3DL3',
    Q8N752: 'CSNK1A1L',
    Q8N766: 'EMC1',
    Q8N7B6: 'PACRGL',
    Q8N7C0: 'LRRC52',
    Q8N7C3: 'TRIML2',
    Q8N7E2: 'CBLL2',
    Q8N7H5: 'PAF1',
    Q8N7J2: 'AMER2',
    Q8N7U6: 'EFHB',
    Q8N7U7: 'TPRX1',
    Q8N7W2: 'BEND7',
    Q8N7X4: 'MAGEB6',
    Q8N807: 'PDILT',
    Q8N841: 'TTLL6',
    Q8N865: 'SPMIP4',
    Q8N884: 'CGAS',
    Q8N895: 'ZNF366',
    Q8N8B7: 'TCEANC',
    Q8N8E2: 'ZNF513',
    Q8N8N0: 'RNF152',
    Q8N8N7: 'PTGR2',
    Q8N8Q3: 'ENDOV',
    Q8N8Q8: 'COX18',
    Q8N8R3: 'SLC25A29',
    Q8N8R7: 'ARL14EP',
    Q8N8S7: 'ENAH',
    Q8N8U9: 'BMPER',
    Q8N8V2: 'GBP7',
    Q8N8V4: 'ANKS4B',
    Q8N8W4: 'PNPLA1',
    Q8N8X9: 'MAB21L3',
    Q8N8Y2: 'ATP6V0D2',
    Q8N912: 'NRAC',
    Q8N960: 'CEP120',
    Q8N966: 'ZDHHC22',
    Q8N983: 'MRPL43',
    Q8N987: 'NECAB1',
    Q8N988: 'ZNF557',
    Q8N9A8: 'CNEP1R1',
    Q8N9B5: 'JMY',
    Q8N9E0: 'FAM133A',
    Q8N9F0: 'NAT8L',
    Q8N9F7: 'GDPD1',
    Q8N9I0: 'SYT2',
    Q8N9I5: 'FADS6',
    Q8N9I9: 'DTX3',
    Q8N9L9: 'ACOT4',
    Q8N9M5: 'TMEM102',
    Q8N9N2: 'ASCC1',
    Q8N9N5: 'BANP',
    Q8N9N8: 'EIF1AD',
    Q8N9Q2: 'SREK1IP1',
    Q8N9R8: 'SCAI',
    Q8N9V2: 'TRIML1',
    Q8N9V6: 'ANKRD53',
    Q8N9W5: 'DNAAF3',
    Q8N9W6: 'BOLL',
    Q8NA29: 'MFSD2A',
    Q8NA31: 'TERB1',
    Q8NA42: 'ZNF383',
    Q8NA54: 'IQUB',
    Q8NA56: 'TTC29',
    Q8NA58: 'PNLDC1',
    Q8NA61: 'CBY2',
    Q8NA72: 'POC5',
    Q8NA77: 'TEX19',
    Q8NA82: 'MARCHF10',
    Q8NAA4: 'ATG16L2',
    Q8NAC3: 'IL17RC',
    Q8NAG6: 'ANKLE1',
    Q8NAM6: 'ZSCAN4',
    Q8NAN2: 'MIGA1',
    Q8NAP3: 'ZBTB38',
    Q8NAP8: 'ZBTB8B',
    Q8NAT1: 'POMGNT2',
    Q8NAU1: 'FNDC5',
    Q8NAV1: 'PRPF38A',
    Q8NAX2: 'KDF1',
    Q8NB12: 'SMYD1',
    Q8NB14: 'USP38',
    Q8NB15: 'ZNF511',
    Q8NB16: 'MLKL',
    Q8NB49: 'ATP11C',
    Q8NB59: 'SYT14',
    Q8NB66: 'UNC13C',
    Q8NB78: 'KDM1B',
    Q8NB90: 'AFG2A',
    Q8NB91: 'FANCB',
    Q8NBB4: 'ZSCAN1',
    Q8NBD8: 'TMEM229B',
    Q8NBF1: 'GLIS1',
    Q8NBF2: 'NHLRC2',
    Q8NBI2: 'CYB561A3',
    Q8NBI3: 'DRAXIN',
    Q8NBI5: 'SLC43A3',
    Q8NBI6: 'XXYLT1',
    Q8NBJ4: 'GOLM1',
    Q8NBJ5: 'COLGALT1',
    Q8NBJ7: 'SUMF2',
    Q8NBJ9: 'SIDT2',
    Q8NBK3: 'SUMF1',
    Q8NBL1: 'POGLUT1',
    Q8NBM4: 'UBAC2',
    Q8NBN3: 'TMEM87A',
    Q8NBN7: 'RDH13',
    Q8NBP7: 'PCSK9',
    Q8NBQ5: 'HSD17B11',
    Q8NBQ7: 'AQP11',
    Q8NBR6: 'MINDY2',
    Q8NBS3: 'SLC4A11',
    Q8NBS9: 'TXNDC5',
    Q8NBT0: 'POC1A',
    Q8NBT2: 'SPC24',
    Q8NBU5: 'ATAD1',
    Q8NBV8: 'SYT8',
    Q8NBW4: 'SLC38A9',
    Q8NBZ0: 'INO80E',
    Q8NBZ7: 'UXS1',
    Q8NC01: 'CLEC1A',
    Q8NC06: 'ACBD4',
    Q8NC24: 'RELL2',
    Q8NC26: 'ZNF114',
    Q8NC42: 'RNF149',
    Q8NC51: 'SERBP1',
    Q8NC56: 'LEMD2',
    Q8NC60: 'NOA1',
    Q8NC67: 'NETO2',
    Q8NC69: 'KCTD6',
    Q8NCA5: 'FAM98A',
    Q8NCB2: 'CAMKV',
    Q8NCC3: 'PLA2G15',
    Q8NCD3: 'HJURP',
    Q8NCE0: 'TSEN2',
    Q8NCE2: 'MTMR14',
    Q8NCF5: 'NFATC2IP',
    Q8NCG5: 'CHST4',
    Q8NCG7: 'DAGLB',
    Q8NCH0: 'CHST14',
    Q8NCK7: 'SLC16A11',
    Q8NCL4: 'GALNT6',
    Q8NCM2: 'KCNH5',
    Q8NCM8: 'DYNC2H1',
    Q8NCN4: 'RNF169',
    Q8NCP5: 'ZBTB44',
    Q8NCR0: 'B3GALNT2',
    Q8NCR6: 'SPMIP6',
    Q8NCS7: 'SLC44A5',
    Q8NCT1: 'ARRDC4',
    Q8NCU7: 'C2CD4A',
    Q8NCU8: 'MTLN',
    Q8NCW0: 'KREMEN2',
    Q8NCW5: 'NAXE',
    Q8NCW6: 'GALNT11',
    Q8ND04: 'SMG8',
    Q8ND23: 'CARMIL3',
    Q8ND25: 'ZNRF1',
    Q8ND30: 'PPFIBP2',
    Q8ND56: 'LSM14A',
    Q8ND76: 'CCNY',
    Q8ND83: 'SLAIN1',
    Q8ND90: 'PNMA1',
    Q8NDB2: 'BANK1',
    Q8NDC0: 'MAPK1IP1L',
    Q8NDC4: 'MORN4',
    Q8NDF8: 'TENT4B',
    Q8NDG6: 'TDRD9',
    Q8NDH3: 'NPEPL1',
    Q8NDH6: 'ICA1L',
    Q8NDI1: 'EHBP1',
    Q8NDL9: 'AGBL5',
    Q8NDM7: 'CFAP43',
    Q8NDN9: 'RCBTB1',
    Q8NDP4: 'ZNF439',
    Q8NDQ6: 'ZNF540',
    Q8NDT2: 'RBM15B',
    Q8NDV1: 'ST6GALNAC3',
    Q8NDV3: 'SMC1B',
    Q8NDV7: 'TNRC6A',
    Q8NDW8: 'TTC21A',
    Q8NDX1: 'PSD4',
    Q8NDX2: 'SLC17A8',
    Q8NDX5: 'PHC3',
    Q8NDZ2: 'SIMC1',
    Q8NDZ4: 'DIPK2A',
    Q8NE01: 'CNNM3',
    Q8NE09: 'RGS22',
    Q8NE31: 'FAM13C',
    Q8NE35: 'CPEB3',
    Q8NE63: 'HIPK4',
    Q8NE71: 'ABCF1',
    Q8NE79: 'BVES',
    Q8NE86: 'MCU',
    Q8NEA6: 'GLIS3',
    Q8NEA9: 'GMCL2',
    Q8NEB5: 'PLPP5',
    Q8NEB9: 'PIK3C3',
    Q8NEC5: 'CATSPER1',
    Q8NEH6: 'MNS1',
    Q8NEJ0: 'DUSP18',
    Q8NEJ9: 'NGDN',
    Q8NEK8: 'TENT5D',
    Q8NEL9: 'DDHD1',
    Q8NEM0: 'MCPH1',
    Q8NEM7: 'SUPT20H',
    Q8NEM8: 'AGBL3',
    Q8NEN9: 'PDZD8',
    Q8NEP3: 'DNAAF1',
    Q8NEQ6: 'SRARP',
    Q8NER1: 'TRPV1',
    Q8NER5: 'ACVR1C',
    Q8NES3: 'LFNG',
    Q8NES8: 'DEFB124',
    Q8NET5: 'NFAM1',
    Q8NET6: 'CHST13',
    Q8NET8: 'TRPV3',
    Q8NEU8: 'APPL2',
    Q8NEV1: 'CSNK2A3',
    Q8NEV4: 'MYO3A',
    Q8NEV8: 'EXPH5',
    Q8NEV9: 'IL27',
    Q8NEW0: 'SLC30A7',
    Q8NEY1: 'NAV1',
    Q8NEY4: 'ATP6V1C2',
    Q8NEY8: 'PPHLN1',
    Q8NEZ2: 'VPS37A',
    Q8NEZ3: 'WDR19',
    Q8NEZ4: 'KMT2C',
    Q8NEZ5: 'FBXO22',
    Q8NF37: 'LPCAT1',
    Q8NF50: 'DOCK8',
    Q8NF64: 'ZMIZ2',
    Q8NF91: 'SYNE1',
    Q8NF99: 'ZNF397',
    Q8NFA0: 'USP32',
    Q8NFA2: 'NOXO1',
    Q8NFB2: 'TMEM185A',
    Q8NFC6: 'BOD1L1',
    Q8NFD2: 'ANKK1',
    Q8NFD5: 'ARID1B',
    Q8NFF2: 'SLC24A4',
    Q8NFF5: 'FLAD1',
    Q8NFG4: 'FLCN',
    Q8NFH3: 'NUP43',
    Q8NFH4: 'NUP37',
    Q8NFH5: 'NUP35',
    Q8NFH8: 'REPS2',
    Q8NFJ5: 'GPRC5A',
    Q8NFJ6: 'PROKR2',
    Q8NFJ9: 'BBS1',
    Q8NFL0: 'B3GNT7',
    Q8NFM4: 'ADCY4',
    Q8NFM7: 'IL17RD',
    Q8NFP4: 'MDGA1',
    Q8NFP7: 'NUDT10',
    Q8NFP9: 'NBEA',
    Q8NFQ8: 'TOR1AIP2',
    Q8NFR3: 'SPTSSB',
    Q8NFR9: 'IL17RE',
    Q8NFT2: 'STEAP2',
    Q8NFT6: 'DBF4B',
    Q8NFT8: 'DNER',
    Q8NFU1: 'BEST2',
    Q8NFU3: 'TSTD1',
    Q8NFU5: 'IPMK',
    Q8NFU7: 'TET1',
    Q8NFV4: 'ABHD11',
    Q8NFW1: 'COL22A1',
    Q8NFW5: 'DMBX1',
    Q8NFW8: 'CMAS',
    Q8NFW9: 'MYRIP',
    Q8NFX7: 'STXBP6',
    Q8NFY4: 'SEMA6D',
    Q8NFY9: 'KBTBD8',
    Q8NFZ0: 'FBH1',
    Q8NFZ3: 'NLGN4Y',
    Q8NFZ4: 'NLGN2',
    Q8NFZ5: 'TNIP2',
    Q8NFZ8: 'CADM4',
    Q8NG06: 'TRIM58',
    Q8NG08: 'HELB',
    Q8NG11: 'TSPAN14',
    Q8NG27: 'PJA1',
    Q8NG31: 'KNL1',
    Q8NG50: 'RDM1',
    Q8NG66: 'NEK11',
    Q8NG98: 'OR7D4',
    Q8NHC4: 'OR10J5',
    Q8NHE4: 'ATP6V0E2',
    Q8NHG7: 'SVIP',
    Q8NHG8: 'ZNRF2',
    Q8NHH1: 'TTLL11',
    Q8NHH9: 'ATL2',
    Q8NHJ6: 'LILRB4',
    Q8NHL6: 'LILRB1',
    Q8NHM5: 'KDM2B',
    Q8NHP6: 'MOSPD2',
    Q8NHP8: 'PLBD2',
    Q8NHQ1: 'CEP70',
    Q8NHQ9: 'DDX55',
    Q8NHS1: 'CLDND2',
    Q8NHS3: 'MFSD8',
    Q8NHS9: 'SPATA22',
    Q8NHU3: 'SGMS2',
    Q8NHU6: 'TDRD7',
    Q8NHV1: 'GIMAP7',
    Q8NHV4: 'NEDD1',
    Q8NHV9: 'RHOXF1',
    Q8NHW3: 'MAFA',
    Q8NHW4: 'CCL4L1',
    Q8NHW4: 'CCL4L2',
    Q8NHX9: 'TPCN2',
    Q8NHY0: 'B4GALNT2',
    Q8NHY2: 'COP1',
    Q8NHY3: 'GAS2L2',
    Q8NHZ8: 'CDC26',
    Q8NI08: 'NCOA7',
    Q8NI17: 'IL31RA',
    Q8NI22: 'MCFD2',
    Q8NI27: 'THOC2',
    Q8NI35: 'PATJ',
    Q8NI36: 'WDR36',
    Q8NI37: 'PPTC7',
    Q8NI38: 'NFKBID',
    Q8NI51: 'CTCFL',
    Q8NI60: 'COQ8A',
    Q8NI77: 'KIF18A',
    Q8TA86: 'RP9',
    Q8TAA9: 'VANGL1',
    Q8TAB3: 'PCDH19',
    Q8TAB5: 'C1orf216',
    Q8TAC2: 'JOSD2',
    Q8TAC9: 'SCAMP5',
    Q8TAD2: 'IL17D',
    Q8TAD4: 'SLC30A5',
    Q8TAD8: 'SNIP1',
    Q8TAE7: 'KCNG3',
    Q8TAE8: 'GADD45GIP1',
    Q8TAF3: 'WDR48',
    Q8TAF8: 'LHFPL5',
    Q8TAG5: 'VSTM2A',
    Q8TAG9: 'EXOC6',
    Q8TAI7: 'RHEBL1',
    Q8TAK6: 'OLIG1',
    Q8TAM1: 'BBS10',
    Q8TAM2: 'TTC8',
    Q8TAM6: 'ERMN',
    Q8TAP4: 'LMO3',
    Q8TAP6: 'CEP76',
    Q8TAP8: 'PPP1R35',
    Q8TAP9: 'MPLKIP',
    Q8TAQ2: 'SMARCC2',
    Q8TAS1: 'UHMK1',
    Q8TAT2: 'FGFBP3',
    Q8TAT5: 'NEIL3',
    Q8TAT6: 'NPLOC4',
    Q8TAU0: 'NKX2-3',
    Q8TAU3: 'ZNF417',
    Q8TAV3: 'CYP2W1',
    Q8TAX0: 'OSR1',
    Q8TAX7: 'MUC7',
    Q8TAX9: 'GSDMB',
    Q8TAZ6: 'CMTM2',
    Q8TB24: 'RIN3',
    Q8TB36: 'GDAP1',
    Q8TB37: 'NUBPL',
    Q8TB40: 'ABHD4',
    Q8TB45: 'DEPTOR',
    Q8TB61: 'SLC35B2',
    Q8TB68: 'PRR7',
    Q8TB72: 'PUM2',
    Q8TB73: 'NDNF',
    Q8TB92: 'HMGCLL1',
    Q8TBA6: 'GOLGA5',
    Q8TBB0: 'THAP6',
    Q8TBB1: 'LNX1',
    Q8TBB6: 'SLC7A14',
    Q8TBC3: 'SHKBP1',
    Q8TBC4: 'UBA3',
    Q8TBC5: 'ZSCAN18',
    Q8TBE0: 'BAHD1',
    Q8TBE1: 'CNIH3',
    Q8TBE3: 'FNDC9',
    Q8TBE7: 'SLC35G2',
    Q8TBE9: 'NANP',
    Q8TBF2: 'PRXL2B',
    Q8TBG4: 'ETNPPL',
    Q8TBG9: 'SYNPR',
    Q8TBJ4: 'PLPPR1',
    Q8TBJ5: 'FEZF2',
    Q8TBK2: 'SETD6',
    Q8TBK6: 'ZCCHC10',
    Q8TBM7: 'TMEM254',
    Q8TBM8: 'DNAJB14',
    Q8TBN0: 'RAB3IL1',
    Q8TBP5: 'FAM174A',
    Q8TBX8: 'PIP4K2C',
    Q8TBY8: 'PMFBP1',
    Q8TBY9: 'CFAP251',
    Q8TBZ3: 'WDR20',
    Q8TBZ6: 'TRMT10A',
    Q8TBZ8: 'ZNF564',
    Q8TC05: 'MDM1',
    Q8TC07: 'TBC1D15',
    Q8TC12: 'RDH11',
    Q8TC20: 'CAGE1',
    Q8TC29: 'ENKUR',
    Q8TC36: 'SUN5',
    Q8TC41: 'RNF217',
    Q8TC44: 'POC1B',
    Q8TC57: 'M1AP',
    Q8TC59: 'PIWIL2',
    Q8TC71: 'SPATA18',
    Q8TC84: 'FANK1',
    Q8TC92: 'ENOX1',
    Q8TC94: 'ACTL9',
    Q8TCB7: 'METTL6',
    Q8TCC7: 'SLC22A8',
    Q8TCD5: 'NT5C',
    Q8TCE6: 'DENND10',
    Q8TCE9: 'LGALS14',
    Q8TCF1: 'ZFAND1',
    Q8TCG1: 'CIP2A',
    Q8TCG2: 'PI4K2B',
    Q8TCG5: 'CPT1C',
    Q8TCI5: 'CIMAP3',
    Q8TCJ0: 'FBXO25',
    Q8TCJ2: 'STT3B',
    Q8TCQ1: 'MARCHF1',
    Q8TCS8: 'PNPT1',
    Q8TCT0: 'CERK',
    Q8TCT1: 'PHOSPHO1',
    Q8TCT6: 'SPPL3',
    Q8TCT7: 'SPPL2B',
    Q8TCT8: 'SPPL2A',
    Q8TCT9: 'HM13',
    Q8TCU4: 'ALMS1',
    Q8TCU5: 'GRIN3A',
    Q8TCU6: 'PREX1',
    Q8TCX1: 'DYNC2LI1',
    Q8TCX5: 'RHPN1',
    Q8TCY5: 'MRAP',
    Q8TCY9: 'URGCP',
    Q8TCZ2: 'CD99L2',
    Q8TD06: 'AGR3',
    Q8TD07: 'RAET1E',
    Q8TD08: 'MAPK15',
    Q8TD10: 'MIPOL1',
    Q8TD16: 'BICD2',
    Q8TD17: 'ZNF398',
    Q8TD19: 'NEK9',
    Q8TD20: 'SLC2A12',
    Q8TD23: 'ZNF675',
    Q8TD26: 'CHD6',
    Q8TD30: 'GPT2',
    Q8TD31: 'CCHCR1',
    Q8TD43: 'TRPM4',
    Q8TD46: 'CD200R1',
    Q8TD57: 'DNAH3',
    Q8TD84: 'DSCAML1',
    Q8TD91: 'MAGEC3',
    Q8TDB4: 'MGARP',
    Q8TDB6: 'DTX3L',
    Q8TDB8: 'SLC2A14',
    Q8TDC0: 'MYOZ3',
    Q8TDC3: 'BRSK1',
    Q8TDD1: 'DDX54',
    Q8TDD2: 'SP7',
    Q8TDD5: 'MCOLN3',
    Q8TDF5: 'NETO1',
    Q8TDF6: 'RASGRP4',
    Q8TDG2: 'ACTRT1',
    Q8TDG4: 'HELQ',
    Q8TDH9: 'BLOC1S5',
    Q8TDI0: 'CHD5',
    Q8TDI7: 'TMC2',
    Q8TDI8: 'TMC1',
    Q8TDJ6: 'DMXL2',
    Q8TDL5: 'BPIFB1',
    Q8TDM6: 'DLG5',
    Q8TDN1: 'KCNG4',
    Q8TDN2: 'KCNV2',
    Q8TDN4: 'CABLES1',
    Q8TDN7: 'ACER1',
    Q8TDP1: 'RNASEH2C',
    Q8TDQ0: 'HAVCR2',
    Q8TDQ1: 'CD300LF',
    Q8TDQ7: 'GNPDA2',
    Q8TDR0: 'TRAF3IP1',
    Q8TDR2: 'STK35',
    Q8TDR4: 'TCP10L',
    Q8TDS4: 'HCAR2',
    Q8TDS5: 'OXER1',
    Q8TDT2: 'GPR152',
    Q8TDU6: 'GPBAR1',
    Q8TDU9: 'RXFP4',
    Q8TDV0: 'GPR151',
    Q8TDW0: 'LRRC8C',
    Q8TDW5: 'SYTL5',
    Q8TDW7: 'FAT3',
    Q8TDX5: 'ACMSD',
    Q8TDX6: 'CSGALNACT1',
    Q8TDX7: 'NEK7',
    Q8TDX9: 'PKD1L1',
    Q8TDY2: 'RB1CC1',
    Q8TDY4: 'ASAP3',
    Q8TDZ2: 'MICAL1',
    Q8TE02: 'ELP5',
    Q8TE04: 'PANK1',
    Q8TE12: 'LMX1A',
    Q8TE23: 'TAS1R2',
    Q8TE49: 'OTUD7A',
    Q8TE54: 'SLC26A7',
    Q8TE56: 'ADAMTS17',
    Q8TE57: 'ADAMTS16',
    Q8TE58: 'ADAMTS15',
    Q8TE60: 'ADAMTS18',
    Q8TE67: 'EPS8L3',
    Q8TE68: 'EPS8L1',
    Q8TE73: 'DNAH5',
    Q8TE76: 'MORC4',
    Q8TE77: 'SSH3',
    Q8TE85: 'GRHL3',
    Q8TE99: 'PXYLP1',
    Q8TEA1: 'NSUN6',
    Q8TEA7: 'TBCK',
    Q8TEA8: 'DTD1',
    Q8TEB1: 'DCAF11',
    Q8TEB7: 'RNF128',
    Q8TEB9: 'RHBDD1',
    Q8TEC5: 'SH3RF2',
    Q8TED0: 'UTP15',
    Q8TED1: 'GPX8',
    Q8TED4: 'SLC37A2',
    Q8TED9: 'AFAP1L1',
    Q8TEH3: 'DENND1A',
    Q8TEJ3: 'SH3RF3',
    Q8TEK3: 'DOT1L',
    Q8TEL6: 'TRPC4AP',
    Q8TEM1: 'NUP210',
    Q8TEP8: 'CEP192',
    Q8TEQ6: 'GEMIN5',
    Q8TEQ8: 'PIGO',
    Q8TER0: 'SNED1',
    Q8TER5: 'ARHGEF40',
    Q8TES7: 'FBF1',
    Q8TEU7: 'RAPGEF6',
    Q8TEU8: 'WFIKKN2',
    Q8TEV9: 'SMCR8',
    Q8TEW0: 'PARD3',
    Q8TEW6: 'DOK4',
    Q8TEW8: 'PARD3B',
    Q8TEX9: 'IPO4',
    Q8TEY5: 'CREB3L4',
    Q8TEY7: 'USP33',
    Q8TEZ7: 'PAQR8',
    Q8TF01: 'PNISR',
    Q8TF09: 'DYNLRB2',
    Q8TF17: 'SH3TC2',
    Q8TF30: 'WHAMM',
    Q8TF40: 'FNIP1',
    Q8TF42: 'UBASH3B',
    Q8TF46: 'DIS3L',
    Q8TF47: 'ZFP90',
    Q8TF50: 'ZNF526',
    Q8TF62: 'ATP8B4',
    Q8TF63: 'DCANP1',
    Q8TF65: 'GIPC2',
    Q8TF66: 'LRRC15',
    Q8TF71: 'SLC16A10',
    Q8TF72: 'SHROOM3',
    Q8TF74: 'WIPF2',
    Q8TF76: 'HASPIN',
    Q8WTP8: 'AEN',
    Q8WTQ1: 'DEFB104A',
    Q8WTQ1: 'DEFB104B',
    Q8WTQ7: 'GRK7',
    Q8WTR2: 'DUSP19',
    Q8WTR4: 'GDPD5',
    Q8WTR7: 'ZNF473',
    Q8WTS1: 'ABHD5',
    Q8WTS6: 'SETD7',
    Q8WTT0: 'CLEC4C',
    Q8WTT2: 'NOC3L',
    Q8WTU0: 'DDI1',
    Q8WTV0: 'SCARB1',
    Q8WTV1: 'THAP3',
    Q8WTW3: 'COG1',
    Q8WTW4: 'NPRL2',
    Q8WTX7: 'CASTOR1',
    Q8WTX9: 'ZDHHC1',
    Q8WU03: 'GLYATL2',
    Q8WU08: 'STK32A',
    Q8WU10: 'PYROXD1',
    Q8WU17: 'RNF139',
    Q8WU20: 'FRS2',
    Q8WU39: 'MZB1',
    Q8WU58: 'FAM222B',
    Q8WU66: 'TSPEAR',
    Q8WU67: 'ABHD3',
    Q8WU68: 'U2AF1L4',
    Q8WU79: 'SMAP2',
    Q8WU90: 'ZC3H15',
    Q8WUA4: 'GTF3C2',
    Q8WUA7: 'TBC1D22A',
    Q8WUA8: 'TSKU',
    Q8WUB8: 'PHF10',
    Q8WUD1: 'RAB2B',
    Q8WUD6: 'CHPT1',
    Q8WUE5: 'CT55',
    Q8WUF5: 'PPP1R13L',
    Q8WUG5: 'SLC22A17',
    Q8WUH2: 'TGFBRAP1',
    Q8WUI4: 'HDAC7',
    Q8WUJ0: 'STYX',
    Q8WUJ3: 'CEMIP',
    Q8WUK0: 'PTPMT1',
    Q8WUM0: 'NUP133',
    Q8WUM4: 'PDCD6IP',
    Q8WUM9: 'SLC20A1',
    Q8WUP2: 'FBLIM1',
    Q8WUQ7: 'CACTIN',
    Q8WUU4: 'ZNF296',
    Q8WUU5: 'GATAD1',
    Q8WUW1: 'BRK1',
    Q8WUX1: 'SLC38A5',
    Q8WUX9: 'CHMP7',
    Q8WUY3: 'PRUNE2',
    Q8WUZ0: 'BCL7C',
    Q8WV16: 'DCAF4',
    Q8WV19: 'SFT2D1',
    Q8WV22: 'NSMCE1',
    Q8WV24: 'PHLDA1',
    Q8WV28: 'BLNK',
    Q8WV37: 'ZNF480',
    Q8WV41: 'SNX33',
    Q8WV44: 'TRIM41',
    Q8WV74: 'NUDT8',
    Q8WV92: 'MITD1',
    Q8WV93: 'AFG1L',
    Q8WV99: 'ZFAND2B',
    Q8WVB3: 'HEXD',
    Q8WVB6: 'CHTF18',
    Q8WVC0: 'LEO1',
    Q8WVD3: 'RNF138',
    Q8WVD5: 'RNF141',
    Q8WVE7: 'TMEM170A',
    Q8WVF1: 'OSCP1',
    Q8WVH0: 'CPLX3',
    Q8WVJ2: 'NUDCD2',
    Q8WVJ9: 'TWIST2',
    Q8WVK2: 'SNRNP27',
    Q8WVK7: 'SKA2',
    Q8WVM0: 'TFB1M',
    Q8WVM7: 'STAG1',
    Q8WVM8: 'SCFD1',
    Q8WVN6: 'SECTM1',
    Q8WVN8: 'UBE2Q2',
    Q8WVP5: 'TNFAIP8L1',
    Q8WVP7: 'LMBR1',
    Q8WVQ1: 'CANT1',
    Q8WVR3: 'TRAPPC14',
    Q8WVS4: 'DYNC2I1',
    Q8WVT3: 'TRAPPC12',
    Q8WVV4: 'POF1B',
    Q8WVV5: 'BTN2A2',
    Q8WVV9: 'HNRNPLL',
    Q8WVX3: 'C4orf3',
    Q8WVX9: 'FAR1',
    Q8WVY7: 'UBLCP1',
    Q8WVZ1: 'ZDHHC19',
    Q8WVZ9: 'KBTBD7',
    Q8WW01: 'TSEN15',
    Q8WW12: 'PCNP',
    Q8WW22: 'DNAJA4',
    Q8WW24: 'TEKT4',
    Q8WW34: 'TMEM239',
    Q8WW35: 'DYNLT2B',
    Q8WW38: 'ZFPM2',
    Q8WW43: 'APH1B',
    Q8WWA0: 'ITLN1',
    Q8WWB3: 'DYDC1',
    Q8WWB5: 'PIH1D2',
    Q8WWB7: 'GLMP',
    Q8WWC4: 'MAIP1',
    Q8WWF3: 'SSMEM1',
    Q8WWF5: 'ZNRF4',
    Q8WWG1: 'NRG4',
    Q8WWG9: 'KCNE4',
    Q8WWH4: 'ASZ1',
    Q8WWH5: 'TRUB1',
    Q8WWI1: 'LMO7',
    Q8WWI5: 'SLC44A1',
    Q8WWK9: 'CKAP2',
    Q8WWL2: 'SPIRE2',
    Q8WWL7: 'CCNB3',
    Q8WWM7: 'ATXN2L',
    Q8WWM9: 'CYGB',
    Q8WWN8: 'ARAP3',
    Q8WWP7: 'GIMAP1',
    Q8WWQ0: 'PHIP',
    Q8WWQ2: 'HPSE2',
    Q8WWQ8: 'STAB2',
    Q8WWR8: 'NEU4',
    Q8WWT9: 'SLC13A3',
    Q8WWU5: 'TCP11',
    Q8WWV3: 'RTN4IP1',
    Q8WWV6: 'FCAMR',
    Q8WWW0: 'RASSF5',
    Q8WWX8: 'SLC5A11',
    Q8WWX9: 'SELENOM',
    Q8WWY3: 'PRPF31',
    Q8WWY6: 'MBD3L1',
    Q8WWY8: 'LIPH',
    Q8WWZ1: 'IL1F10',
    Q8WWZ3: 'EDARADD',
    Q8WWZ4: 'ABCA10',
    Q8WWZ7: 'ABCA5',
    Q8WWZ8: 'OIT3',
    Q8WX92: 'NELFB',
    Q8WX93: 'PALLD',
    Q8WX94: 'NLRP7',
    Q8WXA3: 'RUFY2',
    Q8WXA8: 'HTR3C',
    Q8WXA9: 'SREK1',
    Q8WXB1: 'METTL21A',
    Q8WXC3: 'PYDC1',
    Q8WXC6: 'COPS9',
    Q8WXD0: 'RXFP2',
    Q8WXD2: 'SCG3',
    Q8WXD5: 'GEMIN6',
    Q8WXE1: 'ATRIP',
    Q8WXE9: 'STON2',
    Q8WXF0: 'SRSF12',
    Q8WXF1: 'PSPC1',
    Q8WXF3: 'RLN3',
    Q8WXF7: 'ATL1',
    Q8WXF8: 'DEDD2',
    Q8WXG1: 'RSAD2',
    Q8WXG6: 'MADD',
    Q8WXG8: 'S100Z',
    Q8WXG9: 'ADGRV1',
    Q8WXH0: 'SYNE2',
    Q8WXH2: 'JPH3',
    Q8WXH5: 'SOCS4',
    Q8WXI2: 'CNKSR2',
    Q8WXI3: 'ASB10',
    Q8WXI4: 'ACOT11',
    Q8WXI7: 'MUC16',
    Q8WXI8: 'CLEC4D',
    Q8WXI9: 'GATAD2B',
    Q8WXK1: 'ASB15',
    Q8WXK3: 'ASB13',
    Q8WXK4: 'ASB12',
    Q8WXR4: 'MYO3B',
    Q8WXS3: 'BAALC',
    Q8WXS5: 'CACNG8',
    Q8WXS8: 'ADAMTS14',
    Q8WXU2: 'DNAAF4',
    Q8WXW3: 'PIBF1',
    Q8WXX0: 'DNAH7',
    Q8WXX5: 'DNAJC9',
    Q8WXX7: 'AUTS2',
    Q8WY07: 'SLC7A3',
    Q8WY21: 'SORCS1',
    Q8WY36: 'BBX',
    Q8WY41: 'NANOS1',
    Q8WY54: 'PPM1E',
    Q8WY64: 'MYLIP',
    Q8WY91: 'THAP4',
    Q8WY98: 'TMEM234',
    Q8WYA0: 'IFT81',
    Q8WYA1: 'BMAL2',
    Q8WYA6: 'CTNNBL1',
    Q8WYB5: 'KAT6B',
    Q8WYH8: 'ING5',
    Q8WYJ6: 'SEPTIN1',
    Q8WYK0: 'ACOT12',
    Q8WYK2: 'JDP2',
    Q8WYL5: 'SSH1',
    Q8WYN0: 'ATG4A',
    Q8WYP3: 'RIN2',
    Q8WYP5: 'AHCTF1',
    Q8WYQ3: 'CHCHD10',
    Q8WYQ5: 'DGCR8',
    Q8WYR1: 'PIK3R5',
    Q8WYR4: 'RSPH1',
    Q8WZ04: 'TOMT',
    Q8WZ19: 'KCTD13',
    Q8WZ42: 'TTN',
    Q8WZ55: 'BSND',
    Q8WZ59: 'TMEM190',
    Q8WZ73: 'RFFL',
    Q8WZ74: 'CTTNBP2',
    Q8WZ75: 'ROBO4',
    Q8WZA1: 'POMGNT1',
    Q8WZA2: 'RAPGEF4',
    Q92185: 'ST8SIA1',
    Q92186: 'ST8SIA2',
    Q92187: 'ST8SIA4',
    Q92466: 'DDB2',
    Q92478: 'CLEC2B',
    Q92481: 'TFAP2B',
    Q92482: 'AQP3',
    Q92484: 'SMPDL3A',
    Q92485: 'SMPDL3B',
    Q92496: 'CFHR4',
    Q92499: 'DDX1',
    Q92502: 'STARD8',
    Q92503: 'SEC14L1',
    Q92504: 'SLC39A7',
    Q92506: 'HSD17B8',
    Q92508: 'PIEZO1',
    Q92519: 'TRIB2',
    Q92520: 'FAM3C',
    Q92521: 'PIGB',
    Q92522: 'H1-10',
    Q92523: 'CPT1B',
    Q92526: 'CCT6B',
    Q92529: 'SHC3',
    Q92530: 'PSMF1',
    Q92535: 'PIGC',
    Q92536: 'SLC7A6',
    Q92537: 'SUSD6',
    Q92538: 'GBF1',
    Q92539: 'LPIN2',
    Q92540: 'SMG7',
    Q92541: 'RTF1',
    Q92542: 'NCSTN',
    Q92543: 'SNX19',
    Q92544: 'TM9SF4',
    Q92546: 'RGP1',
    Q92547: 'TOPBP1',
    Q92551: 'IP6K1',
    Q92552: 'MRPS27',
    Q92556: 'ELMO1',
    Q92558: 'WASF1',
    Q92560: 'BAP1',
    Q92562: 'FIG4',
    Q92563: 'SPOCK2',
    Q92564: 'DCUN1D4',
    Q92565: 'RAPGEF5',
    Q92567: 'FAM168A',
    Q92569: 'PIK3R3',
    Q92570: 'NR4A3',
    Q92572: 'AP3S1',
    Q92574: 'TSC1',
    Q92575: 'UBXN4',
    Q92581: 'SLC9A6',
    Q92583: 'CCL17',
    Q92585: 'MAML1',
    Q92597: 'NDRG1',
    Q92598: 'HSPH1',
    Q92599: 'SEPTIN8',
    Q92600: 'CNOT9',
    Q92604: 'LPGAT1',
    Q92608: 'DOCK2',
    Q92609: 'TBC1D5',
    Q92611: 'EDEM1',
    Q92613: 'JADE3',
    Q92614: 'MYO18A',
    Q92615: 'LARP4B',
    Q92616: 'GCN1',
    Q92618: 'ZNF516',
    Q92619: 'ARHGAP45',
    Q92620: 'DHX38',
    Q92621: 'NUP205',
    Q92622: 'RUBCN',
    Q92624: 'APPBP2',
    Q92625: 'ANKS1A',
    Q92626: 'PXDN',
    Q92629: 'SGCD',
    Q92630: 'DYRK2',
    Q92633: 'LPAR1',
    Q92636: 'NSMAF',
    Q92637: 'FCGR1BP',
    Q92643: 'PIGK',
    Q92665: 'MRPS31',
    Q92667: 'AKAP1',
    Q92673: 'SORL1',
    Q92674: 'CENPI',
    Q92681: 'RSC1A1',
    Q92685: 'ALG3',
    Q92686: 'NRGN',
    Q92688: 'ANP32B',
    Q92692: 'NECTIN2',
    Q92696: 'RABGGTA',
    Q92698: 'RAD54L',
    Q92729: 'PTPRU',
    Q92730: 'RND1',
    Q92731: 'ESR2',
    Q92733: 'PRCC',
    Q92734: 'TFG',
    Q92736: 'RYR2',
    Q92737: 'RASL10A',
    Q92738: 'USP6NL',
    Q92743: 'HTRA1',
    Q92748: 'THRSP',
    Q92750: 'TAF4B',
    Q92752: 'TNR',
    Q92753: 'RORB',
    Q92754: 'TFAP2C',
    Q92759: 'GTF2H4',
    Q92764: 'KRT35',
    Q92765: 'FRZB',
    Q92766: 'RREB1',
    Q92769: 'HDAC2',
    Q92772: 'CDKL2',
    Q92777: 'SYN2',
    Q92781: 'RDH5',
    Q92782: 'DPF1',
    Q92783: 'STAM',
    Q92784: 'DPF3',
    Q92785: 'DPF2',
    Q92786: 'PROX1',
    Q92791: 'P3H4',
    Q92793: 'CREBBP',
    Q92794: 'KAT6A',
    Q92796: 'DLG3',
    Q92797: 'SYMPK',
    Q92800: 'EZH1',
    Q92802: 'N4BP2L2',
    Q92804: 'TAF15',
    Q92805: 'GOLGA1',
    Q92813: 'DIO2',
    Q92817: 'EVPL',
    Q92819: 'HAS2',
    Q92820: 'GGH',
    Q92823: 'NRCAM',
    Q92824: 'PCSK5',
    Q92826: 'HOXB13',
    Q92830: 'KAT2A',
    Q92831: 'KAT2B',
    Q92832: 'NELL1',
    Q92833: 'JARID2',
    Q92834: 'RPGR',
    Q92835: 'INPP5D',
    Q92837: 'FRAT1',
    Q92838: 'EDA',
    Q92839: 'HAS1',
    Q92841: 'DDX17',
    Q92843: 'BCL2L2',
    Q92844: 'TANK',
    Q92845: 'KIFAP3',
    Q92847: 'GHSR',
    Q92851: 'CASP10',
    Q92854: 'SEMA4D',
    Q92858: 'ATOH1',
    Q92859: 'NEO1',
    Q92870: 'APBB2',
    Q92871: 'PMM1',
    Q92874: 'DNASE1L2',
    Q92876: 'KLK6',
    Q92878: 'RAD50',
    Q92879: 'CELF1',
    Q92882: 'OSTF1',
    Q92886: 'NEUROG1',
    Q92887: 'ABCC2',
    Q92888: 'ARHGEF1',
    Q92889: 'ERCC4',
    Q92890: 'UFD1',
    Q92896: 'GLG1',
    Q92900: 'UPF1',
    Q92902: 'HPS1',
    Q92903: 'CDS1',
    Q92904: 'DAZL',
    Q92905: 'COPS5',
    Q92908: 'GATA6',
    Q92911: 'SLC5A5',
    Q92913: 'FGF13',
    Q92915: 'FGF14',
    Q92917: 'GPKOW',
    Q92918: 'MAP4K1',
    Q92922: 'SMARCC1',
    Q92925: 'SMARCD2',
    Q92930: 'RAB8B',
    Q92932: 'PTPRN2',
    Q92934: 'BAD',
    Q92935: 'EXTL1',
    Q92945: 'KHSRP',
    Q92947: 'GCDH',
    Q92949: 'FOXJ1',
    Q92952: 'KCNN1',
    Q92953: 'KCNB2',
    Q92954: 'PRG4',
    Q92956: 'TNFRSF14',
    Q92959: 'SLCO2A1',
    Q92963: 'RIT1',
    Q92966: 'SNAPC3',
    Q92968: 'PEX13',
    Q92973: 'TNPO1',
    Q92974: 'ARHGEF2',
    Q92979: 'EMG1',
    Q92982: 'NINJ1',
    Q92985: 'IRF7',
    Q92988: 'DLX4',
    Q92989: 'CLP1',
    Q92990: 'GLMN',
    Q92993: 'KAT5',
    Q92994: 'BRF1',
    Q92995: 'USP13',
    Q92997: 'DVL3',
    Q93008: 'USP9X',
    Q93009: 'USP7',
    Q93015: 'NAA80',
    Q93033: 'CD101',
    Q93034: 'CUL5',
    Q93038: 'TNFRSF25',
    Q93045: 'STMN2',
    Q93050: 'ATP6V0A1',
    Q93052: 'LPP',
    Q93062: 'RBPMS',
    Q93063: 'EXT2',
    Q93070: 'ART4',
    Q93074: 'MED12',
    Q93077: 'H2AC6',
    Q93079: 'H2BC9',
    Q93084: 'ATP2A3',
    Q93086: 'P2RX5',
    Q93088: 'BHMT',
    Q93091: 'RNASE6',
    Q93096: 'PTP4A1',
    Q93097: 'WNT2B',
    Q93098: 'WNT8B',
    Q93099: 'HGD',
    Q93100: 'PHKB',
    Q95460: 'MR1',
    Q969D9: 'TSLP',
    Q969E2: 'SCAMP4',
    Q969E3: 'UCN3',
    Q969E8: 'TSR2',
    Q969F0: 'FATE1',
    Q969F1: 'GTF3C6',
    Q969F2: 'NKD2',
    Q969F8: 'KISS1R',
    Q969F9: 'HPS3',
    Q969G2: 'LHX4',
    Q969G3: 'SMARCE1',
    Q969G5: 'CAVIN3',
    Q969G6: 'RFK',
    Q969G9: 'NKD1',
    Q969H0: 'FBXW7',
    Q969H4: 'CNKSR1',
    Q969H6: 'POP5',
    Q969H8: 'MYDGF',
    Q969I6: 'SLC38A4',
    Q969J2: 'ZKSCAN4',
    Q969J3: 'BORCS5',
    Q969J5: 'IL22RA2',
    Q969K3: 'RNF34',
    Q969K4: 'ABTB1',
    Q969K7: 'TMEM54',
    Q969L2: 'MAL2',
    Q969L4: 'LSM10',
    Q969M3: 'YIPF5',
    Q969M7: 'UBE2F',
    Q969N2: 'PIGT',
    Q969P0: 'IGSF8',
    Q969P5: 'FBXO32',
    Q969P6: 'TOP1MT',
    Q969Q1: 'TRIM63',
    Q969Q6: 'PPP2R3C',
    Q969R2: 'OSBP2',
    Q969R5: 'L3MBTL2',
    Q969R8: 'ITFG2',
    Q969S0: 'SLC35B4',
    Q969S2: 'NEIL2',
    Q969S3: 'ZNF622',
    Q969S6: 'TMEM203',
    Q969S8: 'HDAC10',
    Q969S9: 'GFM2',
    Q969T4: 'UBE2E3',
    Q969T7: 'NT5C3B',
    Q969T9: 'WBP2',
    Q969U6: 'FBXW5',
    Q969U7: 'PSMG2',
    Q969V3: 'NCLN',
    Q969V4: 'TEKT1',
    Q969V5: 'MUL1',
    Q969V6: 'MRTFA',
    Q969W0: 'SPTSSA',
    Q969W1: 'ZDHHC16',
    Q969W9: 'PMEPA1',
    Q969X0: 'RILPL2',
    Q969X1: 'TMBIM1',
    Q969X2: 'ST6GALNAC6',
    Q969X5: 'ERGIC1',
    Q969X6: 'UTP4',
    Q969Y2: 'GTPBP3',
    Q969Z0: 'TBRG4',
    Q969Z3: 'MTARC2',
    Q969Z4: 'RELT',
    Q96A08: 'H2BC1',
    Q96A09: 'TENT5B',
    Q96A11: 'GAL3ST3',
    Q96A25: 'TMEM106A',
    Q96A26: 'FAM162A',
    Q96A29: 'SLC35C1',
    Q96A32: 'MYL11',
    Q96A33: 'CCDC47',
    Q96A37: 'RNF166',
    Q96A44: 'SPSB4',
    Q96A49: 'SYAP1',
    Q96A54: 'ADIPOR1',
    Q96A56: 'TP53INP1',
    Q96A57: 'TMEM230',
    Q96A58: 'RERG',
    Q96A59: 'MARVELD3',
    Q96A61: 'TRIM52',
    Q96A65: 'EXOC4',
    Q96A70: 'AZIN2',
    Q96A72: 'MAGOHB',
    Q96A83: 'COL26A1',
    Q96AA3: 'RFT1',
    Q96AA8: 'JAKMIP2',
    Q96AB6: 'NTAN1',
    Q96AC1: 'FERMT2',
    Q96AD5: 'PNPLA2',
    Q96AE4: 'FUBP1',
    Q96AE7: 'TTC17',
    Q96AG3: 'SLC25A46',
    Q96AG4: 'LRRC59',
    Q96AH0: 'NABP1',
    Q96AH8: 'RAB7B',
    Q96AJ1: 'CLUAP1',
    Q96AJ9: 'VTI1A',
    Q96AK3: 'APOBEC3D',
    Q96AN5: 'TMEM143',
    Q96AP0: 'ACD',
    Q96AP4: 'ZUP1',
    Q96AP7: 'ESAM',
    Q96AQ6: 'PBXIP1',
    Q96AQ7: 'CIDEC',
    Q96AQ8: 'MCUR1',
    Q96AT9: 'RPE',
    Q96AV8: 'E2F7',
    Q96AW1: 'VOPP1',
    Q96AX1: 'VPS33A',
    Q96AX2: 'RAB37',
    Q96AX9: 'MIB2',
    Q96AY2: 'EME1',
    Q96AY3: 'FKBP10',
    Q96AY4: 'TTC28',
    Q96AZ1: 'EEF1AKMT3',
    Q96AZ6: 'ISG20',
    Q96B01: 'RAD51AP1',
    Q96B02: 'UBE2W',
    Q96B18: 'DACT3',
    Q96B21: 'TMEM45B',
    Q96B26: 'EXOSC8',
    Q96B36: 'AKT1S1',
    Q96B42: 'TMEM18',
    Q96B49: 'TOMM6',
    Q96B67: 'ARRDC3',
    Q96B86: 'RGMA',
    Q96B96: 'LDAF1',
    Q96B97: 'SH3KBP1',
    Q96BA8: 'CREB3L1',
    Q96BD0: 'SLCO4A1',
    Q96BD5: 'PHF21A',
    Q96BD6: 'SPSB1',
    Q96BD8: 'SKA1',
    Q96BF3: 'TMIGD2',
    Q96BF6: 'NACC2',
    Q96BH1: 'RNF25',
    Q96BI1: 'SLC22A18',
    Q96BI3: 'APH1A',
    Q96BJ3: 'AIDA',
    Q96BK5: 'PINX1',
    Q96BM1: 'ANKRD9',
    Q96BM9: 'ARL8A',
    Q96BN2: 'TADA1',
    Q96BN8: 'OTULIN',
    Q96BP2: 'CHCHD1',
    Q96BP3: 'PPWD1',
    Q96BR1: 'SGK3',
    Q96BR5: 'COA7',
    Q96BR6: 'ZNF669',
    Q96BR9: 'ZBTB8A',
    Q96BS2: 'TESC',
    Q96BT3: 'CENPT',
    Q96BT7: 'ALKBH8',
    Q96BW1: 'UPRT',
    Q96BY2: 'MOAP1',
    Q96BY6: 'DOCK10',
    Q96BY7: 'ATG2B',
    Q96BY9: 'SARAF',
    Q96BZ4: 'PLD4',
    Q96BZ8: 'LENG1',
    Q96BZ9: 'TBC1D20',
    Q96C00: 'ZBTB9',
    Q96C03: 'MIEF2',
    Q96C10: 'DHX58',
    Q96C11: 'FGGY',
    Q96C12: 'ARMC5',
    Q96C23: 'GALM',
    Q96C24: 'SYTL4',
    Q96C36: 'PYCR2',
    Q96C45: 'ULK4',
    Q96C55: 'ZNF524',
    Q96C74: 'ROPN1L',
    Q96C86: 'DCPS',
    Q96C92: 'ENTR1',
    Q96CA5: 'BIRC7',
    Q96CB8: 'INTS12',
    Q96CB9: 'NSUN4',
    Q96CC6: 'RHBDF1',
    Q96CD2: 'PPCDC',
    Q96CE8: 'TM4SF18',
    Q96CF2: 'CHMP4C',
    Q96CG3: 'TIFA',
    Q96CG8: 'CTHRC1',
    Q96CJ1: 'EAF2',
    Q96CK0: 'ZNF653',
    Q96CM3: 'RPUSD4',
    Q96CM8: 'ACSF2',
    Q96CN4: 'EVI5L',
    Q96CN5: 'LRRC45',
    Q96CN9: 'GCC1',
    Q96CP6: 'GRAMD1A',
    Q96CP7: 'TLCD1',
    Q96CQ1: 'SLC25A36',
    Q96CS2: 'HAUS1',
    Q96CS3: 'FAF2',
    Q96CS7: 'PLEKHB2',
    Q96CT7: 'CCDC124',
    Q96CU9: 'FOXRED1',
    Q96CV9: 'OPTN',
    Q96CW1: 'AP2M1',
    Q96CW5: 'TUBGCP3',
    Q96CW9: 'NTNG2',
    Q96D03: 'DDIT4L',
    Q96D05: 'FAM241B',
    Q96D09: 'GPRASP2',
    Q96D15: 'RCN3',
    Q96D21: 'RASD2',
    Q96D31: 'ORAI1',
    Q96D42: 'HAVCR1',
    Q96D46: 'NMD3',
    Q96D53: 'COQ8B',
    Q96D59: 'RNF183',
    Q96D71: 'REPS1',
    Q96D96: 'HVCN1',
    Q96D98: 'EID2B',
    Q96DA2: 'RAB39B',
    Q96DA6: 'DNAJC19',
    Q96DB2: 'HDAC11',
    Q96DB9: 'FXYD5',
    Q96DC9: 'OTUB2',
    Q96DE0: 'NUDT16',
    Q96DE5: 'ANAPC16',
    Q96DF8: 'ESS2',
    Q96DG6: 'CMBL',
    Q96DH6: 'MSI2',
    Q96DI7: 'SNRNP40',
    Q96DM3: 'RMC1',
    Q96DN0: 'ERP27',
    Q96DN2: 'VWCE',
    Q96DP5: 'MTFMT',
    Q96DR4: 'STARD4',
    Q96DR5: 'BPIFA2',
    Q96DR7: 'ARHGEF26',
    Q96DR8: 'MUCL1',
    Q96DT0: 'LGALS12',
    Q96DT5: 'DNAH11',
    Q96DT6: 'ATG4C',
    Q96DT7: 'ZBTB10',
    Q96DU3: 'SLAMF6',
    Q96DU7: 'ITPKC',
    Q96DV4: 'MRPL38',
    Q96DW6: 'SLC25A38',
    Q96DX5: 'ASB9',
    Q96DX7: 'TRIM44',
    Q96DX8: 'RTP4',
    Q96DZ1: 'ERLEC1',
    Q96DZ5: 'CLIP3',
    Q96DZ7: 'TM4SF19',
    Q96DZ9: 'CMTM5',
    Q96E09: 'PABIR1',
    Q96E11: 'MRRF',
    Q96E14: 'RMI2',
    Q96E17: 'RAB3C',
    Q96E22: 'NUS1',
    Q96E29: 'MTERF3',
    Q96E35: 'ZMYND19',
    Q96E52: 'OMA1',
    Q96E93: 'KLRG1',
    Q96EA4: 'SPDL1',
    Q96EB1: 'ELP4',
    Q96EB6: 'SIRT1',
    Q96EC8: 'YIPF6',
    Q96ED9: 'HOOK2',
    Q96EE3: 'SEH1L',
    Q96EF0: 'MTMR8',
    Q96EF6: 'FBXO17',
    Q96EG1: 'ARSG',
    Q96EG3: 'ZNF837',
    Q96EH3: 'MALSU1',
    Q96EK4: 'THAP11',
    Q96EK5: 'KIFBP',
    Q96EK6: 'GNPNAT1',
    Q96EL1: 'INKA1',
    Q96EL3: 'MRPL53',
    Q96EM0: 'L3HYPDH',
    Q96EN8: 'MOCOS',
    Q96EP0: 'RNF31',
    Q96EP1: 'CHFR',
    Q96EP5: 'DAZAP1',
    Q96EP9: 'SLC10A4',
    Q96EQ0: 'SGTB',
    Q96EQ8: 'RNF125',
    Q96ER9: 'CCDC51',
    Q96ES7: 'SGF29',
    Q96EU6: 'RRP36',
    Q96EU7: 'C1GALT1C1',
    Q96EV8: 'DTNBP1',
    Q96EW2: 'HSPBAP1',
    Q96EX3: 'DYNC2I2',
    Q96EY1: 'DNAJA3',
    Q96EY4: 'TMA16',
    Q96EY5: 'MVB12A',
    Q96EY7: 'PTCD3',
    Q96EY8: 'MMAB',
    Q96EZ8: 'MCRS1',
    Q96F05: 'C11orf24',
    Q96F07: 'CYFIP2',
    Q96F10: 'SAT2',
    Q96F15: 'GIMAP5',
    Q96F24: 'NRBF2',
    Q96F25: 'ALG14',
    Q96F44: 'TRIM11',
    Q96F45: 'ZNF503',
    Q96F46: 'IL17RA',
    Q96F81: 'DISP1',
    Q96F85: 'CNRIP1',
    Q96F86: 'EDC3',
    Q96FA3: 'PELI1',
    Q96FC9: 'DDX11',
    Q96FE5: 'LINGO1',
    Q96FE7: 'PIK3IP1',
    Q96FF9: 'CDCA5',
    Q96FG2: 'ELMOD3',
    Q96FH0: 'BORCS8',
    Q96FI4: 'NEIL1',
    Q96FJ0: 'STAMBPL1',
    Q96FJ2: 'DYNLL2',
    Q96FL8: 'SLC47A1',
    Q96FL9: 'GALNT14',
    Q96FM1: 'PGAP3',
    Q96FN4: 'CPNE2',
    Q96FQ6: 'S100A16',
    Q96FS4: 'SIPA1',
    Q96FT7: 'ASIC4',
    Q96FT9: 'IFT43',
    Q96FV3: 'TSPAN17',
    Q96FV9: 'THOC1',
    Q96FW1: 'OTUB1',
    Q96FX2: 'DPH3',
    Q96FX7: 'TRMT61A',
    Q96FX8: 'PERP',
    Q96FZ2: 'HMCES',
    Q96FZ5: 'CMTM7',
    Q96FZ7: 'CHMP6',
    Q96G01: 'BICD1',
    Q96G03: 'PGM2',
    Q96G04: 'EEF2KMT',
    Q96G21: 'IMP4',
    Q96G23: 'CERS2',
    Q96G25: 'MED8',
    Q96G28: 'CFAP36',
    Q96G30: 'MRAP2',
    Q96G42: 'KLHDC7B',
    Q96G46: 'DUS3L',
    Q96G61: 'NUDT11',
    Q96G74: 'OTUD5',
    Q96G75: 'RMND5B',
    Q96G79: 'SLC35A4',
    Q96G91: 'P2RY11',
    Q96G97: 'BSCL2',
    Q96GA7: 'SDSL',
    Q96GC6: 'ZNF274',
    Q96GC9: 'VMP1',
    Q96GD0: 'PDXP',
    Q96GD3: 'SCMH1',
    Q96GD4: 'AURKB',
    Q96GE4: 'CEP95',
    Q96GF1: 'RNF185',
    Q96GG9: 'DCUN1D1',
    Q96GJ1: 'TRMT2B',
    Q96GL9: 'FAM163A',
    Q96GM1: 'PLPPR2',
    Q96GM5: 'SMARCD1',
    Q96GM8: 'TOE1',
    Q96GN5: 'CDCA7L',
    Q96GP6: 'SCARF2',
    Q96GQ5: 'RUSF1',
    Q96GQ7: 'DDX27',
    Q96GR2: 'ACSBG1',
    Q96GR4: 'ZDHHC12',
    Q96GS4: 'BORCS6',
    Q96GS6: 'ABHD17A',
    Q96GV9: 'MACIR',
    Q96GW7: 'BCAN',
    Q96GW9: 'MARS2',
    Q96GX1: 'TCTN2',
    Q96GX5: 'MASTL',
    Q96GX9: 'APIP',
    Q96GY3: 'LIN37',
    Q96GZ6: 'SLC41A3',
    Q96H15: 'TIMD4',
    Q96H20: 'SNF8',
    Q96H22: 'CENPN',
    Q96H55: 'MYO19',
    Q96H72: 'SLC39A13',
    Q96H86: 'ZNF764',
    Q96H96: 'COQ2',
    Q96HA1: 'POM121',
    Q96HA7: 'TONSL',
    Q96HA8: 'NTAQ1',
    Q96HA9: 'PEX11G',
    Q96HB5: 'CCDC120',
    Q96HC4: 'PDLIM5',
    Q96HD1: 'CRELD1',
    Q96HD9: 'ACY3',
    Q96HE7: 'ERO1A',
    Q96HE8: 'TMEM80',
    Q96HF1: 'SFRP2',
    Q96HH6: 'TMEM19',
    Q96HH9: 'GRAMD2B',
    Q96HI0: 'SENP5',
    Q96HJ5: 'MS4A3',
    Q96HN2: 'AHCYL2',
    Q96HP0: 'DOCK6',
    Q96HR3: 'MED30',
    Q96HR8: 'NAF1',
    Q96HR9: 'REEP6',
    Q96HS1: 'PGAM5',
    Q96HT8: 'MRFAP1L1',
    Q96HU1: 'SGSM3',
    Q96HW7: 'INTS4',
    Q96HY6: 'DDRGK1',
    Q96HY7: 'DHTKD1',
    Q96HZ4: 'HES6',
    Q96I15: 'SCLY',
    Q96I24: 'FUBP3',
    Q96I25: 'RBM17',
    Q96I27: 'ZNF625',
    Q96I34: 'PPP1R16A',
    Q96I51: 'RCC1L',
    Q96I59: 'NARS2',
    Q96I76: 'GPATCH3',
    Q96I99: 'SUCLG2',
    Q96IF1: 'AJUBA',
    Q96II8: 'LRCH3',
    Q96IJ6: 'GMPPA',
    Q96IK1: 'BOD1',
    Q96IK5: 'GMCL1',
    Q96IL0: 'COA8',
    Q96IP4: 'TENT5A',
    Q96IQ9: 'ZNF414',
    Q96IR7: 'HPDL',
    Q96IS3: 'RAX2',
    Q96IT1: 'ZNF496',
    Q96IU2: 'ZBED3',
    Q96IU4: 'ABHD14B',
    Q96IV0: 'NGLY1',
    Q96IV6: 'FAXDC2',
    Q96IW7: 'SEC22A',
    Q96IX5: 'ATP5MK',
    Q96IY1: 'NSL1',
    Q96IY4: 'CPB2',
    Q96IZ0: 'PAWR',
    Q96IZ2: 'ADTRP',
    Q96IZ5: 'RBM41',
    Q96IZ6: 'METTL2A',
    Q96IZ7: 'RSRC1',
    Q96J01: 'THOC3',
    Q96J02: 'ITCH',
    Q96J42: 'TXNDC15',
    Q96J65: 'ABCC12',
    Q96J66: 'ABCC11',
    Q96J84: 'KIRREL1',
    Q96J87: 'CELF6',
    Q96J92: 'WNK4',
    Q96J94: 'PIWIL1',
    Q96JA1: 'LRIG1',
    Q96JA3: 'PLEKHA8',
    Q96JB1: 'DNAH8',
    Q96JB2: 'COG3',
    Q96JB3: 'HIC2',
    Q96JB5: 'CDK5RAP3',
    Q96JB6: 'LOXL4',
    Q96JB8: 'MPP4',
    Q96JC1: 'VPS39',
    Q96JC9: 'EAF1',
    Q96JD6: 'AKR1E2',
    Q96JE7: 'SEC16B',
    Q96JE9: 'MAP6',
    Q96JF0: 'ST6GAL2',
    Q96JG6: 'VPS50',
    Q96JG8: 'MAGED4',
    Q96JG8: 'MAGED4B',
    Q96JG9: 'ZNF469',
    Q96JH7: 'VCPIP1',
    Q96JH8: 'RADIL',
    Q96JI7: 'SPG11',
    Q96JJ3: 'ELMO2',
    Q96JJ6: 'JPH4',
    Q96JJ7: 'TMX3',
    Q96JK2: 'DCAF5',
    Q96JK9: 'MAML3',
    Q96JL9: 'ZNF333',
    Q96JM2: 'ZNF462',
    Q96JM3: 'CHAMP1',
    Q96JM7: 'L3MBTL3',
    Q96JN0: 'LCOR',
    Q96JN2: 'CCDC136',
    Q96JP0: 'FEM1C',
    Q96JP5: 'ZFP91',
    Q96JP9: 'CDHR1',
    Q96JQ0: 'DCHS1',
    Q96JQ5: 'MS4A4A',
    Q96JS3: 'PGBD1',
    Q96JW4: 'SLC41A2',
    Q96JX3: 'SERAC1',
    Q96JY0: 'MAEL',
    Q96JY6: 'PDLIM2',
    Q96JZ2: 'HSH2D',
    Q96K12: 'FAR2',
    Q96K19: 'RNF170',
    Q96K21: 'ZFYVE19',
    Q96K30: 'RITA1',
    Q96K76: 'USP47',
    Q96K78: 'ADGRG7',
    Q96K80: 'ZC3H10',
    Q96K83: 'ZNF521',
    Q96KA5: 'CLPTM1L',
    Q96KB5: 'PBK',
    Q96KC8: 'DNAJC1',
    Q96KG7: 'MEGF10',
    Q96KG9: 'SCYL1',
    Q96KK3: 'KCNS1',
    Q96KK4: 'OR10C1',
    Q96KM6: 'ZNF512B',
    Q96KN2: 'CNDP1',
    Q96KN3: 'PKNOX2',
    Q96KN4: 'LRATD1',
    Q96KN7: 'RPGRIP1',
    Q96KN8: 'PLAAT5',
    Q96KP1: 'EXOC2',
    Q96KP4: 'CNDP2',
    Q96KP6: 'TNIP3',
    Q96KQ4: 'PPP1R13B',
    Q96KQ7: 'EHMT2',
    Q96KR4: 'LMLN',
    Q96KR6: 'FAM210B',
    Q96KR7: 'PHACTR3',
    Q96KS0: 'EGLN2',
    Q96KV7: 'WDR90',
    Q96L08: 'SUSD3',
    Q96L12: 'CALR3',
    Q96L14: 'CEP170P1',
    Q96L21: 'RPL10L',
    Q96L34: 'MARK4',
    Q96L42: 'KCNH8',
    Q96L46: 'CAPNS2',
    Q96L50: 'LRR1',
    Q96L58: 'B3GALT6',
    Q96L73: 'NSD1',
    Q96L91: 'EP400',
    Q96L92: 'SNX27',
    Q96L93: 'KIF16B',
    Q96L96: 'ALPK3',
    Q96LA5: 'FCRL2',
    Q96LA6: 'FCRL1',
    Q96LA8: 'PRMT6',
    Q96LB1: 'MRGPRX2',
    Q96LB2: 'MRGPRX1',
    Q96LB3: 'IFT74',
    Q96LB8: 'PGLYRP4',
    Q96LB9: 'PGLYRP3',
    Q96LC7: 'SIGLEC10',
    Q96LC9: 'BMF',
    Q96LD4: 'TRIM47',
    Q96LD8: 'SENP8',
    Q96LI5: 'CNOT6L',
    Q96LI6: 'HSFY1',
    Q96LI6: 'HSFY2',
    Q96LJ7: 'DHRS1',
    Q96LJ8: 'UBXN10',
    Q96LK0: 'CEP19',
    Q96LL4: 'C8orf48',
    Q96LL9: 'DNAJC30',
    Q96LM5: 'SPMIP2',
    Q96LM6: 'SPMIP9',
    Q96LR2: 'LURAP1',
    Q96LR5: 'UBE2E2',
    Q96LT4: 'SAMD8',
    Q96LT7: 'C9orf72',
    Q96LT9: 'RNPC3',
    Q96LW4: 'PRIMPOL',
    Q96LW7: 'CARD19',
    Q96LX7: 'CCDC17',
    Q96LX8: 'ZNF597',
    Q96LZ3: 'PPP3R2',
    Q96LZ7: 'RMDN2',
    Q96M02: 'C10orf90',
    Q96M11: 'HYLS1',
    Q96M29: 'TEKT5',
    Q96M32: 'AK7',
    Q96M61: 'MAGEB18',
    Q96M63: 'ODAD1',
    Q96M86: 'DNHD1',
    Q96M91: 'CFAP53',
    Q96M94: 'KLHL15',
    Q96M96: 'FGD4',
    Q96M98: 'PACRG',
    Q96MA6: 'AK8',
    Q96MC2: 'DRC1',
    Q96MD2: 'KICS2',
    Q96MF2: 'STAC3',
    Q96MF7: 'NSMCE2',
    Q96MG2: 'JSRP1',
    Q96MG7: 'NSMCE3',
    Q96MH2: 'HEXIM2',
    Q96MI9: 'AGBL1',
    Q96MK3: 'FAM20A',
    Q96MM3: 'ZFP42',
    Q96MM7: 'HS6ST2',
    Q96MN2: 'NLRP4',
    Q96MN9: 'ZNF488',
    Q96MP8: 'KCTD7',
    Q96MS0: 'ROBO3',
    Q96MT3: 'PRICKLE1',
    Q96MT7: 'CFAP44',
    Q96MT8: 'CEP63',
    Q96MU7: 'YTHDC1',
    Q96MU8: 'KREMEN1',
    Q96MV1: 'TLCD4',
    Q96MV8: 'ZDHHC15',
    Q96MW5: 'COG8',
    Q96MX0: 'CMTM3',
    Q96MX3: 'ZNF48',
    Q96MY7: 'FAM161B',
    Q96N16: 'JAKMIP1',
    Q96N19: 'GPR137',
    Q96N21: 'TEPSIN',
    Q96N58: 'ZNF578',
    Q96N64: 'PWWP2A',
    Q96N66: 'MBOAT7',
    Q96N67: 'DOCK7',
    Q96N76: 'UROC1',
    Q96N77: 'ZNF641',
    Q96N87: 'SLC6A18',
    Q96N95: 'ZNF396',
    Q96N96: 'SPATA13',
    Q96NA2: 'RILP',
    Q96NB1: 'CEP20',
    Q96NB2: 'SFXN2',
    Q96NB3: 'ZNF830',
    Q96NC0: 'ZMAT2',
    Q96NE9: 'FRMD6',
    Q96NG3: 'ODAD4',
    Q96NG5: 'ZNF558',
    Q96NH3: 'TBC1D32',
    Q96NI6: 'LRFN5',
    Q96NL6: 'SCLT1',
    Q96NL8: 'CFAP418',
    Q96NM4: 'TOX2',
    Q96NN9: 'AIFM3',
    Q96NR3: 'PTCHD1',
    Q96NR8: 'RDH12',
    Q96NT0: 'CCDC115',
    Q96NT3: 'GUCD1',
    Q96NT5: 'SLC46A1',
    Q96NU1: 'SAMD11',
    Q96NW4: 'ANKRD27',
    Q96NW7: 'LRRC7',
    Q96NX5: 'CAMK1G',
    Q96NY7: 'CLIC6',
    Q96NY8: 'NECTIN4',
    Q96NY9: 'MUS81',
    Q96NZ1: 'FOXN4',
    Q96NZ8: 'WFIKKN1',
    Q96NZ9: 'PRAP1',
    Q96P09: 'BIRC8',
    Q96P11: 'NSUN5',
    Q96P15: 'SERPINB11',
    Q96P16: 'RPRD1A',
    Q96P20: 'NLRP3',
    Q96P26: 'NT5C1B',
    Q96P31: 'FCRL3',
    Q96P44: 'COL21A1',
    Q96P47: 'AGAP3',
    Q96P48: 'ARAP1',
    Q96P53: 'WDFY2',
    Q96P56: 'CATSPER2',
    Q96P63: 'SERPINB12',
    Q96P65: 'QRFPR',
    Q96P66: 'GPR101',
    Q96P70: 'IPO9',
    Q96P71: 'NECAB3',
    Q96PB1: 'CASD1',
    Q96PB7: 'OLFM3',
    Q96PC2: 'IP6K3',
    Q96PC3: 'AP1S3',
    Q96PC5: 'MIA2',
    Q96PD2: 'DCBLD2',
    Q96PD4: 'IL17F',
    Q96PD5: 'PGLYRP2',
    Q96PD6: 'MOGAT1',
    Q96PD7: 'DGAT2',
    Q96PE1: 'ADGRA2',
    Q96PE3: 'INPP4A',
    Q96PE7: 'MCEE',
    Q96PF1: 'TGM7',
    Q96PF2: 'TSSK2',
    Q96PG8: 'BBC3',
    Q96PH1: 'NOX5',
    Q96PH6: 'DEFB118',
    Q96PJ5: 'FCRL4',
    Q96PK6: 'RBM14',
    Q96PL5: 'ERMAP',
    Q96PM5: 'RCHY1',
    Q96PM9: 'ZNF385A',
    Q96PN6: 'ADCY10',
    Q96PN7: 'TRERF1',
    Q96PN8: 'TSSK3',
    Q96PP8: 'GBP5',
    Q96PP9: 'GBP4',
    Q96PQ0: 'SORCS2',
    Q96PQ1: 'SIGLEC12',
    Q96PQ6: 'ZNF317',
    Q96PR1: 'KCNC2',
    Q96PS8: 'AQP10',
    Q96PU4: 'UHRF2',
    Q96PU5: 'NEDD4L',
    Q96PU8: 'QKI',
    Q96PV0: 'SYNGAP1',
    Q96PV4: 'PNMA5',
    Q96PV6: 'LENG8',
    Q96PV7: 'FAM193B',
    Q96PX1: 'RNF157',
    Q96PX8: 'SLITRK1',
    Q96PY5: 'FMNL2',
    Q96PY6: 'NEK1',
    Q96PZ0: 'PUS7',
    Q96PZ2: 'FAM111A',
    Q96PZ7: 'CSMD1',
    Q96Q04: 'LMTK3',
    Q96Q05: 'TRAPPC9',
    Q96Q06: 'PLIN4',
    Q96Q11: 'TRNT1',
    Q96Q15: 'SMG1',
    Q96Q27: 'ASB2',
    Q96Q35: 'FLACC1',
    Q96Q40: 'CDK15',
    Q96Q42: 'ALS2',
    Q96Q45: 'TMEM237',
    Q96Q77: 'CIB3',
    Q96Q80: 'DERL3',
    Q96Q83: 'ALKBH3',
    Q96Q89: 'KIF20B',
    Q96Q91: 'SLC4A9',
    Q96QA5: 'GSDMA',
    Q96QB1: 'DLC1',
    Q96QC0: 'PPP1R10',
    Q96QD8: 'SLC38A2',
    Q96QD9: 'FYTTD1',
    Q96QE2: 'SLC2A13',
    Q96QE3: 'ATAD5',
    Q96QE5: 'TEFM',
    Q96QF0: 'RAB3IP',
    Q96QF7: 'GCNA',
    Q96QG7: 'MTMR9',
    Q96QH2: 'PRAM1',
    Q96QI5: 'HS3ST6',
    Q96QK1: 'VPS35',
    Q96QP1: 'ALPK1',
    Q96QR8: 'PURB',
    Q96QS3: 'ARX',
    Q96QS6: 'PSKH2',
    Q96QT4: 'TRPM7',
    Q96QT6: 'PHF12',
    Q96QU1: 'PCDH15',
    Q96QU8: 'XPO6',
    Q96QV1: 'HHIP',
    Q96QV6: 'H2AC1',
    Q96QZ7: 'MAGI1',
    Q96R06: 'SPAG5',
    Q96RD6: 'PANX2',
    Q96RD7: 'PANX1',
    Q96RD9: 'FCRL5',
    Q96RE7: 'NACC1',
    Q96RE9: 'ZNF300',
    Q96RF0: 'SNX18',
    Q96RG2: 'PASK',
    Q96RI0: 'F2RL3',
    Q96RI1: 'NR1H4',
    Q96RI8: 'TAAR6',
    Q96RJ3: 'TNFRSF13C',
    Q96RJ6: 'FERD3L',
    Q96RK0: 'CIC',
    Q96RK4: 'BBS4',
    Q96RL1: 'UIMC1',
    Q96RL6: 'SIGLEC11',
    Q96RL7: 'VPS13A',
    Q96RN1: 'SLC26A8',
    Q96RN5: 'MED15',
    Q96RP3: 'UCN2',
    Q96RP7: 'GAL3ST4',
    Q96RP9: 'GFM1',
    Q96RQ1: 'ERGIC2',
    Q96RQ3: 'MCCC1',
    Q96RQ9: 'IL4I1',
    Q96RR1: 'TWNK',
    Q96RR4: 'CAMKK2',
    Q96RS0: 'TGS1',
    Q96RS6: 'NUDCD1',
    Q96RT1: 'ERBIN',
    Q96RT7: 'TUBGCP6',
    Q96RT8: 'TUBGCP5',
    Q96RU2: 'USP28',
    Q96RU3: 'FNBP1',
    Q96RU7: 'TRIB3',
    Q96RU8: 'TRIB1',
    Q96RW7: 'HMCN1',
    Q96RY7: 'IFT140',
    Q96S06: 'LMF1',
    Q96S15: 'WDR24',
    Q96S16: 'JMJD8',
    Q96S21: 'RAB40C',
    Q96S37: 'SLC22A12',
    Q96S38: 'RPS6KC1',
    Q96S42: 'NODAL',
    Q96S44: 'TP53RK',
    Q96S52: 'PIGS',
    Q96S53: 'TESK2',
    Q96S55: 'WRNIP1',
    Q96S59: 'RANBP9',
    Q96S65: 'CSRNP1',
    Q96S66: 'CLCC1',
    Q96S94: 'CCNL2',
    Q96S97: 'MYADM',
    Q96S99: 'PLEKHF1',
    Q96SB3: 'PPP1R9B',
    Q96SB4: 'SRPK1',
    Q96SB8: 'SMC6',
    Q96SC8: 'DMRTA2',
    Q96SD1: 'DCLRE1C',
    Q96SF7: 'TBX15',
    Q96SI1: 'KCTD15',
    Q96SI9: 'STRBP',
    Q96SL1: 'SLC49A4',
    Q96SL4: 'GPX7',
    Q96SN8: 'CDK5RAP2',
    Q96SQ5: 'ZNF587',
    Q96SQ7: 'ATOH8',
    Q96SQ9: 'CYP2S1',
    Q96ST2: 'IWS1',
    Q96ST3: 'SIN3A',
    Q96ST8: 'CEP89',
    Q96SU4: 'OSBPL9',
    Q96SW2: 'CRBN',
    Q96SZ4: 'ZSCAN10',
    Q96SZ5: 'ADO',
    Q96SZ6: 'CDK5RAP1',
    Q96T21: 'SECISBP2',
    Q96T23: 'RSF1',
    Q96T37: 'RBM15',
    Q96T49: 'PPP1R16B',
    Q96T51: 'RUFY1',
    Q96T52: 'IMMP2L',
    Q96T53: 'MBOAT4',
    Q96T54: 'KCNK17',
    Q96T55: 'KCNK16',
    Q96T58: 'SPEN',
    Q96T60: 'PNKP',
    Q96T66: 'NMNAT3',
    Q96T68: 'SETDB2',
    Q96T76: 'MMS19',
    Q96T83: 'SLC9A7',
    Q96T88: 'UHRF1',
    Q96T91: 'GPHA2',
    Q96TA1: 'NIBAN2',
    Q96TA2: 'YME1L1',
    Q96TC7: 'RMDN3',
    Q99062: 'CSF3R',
    Q99075: 'HBEGF',
    Q99081: 'TCF12',
    Q99102: 'MUC4',
    Q99217: 'AMELX',
    Q99250: 'SCN2A',
    Q99259: 'GAD1',
    Q99417: 'MYCBP',
    Q99418: 'CYTH2',
    Q99424: 'ACOX2',
    Q99426: 'TBCB',
    Q99435: 'NELL2',
    Q99436: 'PSMB7',
    Q99437: 'ATP6V0B',
    Q99439: 'CNN2',
    Q99447: 'PCYT2',
    Q99453: 'PHOX2B',
    Q99456: 'KRT12',
    Q99459: 'CDC5L',
    Q99460: 'PSMD1',
    Q99466: 'NOTCH4',
    Q99467: 'CD180',
    Q99469: 'STAC',
    Q99471: 'PFDN5',
    Q99487: 'PAFAH2',
    Q99489: 'DDO',
    Q99490: 'AGAP2',
    Q99496: 'RNF2',
    Q99497: 'PARK7',
    Q99500: 'S1PR3',
    Q99501: 'GAS2L1',
    Q99502: 'EYA1',
    Q99504: 'EYA3',
    Q99518: 'FMO2',
    Q99519: 'NEU1',
    Q99523: 'SORT1',
    Q99527: 'GPER1',
    Q99536: 'VAT1',
    Q99538: 'LGMN',
    Q99541: 'PLIN2',
    Q99542: 'MMP19',
    Q99543: 'DNAJC2',
    Q99547: 'MPHOSPH6',
    Q99549: 'MPHOSPH8',
    Q99550: 'MPHOSPH9',
    Q99551: 'MTERF1',
    Q99558: 'MAP3K14',
    Q99567: 'NUP88',
    Q99569: 'PKP4',
    Q99570: 'PIK3R4',
    Q99571: 'P2RX4',
    Q99572: 'P2RX7',
    Q99574: 'SERPINI1',
    Q99575: 'POP1',
    Q99576: 'TSC22D3',
    Q99578: 'RIT2',
    Q99581: 'FEV',
    Q99583: 'MNT',
    Q99584: 'S100A13',
    Q99590: 'SCAF11',
    Q99592: 'ZBTB18',
    Q99593: 'TBX5',
    Q99594: 'TEAD3',
    Q99595: 'TIMM17A',
    Q99598: 'TSNAX',
    Q99607: 'ELF4',
    Q99608: 'NDN',
    Q99611: 'SEPHS2',
    Q99612: 'KLF6',
    Q99615: 'DNAJC7',
    Q99616: 'CCL13',
    Q99619: 'SPSB2',
    Q99622: 'C12orf57',
    Q99623: 'PHB2',
    Q99624: 'SLC38A3',
    Q99626: 'CDX2',
    Q99627: 'COPS8',
    Q99633: 'PRPF18',
    Q99638: 'RAD9A',
    Q99640: 'PKMYT1',
    Q99643: 'SDHC',
    Q99645: 'EPYC',
    Q99650: 'OSMR',
    Q99653: 'CHP1',
    Q99661: 'KIF2C',
    Q99665: 'IL12RB2',
    Q99674: 'CGREF1',
    Q99675: 'CGRRF1',
    Q99677: 'LPAR4',
    Q99678: 'GPR20',
    Q99683: 'MAP3K5',
    Q99684: 'GFI1',
    Q99685: 'MGLL',
    Q99687: 'MEIS3',
    Q99689: 'FEZ1',
    Q99697: 'PITX2',
    Q99698: 'LYST',
    Q99700: 'ATXN2',
    Q99704: 'DOK1',
    Q99705: 'MCHR1',
    Q99706: 'KIR2DL4',
    Q99707: 'MTR',
    Q99708: 'RBBP8',
    Q99712: 'KCNJ15',
    Q99714: 'HSD17B10',
    Q99715: 'COL12A1',
    Q99717: 'SMAD5',
    Q99719: 'SEPTIN5',
    Q99720: 'SIGMAR1',
    Q99726: 'SLC30A3',
    Q99727: 'TIMP4',
    Q99728: 'BARD1',
    Q99729: 'HNRNPAB',
    Q99731: 'CCL19',
    Q99732: 'LITAF',
    Q99733: 'NAP1L4',
    Q99735: 'MGST2',
    Q99741: 'CDC6',
    Q99743: 'NPAS2',
    Q99747: 'NAPG',
    Q99748: 'NRTN',
    Q99750: 'MDFI',
    Q99755: 'PIP5K1A',
    Q99757: 'TXN2',
    Q99758: 'ABCA3',
    Q99759: 'MAP3K3',
    Q99766: 'DMAC2L',
    Q99767: 'APBA2',
    Q99784: 'OLFM1',
    Q99788: 'CMKLR1',
    Q99795: 'GPA33',
    Q99797: 'MIPEP',
    Q99798: 'ACO2',
    Q99801: 'NKX3-1',
    Q99807: 'COQ7',
    Q99808: 'SLC29A1',
    Q99814: 'EPAS1',
    Q99816: 'TSG101',
    Q99828: 'CIB1',
    Q99829: 'CPNE1',
    Q99832: 'CCT7',
    Q99835: 'SMO',
    Q99836: 'MYD88',
    Q99848: 'EBNA1BP2',
    Q99853: 'FOXB1',
    Q99856: 'ARID3A',
    Q99871: 'HAUS7',
    Q99873: 'PRMT1',
    Q99877: 'H2BC15',
    Q99878: 'H2AC14',
    Q99879: 'H2BC14',
    Q99880: 'H2BC13',
    Q99884: 'SLC6A7',
    Q99895: 'CTRC',
    Q99909: 'SSX3',
    Q99928: 'GABRG3',
    Q99929: 'ASCL2',
    Q99932: 'SPAG8',
    Q99933: 'BAG1',
    Q99935: 'OPRPN',
    Q99941: 'ATF6B',
    Q99942: 'RNF5',
    Q99943: 'AGPAT1',
    Q99944: 'EGFL8',
    Q99946: 'PRRT1',
    Q99952: 'PTPN18',
    Q99956: 'DUSP9',
    Q99958: 'FOXC2',
    Q99959: 'PKP2',
    Q99961: 'SH3GL1',
    Q99962: 'SH3GL2',
    Q99963: 'SH3GL3',
    Q99965: 'ADAM2',
    Q99966: 'CITED1',
    Q99967: 'CITED2',
    Q99969: 'RARRES2',
    Q99972: 'MYOC',
    Q99973: 'TEP1',
    Q99983: 'OMD',
    Q99985: 'SEMA3C',
    Q99986: 'VRK1',
    Q99988: 'GDF15',
    Q99990: 'VGLL1',
    Q99996: 'AKAP9',
    Q99999: 'GAL3ST1',
    Q9BPU6: 'DPYSL5',
    Q9BPU9: 'B9D2',
    Q9BPV8: 'P2RY13',
    Q9BPW9: 'DHRS9',
    Q9BPX1: 'HSD17B14',
    Q9BPX3: 'NCAPG',
    Q9BPX6: 'MICU1',
    Q9BPY8: 'HOPX',
    Q9BPZ2: 'SPIN2B',
    Q9BPZ3: 'PAIP2',
    Q9BPZ7: 'MAPKAP1',
    Q9BQ04: 'RBM4B',
    Q9BQ15: 'NABP2',
    Q9BQ16: 'SPOCK3',
    Q9BQ24: 'ZFYVE21',
    Q9BQ31: 'KCNS3',
    Q9BQ39: 'DDX50',
    Q9BQ50: 'TREX2',
    Q9BQ51: 'PDCD1LG2',
    Q9BQ52: 'ELAC2',
    Q9BQ61: 'TRIR',
    Q9BQ65: 'USB1',
    Q9BQ66: 'KRTAP4-12',
    Q9BQ67: 'GRWD1',
    Q9BQ69: 'MACROD1',
    Q9BQ70: 'TCF25',
    Q9BQ83: 'SLX1A',
    Q9BQ83: 'SLX1B',
    Q9BQ87: 'TBL1Y',
    Q9BQ89: 'FAM110A',
    Q9BQ90: 'KLHDC3',
    Q9BQ95: 'ECSIT',
    Q9BQA1: 'WDR77',
    Q9BQA5: 'HINFP',
    Q9BQA9: 'CYBC1',
    Q9BQB4: 'SOST',
    Q9BQB6: 'VKORC1',
    Q9BQC3: 'DPH2',
    Q9BQD3: 'KXD1',
    Q9BQD7: 'ANTKMT',
    Q9BQE3: 'TUBA1C',
    Q9BQE4: 'SELENOS',
    Q9BQE5: 'APOL2',
    Q9BQE9: 'BCL7B',
    Q9BQF6: 'SENP7',
    Q9BQG0: 'MYBBP1A',
    Q9BQG1: 'SYT3',
    Q9BQG2: 'NUDT12',
    Q9BQI0: 'AIF1L',
    Q9BQI3: 'EIF2AK1',
    Q9BQI4: 'CCDC3',
    Q9BQI5: 'SGIP1',
    Q9BQI6: 'SLF1',
    Q9BQJ4: 'TMEM47',
    Q9BQK8: 'LPIN3',
    Q9BQL6: 'FERMT1',
    Q9BQP7: 'MGME1',
    Q9BQQ3: 'GORASP1',
    Q9BQS2: 'SYT15',
    Q9BQS7: 'HEPH',
    Q9BQS8: 'FYCO1',
    Q9BQT8: 'SLC25A21',
    Q9BQT9: 'CLSTN3',
    Q9BQY4: 'RHOXF2',
    Q9BR01: 'SULT4A1',
    Q9BR39: 'JPH2',
    Q9BR76: 'CORO1B',
    Q9BRA0: 'NAA38',
    Q9BRA2: 'TXNDC17',
    Q9BRB3: 'PIGQ',
    Q9BRC7: 'PLCD4',
    Q9BRD0: 'BUD13',
    Q9BRF8: 'CPPED1',
    Q9BRG1: 'VPS25',
    Q9BRG2: 'SH2D3A',
    Q9BRI3: 'SLC30A2',
    Q9BRJ7: 'NUDT16L1',
    Q9BRJ9: 'MESP1',
    Q9BRK0: 'REEP2',
    Q9BRK3: 'MXRA8',
    Q9BRK4: 'LZTS2',
    Q9BRK5: 'SDF4',
    Q9BRL6: 'SRSF8',
    Q9BRL7: 'SEC22C',
    Q9BRP0: 'OVOL2',
    Q9BRP8: 'PYM1',
    Q9BRQ0: 'PYGO2',
    Q9BRQ3: 'NUDT22',
    Q9BRQ6: 'CHCHD6',
    Q9BRQ8: 'AIFM2',
    Q9BRR0: 'ZKSCAN3',
    Q9BRR3: 'PGAP4',
    Q9BRR6: 'ADPGK',
    Q9BRR9: 'ARHGAP9',
    Q9BRS2: 'RIOK1',
    Q9BRS8: 'LARP6',
    Q9BRT2: 'UQCC2',
    Q9BRT3: 'MIEN1',
    Q9BRT9: 'GINS4',
    Q9BRU9: 'UTP23',
    Q9BRV3: 'SLC50A1',
    Q9BRV8: 'SIKE1',
    Q9BRX2: 'PELO',
    Q9BRX5: 'GINS3',
    Q9BRX8: 'PRXL2A',
    Q9BRX9: 'WDR83',
    Q9BRZ2: 'TRIM56',
    Q9BS16: 'CENPK',
    Q9BS26: 'ERP44',
    Q9BS34: 'ZNF670',
    Q9BS40: 'LXN',
    Q9BS86: 'ZPBP',
    Q9BSA4: 'TTYH2',
    Q9BSA9: 'TMEM175',
    Q9BSB4: 'ATG101',
    Q9BSD3: 'RHNO1',
    Q9BSD7: 'NTPCR',
    Q9BSE2: 'TMEM79',
    Q9BSE4: 'HERPUD2',
    Q9BSF0: 'C2orf88',
    Q9BSG1: 'ZNF2',
    Q9BSH4: 'TACO1',
    Q9BSI4: 'TINF2',
    Q9BSJ2: 'TUBGCP2',
    Q9BSJ6: 'PIMREG',
    Q9BSJ8: 'ESYT1',
    Q9BSK2: 'SLC25A33',
    Q9BSK4: 'FEM1A',
    Q9BSL1: 'UBAC1',
    Q9BSM1: 'PCGF1',
    Q9BSQ5: 'CCM2',
    Q9BSR8: 'YIPF4',
    Q9BST9: 'RTKN',
    Q9BSU1: 'PHAF1',
    Q9BSU3: 'NAA11',
    Q9BSV6: 'TSEN34',
    Q9BSW2: 'CRACR2A',
    Q9BSW7: 'SYT17',
    Q9BSY9: 'DESI2',
    Q9BT04: 'FUZ',
    Q9BT09: 'CNPY3',
    Q9BT17: 'MTG1',
    Q9BT22: 'ALG1',
    Q9BT25: 'HAUS8',
    Q9BT30: 'ALKBH7',
    Q9BT40: 'INPP5K',
    Q9BT43: 'POLR3GL',
    Q9BT49: 'THAP7',
    Q9BT56: 'SPX',
    Q9BT67: 'NDFIP1',
    Q9BT78: 'COPS4',
    Q9BT81: 'SOX7',
    Q9BT88: 'SYT11',
    Q9BT92: 'TCHP',
    Q9BTA9: 'WAC',
    Q9BTC0: 'DIDO1',
    Q9BTC8: 'MTA3',
    Q9BTD3: 'TMEM121',
    Q9BTD8: 'RBM42',
    Q9BTE1: 'DCTN5',
    Q9BTE3: 'MCMBP',
    Q9BTE6: 'AARSD1',
    Q9BTE7: 'DCUN1D5',
    Q9BTK6: 'PAGR1',
    Q9BTL3: 'RAMAC',
    Q9BTL4: 'IER2',
    Q9BTM9: 'URM1',
    Q9BTN0: 'LRFN3',
    Q9BTP6: 'ZBED2',
    Q9BTP7: 'FAAP24',
    Q9BTT0: 'ANP32E',
    Q9BTT4: 'MED10',
    Q9BTU6: 'PI4K2A',
    Q9BTV4: 'TMEM43',
    Q9BTV5: 'FSD1',
    Q9BTW9: 'TBCD',
    Q9BTX1: 'NDC1',
    Q9BTX3: 'TMEM208',
    Q9BTY2: 'FUCA2',
    Q9BTZ2: 'DHRS4',
    Q9BU02: 'THTPA',
    Q9BU19: 'ZNF692',
    Q9BU20: 'CPLANE2',
    Q9BU23: 'LMF2',
    Q9BU40: 'CHRDL1',
    Q9BU61: 'NDUFAF3',
    Q9BU64: 'CENPO',
    Q9BU76: 'MMTAG2',
    Q9BU79: 'TMEM243',
    Q9BU89: 'DOHH',
    Q9BUB4: 'ADAT1',
    Q9BUB5: 'MKNK1',
    Q9BUB7: 'TMEM70',
    Q9BUD6: 'SPON2',
    Q9BUE0: 'MED18',
    Q9BUE6: 'ISCA1',
    Q9BUF5: 'TUBB6',
    Q9BUF7: 'CRB3',
    Q9BUH6: 'PAXX',
    Q9BUH8: 'BEGAIN',
    Q9BUI4: 'POLR3C',
    Q9BUJ2: 'HNRNPUL1',
    Q9BUK6: 'MSTO1',
    Q9BUL5: 'PHF23',
    Q9BUL8: 'PDCD10',
    Q9BUL9: 'RPP25',
    Q9BUM1: 'G6PC3',
    Q9BUN5: 'CCDC28B',
    Q9BUN8: 'DERL1',
    Q9BUP0: 'EFHD1',
    Q9BUP3: 'HTATIP2',
    Q9BUQ8: 'DDX23',
    Q9BUR4: 'WRAP53',
    Q9BUR5: 'APOO',
    Q9BUT1: 'BDH2',
    Q9BUU2: 'METTL22',
    Q9BUX1: 'CHAC1',
    Q9BUY5: 'ZNF426',
    Q9BUZ4: 'TRAF4',
    Q9BV10: 'ALG12',
    Q9BV20: 'MRI1',
    Q9BV23: 'ABHD6',
    Q9BV35: 'SLC25A23',
    Q9BV36: 'MLPH',
    Q9BV38: 'WDR18',
    Q9BV40: 'VAMP8',
    Q9BV44: 'THUMPD3',
    Q9BV47: 'DUSP26',
    Q9BV57: 'ADI1',
    Q9BV68: 'RNF126',
    Q9BV73: 'CEP250',
    Q9BV79: 'MECR',
    Q9BV81: 'EMC6',
    Q9BV86: 'NTMT1',
    Q9BV90: 'SNRNP25',
    Q9BV94: 'EDEM2',
    Q9BVA0: 'KATNB1',
    Q9BVA1: 'TUBB2B',
    Q9BVA6: 'FICD',
    Q9BVC3: 'DSCC1',
    Q9BVC4: 'MLST8',
    Q9BVC6: 'TMEM109',
    Q9BVG3: 'TRIM62',
    Q9BVG8: 'KIFC3',
    Q9BVG9: 'PTDSS2',
    Q9BVH7: 'ST6GALNAC5',
    Q9BVI0: 'PHF20',
    Q9BVI4: 'NOC4L',
    Q9BVJ6: 'UTP14A',
    Q9BVJ7: 'DUSP23',
    Q9BVK2: 'ALG8',
    Q9BVK6: 'TMED9',
    Q9BVK8: 'TMEM147',
    Q9BVL2: 'NUP58',
    Q9BVL4: 'SELENOO',
    Q9BVM4: 'GGACT',
    Q9BVN2: 'RUSC1',
    Q9BVP2: 'GNL3',
    Q9BVQ7: 'AFG2B',
    Q9BVS4: 'RIOK2',
    Q9BVS5: 'TRMT61B',
    Q9BVT8: 'TMUB1',
    Q9BVV2: 'FNDC11',
    Q9BVV6: 'KIAA0586',
    Q9BVV7: 'TIMM21',
    Q9BVW5: 'TIPIN',
    Q9BVX2: 'TMEM106C',
    Q9BW04: 'SARG',
    Q9BW11: 'MXD3',
    Q9BW19: 'KIFC1',
    Q9BW27: 'NUP85',
    Q9BW60: 'ELOVL1',
    Q9BW61: 'DDA1',
    Q9BW62: 'KATNAL1',
    Q9BW66: 'CINP',
    Q9BW71: 'HIRIP3',
    Q9BW83: 'IFT27',
    Q9BW85: 'YJU2',
    Q9BW91: 'NUDT9',
    Q9BW92: 'TARS2',
    Q9BWC9: 'CCDC106',
    Q9BWD1: 'ACAT2',
    Q9BWE0: 'REPIN1',
    Q9BWF2: 'TRAIP',
    Q9BWF3: 'RBM4',
    Q9BWG6: 'SCNM1',
    Q9BWH2: 'FUNDC2',
    Q9BWH6: 'RPAP1',
    Q9BWJ5: 'SF3B5',
    Q9BWK5: 'CYREN',
    Q9BWL3: 'C1orf43',
    Q9BWN1: 'PRR14',
    Q9BWP8: 'COLEC11',
    Q9BWQ6: 'YIPF2',
    Q9BWQ8: 'FAIM2',
    Q9BWS9: 'CHID1',
    Q9BWT1: 'CDCA7',
    Q9BWT3: 'PAPOLG',
    Q9BWT7: 'CARD10',
    Q9BWU1: 'CDK19',
    Q9BWV1: 'BOC',
    Q9BWV3: 'CDADC1',
    Q9BWW4: 'SSBP3',
    Q9BWW7: 'SCRT1',
    Q9BWX1: 'PHF7',
    Q9BWX5: 'GATA5',
    Q9BX10: 'GTPBP2',
    Q9BX26: 'SYCP2',
    Q9BX40: 'LSM14B',
    Q9BX46: 'RBM24',
    Q9BX59: 'TAPBPL',
    Q9BX63: 'BRIP1',
    Q9BX66: 'SORBS1',
    Q9BX67: 'JAM3',
    Q9BX68: 'HINT2',
    Q9BX70: 'BTBD2',
    Q9BX74: 'TM2D1',
    Q9BX79: 'STRA6',
    Q9BX84: 'TRPM6',
    Q9BX95: 'SGPP1',
    Q9BX97: 'PLVAP',
    Q9BXA5: 'SUCNR1',
    Q9BXA6: 'TSSK6',
    Q9BXA7: 'TSSK1B',
    Q9BXB1: 'LGR4',
    Q9BXB4: 'OSBPL11',
    Q9BXB5: 'OSBPL10',
    Q9BXB7: 'SPATA16',
    Q9BXC0: 'HCAR1',
    Q9BXC9: 'BBS2',
    Q9BXD5: 'NPL',
    Q9BXF3: 'CECR2',
    Q9BXF6: 'RAB11FIP5',
    Q9BXF9: 'TEKT3',
    Q9BXH1: 'BBC3',
    Q9BXI2: 'SLC25A2',
    Q9BXI3: 'NT5C1A',
    Q9BXI6: 'TBC1D10A',
    Q9BXI9: 'C1QTNF6',
    Q9BXJ0: 'C1QTNF5',
    Q9BXJ1: 'C1QTNF1',
    Q9BXJ3: 'C1QTNF4',
    Q9BXJ4: 'C1QTNF3',
    Q9BXJ5: 'C1QTNF2',
    Q9BXJ7: 'AMN',
    Q9BXJ8: 'TMEM120A',
    Q9BXJ9: 'NAA15',
    Q9BXK5: 'BCL2L13',
    Q9BXL6: 'CARD14',
    Q9BXL7: 'CARD11',
    Q9BXL8: 'CDCA4',
    Q9BXM0: 'PRX',
    Q9BXM7: 'PINK1',
    Q9BXN1: 'ASPN',
    Q9BXN2: 'CLEC7A',
    Q9BXP2: 'SLC12A9',
    Q9BXP5: 'SRRT',
    Q9BXP8: 'PAPPA2',
    Q9BXR0: 'QTRT1',
    Q9BXR3: 'ERVK-6',
    Q9BXR5: 'TLR10',
    Q9BXR6: 'CFHR5',
    Q9BXS0: 'COL25A1',
    Q9BXS1: 'IDI2',
    Q9BXS4: 'TMEM59',
    Q9BXS5: 'AP1M1',
    Q9BXS6: 'NUSAP1',
    Q9BXS9: 'SLC26A6',
    Q9BXT4: 'TDRD1',
    Q9BXT5: 'TEX15',
    Q9BXT6: 'MOV10L1',
    Q9BXT8: 'RNF17',
    Q9BXU0: 'TEX12',
    Q9BXU1: 'STK31',
    Q9BXU7: 'USP26',
    Q9BXU9: 'CALN1',
    Q9BXV9: 'GON7',
    Q9BXW4: 'MAP1LC3C',
    Q9BXW6: 'OSBPL1A',
    Q9BXW9: 'FANCD2',
    Q9BXX0: 'EMILIN2',
    Q9BXY4: 'RSPO3',
    Q9BXY8: 'BEX2',
    Q9BY07: 'SLC4A5',
    Q9BY08: 'EBPL',
    Q9BY11: 'PACSIN1',
    Q9BY12: 'SCAPER',
    Q9BY14: 'TEX101',
    Q9BY15: 'ADGRE3',
    Q9BY27: 'DGCR6L',
    Q9BY32: 'ITPA',
    Q9BY41: 'HDAC8',
    Q9BY42: 'RTF2',
    Q9BY43: 'CHMP4A',
    Q9BY44: 'EIF2A',
    Q9BY49: 'PECR',
    Q9BY50: 'SEC11C',
    Q9BY64: 'UGT2B28',
    Q9BY66: 'KDM5D',
    Q9BY67: 'CADM1',
    Q9BY76: 'ANGPTL4',
    Q9BY77: 'POLDIP3',
    Q9BY78: 'RNF26',
    Q9BY79: 'MFRP',
    Q9BY84: 'DUSP16',
    Q9BYB0: 'SHANK3',
    Q9BYC5: 'FUT8',
    Q9BYD5: 'CNFN',
    Q9BYE0: 'HES7',
    Q9BYE2: 'TMPRSS13',
    Q9BYE3: 'LCE3D',
    Q9BYE7: 'PCGF6',
    Q9BYE9: 'CDHR2',
    Q9BYF1: 'ACE2',
    Q9BYG0: 'B3GNT5',
    Q9BYG3: 'NIFK',
    Q9BYG4: 'PARD6G',
    Q9BYG5: 'PARD6B',
    Q9BYG8: 'GSDMC',
    Q9BYH1: 'SEZ6L',
    Q9BYH8: 'NFKBIZ',
    Q9BYI3: 'HYCC1',
    Q9BYJ1: 'ALOXE3',
    Q9BYJ4: 'TRIM34',
    Q9BYJ9: 'YTHDF1',
    Q9BYK8: 'HELZ2',
    Q9BYM8: 'RBCK1',
    Q9BYN0: 'SRXN1',
    Q9BYN7: 'ZNF341',
    Q9BYP7: 'WNK3',
    Q9BYP8: 'KRTAP17-1',
    Q9BYP9: 'KRTAP9-9',
    Q9BYQ0: 'KRTAP9-8',
    Q9BYQ2: 'KRTAP9-4',
    Q9BYQ3: 'KRTAP9-3',
    Q9BYQ4: 'KRTAP9-2',
    Q9BYQ5: 'KRTAP4-6',
    Q9BYQ6: 'KRTAP4-11',
    Q9BYQ7: 'KRTAP4-1',
    Q9BYQ8: 'KRTAP4-9',
    Q9BYR0: 'KRTAP4-7',
    Q9BYR2: 'KRTAP4-5',
    Q9BYR3: 'KRTAP4-4',
    Q9BYR4: 'KRTAP4-3',
    Q9BYR5: 'KRTAP4-2',
    Q9BYR6: 'KRTAP3-3',
    Q9BYR7: 'KRTAP3-2',
    Q9BYR8: 'KRTAP3-1',
    Q9BYR9: 'KRTAP2-4',
    Q9BYS1: 'KRTAP1-5',
    Q9BYT1: 'SLC17A9',
    Q9BYT3: 'STK33',
    Q9BYT8: 'NLN',
    Q9BYT9: 'ANO3',
    Q9BYU1: 'PBX4',
    Q9BYV1: 'AGXT2',
    Q9BYV2: 'TRIM54',
    Q9BYV6: 'TRIM55',
    Q9BYV7: 'BCO2',
    Q9BYV8: 'CEP41',
    Q9BYV9: 'BACH2',
    Q9BYW1: 'SLC2A11',
    Q9BYW2: 'SETD2',
    Q9BYW3: 'DEFB126',
    Q9BYX2: 'TBC1D2',
    Q9BYX4: 'IFIH1',
    Q9BYZ2: 'LDHAL6B',
    Q9BYZ6: 'RHOBTB2',
    Q9BYZ8: 'REG4',
    Q9BZ11: 'ADAM33',
    Q9BZ23: 'PANK2',
    Q9BZ29: 'DOCK9',
    Q9BZ67: 'FRMD8',
    Q9BZ71: 'PITPNM3',
    Q9BZ72: 'PITPNM2',
    Q9BZ95: 'NSD3',
    Q9BZA7: 'PCDH11X',
    Q9BZA8: 'PCDH11Y',
    Q9BZB8: 'CPEB1',
    Q9BZC1: 'CELF4',
    Q9BZC7: 'ABCA2',
    Q9BZD2: 'SLC29A3',
    Q9BZD4: 'NUF2',
    Q9BZD6: 'PRRG4',
    Q9BZE0: 'GLIS2',
    Q9BZE2: 'PUS3',
    Q9BZE4: 'GTPBP4',
    Q9BZE9: 'ASPSCR1',
    Q9BZF1: 'OSBPL8',
    Q9BZF2: 'OSBPL7',
    Q9BZF3: 'OSBPL6',
    Q9BZF9: 'UACA',
    Q9BZG1: 'RAB34',
    Q9BZG2: 'ACP4',
    Q9BZG8: 'DPH1',
    Q9BZH6: 'WDR11',
    Q9BZI7: 'UPF3B',
    Q9BZJ0: 'CRNKL1',
    Q9BZJ3: 'TPSD1',
    Q9BZJ7: 'GPR62',
    Q9BZJ8: 'GPR61',
    Q9BZK7: 'TBL1XR1',
    Q9BZL1: 'UBL5',
    Q9BZL3: 'SMIM3',
    Q9BZL4: 'PPP1R12C',
    Q9BZL6: 'PRKD2',
    Q9BZM1: 'PLA2G12A',
    Q9BZM2: 'PLA2G2F',
    Q9BZM3: 'GSX2',
    Q9BZM4: 'ULBP3',
    Q9BZM5: 'ULBP2',
    Q9BZM6: 'ULBP1',
    Q9BZP6: 'CHIA',
    Q9BZQ2: 'SHCBP1L',
    Q9BZQ4: 'NMNAT2',
    Q9BZQ6: 'EDEM3',
    Q9BZQ8: 'NIBAN1',
    Q9BZR6: 'RTN4R',
    Q9BZR8: 'BCL2L14',
    Q9BZR9: 'TRIM8',
    Q9BZS1: 'FOXP3',
    Q9BZV1: 'UBXN6',
    Q9BZV2: 'SLC19A3',
    Q9BZV3: 'IMPG2',
    Q9BZW4: 'TM6SF2',
    Q9BZW7: 'TSGA10',
    Q9BZW8: 'CD244',
    Q9BZX2: 'UCK2',
    Q9BZX4: 'ROPN1B',
    Q9BZY9: 'TRIM31',
    Q9BZZ2: 'SIGLEC1',
    Q9BZZ5: 'API5',
    Q9C000: 'NLRP1',
    Q9C004: 'SPRY4',
    Q9C005: 'DPY30',
    Q9C019: 'TRIM15',
    Q9C026: 'TRIM9',
    Q9C029: 'TRIM7',
    Q9C030: 'TRIM6',
    Q9C035: 'TRIM5',
    Q9C037: 'TRIM4',
    Q9C040: 'TRIM2',
    Q9C056: 'NKX6-2',
    Q9C086: 'INO80B',
    Q9C091: 'GREB1L',
    Q9C093: 'SPEF2',
    Q9C098: 'DCLK3',
    Q9C0A0: 'CNTNAP4',
    Q9C0A1: 'ZFHX2',
    Q9C0A6: 'SETD5',
    Q9C0B0: 'UNK',
    Q9C0B1: 'FTO',
    Q9C0B5: 'ZDHHC5',
    Q9C0C2: 'TNKS1BP1',
    Q9C0C4: 'SEMA4C',
    Q9C0C6: 'CIPC',
    Q9C0C7: 'AMBRA1',
    Q9C0C9: 'UBE2O',
    Q9C0D0: 'PHACTR1',
    Q9C0D2: 'CEP295',
    Q9C0D5: 'TANC1',
    Q9C0D6: 'FHDC1',
    Q9C0D9: 'SELENOI',
    Q9C0E4: 'GRIP2',
    Q9C0E8: 'LNPK',
    Q9C0F0: 'ASXL3',
    Q9C0F1: 'CEP44',
    Q9C0F3: 'ZNF436',
    Q9C0G0: 'ZNF407',
    Q9C0G6: 'DNAH6',
    Q9C0H2: 'TTYH3',
    Q9C0H9: 'SRCIN1',
    Q9C0I1: 'MTMR12',
    Q9C0J1: 'B3GNT4',
    Q9C0J8: 'WDR33',
    Q9C0J9: 'BHLHE41',
    Q9C0K0: 'BCL11B',
    Q9C0K1: 'SLC39A8',
    Q9C0K7: 'STRADB',
    Q9GZL7: 'WDR12',
    Q9GZM5: 'YIPF3',
    Q9GZM7: 'TINAGL1',
    Q9GZM8: 'NDEL1',
    Q9GZN0: 'GPR88',
    Q9GZN1: 'ACTR6',
    Q9GZN2: 'TGIF2',
    Q9GZN4: 'PRSS22',
    Q9GZN7: 'ROGDI',
    Q9GZP0: 'PDGFD',
    Q9GZP9: 'DERL2',
    Q9GZQ4: 'NMUR2',
    Q9GZQ6: 'NPFFR1',
    Q9GZQ8: 'MAP1LC3B',
    Q9GZR1: 'SENP6',
    Q9GZR2: 'REXO4',
    Q9GZR5: 'ELOVL4',
    Q9GZS0: 'DNAI2',
    Q9GZS1: 'POLR1E',
    Q9GZS3: 'SKIC8',
    Q9GZS9: 'CHST5',
    Q9GZT3: 'SLIRP',
    Q9GZT4: 'SRR',
    Q9GZT5: 'WNT10A',
    Q9GZT8: 'NIF3L1',
    Q9GZT9: 'EGLN1',
    Q9GZU1: 'MCOLN1',
    Q9GZU2: 'PEG3',
    Q9GZU5: 'NYX',
    Q9GZU7: 'CTDSP1',
    Q9GZU8: 'PSME3IP1',
    Q9GZV1: 'ANKRD2',
    Q9GZV3: 'SLC5A7',
    Q9GZV4: 'EIF5A2',
    Q9GZV5: 'WWTR1',
    Q9GZV7: 'HAPLN2',
    Q9GZV8: 'PRDM14',
    Q9GZV9: 'FGF23',
    Q9GZW8: 'MS4A7',
    Q9GZX3: 'CHST6',
    Q9GZX5: 'ZNF350',
    Q9GZX6: 'IL22',
    Q9GZX7: 'AICDA',
    Q9GZX9: 'TWSG1',
    Q9GZY0: 'NXF2',
    Q9GZY0: 'NXF2B',
    Q9GZY4: 'COA1',
    Q9GZY6: 'LAT2',
    Q9GZY8: 'MFF',
    Q9GZZ1: 'NAA50',
    Q9GZZ6: 'CHRNA10',
    Q9GZZ7: 'GFRA4',
    Q9GZZ8: 'LACRT',
    Q9GZZ9: 'UBA5',
    Q9H000: 'MKRN2',
    Q9H008: 'LHPP',
    Q9H013: 'ADAM19',
    Q9H015: 'SLC22A4',
    Q9H040: 'SPRTN',
    Q9H063: 'MAF1',
    Q9H074: 'PAIP1',
    Q9H078: 'CLPB',
    Q9H079: 'KATNBL1',
    Q9H081: 'MIS12',
    Q9H082: 'RAB33B',
    Q9H089: 'LSG1',
    Q9H093: 'NUAK2',
    Q9H095: 'IQCG',
    Q9H0A0: 'NAT10',
    Q9H0A6: 'RNF32',
    Q9H0A8: 'COMMD4',
    Q9H0A9: 'SPATC1L',
    Q9H0B3: 'IQCN',
    Q9H0B6: 'KLC2',
    Q9H0B8: 'CRISPLD2',
    Q9H0C1: 'ZMYND12',
    Q9H0C2: 'SLC25A31',
    Q9H0C5: 'BTBD1',
    Q9H0C8: 'ILKAP',
    Q9H0D2: 'ZNF541',
    Q9H0D6: 'XRN2',
    Q9H0E2: 'TOLLIP',
    Q9H0E3: 'SAP130',
    Q9H0E7: 'USP44',
    Q9H0E9: 'BRD8',
    Q9H0F5: 'RNF38',
    Q9H0F6: 'SHARPIN',
    Q9H0F7: 'ARL6',
    Q9H0G5: 'NSRP1',
    Q9H0H0: 'INTS2',
    Q9H0H5: 'RACGAP1',
    Q9H0I2: 'ENKD1',
    Q9H0J4: 'QRICH2',
    Q9H0J9: 'PARP12',
    Q9H0K1: 'SIK2',
    Q9H0K6: 'PUS7L',
    Q9H0L4: 'CSTF2T',
    Q9H0M0: 'WWP1',
    Q9H0M4: 'ZCWPW1',
    Q9H0N0: 'RAB6C',
    Q9H0N5: 'PCBD2',
    Q9H0P0: 'NT5C3A',
    Q9H0Q3: 'FXYD6',
    Q9H0R1: 'AP5M1',
    Q9H0R3: 'TMEM222',
    Q9H0R5: 'GBP3',
    Q9H0R6: 'QRSL1',
    Q9H0R8: 'GABARAPL1',
    Q9H0S4: 'DDX47',
    Q9H0T7: 'RAB17',
    Q9H0U3: 'MAGT1',
    Q9H0U4: 'RAB1B',
    Q9H0U6: 'MRPL18',
    Q9H0V9: 'LMAN2L',
    Q9H0W5: 'CCDC8',
    Q9H0W8: 'SMG9',
    Q9H0W9: 'C11orf54',
    Q9H0X6: 'RNF208',
    Q9H0X9: 'OSBPL5',
    Q9H0Y0: 'ATG10',
    Q9H0Z9: 'RBM38',
    Q9H112: 'CST11',
    Q9H115: 'NAPB',
    Q9H116: 'GZF1',
    Q9H147: 'DNTTIP1',
    Q9H156: 'SLITRK2',
    Q9H160: 'ING2',
    Q9H161: 'ALX4',
    Q9H165: 'BCL11A',
    Q9H169: 'STMN4',
    Q9H171: 'ZBP1',
    Q9H172: 'ABCG4',
    Q9H173: 'SIL1',
    Q9H190: 'SDCBP2',
    Q9H1A4: 'ANAPC1',
    Q9H1B4: 'NXF5',
    Q9H1B5: 'XYLT2',
    Q9H1B7: 'IRF2BPL',
    Q9H1C4: 'UNC93B1',
    Q9H1D0: 'TRPV6',
    Q9H1D9: 'POLR3F',
    Q9H1E1: 'RNASE7',
    Q9H1E3: 'NUCKS1',
    Q9H1H9: 'KIF13A',
    Q9H1I8: 'ASCC2',
    Q9H1J1: 'UPF3A',
    Q9H1J5: 'WNT8A',
    Q9H1J7: 'WNT5B',
    Q9H1K0: 'RBSN',
    Q9H1K1: 'ISCU',
    Q9H1K4: 'SLC25A18',
    Q9H1M4: 'DEFB127',
    Q9H1P3: 'OSBPL2',
    Q9H1P6: 'CIMIP1',
    Q9H1R2: 'DUSP15',
    Q9H1R3: 'MYLK2',
    Q9H1U9: 'SLC25A51',
    Q9H1V8: 'SLC6A17',
    Q9H1X1: 'RSPH9',
    Q9H1Y0: 'ATG5',
    Q9H1Y3: 'OPN3',
    Q9H1Z8: 'ECRG4',
    Q9H201: 'EPN3',
    Q9H204: 'MED28',
    Q9H211: 'CDT1',
    Q9H221: 'ABCG8',
    Q9H222: 'ABCG5',
    Q9H223: 'EHD4',
    Q9H227: 'GBA3',
    Q9H228: 'S1PR5',
    Q9H237: 'PORCN',
    Q9H239: 'MMP28',
    Q9H244: 'P2RY12',
    Q9H251: 'CDH23',
    Q9H252: 'KCNH6',
    Q9H254: 'SPTBN4',
    Q9H255: 'OR51E2',
    Q9H257: 'CARD9',
    Q9H267: 'VPS33B',
    Q9H269: 'VPS16',
    Q9H270: 'VPS11',
    Q9H293: 'IL25',
    Q9H295: 'DCSTAMP',
    Q9H2A2: 'ALDH8A1',
    Q9H2A7: 'CXCL16',
    Q9H2A9: 'CHST8',
    Q9H2B2: 'SYT4',
    Q9H2B4: 'SLC26A1',
    Q9H2C0: 'GAN',
    Q9H2C1: 'LHX5',
    Q9H2C2: 'ARV1',
    Q9H2D1: 'SLC25A32',
    Q9H2D6: 'TRIOBP',
    Q9H2E6: 'SEMA6A',
    Q9H2F3: 'HSD3B7',
    Q9H2F5: 'EPC1',
    Q9H2F9: 'CCDC68',
    Q9H2G2: 'SLK',
    Q9H2G4: 'TSPYL2',
    Q9H2G9: 'BLZF1',
    Q9H2H0: 'CXXC4',
    Q9H2H8: 'PPIL3',
    Q9H2H9: 'SLC38A1',
    Q9H2J4: 'PDCL3',
    Q9H2J7: 'SLC6A15',
    Q9H2K0: 'MTIF3',
    Q9H2K2: 'TNKS2',
    Q9H2K8: 'TAOK3',
    Q9H2L4: 'TMEM60',
    Q9H2L5: 'RASSF4',
    Q9H2M3: 'BHMT2',
    Q9H2M9: 'RAB3GAP2',
    Q9H2P0: 'ADNP',
    Q9H2R5: 'KLK15',
    Q9H2S1: 'KCNN2',
    Q9H2S5: 'RNF39',
    Q9H2S6: 'TNMD',
    Q9H2S9: 'IKZF4',
    Q9H2U1: 'DHX36',
    Q9H2U2: 'PPA2',
    Q9H2U9: 'ADAM7',
    Q9H2V7: 'SPNS1',
    Q9H2W1: 'MS4A6A',
    Q9H2W2: 'MIXL1',
    Q9H2X0: 'CHRD',
    Q9H2X3: 'CLEC4M',
    Q9H2X6: 'HIPK2',
    Q9H2X9: 'SLC12A5',
    Q9H2Y7: 'ZNF106',
    Q9H300: 'PARL',
    Q9H305: 'CDIP1',
    Q9H306: 'MMP27',
    Q9H307: 'PNN',
    Q9H310: 'RHBG',
    Q9H313: 'TTYH1',
    Q9H324: 'ADAMTS10',
    Q9H329: 'EPB41L4B',
    Q9H334: 'FOXP1',
    Q9H361: 'PABPC3',
    Q9H3D4: 'TP63',
    Q9H3F6: 'KCTD10',
    Q9H3H1: 'TRIT1',
    Q9H3H3: 'C11orf68',
    Q9H3H5: 'DPAGT1',
    Q9H3J6: 'MTRFR',
    Q9H3K2: 'GHITM',
    Q9H3K6: 'BOLA2',
    Q9H3K6: 'BOLA2B',
    Q9H3L0: 'MMADHC',
    Q9H3M0: 'KCNF1',
    Q9H3M7: 'TXNIP',
    Q9H3N1: 'TMX1',
    Q9H3N8: 'HRH4',
    Q9H3P2: 'NELFA',
    Q9H3P7: 'ACBD3',
    Q9H3Q1: 'CDC42EP4',
    Q9H3Q3: 'GAL3ST2',
    Q9H3R0: 'KDM4C',
    Q9H3R1: 'NDST4',
    Q9H3R2: 'MUC13',
    Q9H3R5: 'CENPH',
    Q9H3S1: 'SEMA4A',
    Q9H3S3: 'TMPRSS5',
    Q9H3S4: 'TPK1',
    Q9H3S7: 'PTPN23',
    Q9H3T2: 'SEMA6C',
    Q9H3T3: 'SEMA6B',
    Q9H3U1: 'UNC45A',
    Q9H3U5: 'MFSD1',
    Q9H3U7: 'SMOC2',
    Q9H3Y6: 'SRMS',
    Q9H3Z4: 'DNAJC5',
    Q9H400: 'LIME1',
    Q9H410: 'DSN1',
    Q9H422: 'HIPK3',
    Q9H427: 'KCNK15',
    Q9H444: 'CHMP4B',
    Q9H461: 'FZD8',
    Q9H467: 'CUEDC2',
    Q9H469: 'FBXL15',
    Q9H477: 'RBKS',
    Q9H479: 'FN3K',
    Q9H488: 'POFUT1',
    Q9H490: 'PIGU',
    Q9H492: 'MAP1LC3A',
    Q9H497: 'TOR3A',
    Q9H4A3: 'WNK1',
    Q9H4A5: 'GOLPH3L',
    Q9H4A6: 'GOLPH3',
    Q9H4A9: 'DPEP2',
    Q9H4B0: 'OSGEPL1',
    Q9H4B4: 'PLK3',
    Q9H4B6: 'SAV1',
    Q9H4B7: 'TUBB1',
    Q9H4D0: 'CLSTN2',
    Q9H4D5: 'NXF3',
    Q9H4E5: 'RHOJ',
    Q9H4E7: 'DEF6',
    Q9H4F1: 'ST6GALNAC4',
    Q9H4F8: 'SMOC1',
    Q9H4G0: 'EPB41L1',
    Q9H4G4: 'GLIPR2',
    Q9H4H8: 'FAM83D',
    Q9H4I2: 'ZHX3',
    Q9H4I9: 'SMDT1',
    Q9H4K7: 'MTG2',
    Q9H4L4: 'SENP3',
    Q9H4L5: 'OSBPL3',
    Q9H4L7: 'SMARCAD1',
    Q9H4M3: 'FBXO44',
    Q9H4M7: 'PLEKHA4',
    Q9H4M9: 'EHD1',
    Q9H4P4: 'RNF41',
    Q9H4Q4: 'PRDM12',
    Q9H4S2: 'GSX1',
    Q9H4T2: 'ZSCAN16',
    Q9H4W6: 'EBF3',
    Q9H4X1: 'RGCC',
    Q9H4Y5: 'GSTO2',
    Q9H4Z2: 'ZNF335',
    Q9H4Z3: 'PCIF1',
    Q9H503: 'BANF2',
    Q9H553: 'ALG2',
    Q9H582: 'ZNF644',
    Q9H583: 'HEATR1',
    Q9H596: 'DUSP21',
    Q9H598: 'SLC32A1',
    Q9H5F2: 'CFAP68',
    Q9H5H4: 'ZNF768',
    Q9H5I1: 'SUV39H2',
    Q9H5I5: 'PIEZO2',
    Q9H5J4: 'ELOVL6',
    Q9H5J8: 'TAF1D',
    Q9H5K3: 'POMK',
    Q9H5N1: 'RABEP2',
    Q9H5P4: 'PDZD7',
    Q9H5Q4: 'TFB2M',
    Q9H5U6: 'ZCCHC4',
    Q9H5V7: 'IKZF5',
    Q9H5V8: 'CDCP1',
    Q9H5V9: 'STEEP1',
    Q9H5X1: 'CIAO2A',
    Q9H5Y7: 'SLITRK6',
    Q9H5Z1: 'DHX35',
    Q9H5Z6: 'FAM124B',
    Q9H611: 'PIF1',
    Q9H633: 'RPP21',
    Q9H649: 'NSUN3',
    Q9H668: 'STN1',
    Q9H672: 'ASB7',
    Q9H694: 'BICC1',
    Q9H6B4: 'CLMP',
    Q9H6B9: 'EPHX3',
    Q9H6D3: 'XKR8',
    Q9H6D7: 'HAUS4',
    Q9H6E4: 'CCDC134',
    Q9H6E5: 'TUT1',
    Q9H6H4: 'REEP4',
    Q9H6I2: 'SOX17',
    Q9H6J7: 'CSTPP1',
    Q9H6K1: 'ILRUN',
    Q9H6L2: 'TMEM231',
    Q9H6L4: 'ARMC7',
    Q9H6L5: 'RETREG1',
    Q9H6P5: 'TASP1',
    Q9H6Q3: 'SLA2',
    Q9H6Q4: 'CIAO3',
    Q9H6R0: 'DHX33',
    Q9H6R3: 'ACSS3',
    Q9H6R4: 'NOL6',
    Q9H6R6: 'ZDHHC6',
    Q9H6R7: 'WDCP',
    Q9H6S0: 'YTHDC2',
    Q9H6S1: 'AZI2',
    Q9H6S3: 'EPS8L2',
    Q9H6T0: 'ESRP2',
    Q9H6T3: 'RPAP3',
    Q9H6U6: 'BCAS3',
    Q9H6U8: 'ALG9',
    Q9H6W3: 'RIOX1',
    Q9H6X2: 'ANTXR1',
    Q9H6Y7: 'RNF167',
    Q9H6Z4: 'RANBP3',
    Q9H6Z9: 'EGLN3',
    Q9H706: 'GAREM1',
    Q9H707: 'ZNF552',
    Q9H714: 'RUBCNL',
    Q9H741: 'SPRING1',
    Q9H772: 'GREM2',
    Q9H773: 'DCTPP1',
    Q9H777: 'ELAC1',
    Q9H788: 'SH2D4A',
    Q9H790: 'EXO5',
    Q9H792: 'PEAK1',
    Q9H799: 'CPLANE1',
    Q9H7B2: 'RPF2',
    Q9H7B4: 'SMYD3',
    Q9H7C4: 'SYNC',
    Q9H7D0: 'DOCK5',
    Q9H7D7: 'WDR26',
    Q9H7E2: 'TDRD3',
    Q9H7E9: 'C8orf33',
    Q9H7F0: 'ATP13A3',
    Q9H7H0: 'METTL17',
    Q9H7L9: 'SUDS3',
    Q9H7M9: 'VSIR',
    Q9H7N4: 'SCAF1',
    Q9H7P6: 'MVB12B',
    Q9H7P9: 'PLEKHG2',
    Q9H7S9: 'ZNF703',
    Q9H7T9: 'AUNIP',
    Q9H7V2: 'SYNDIG1',
    Q9H7X0: 'NAA60',
    Q9H7X3: 'ZNF696',
    Q9H7Z3: 'NRDE2',
    Q9H7Z6: 'KAT8',
    Q9H7Z7: 'PTGES2',
    Q9H808: 'TLE6',
    Q9H813: 'PACC1',
    Q9H814: 'PHAX',
    Q9H816: 'DCLRE1B',
    Q9H825: 'METTL8',
    Q9H832: 'UBE2Z',
    Q9H840: 'GEMIN7',
    Q9H845: 'ACAD9',
    Q9H867: 'VCPKMT',
    Q9H869: 'YY1AP1',
    Q9H871: 'RMND5A',
    Q9H875: 'PRKRIP1',
    Q9H892: 'TTC12',
    Q9H8E8: 'KAT14',
    Q9H8H2: 'DDX31',
    Q9H8H3: 'TMT1A',
    Q9H8K7: 'PAAT',
    Q9H8L6: 'MMRN2',
    Q9H8M2: 'BRD9',
    Q9H8M5: 'CNNM2',
    Q9H8M7: 'MINDY3',
    Q9H8M9: 'EVA1A',
    Q9H8N7: 'ZNF395',
    Q9H8P0: 'SRD5A3',
    Q9H8S9: 'MOB1A',
    Q9H8T0: 'AKTIP',
    Q9H8V3: 'ECT2',
    Q9H8W4: 'PLEKHF2',
    Q9H8W5: 'TRIM45',
    Q9H8X2: 'IPPK',
    Q9H8X9: 'ZDHHC11',
    Q9H8Y5: 'ANKZF1',
    Q9H8Y8: 'GORASP2',
    Q9H900: 'ZWILCH',
    Q9H902: 'REEP1',
    Q9H903: 'MTHFD2L',
    Q9H910: 'JPT2',
    Q9H936: 'SLC25A22',
    Q9H944: 'MED20',
    Q9H974: 'QTRT2',
    Q9H977: 'WDR54',
    Q9H981: 'ACTR8',
    Q9H987: 'SYNPO2L',
    Q9H992: 'MARCHF7',
    Q9H993: 'ARMT1',
    Q9H999: 'PANK3',
    Q9H9A5: 'CNOT10',
    Q9H9A7: 'RMI1',
    Q9H9B1: 'EHMT1',
    Q9H9B4: 'SFXN1',
    Q9H9C1: 'VIPAS39',
    Q9H9D4: 'ZNF408',
    Q9H9E1: 'ANKRA2',
    Q9H9E3: 'COG4',
    Q9H9F9: 'ACTR5',
    Q9H9G7: 'AGO3',
    Q9H9H4: 'VPS37B',
    Q9H9J2: 'MRPL44',
    Q9H9J4: 'USP42',
    Q9H9K5: 'ERVMER34-1',
    Q9H9L4: 'KANSL2',
    Q9H9L7: 'AKIRIN1',
    Q9H9P2: 'CHODL',
    Q9H9P5: 'UNKL',
    Q9H9P8: 'L2HGDH',
    Q9H9Q2: 'COPS7B',
    Q9H9Q4: 'NHEJ1',
    Q9H9S0: 'NANOG',
    Q9H9S5: 'FKRP',
    Q9H9T3: 'ELP3',
    Q9H9V4: 'RNF122',
    Q9H9V9: 'JMJD4',
    Q9H9Y6: 'POLR1B',
    Q9H9Z2: 'LIN28A',
    Q9HA38: 'ZMAT3',
    Q9HA47: 'UCK1',
    Q9HA65: 'TBC1D17',
    Q9HA82: 'CERS4',
    Q9HAB3: 'SLC52A2',
    Q9HAB8: 'PPCS',
    Q9HAC7: 'SUGCT',
    Q9HAC8: 'UBTD1',
    Q9HAD4: 'WDR41',
    Q9HAF1: 'MEAF6',
    Q9HAI6: 'TASL',
    Q9HAJ7: 'SAP30L',
    Q9HAK2: 'EBF2',
    Q9HAN9: 'NMNAT1',
    Q9HAP2: 'MLXIP',
    Q9HAP6: 'LIN7B',
    Q9HAQ2: 'KIF9',
    Q9HAR2: 'ADGRL3',
    Q9HAS3: 'SLC28A3',
    Q9HAT0: 'ROPN1',
    Q9HAT2: 'SIAE',
    Q9HAT8: 'PELI2',
    Q9HAU0: 'PLEKHA5',
    Q9HAU4: 'SMURF2',
    Q9HAU5: 'UPF2',
    Q9HAU8: 'RNPEPL1',
    Q9HAV0: 'GNB4',
    Q9HAV4: 'XPO5',
    Q9HAV5: 'EDA2R',
    Q9HAV7: 'GRPEL1',
    Q9HAW0: 'BRF2',
    Q9HAW4: 'CLSPN',
    Q9HAW7: 'UGT1A7',
    Q9HAW8: 'UGT1A10',
    Q9HAW9: 'UGT1A8',
    Q9HAY6: 'BCO1',
    Q9HAZ1: 'CLK4',
    Q9HAZ2: 'PRDM16',
    Q9HB03: 'ELOVL3',
    Q9HB07: 'MYG1',
    Q9HB19: 'PLEKHA2',
    Q9HB20: 'PLEKHA3',
    Q9HB21: 'PLEKHA1',
    Q9HB29: 'IL1RL2',
    Q9HB55: 'CYP3A43',
    Q9HB58: 'SP110',
    Q9HB63: 'NTN4',
    Q9HB65: 'ELL3',
    Q9HB71: 'CACYBP',
    Q9HB75: 'PIDD1',
    Q9HB89: 'NMUR1',
    Q9HB90: 'RRAGC',
    Q9HB96: 'FANCE',
    Q9HBA0: 'TRPV4',
    Q9HBB8: 'CDHR5',
    Q9HBD1: 'RC3H2',
    Q9HBE1: 'PATZ1',
    Q9HBE4: 'IL21',
    Q9HBE5: 'IL21R',
    Q9HBF4: 'ZFYVE1',
    Q9HBG4: 'ATP6V0A4',
    Q9HBG6: 'IFT122',
    Q9HBG7: 'LY9',
    Q9HBH0: 'RHOF',
    Q9HBH1: 'PDF',
    Q9HBH5: 'RDH14',
    Q9HBH7: 'BEX1',
    Q9HBH9: 'MKNK2',
    Q9HBI0: 'PARVG',
    Q9HBI1: 'PARVB',
    Q9HBI6: 'CYP4F11',
    Q9HBJ7: 'USP29',
    Q9HBJ8: 'CLTRN',
    Q9HBK9: 'AS3MT',
    Q9HBL0: 'TNS1',
    Q9HBL8: 'NMRAL1',
    Q9HBM0: 'VEZT',
    Q9HBM1: 'SPC25',
    Q9HBM6: 'TAF9B',
    Q9HBT6: 'CDH20',
    Q9HBT8: 'ZNF286A',
    Q9HBU1: 'BARX1',
    Q9HBU6: 'ETNK1',
    Q9HBV2: 'SPACA1',
    Q9HBW0: 'LPAR2',
    Q9HBW1: 'LRRC4',
    Q9HBW9: 'ADGRL4',
    Q9HBX8: 'LGR6',
    Q9HBX9: 'RXFP1',
    Q9HBY0: 'NOX3',
    Q9HBY8: 'SGK2',
    Q9HBZ2: 'ARNT2',
    Q9HC07: 'TMEM165',
    Q9HC10: 'OTOF',
    Q9HC16: 'APOBEC3G',
    Q9HC21: 'SLC25A19',
    Q9HC23: 'PROK2',
    Q9HC24: 'TMBIM4',
    Q9HC29: 'NOD2',
    Q9HC35: 'EML4',
    Q9HC36: 'MRM3',
    Q9HC52: 'CBX8',
    Q9HC58: 'SLC24A3',
    Q9HC62: 'SENP2',
    Q9HC73: 'CRLF2',
    Q9HC77: 'CENPJ',
    Q9HC78: 'ZBTB20',
    Q9HC84: 'MUC5B',
    Q9HC96: 'CAPN10',
    Q9HC97: 'GPR35',
    Q9HC98: 'NEK6',
    Q9HCB6: 'SPON1',
    Q9HCC0: 'MCCC2',
    Q9HCC8: 'GDPD2',
    Q9HCC9: 'ZFYVE28',
    Q9HCD5: 'NCOA5',
    Q9HCD6: 'TANC2',
    Q9HCE0: 'EPG5',
    Q9HCE1: 'MOV10',
    Q9HCE5: 'METTL14',
    Q9HCE6: 'ARHGEF10L',
    Q9HCE7: 'SMURF1',
    Q9HCE9: 'ANO8',
    Q9HCF6: 'TRPM3',
    Q9HCG7: 'GBA2',
    Q9HCG8: 'CWC22',
    Q9HCH0: 'NCKAP5L',
    Q9HCH3: 'CPNE5',
    Q9HCH5: 'SYTL2',
    Q9HCI5: 'MAGEE1',
    Q9HCI7: 'MSL2',
    Q9HCJ0: 'TNRC6C',
    Q9HCJ1: 'ANKH',
    Q9HCJ2: 'LRRC4C',
    Q9HCK0: 'ZBTB26',
    Q9HCK4: 'ROBO2',
    Q9HCK5: 'AGO4',
    Q9HCK8: 'CHD8',
    Q9HCL2: 'GPAM',
    Q9HCM1: 'RESF1',
    Q9HCM2: 'PLXNA4',
    Q9HCM3: 'KIAA1549',
    Q9HCM4: 'EPB41L5',
    Q9HCM9: 'TRIM39',
    Q9HCN3: 'PGAP6',
    Q9HCN4: 'GPN1',
    Q9HCN6: 'GP6',
    Q9HCP0: 'CSNK1G1',
    Q9HCP6: 'HHATL',
    Q9HCQ5: 'GALNT9',
    Q9HCQ7: 'NPVF',
    Q9HCR9: 'PDE11A',
    Q9HCS2: 'CYP4F12',
    Q9HCS4: 'TCF7L1',
    Q9HCS7: 'XAB2',
    Q9HCU0: 'CD248',
    Q9HCU4: 'CELSR2',
    Q9HCU5: 'PREB',
    Q9HCU8: 'POLD4',
    Q9HCU9: 'BRMS1',
    Q9HCX3: 'ZNF304',
    Q9HCX4: 'TRPC7',
    Q9HCY8: 'S100A14',
    Q9HD15: 'SRA1',
    Q9HD20: 'ATP13A1',
    Q9HD23: 'MRS2',
    Q9HD26: 'GOPC',
    Q9HD34: 'LYRM4',
    Q9HD36: 'BCL2L10',
    Q9HD40: 'SEPSECS',
    Q9HD42: 'CHMP1A',
    Q9HD43: 'PTPRH',
    Q9HD47: 'RANGRF',
    Q9HD67: 'MYO10',
    Q9HD89: 'RETN',
    Q9HD90: 'NEUROD4',
    Q9HDB5: 'NRXN3',
    Q9HDC5: 'JPH1',
    Q9HDC9: 'APMAP',
    Q9HDD0: 'PLAAT1',
    Q9NNW5: 'WDR6',
    Q9NNW7: 'TXNRD2',
    Q9NNX6: 'CD209',
    Q9NP31: 'SH2D2A',
    Q9NP50: 'SINHCAF',
    Q9NP55: 'BPIFA1',
    Q9NP56: 'PDE7B',
    Q9NP58: 'ABCB6',
    Q9NP59: 'SLC40A1',
    Q9NP60: 'IL1RAPL2',
    Q9NP61: 'ARFGAP3',
    Q9NP62: 'GCM1',
    Q9NP64: 'ZCCHC17',
    Q9NP66: 'HMG20A',
    Q9NP70: 'AMBN',
    Q9NP71: 'MLXIPL',
    Q9NP72: 'RAB18',
    Q9NP73: 'ALG13',
    Q9NP74: 'PALMD',
    Q9NP77: 'SSU72',
    Q9NP78: 'ABCB9',
    Q9NP79: 'VTA1',
    Q9NP80: 'PNPLA8',
    Q9NP81: 'SARS2',
    Q9NP84: 'TNFRSF12A',
    Q9NP85: 'NPHS2',
    Q9NP86: 'CABP5',
    Q9NP87: 'POLM',
    Q9NP90: 'RAB9B',
    Q9NP91: 'SLC6A20',
    Q9NP94: 'SLC39A2',
    Q9NP95: 'FGF20',
    Q9NP97: 'DYNLRB1',
    Q9NP98: 'MYOZ1',
    Q9NP99: 'TREM1',
    Q9NPA0: 'EMC7',
    Q9NPA1: 'KCNMB3',
    Q9NPA2: 'MMP25',
    Q9NPA8: 'ENY2',
    Q9NPB1: 'NT5M',
    Q9NPB3: 'CABP2',
    Q9NPB6: 'PARD6A',
    Q9NPB9: 'ACKR4',
    Q9NPC1: 'LTB4R2',
    Q9NPC2: 'KCNK9',
    Q9NPC3: 'CCNB1IP1',
    Q9NPC4: 'A4GALT',
    Q9NPC6: 'MYOZ2',
    Q9NPC7: 'MYNN',
    Q9NPC8: 'SIX2',
    Q9NPD3: 'EXOSC4',
    Q9NPD5: 'SLCO1B3',
    Q9NPD8: 'UBE2T',
    Q9NPE2: 'NGRN',
    Q9NPE3: 'NOP10',
    Q9NPE6: 'SPAG4',
    Q9NPF0: 'CD320',
    Q9NPF2: 'CHST11',
    Q9NPF4: 'OSGEP',
    Q9NPF5: 'DMAP1',
    Q9NPF7: 'IL23A',
    Q9NPF8: 'ADAP2',
    Q9NPG1: 'FZD3',
    Q9NPG2: 'NGB',
    Q9NPG3: 'UBN1',
    Q9NPG4: 'PCDH12',
    Q9NPG8: 'ZDHHC4',
    Q9NPH0: 'ACP6',
    Q9NPH2: 'ISYNA1',
    Q9NPH3: 'IL1RAP',
    Q9NPH5: 'NOX4',
    Q9NPH9: 'IL26',
    Q9NPI0: 'TMEM138',
    Q9NPI1: 'BRD7',
    Q9NPI5: 'NMRK2',
    Q9NPI6: 'DCP1A',
    Q9NPI8: 'FANCF',
    Q9NPI9: 'KCNJ16',
    Q9NPJ1: 'MKKS',
    Q9NPJ3: 'ACOT13',
    Q9NPJ4: 'PNRC2',
    Q9NPJ6: 'MED4',
    Q9NPJ8: 'NXT2',
    Q9NPL8: 'TIMMDC1',
    Q9NPP4: 'NLRC4',
    Q9NPQ8: 'RIC8A',
    Q9NPR2: 'SEMA4B',
    Q9NPR9: 'GPR108',
    Q9NPY3: 'CD93',
    Q9NPZ5: 'B3GAT2',
    Q9NQ11: 'ATP13A2',
    Q9NQ25: 'SLAMF7',
    Q9NQ29: 'LUC7L',
    Q9NQ30: 'ESM1',
    Q9NQ31: 'AKIP1',
    Q9NQ36: 'SCUBE2',
    Q9NQ38: 'SPINK5',
    Q9NQ40: 'SLC52A3',
    Q9NQ48: 'LZTFL1',
    Q9NQ50: 'MRPL40',
    Q9NQ55: 'PPAN',
    Q9NQ66: 'PLCB1',
    Q9NQ69: 'LHX9',
    Q9NQ75: 'CASS4',
    Q9NQ76: 'MEPE',
    Q9NQ79: 'CRTAC1',
    Q9NQ84: 'GPRC5C',
    Q9NQ86: 'TRIM36',
    Q9NQ87: 'HEYL',
    Q9NQ88: 'TIGAR',
    Q9NQ90: 'ANO2',
    Q9NQ92: 'COPRS',
    Q9NQ94: 'A1CF',
    Q9NQA3: 'WASH6P',
    Q9NQA5: 'TRPV5',
    Q9NQB0: 'TCF7L2',
    Q9NQC1: 'JADE2',
    Q9NQC3: 'RTN4',
    Q9NQC7: 'CYLD',
    Q9NQC8: 'IFT46',
    Q9NQE9: 'HINT3',
    Q9NQG1: 'MANBAL',
    Q9NQG5: 'RPRD1B',
    Q9NQG6: 'MIEF1',
    Q9NQG7: 'HPS4',
    Q9NQH7: 'XPNPEP3',
    Q9NQI0: 'DDX4',
    Q9NQL2: 'RRAGD',
    Q9NQL9: 'DMRT3',
    Q9NQM4: 'DNAAF6',
    Q9NQP4: 'PFDN4',
    Q9NQQ7: 'SLC35C2',
    Q9NQR1: 'KMT5A',
    Q9NQR4: 'NIT2',
    Q9NQR9: 'G6PC2',
    Q9NQS3: 'NECTIN3',
    Q9NQS5: 'GPR84',
    Q9NQS7: 'INCENP',
    Q9NQT4: 'EXOSC5',
    Q9NQT5: 'EXOSC3',
    Q9NQT8: 'KIF13B',
    Q9NQU5: 'PAK6',
    Q9NQV5: 'PRDM11',
    Q9NQV6: 'PRDM10',
    Q9NQV7: 'PRDM9',
    Q9NQV8: 'PRDM8',
    Q9NQW1: 'SEC31B',
    Q9NQW5: 'PRDM7',
    Q9NQW6: 'ANLN',
    Q9NQW7: 'XPNPEP1',
    Q9NQW8: 'CNGB3',
    Q9NQX0: 'PRDM6',
    Q9NQX1: 'PRDM5',
    Q9NQX3: 'GPHN',
    Q9NQX4: 'MYO5C',
    Q9NQX5: 'NPDC1',
    Q9NQX7: 'ITM2C',
    Q9NQY0: 'BIN3',
    Q9NQZ2: 'UTP3',
    Q9NQZ3: 'DAZ1',
    Q9NQZ6: 'ZC4H2',
    Q9NQZ7: 'ENTPD7',
    Q9NQZ8: 'ZNF71',
    Q9NR00: 'TCIM',
    Q9NR09: 'BIRC6',
    Q9NR11: 'ZNF302',
    Q9NR12: 'PDLIM7',
    Q9NR16: 'CD163L1',
    Q9NR19: 'ACSS2',
    Q9NR20: 'DYRK4',
    Q9NR21: 'PARP11',
    Q9NR22: 'PRMT8',
    Q9NR23: 'GDF3',
    Q9NR28: 'DIABLO',
    Q9NR30: 'DDX21',
    Q9NR31: 'SAR1A',
    Q9NR33: 'POLE4',
    Q9NR34: 'MAN1C1',
    Q9NR45: 'NANS',
    Q9NR46: 'SH3GLB2',
    Q9NR48: 'ASH1L',
    Q9NR50: 'EIF2B3',
    Q9NR55: 'BATF3',
    Q9NR56: 'MBNL1',
    Q9NR61: 'DLL4',
    Q9NR63: 'CYP26B1',
    Q9NR71: 'ASAH2',
    Q9NR77: 'PXMP2',
    Q9NR80: 'ARHGEF4',
    Q9NR81: 'ARHGEF3',
    Q9NR82: 'KCNQ5',
    Q9NR83: 'SLC2A4RG',
    Q9NR90: 'DAZ3',
    Q9NR96: 'TLR9',
    Q9NR97: 'TLR8',
    Q9NR99: 'MXRA5',
    Q9NRA0: 'SPHK2',
    Q9NRA1: 'PDGFC',
    Q9NRA2: 'SLC17A5',
    Q9NRA8: 'EIF4ENIF1',
    Q9NRB3: 'CHST12',
    Q9NRC1: 'ST7',
    Q9NRC6: 'SPTBN5',
    Q9NRC8: 'SIRT7',
    Q9NRD1: 'FBXO6',
    Q9NRD5: 'PICK1',
    Q9NRD8: 'DUOX2',
    Q9NRD9: 'DUOX1',
    Q9NRE1: 'MMP26',
    Q9NRE2: 'TSHZ2',
    Q9NRF2: 'SH2B1',
    Q9NRF8: 'CTPS2',
    Q9NRF9: 'POLE3',
    Q9NRG0: 'CHRAC1',
    Q9NRG1: 'PRTFDC1',
    Q9NRG4: 'SMYD2',
    Q9NRG9: 'AAAS',
    Q9NRH2: 'SNRK',
    Q9NRH3: 'TUBG2',
    Q9NRI5: 'DISC1',
    Q9NRJ3: 'CCL28',
    Q9NRJ4: 'TULP4',
    Q9NRJ7: 'PCDHB16',
    Q9NRK6: 'ABCB10',
    Q9NRL2: 'BAZ1A',
    Q9NRL3: 'STRN4',
    Q9NRM0: 'SLC2A9',
    Q9NRM1: 'ENAM',
    Q9NRM6: 'IL17RB',
    Q9NRM7: 'LATS2',
    Q9NRN7: 'AASDHPPT',
    Q9NRN9: 'METTL5',
    Q9NRP0: 'OSTC',
    Q9NRP7: 'STK36',
    Q9NRQ2: 'PLSCR4',
    Q9NRQ5: 'SMCO4',
    Q9NRR2: 'TPSG1',
    Q9NRR3: 'CDC42SE2',
    Q9NRR4: 'DROSHA',
    Q9NRR5: 'UBQLN4',
    Q9NRR6: 'INPP5E',
    Q9NRR8: 'CDC42SE1',
    Q9NRS4: 'TMPRSS4',
    Q9NRS6: 'SNX15',
    Q9NRW1: 'RAB6B',
    Q9NRW3: 'APOBEC3C',
    Q9NRW4: 'DUSP22',
    Q9NRW7: 'VPS45',
    Q9NRX2: 'MRPL17',
    Q9NRX4: 'PHPT1',
    Q9NRX5: 'SERINC1',
    Q9NRX6: 'TMEM167B',
    Q9NRY2: 'INIP',
    Q9NRY4: 'ARHGAP35',
    Q9NRY6: 'PLSCR3',
    Q9NRY7: 'PLSCR2',
    Q9NRZ5: 'AGPAT4',
    Q9NRZ7: 'AGPAT3',
    Q9NRZ9: 'HELLS',
    Q9NS00: 'C1GALT1',
    Q9NS15: 'LTBP3',
    Q9NS18: 'GLRX2',
    Q9NS23: 'RASSF1',
    Q9NS37: 'CREBZF',
    Q9NS39: 'ADARB2',
    Q9NS40: 'KCNH7',
    Q9NS56: 'TOPORS',
    Q9NS61: 'KCNIP2',
    Q9NS62: 'THSD1',
    Q9NS64: 'RPRM',
    Q9NS68: 'TNFRSF19',
    Q9NS69: 'TOMM22',
    Q9NS71: 'GKN1',
    Q9NS73: 'MBIP',
    Q9NS75: 'CYSLTR2',
    Q9NS82: 'SLC7A10',
    Q9NS84: 'CHST7',
    Q9NS86: 'LANCL2',
    Q9NS87: 'KIF15',
    Q9NS91: 'RAD18',
    Q9NSA0: 'SLC22A11',
    Q9NSA1: 'FGF21',
    Q9NSA2: 'KCND1',
    Q9NSA3: 'CTNNBIP1',
    Q9NSB2: 'KRT84',
    Q9NSB4: 'KRT82',
    Q9NSB8: 'HOMER2',
    Q9NSC2: 'SALL1',
    Q9NSC5: 'HOMER3',
    Q9NSC7: 'ST6GALNAC1',
    Q9NSD4: 'ZNF275',
    Q9NSD5: 'SLC6A13',
    Q9NSD7: 'RXFP3',
    Q9NSD9: 'FARSB',
    Q9NSE2: 'CISH',
    Q9NSE4: 'IARS2',
    Q9NSI6: 'BRWD1',
    Q9NSI8: 'SAMSN1',
    Q9NSK0: 'KLC4',
    Q9NSK7: 'C19orf12',
    Q9NSN8: 'SNTG1',
    Q9NST1: 'PNPLA3',
    Q9NSU2: 'TREX1',
    Q9NSV4: 'DIAPH3',
    Q9NSY1: 'BMP2K',
    Q9NT22: 'EMILIN3',
    Q9NT62: 'ATG3',
    Q9NT68: 'TENM2',
    Q9NT99: 'LRRC4B',
    Q9NTG1: 'PKDREJ',
    Q9NTG7: 'SIRT3',
    Q9NTI2: 'ATP8A2',
    Q9NTI5: 'PDS5B',
    Q9NTJ3: 'SMC4',
    Q9NTJ4: 'MAN2C1',
    Q9NTJ5: 'SACM1L',
    Q9NTK1: 'DEPP1',
    Q9NTK5: 'OLA1',
    Q9NTM9: 'CUTC',
    Q9NTN3: 'SLC35D1',
    Q9NTN9: 'SEMA4G',
    Q9NTQ9: 'GJB4',
    Q9NTW7: 'ZFP64',
    Q9NTX7: 'RNF146',
    Q9NTX9: 'FAM217B',
    Q9NU19: 'TBC1D22B',
    Q9NU22: 'MDN1',
    Q9NU39: 'FOXD4L1',
    Q9NU63: 'ZFP57',
    Q9NUB1: 'ACSS1',
    Q9NUD5: 'ZCCHC3',
    Q9NUD9: 'PIGV',
    Q9NUE0: 'ZDHHC18',
    Q9NUH8: 'TMEM14B',
    Q9NUI1: 'DECR2',
    Q9NUJ1: 'ABHD10',
    Q9NUJ3: 'TCP11L1',
    Q9NUK0: 'MBNL3',
    Q9NUL3: 'STAU2',
    Q9NUL5: 'SHFL',
    Q9NUL7: 'DDX28',
    Q9NUM3: 'SLC39A9',
    Q9NUM4: 'TMEM106B',
    Q9NUN5: 'LMBRD1',
    Q9NUN7: 'ACER3',
    Q9NUP9: 'LIN7C',
    Q9NUQ2: 'AGPAT5',
    Q9NUQ3: 'TXLNG',
    Q9NUQ7: 'UFSP2',
    Q9NUQ9: 'CYRIB',
    Q9NUS5: 'AP5S1',
    Q9NUT2: 'ABCB8',
    Q9NUU6: 'OTULINL',
    Q9NUU7: 'DDX19A',
    Q9NUV7: 'SPTLC3',
    Q9NUV9: 'GIMAP4',
    Q9NUW8: 'TDP1',
    Q9NUX5: 'POT1',
    Q9NUY8: 'TBC1D23',
    Q9NV06: 'DCAF13',
    Q9NV12: 'TMEM140',
    Q9NV23: 'OLAH',
    Q9NV29: 'TMEM100',
    Q9NV31: 'IMP3',
    Q9NV35: 'NUDT15',
    Q9NV56: 'MRGBP',
    Q9NV58: 'RNF19A',
    Q9NV64: 'TMEM39A',
    Q9NV70: 'EXOC1',
    Q9NV79: 'PCMTD2',
    Q9NV88: 'INTS9',
    Q9NV92: 'NDFIP2',
    Q9NV96: 'TMEM30A',
    Q9NVA1: 'UQCC1',
    Q9NVA2: 'SEPTIN11',
    Q9NVC3: 'SLC38A7',
    Q9NVC6: 'MED17',
    Q9NVD3: 'SETD4',
    Q9NVD7: 'PARVA',
    Q9NVE5: 'USP40',
    Q9NVE7: 'PANK4',
    Q9NVF7: 'FBXO28',
    Q9NVF9: 'ETNK2',
    Q9NVH0: 'EXD2',
    Q9NVH1: 'DNAJC11',
    Q9NVH2: 'INTS7',
    Q9NVH6: 'TMLHE',
    Q9NVI1: 'FANCI',
    Q9NVI7: 'ATAD3A',
    Q9NVJ2: 'ARL8B',
    Q9NVL1: 'FAM86C1P',
    Q9NVM4: 'PRMT7',
    Q9NVM9: 'INTS13',
    Q9NVN3: 'RIC8B',
    Q9NVN8: 'GNL3L',
    Q9NVP1: 'DDX18',
    Q9NVP2: 'ASF1B',
    Q9NVR2: 'INTS10',
    Q9NVR5: 'DNAAF2',
    Q9NVS9: 'PNPO',
    Q9NVT9: 'ARMC1',
    Q9NVU0: 'POLR3E',
    Q9NVU7: 'SDAD1',
    Q9NVV0: 'TMEM38B',
    Q9NVV4: 'MTPAP',
    Q9NVV5: 'AIG1',
    Q9NVV9: 'THAP1',
    Q9NVW2: 'RLIM',
    Q9NVX0: 'HAUS2',
    Q9NVX2: 'NLE1',
    Q9NW08: 'POLR3B',
    Q9NW13: 'RBM28',
    Q9NW15: 'ANO10',
    Q9NW38: 'FANCL',
    Q9NW64: 'RBM22',
    Q9NW75: 'GPATCH2',
    Q9NW81: 'DMAC2',
    Q9NW97: 'TMEM51',
    Q9NWA0: 'MED9',
    Q9NWB1: 'RBFOX1',
    Q9NWB7: 'IFT57',
    Q9NWD8: 'TMEM248',
    Q9NWD9: 'BEX4',
    Q9NWF4: 'SLC52A1',
    Q9NWF9: 'RNF216',
    Q9NWH2: 'TMEM242',
    Q9NWH9: 'SLTM',
    Q9NWK9: 'ZNHIT6',
    Q9NWM0: 'SMOX',
    Q9NWM8: 'FKBP14',
    Q9NWN3: 'FBXO34',
    Q9NWQ4: 'GPATCH2L',
    Q9NWQ8: 'PAG1',
    Q9NWQ9: 'C14orf119',
    Q9NWR8: 'MCUB',
    Q9NWS0: 'PIH1D1',
    Q9NWS1: 'PARPBP',
    Q9NWS6: 'FAM118A',
    Q9NWS8: 'RMND1',
    Q9NWS9: 'ZNF446',
    Q9NWT1: 'PAK1IP1',
    Q9NWT6: 'HIF1AN',
    Q9NWT8: 'AURKAIP1',
    Q9NWU1: 'OXSM',
    Q9NWU2: 'GID8',
    Q9NWU5: 'MRPL22',
    Q9NWV8: 'BABAM1',
    Q9NWW5: 'CLN6',
    Q9NWW6: 'NMRK1',
    Q9NWW9: 'PLAAT2',
    Q9NWX5: 'ASB6',
    Q9NWX6: 'THG1L',
    Q9NWY4: 'HPF1',
    Q9NWZ3: 'IRAK4',
    Q9NWZ5: 'UCKL1',
    Q9NWZ8: 'GEMIN8',
    Q9NX01: 'TXNL4B',
    Q9NX02: 'NLRP2',
    Q9NX04: 'AIRIM',
    Q9NX07: 'TRNAU1AP',
    Q9NX09: 'DDIT4',
    Q9NX14: 'NDUFB11',
    Q9NX18: 'SDHAF2',
    Q9NX24: 'NHP2',
    Q9NX40: 'OCIAD1',
    Q9NX46: 'ADPRS',
    Q9NX47: 'MARCHF5',
    Q9NX52: 'RHBDL2',
    Q9NX55: 'HYPK',
    Q9NX57: 'RAB20',
    Q9NX58: 'LYAR',
    Q9NX61: 'TMEM161A',
    Q9NX62: 'BPNT2',
    Q9NX63: 'CHCHD3',
    Q9NX65: 'ZSCAN32',
    Q9NX70: 'MED29',
    Q9NX74: 'DUS2',
    Q9NX76: 'CMTM6',
    Q9NX94: 'WBP1L',
    Q9NX95: 'SYBU',
    Q9NXA8: 'SIRT5',
    Q9NXB0: 'MKS1',
    Q9NXB9: 'ELOVL2',
    Q9NXC2: 'GFOD1',
    Q9NXC5: 'MIOS',
    Q9NXE4: 'SMPD4',
    Q9NXE8: 'CWC25',
    Q9NXF8: 'ZDHHC7',
    Q9NXG0: 'CNTLN',
    Q9NXG6: 'P4HTM',
    Q9NXH9: 'TRMT1',
    Q9NXI6: 'RNF186',
    Q9NXJ5: 'PGPEP1',
    Q9NXK8: 'FBXL12',
    Q9NXL9: 'MCM9',
    Q9NXR1: 'NDE1',
    Q9NXR5: 'ANKRD10',
    Q9NXR7: 'BABAM2',
    Q9NXR8: 'ING3',
    Q9NXS2: 'QPCTL',
    Q9NXV2: 'KCTD5',
    Q9NXV6: 'CDKN2AIP',
    Q9NXW2: 'DNAJB12',
    Q9NXW9: 'ALKBH4',
    Q9NXX6: 'NSMCE4A',
    Q9NY12: 'GAR1',
    Q9NY15: 'STAB1',
    Q9NY25: 'CLEC5A',
    Q9NY26: 'SLC39A1',
    Q9NY27: 'PPP4R2',
    Q9NY28: 'GALNT8',
    Q9NY30: 'BTG4',
    Q9NY33: 'DPP3',
    Q9NY46: 'SCN3A',
    Q9NY47: 'CACNA2D2',
    Q9NY56: 'OBP2A',
    Q9NY59: 'SMPD3',
    Q9NY61: 'AATF',
    Q9NY64: 'SLC2A8',
    Q9NY65: 'TUBA8',
    Q9NY72: 'SCN3B',
    Q9NY74: 'ETAA1',
    Q9NY91: 'SLC5A4',
    Q9NY93: 'DDX56',
    Q9NY97: 'B3GNT2',
    Q9NY99: 'SNTG2',
    Q9NYA1: 'SPHK1',
    Q9NYA3: 'GOLGA6A',
    Q9NYA4: 'MTMR4',
    Q9NYB0: 'TERF2IP',
    Q9NYB5: 'SLCO1C1',
    Q9NYB9: 'ABI2',
    Q9NYC9: 'DNAH9',
    Q9NYD6: 'HOXC10',
    Q9NYF0: 'DACT1',
    Q9NYF8: 'BCLAF1',
    Q9NYG2: 'ZDHHC3',
    Q9NYG5: 'ANAPC11',
    Q9NYG8: 'KCNK4',
    Q9NYH9: 'UTP6',
    Q9NYI0: 'PSD3',
    Q9NYJ7: 'DLL3',
    Q9NYJ8: 'TAB2',
    Q9NYK1: 'TLR7',
    Q9NYK5: 'MRPL39',
    Q9NYK6: 'EURL',
    Q9NYL2: 'MAP3K20',
    Q9NYL5: 'CYP39A1',
    Q9NYM4: 'GPR83',
    Q9NYP3: 'DONSON',
    Q9NYP7: 'ELOVL5',
    Q9NYP9: 'MIS18A',
    Q9NYQ3: 'HAO2',
    Q9NYQ6: 'CELSR1',
    Q9NYQ7: 'CELSR3',
    Q9NYQ8: 'FAT2',
    Q9NYR8: 'RDH8',
    Q9NYR9: 'NKIRAS2',
    Q9NYS0: 'NKIRAS1',
    Q9NYU1: 'UGGT2',
    Q9NYU2: 'UGGT1',
    Q9NYV4: 'CDK12',
    Q9NYV6: 'RRN3',
    Q9NYV7: 'TAS2R16',
    Q9NYW0: 'TAS2R10',
    Q9NYW4: 'TAS2R5',
    Q9NYW5: 'TAS2R4',
    Q9NYW8: 'RBAK',
    Q9NYX4: 'CALY',
    Q9NYY1: 'IL20',
    Q9NYY3: 'PLK2',
    Q9NYY8: 'FASTKD2',
    Q9NYZ1: 'TVP23B',
    Q9NYZ2: 'SLC25A37',
    Q9NYZ3: 'GTSE1',
    Q9NYZ4: 'SIGLEC8',
    Q9NZ01: 'TECR',
    Q9NZ08: 'ERAP1',
    Q9NZ09: 'UBAP1',
    Q9NZ20: 'PLA2G3',
    Q9NZ42: 'PSENEN',
    Q9NZ43: 'USE1',
    Q9NZ45: 'CISD1',
    Q9NZ52: 'GGA3',
    Q9NZ53: 'PODXL2',
    Q9NZ56: 'FMN2',
    Q9NZ71: 'RTEL1',
    Q9NZ72: 'STMN3',
    Q9NZ81: 'PRR13',
    Q9NZ94: 'NLGN3',
    Q9NZA1: 'CLIC5',
    Q9NZB2: 'FAM120A',
    Q9NZB8: 'MOCS1',
    Q9NZC2: 'TREM2',
    Q9NZC3: 'GDE1',
    Q9NZC4: 'EHF',
    Q9NZC7: 'WWOX',
    Q9NZC9: 'SMARCAL1',
    Q9NZD1: 'GPRC5D',
    Q9NZD2: 'GLTP',
    Q9NZD4: 'AHSP',
    Q9NZD8: 'SPG21',
    Q9NZE8: 'MRPL35',
    Q9NZG7: 'NINJ2',
    Q9NZH0: 'GPRC5B',
    Q9NZH6: 'IL37',
    Q9NZH7: 'IL36B',
    Q9NZH8: 'IL36G',
    Q9NZI2: 'KCNIP1',
    Q9NZI5: 'GRHL1',
    Q9NZI6: 'TFCP2L1',
    Q9NZI7: 'UBP1',
    Q9NZI8: 'IGF2BP1',
    Q9NZJ0: 'DTL',
    Q9NZJ4: 'SACS',
    Q9NZJ5: 'EIF2AK3',
    Q9NZJ6: 'COQ3',
    Q9NZJ7: 'MTCH1',
    Q9NZJ9: 'NUDT4',
    Q9NZK5: 'ADA2',
    Q9NZK7: 'PLA2G2E',
    Q9NZL3: 'ZNF224',
    Q9NZL4: 'HSPBP1',
    Q9NZL9: 'MAT2B',
    Q9NZM1: 'MYOF',
    Q9NZM3: 'ITSN2',
    Q9NZM4: 'BICRA',
    Q9NZM5: 'NOP53',
    Q9NZM6: 'PKD2L2',
    Q9NZN1: 'IL1RAPL1',
    Q9NZN3: 'EHD3',
    Q9NZN4: 'EHD2',
    Q9NZN5: 'ARHGEF12',
    Q9NZN8: 'CNOT2',
    Q9NZN9: 'AIPL1',
    Q9NZP6: 'NPAP1',
    Q9NZP8: 'C1RL',
    Q9NZQ3: 'NCKIPSD',
    Q9NZQ7: 'CD274',
    Q9NZQ8: 'TRPM5',
    Q9NZR1: 'TMOD2',
    Q9NZR2: 'LRP1B',
    Q9NZR4: 'VSX1',
    Q9NZS2: 'KLRF1',
    Q9NZS9: 'BFAR',
    Q9NZT1: 'CALML5',
    Q9NZU0: 'FLRT3',
    Q9NZU1: 'FLRT1',
    Q9NZU5: 'LMCD1',
    Q9NZU7: 'CABP1',
    Q9NZV1: 'CRIM1',
    Q9NZV5: 'SELENON',
    Q9NZV6: 'MSRB1',
    Q9NZV7: 'ZIM2',
    Q9NZV8: 'KCND2',
    Q9NZW4: 'DSPP',
    Q9NZZ3: 'CHMP5',
    Q9P000: 'COMMD9',
    Q9P003: 'CNIH4',
    Q9P013: 'CWC15',
    Q9P021: 'CRIPT',
    Q9P032: 'NDUFAF4',
    Q9P035: 'HACD3',
    Q9P086: 'MED11',
    Q9P0B6: 'CCDC167',
    Q9P0G3: 'KLK14',
    Q9P0I2: 'EMC3',
    Q9P0J0: 'NDUFA13',
    Q9P0J1: 'PDP1',
    Q9P0J7: 'KCMF1',
    Q9P0K1: 'ADAM22',
    Q9P0K7: 'RAI14',
    Q9P0K8: 'FOXJ2',
    Q9P0K9: 'FRRS1L',
    Q9P0L0: 'VAPA',
    Q9P0L1: 'ZKSCAN7',
    Q9P0L2: 'MARK1',
    Q9P0L9: 'PKD2L1',
    Q9P0M2: 'AKAP7',
    Q9P0M6: 'MACROH2A2',
    Q9P0N5: 'TMEM216',
    Q9P0N8: 'MARCHF2',
    Q9P0N9: 'TBC1D7',
    Q9P0P0: 'RNF181',
    Q9P0P8: 'MTRES1',
    Q9P0R6: 'GSKIP',
    Q9P0S3: 'ORMDL1',
    Q9P0S9: 'TMEM14C',
    Q9P0T4: 'ZNF581',
    Q9P0T7: 'TMEM9',
    Q9P0U1: 'TOMM7',
    Q9P0U3: 'SENP1',
    Q9P0U4: 'CXXC1',
    Q9P0V3: 'SH3BP4',
    Q9P0V8: 'SLAMF8',
    Q9P0W0: 'IFNK',
    Q9P0W2: 'HMG20B',
    Q9P0W8: 'SPATA7',
    Q9P0X4: 'CACNA1I',
    Q9P0Z9: 'PIPOX',
    Q9P107: 'GMIP',
    Q9P109: 'GCNT4',
    Q9P121: 'NTM',
    Q9P126: 'CLEC1B',
    Q9P127: 'LUZP4',
    Q9P1A6: 'DLGAP2',
    Q9P1Q0: 'VPS54',
    Q9P1T7: 'MDFIC',
    Q9P1W8: 'SIRPG',
    Q9P1W9: 'PIM2',
    Q9P1Y5: 'CAMSAP3',
    Q9P1Z0: 'ZBTB4',
    Q9P1Z2: 'CALCOCO1',
    Q9P1Z3: 'HCN3',
    Q9P202: 'WHRN',
    Q9P209: 'CEP72',
    Q9P212: 'PLCE1',
    Q9P218: 'COL20A1',
    Q9P219: 'CCDC88C',
    Q9P225: 'DNAH2',
    Q9P232: 'CNTN3',
    Q9P241: 'ATP10D',
    Q9P243: 'ZFAT',
    Q9P246: 'STIM2',
    Q9P253: 'VPS18',
    Q9P258: 'RCC2',
    Q9P266: 'JCAD',
    Q9P267: 'MBD5',
    Q9P270: 'SLAIN2',
    Q9P272: 'TRMT9B',
    Q9P273: 'TENM3',
    Q9P275: 'USP36',
    Q9P278: 'FNIP2',
    Q9P283: 'SEMA5B',
    Q9P286: 'PAK5',
    Q9P287: 'BCCIP',
    Q9P289: 'STK26',
    Q9P296: 'C5AR2',
    Q9P2A4: 'ABI3',
    Q9P2B2: 'PTGFRN',
    Q9P2B4: 'CTTNBP2NL',
    Q9P2D0: 'IBTK',
    Q9P2D1: 'CHD7',
    Q9P2D3: 'HEATR5B',
    Q9P2D7: 'DNAH1',
    Q9P2E2: 'KIF17',
    Q9P2E3: 'ZNFX1',
    Q9P2E5: 'CHPF2',
    Q9P2E8: 'MARCHF4',
    Q9P2E9: 'RRBP1',
    Q9P2F6: 'ARHGAP20',
    Q9P2F9: 'ZNF319',
    Q9P2G1: 'ANKIB1',
    Q9P2G3: 'KLHL14',
    Q9P2G4: 'MAP10',
    Q9P2G9: 'KLHL8',
    Q9P2H0: 'CEP126',
    Q9P2H3: 'IFT80',
    Q9P2I0: 'CPSF2',
    Q9P2J2: 'IGSF9',
    Q9P2J3: 'KLHL9',
    Q9P2J5: 'LARS1',
    Q9P2K1: 'CC2D2A',
    Q9P2K2: 'TXNDC16',
    Q9P2K3: 'RCOR3',
    Q9P2K5: 'MYEF2',
    Q9P2K6: 'KLHL42',
    Q9P2K8: 'EIF2AK4',
    Q9P2K9: 'DISP3',
    Q9P2L0: 'WDR35',
    Q9P2M1: 'LRP2BP',
    Q9P2M4: 'TBC1D14',
    Q9P2M7: 'CGN',
    Q9P2N4: 'ADAMTS9',
    Q9P2N6: 'KANSL3',
    Q9P2N7: 'KLHL13',
    Q9P2P5: 'HECW2',
    Q9P2P6: 'STARD9',
    Q9P2Q2: 'FRMD4A',
    Q9P2R3: 'ANKFY1',
    Q9P2R6: 'RERE',
    Q9P2R7: 'SUCLA2',
    Q9P2S2: 'NRXN2',
    Q9P2S5: 'WRAP73',
    Q9P2T1: 'GMPR2',
    Q9P2U7: 'SLC17A7',
    Q9P2U8: 'SLC17A6',
    Q9P2W1: 'PSMC3IP',
    Q9P2W3: 'GNG13',
    Q9P2W7: 'B3GAT1',
    Q9P2W9: 'STX18',
    Q9P2X0: 'DPM3',
    Q9P2X3: 'IMPACT',
    Q9P2Y4: 'ZNF219',
    Q9P2Y5: 'UVRAG',
    Q9UBB4: 'ATXN10',
    Q9UBB5: 'MBD2',
    Q9UBB6: 'NCDN',
    Q9UBB9: 'TFIP11',
    Q9UBC0: 'ONECUT1',
    Q9UBC1: 'NFKBIL1',
    Q9UBC2: 'EPS15L1',
    Q9UBC3: 'DNMT3B',
    Q9UBC5: 'MYO1A',
    Q9UBC7: 'GALP',
    Q9UBC9: 'SPRR3',
    Q9UBD0: 'HSFX1',
    Q9UBD0: 'HSFX2',
    Q9UBD3: 'XCL2',
    Q9UBD5: 'ORC3',
    Q9UBD6: 'RHCG',
    Q9UBD9: 'CLCF1',
    Q9UBE0: 'SAE1',
    Q9UBE8: 'NLK',
    Q9UBF1: 'MAGEC2',
    Q9UBF2: 'COPG2',
    Q9UBF6: 'RNF7',
    Q9UBF8: 'PI4KB',
    Q9UBF9: 'MYOT',
    Q9UBG0: 'MRC2',
    Q9UBG3: 'CRNN',
    Q9UBH0: 'IL36RN',
    Q9UBH6: 'XPR1',
    Q9UBI1: 'COMMD3',
    Q9UBI4: 'STOML1',
    Q9UBI6: 'GNG12',
    Q9UBJ2: 'ABCD2',
    Q9UBK2: 'PPARGC1A',
    Q9UBK5: 'HCST',
    Q9UBK8: 'MTRR',
    Q9UBK9: 'UXT',
    Q9UBL3: 'ASH2L',
    Q9UBL6: 'CPNE7',
    Q9UBL9: 'P2RX2',
    Q9UBM1: 'PEMT',
    Q9UBM4: 'OPTC',
    Q9UBM7: 'DHCR7',
    Q9UBM8: 'MGAT4C',
    Q9UBN1: 'CACNG4',
    Q9UBN4: 'TRPC4',
    Q9UBN6: 'TNFRSF10D',
    Q9UBN7: 'HDAC6',
    Q9UBP0: 'SPAST',
    Q9UBP4: 'DKK3',
    Q9UBP5: 'HEY2',
    Q9UBP6: 'METTL1',
    Q9UBP9: 'GULP1',
    Q9UBQ0: 'VPS29',
    Q9UBQ5: 'EIF3K',
    Q9UBQ6: 'EXTL2',
    Q9UBQ7: 'GRHPR',
    Q9UBR1: 'UPB1',
    Q9UBR2: 'CTSZ',
    Q9UBR4: 'LHX3',
    Q9UBR5: 'CKLF',
    Q9UBS0: 'RPS6KB2',
    Q9UBS3: 'DNAJB9',
    Q9UBS4: 'DNAJB11',
    Q9UBS5: 'GABBR1',
    Q9UBS8: 'RNF14',
    Q9UBS9: 'SUCO',
    Q9UBT2: 'UBA2',
    Q9UBT3: 'DKK4',
    Q9UBT6: 'POLK',
    Q9UBT7: 'CTNNAL1',
    Q9UBU3: 'GHRL',
    Q9UBU7: 'DBF4',
    Q9UBU8: 'MORF4L1',
    Q9UBU9: 'NXF1',
    Q9UBV2: 'SEL1L',
    Q9UBV4: 'WNT16',
    Q9UBV7: 'B4GALT7',
    Q9UBV8: 'PEF1',
    Q9UBW5: 'BIN2',
    Q9UBW7: 'ZMYM2',
    Q9UBW8: 'COPS7A',
    Q9UBX0: 'HESX1',
    Q9UBX1: 'CTSF',
    Q9UBX2: 'DUX4',
    Q9UBX3: 'SLC25A10',
    Q9UBX5: 'FBLN5',
    Q9UBX7: 'KLK11',
    Q9UBX8: 'B4GALT6',
    Q9UBY0: 'SLC9A2',
    Q9UBY5: 'LPAR3',
    Q9UBY8: 'CLN8',
    Q9UBY9: 'HSPB7',
    Q9UBZ4: 'APEX2',
    Q9UBZ9: 'REV1',
    Q9UC07: 'ZNF69',
    Q9UD71: 'PPP1R1B',
    Q9UDR5: 'AASS',
    Q9UDT6: 'CLIP2',
    Q9UDV6: 'ZNF212',
    Q9UDV7: 'ZNF282',
    Q9UDW1: 'UQCR10',
    Q9UDW3: 'ZMAT5',
    Q9UDX3: 'SEC14L4',
    Q9UDY2: 'TJP2',
    Q9UDY4: 'DNAJB4',
    Q9UDY6: 'TRIM10',
    Q9UDY8: 'MALT1',
    Q9UEE5: 'STK17A',
    Q9UEF7: 'KL',
    Q9UEG4: 'ZNF629',
    Q9UER7: 'DAXX',
    Q9UET6: 'FTSJ1',
    Q9UEU0: 'VTI1B',
    Q9UEW3: 'MARCO',
    Q9UEW8: 'STK39',
    Q9UEY8: 'ADD3',
    Q9UF11: 'PLEKHB1',
    Q9UF12: 'PRODH2',
    Q9UF33: 'EPHA6',
    Q9UF56: 'FBXL17',
    Q9UFB7: 'ZBTB47',
    Q9UFC0: 'LRWD1',
    Q9UFD9: 'RIMBP3',
    Q9UFE4: 'CCDC39',
    Q9UFF9: 'CNOT8',
    Q9UFG5: 'C19orf25',
    Q9UFH2: 'DNAH17',
    Q9UFP1: 'GASK1A',
    Q9UFW8: 'CGGBP1',
    Q9UG01: 'IFT172',
    Q9UG22: 'GIMAP2',
    Q9UG56: 'PISD',
    Q9UGB7: 'MIOX',
    Q9UGC6: 'RGS17',
    Q9UGC7: 'MTRF1L',
    Q9UGH3: 'SLC23A2',
    Q9UGI0: 'ZRANB1',
    Q9UGI6: 'KCNN3',
    Q9UGI8: 'TES',
    Q9UGI9: 'PRKAG3',
    Q9UGJ0: 'PRKAG2',
    Q9UGJ1: 'TUBGCP4',
    Q9UGK3: 'STAP2',
    Q9UGK8: 'SERGEF',
    Q9UGL1: 'KDM5B',
    Q9UGL9: 'CRCT1',
    Q9UGM1: 'CHRNA9',
    Q9UGM3: 'DMBT1',
    Q9UGM5: 'FETUB',
    Q9UGM6: 'WARS2',
    Q9UGN4: 'CD300A',
    Q9UGN5: 'PARP2',
    Q9UGP4: 'LIMD1',
    Q9UGP5: 'POLL',
    Q9UGP8: 'SEC63',
    Q9UGQ3: 'SLC2A6',
    Q9UGR2: 'ZC3H7B',
    Q9UGT4: 'SUSD2',
    Q9UGU0: 'TCF20',
    Q9UGU5: 'HMGXB4',
    Q9UGY1: 'NOL12',
    Q9UH03: 'SEPTIN3',
    Q9UH17: 'APOBEC3B',
    Q9UH65: 'SWAP70',
    Q9UH73: 'EBF1',
    Q9UH77: 'KLHL3',
    Q9UH92: 'MLX',
    Q9UH99: 'SUN2',
    Q9UHA4: 'LAMTOR3',
    Q9UHA7: 'IL36A',
    Q9UHB4: 'NDOR1',
    Q9UHB6: 'LIMA1',
    Q9UHB7: 'AFF4',
    Q9UHB9: 'SRP68',
    Q9UHC1: 'MLH3',
    Q9UHC3: 'ASIC3',
    Q9UHC6: 'CNTNAP2',
    Q9UHC7: 'MKRN1',
    Q9UHC9: 'NPC1L1',
    Q9UHD0: 'IL19',
    Q9UHD1: 'CHORDC1',
    Q9UHD2: 'TBK1',
    Q9UHD4: 'CIDEB',
    Q9UHD8: 'SEPTIN9',
    Q9UHD9: 'UBQLN2',
    Q9UHE5: 'NAT8',
    Q9UHF0: 'TAC3',
    Q9UHF1: 'EGFL7',
    Q9UHF3: 'NAT8B',
    Q9UHF4: 'IL20RA',
    Q9UHF7: 'TRPS1',
    Q9UHG0: 'DCDC2',
    Q9UHG2: 'PCSK1N',
    Q9UHG3: 'PCYOX1',
    Q9UHH9: 'IP6K2',
    Q9UHI5: 'SLC7A8',
    Q9UHI6: 'DDX20',
    Q9UHI7: 'SLC23A1',
    Q9UHI8: 'ADAMTS1',
    Q9UHJ3: 'SFMBT1',
    Q9UHJ6: 'SHPK',
    Q9UHJ9: 'PGAP2',
    Q9UHK0: 'NUFIP1',
    Q9UHK6: 'AMACR',
    Q9UHL0: 'DDX25',
    Q9UHL4: 'DPP7',
    Q9UHL9: 'GTF2IRD1',
    Q9UHM6: 'OPN4',
    Q9UHN1: 'POLG2',
    Q9UHN6: 'CEMIP2',
    Q9UHP3: 'USP25',
    Q9UHP6: 'RSPH14',
    Q9UHP7: 'CLEC2D',
    Q9UHQ1: 'NARF',
    Q9UHQ9: 'CYB5R1',
    Q9UHR4: 'BAIAP2L1',
    Q9UHR5: 'SAP30BP',
    Q9UHV2: 'SERTAD1',
    Q9UHV7: 'MED13',
    Q9UHV8: 'LGALS13',
    Q9UHV9: 'PFDN2',
    Q9UHW9: 'SLC12A6',
    Q9UHX1: 'PUF60',
    Q9UHX3: 'ADGRE2',
    Q9UHY1: 'NRBP1',
    Q9UHY7: 'ENOPH1',
    Q9UHY8: 'FEZ2',
    Q9UI08: 'EVL',
    Q9UI09: 'NDUFA12',
    Q9UI10: 'EIF2B4',
    Q9UI12: 'ATP6V1H',
    Q9UI14: 'RABAC1',
    Q9UI17: 'DMGDH',
    Q9UI26: 'IPO11',
    Q9UI30: 'TRMT112',
    Q9UI32: 'GLS2',
    Q9UI33: 'SCN11A',
    Q9UI36: 'DACH1',
    Q9UI38: 'PRSS50',
    Q9UI40: 'SLC24A2',
    Q9UI42: 'CPA4',
    Q9UI43: 'MRM2',
    Q9UI46: 'DNAI1',
    Q9UI47: 'CTNNA3',
    Q9UI95: 'MAD2L2',
    Q9UIA0: 'CYTH4',
    Q9UIA9: 'XPO7',
    Q9UIB8: 'CD84',
    Q9UIC8: 'LCMT1',
    Q9UID3: 'VPS51',
    Q9UID6: 'ZNF639',
    Q9UIE0: 'ZNF230',
    Q9UIF7: 'MUTYH',
    Q9UIF8: 'BAZ2B',
    Q9UIF9: 'BAZ2A',
    Q9UIG0: 'BAZ1B',
    Q9UIG4: 'PSORS1C2',
    Q9UIG8: 'SLCO3A1',
    Q9UIH9: 'KLF15',
    Q9UII2: 'ATP5IF1',
    Q9UII4: 'HERC5',
    Q9UII6: 'DUSP13B',
    Q9UIJ5: 'ZDHHC2',
    Q9UIJ7: 'AK3',
    Q9UIK4: 'DAPK2',
    Q9UIK5: 'TMEFF2',
    Q9UIL1: 'SCOC',
    Q9UIL4: 'KIF25',
    Q9UIL8: 'PHF11',
    Q9UIQ6: 'LNPEP',
    Q9UIR0: 'BTNL2',
    Q9UIS9: 'MBD1',
    Q9UIU6: 'SIX4',
    Q9UIV1: 'CNOT7',
    Q9UIV8: 'SERPINB13',
    Q9UIW0: 'VAX2',
    Q9UIW2: 'PLXNA1',
    Q9UIX4: 'KCNG1',
    Q9UJ14: 'GGT7',
    Q9UJ37: 'ST6GALNAC2',
    Q9UJ41: 'RABGEF1',
    Q9UJ55: 'MAGEL2',
    Q9UJ68: 'MSRA',
    Q9UJ70: 'NAGK',
    Q9UJ71: 'CD207',
    Q9UJ78: 'ZMYM5',
    Q9UJ83: 'HACL1',
    Q9UJ90: 'KCNE5',
    Q9UJ96: 'KCNG2',
    Q9UJ98: 'STAG3',
    Q9UJA2: 'CRLS1',
    Q9UJA3: 'MCM8',
    Q9UJA5: 'TRMT6',
    Q9UJA9: 'ENPP5',
    Q9UJC3: 'HOOK1',
    Q9UJD0: 'RIMS3',
    Q9UJF2: 'RASAL2',
    Q9UJJ9: 'GNPTG',
    Q9UJL9: 'ZFP69B',
    Q9UJM3: 'ERRFI1',
    Q9UJM8: 'HAO1',
    Q9UJP4: 'KLHL21',
    Q9UJQ1: 'LAMP5',
    Q9UJQ4: 'SALL4',
    Q9UJS0: 'SLC25A13',
    Q9UJT1: 'TUBD1',
    Q9UJT2: 'TSKS',
    Q9UJT9: 'FBXL7',
    Q9UJU2: 'LEF1',
    Q9UJU5: 'FOXD3',
    Q9UJU6: 'DBNL',
    Q9UJV3: 'MID2',
    Q9UJV9: 'DDX41',
    Q9UJW0: 'DCTN4',
    Q9UJW2: 'TINAG',
    Q9UJW3: 'DNMT3L',
    Q9UJW8: 'ZNF180',
    Q9UJW9: 'SERTAD3',
    Q9UJX0: 'OSGIN1',
    Q9UJX2: 'CDC23',
    Q9UJX3: 'ANAPC7',
    Q9UJX4: 'ANAPC5',
    Q9UJX5: 'ANAPC4',
    Q9UJX6: 'ANAPC2',
    Q9UJY1: 'HSPB8',
    Q9UJY4: 'GGA2',
    Q9UJY5: 'GGA1',
    Q9UJZ1: 'STOML2',
    Q9UK05: 'GDF2',
    Q9UK17: 'KCND3',
    Q9UK22: 'FBXO2',
    Q9UK23: 'NAGPA',
    Q9UK32: 'RPS6KA6',
    Q9UK33: 'ZNF580',
    Q9UK39: 'NOCT',
    Q9UK41: 'VPS28',
    Q9UK45: 'LSM7',
    Q9UK53: 'ING1',
    Q9UK55: 'SERPINA10',
    Q9UK58: 'CCNL1',
    Q9UK59: 'DBR1',
    Q9UK61: 'TASOR',
    Q9UK73: 'FEM1B',
    Q9UK76: 'JPT1',
    Q9UK80: 'USP21',
    Q9UK96: 'FBXO10',
    Q9UK97: 'FBXO9',
    Q9UK99: 'FBXO3',
    Q9UKA1: 'FBXL5',
    Q9UKA2: 'FBXL4',
    Q9UKA4: 'AKAP11',
    Q9UKA8: 'RCAN3',
    Q9UKA9: 'PTBP2',
    Q9UKB1: 'FBXW11',
    Q9UKB5: 'AJAP1',
    Q9UKC9: 'FBXL2',
    Q9UKD1: 'GMEB2',
    Q9UKE5: 'TNIK',
    Q9UKF2: 'ADAM30',
    Q9UKF5: 'ADAM29',
    Q9UKF6: 'CPSF3',
    Q9UKF7: 'PITPNC1',
    Q9UKG1: 'APPL1',
    Q9UKG4: 'SLC13A4',
    Q9UKG9: 'CROT',
    Q9UKI2: 'CDC42EP3',
    Q9UKI8: 'TLK1',
    Q9UKI9: 'POU2F3',
    Q9UKJ1: 'PILRA',
    Q9UKJ5: 'CHIC2',
    Q9UKJ8: 'ADAM21',
    Q9UKK3: 'PARP4',
    Q9UKK6: 'NXT1',
    Q9UKK9: 'NUDT5',
    Q9UKL0: 'RCOR1',
    Q9UKL3: 'CASP8AP2',
    Q9UKL6: 'PCTP',
    Q9UKM7: 'MAN1B1',
    Q9UKM9: 'RALY',
    Q9UKN1: 'MUC12',
    Q9UKN5: 'PRDM4',
    Q9UKN7: 'MYO15A',
    Q9UKN8: 'GTF3C4',
    Q9UKP3: 'ITGB1BP2',
    Q9UKP4: 'ADAMTS7',
    Q9UKP5: 'ADAMTS6',
    Q9UKP6: 'UTS2R',
    Q9UKQ2: 'ADAM28',
    Q9UKR0: 'KLK12',
    Q9UKR5: 'ERG28',
    Q9UKS6: 'PACSIN3',
    Q9UKS7: 'IKZF2',
    Q9UKT4: 'FBXO5',
    Q9UKT5: 'FBXO4',
    Q9UKT6: 'FBXL21P',
    Q9UKT7: 'FBXL3',
    Q9UKT8: 'FBXW2',
    Q9UKT9: 'IKZF3',
    Q9UKU0: 'ACSL6',
    Q9UKU6: 'TRHDE',
    Q9UKU7: 'ACAD8',
    Q9UKV0: 'HDAC9',
    Q9UKV3: 'ACIN1',
    Q9UKV5: 'AMFR',
    Q9UKV8: 'AGO2',
    Q9UKW4: 'VAV3',
    Q9UKW6: 'ELF5',
    Q9UKX2: 'MYH2',
    Q9UKX3: 'MYH13',
    Q9UKX5: 'ITGA11',
    Q9UKX7: 'NUP50',
    Q9UKY0: 'PRND',
    Q9UKY1: 'ZHX1',
    Q9UKY4: 'POMT2',
    Q9UKZ1: 'CNOT11',
    Q9UKZ4: 'TENM1',
    Q9UKZ9: 'PCOLCE2',
    Q9UL01: 'DSE',
    Q9UL03: 'INTS6',
    Q9UL12: 'SARDH',
    Q9UL15: 'BAG5',
    Q9UL16: 'CFAP45',
    Q9UL17: 'TBX21',
    Q9UL18: 'AGO1',
    Q9UL19: 'PLAAT4',
    Q9UL25: 'RAB21',
    Q9UL26: 'RAB22A',
    Q9UL33: 'TRAPPC2L',
    Q9UL40: 'ZNF346',
    Q9UL41: 'PNMA3',
    Q9UL42: 'PNMA2',
    Q9UL45: 'BLOC1S6',
    Q9UL46: 'PSME2',
    Q9UL49: 'TCFL5',
    Q9UL51: 'HCN2',
    Q9UL52: 'TMPRSS11E',
    Q9UL54: 'TAOK2',
    Q9UL62: 'TRPC5',
    Q9UL63: 'MKLN1',
    Q9UL68: 'MYT1L',
    Q9ULA0: 'DNPEP',
    Q9ULB1: 'NRXN1',
    Q9ULB5: 'CDH7',
    Q9ULC0: 'EMCN',
    Q9ULC3: 'RAB23',
    Q9ULC4: 'MCTS1',
    Q9ULC5: 'ACSL5',
    Q9ULC6: 'PADI1',
    Q9ULC8: 'ZDHHC8',
    Q9ULD0: 'OGDHL',
    Q9ULD2: 'MTUS1',
    Q9ULD4: 'BRPF3',
    Q9ULD5: 'ZNF777',
    Q9ULD6: 'INTU',
    Q9ULD8: 'KCNH3',
    Q9ULE0: 'WWC3',
    Q9ULG1: 'INO80',
    Q9ULG6: 'CCPG1',
    Q9ULH0: 'KIDINS220',
    Q9ULH1: 'ASAP1',
    Q9ULH4: 'LRFN2',
    Q9ULH7: 'MRTFB',
    Q9ULI0: 'ATAD2B',
    Q9ULI2: 'RIMKLB',
    Q9ULI3: 'HEG1',
    Q9ULJ1: 'ODF2L',
    Q9ULJ3: 'ZBTB21',
    Q9ULJ6: 'ZMIZ1',
    Q9ULJ8: 'PPP1R9A',
    Q9ULK0: 'GRID1',
    Q9ULK4: 'MED23',
    Q9ULK5: 'VANGL2',
    Q9ULL4: 'PLXNB3',
    Q9ULL8: 'SHROOM4',
    Q9ULM2: 'ZNF490',
    Q9ULM3: 'YEATS2',
    Q9ULM6: 'CNOT6',
    Q9ULP0: 'NDRG4',
    Q9ULP9: 'TBC1D24',
    Q9ULQ0: 'STRIP2',
    Q9ULQ1: 'TPCN1',
    Q9ULR0: 'ISY1',
    Q9ULR3: 'PPM1H',
    Q9ULT0: 'TTC7A',
    Q9ULT6: 'ZNRF3',
    Q9ULT8: 'HECTD1',
    Q9ULU4: 'ZMYND8',
    Q9ULU8: 'CADPS',
    Q9ULV0: 'MYO5B',
    Q9ULV1: 'FZD4',
    Q9ULV3: 'CIZ1',
    Q9ULV4: 'CORO1C',
    Q9ULV5: 'HSF4',
    Q9ULV8: 'CBLC',
    Q9ULW0: 'TPX2',
    Q9ULW2: 'FZD10',
    Q9ULW3: 'ABT1',
    Q9ULW5: 'RAB26',
    Q9ULW6: 'NAP1L2',
    Q9ULW8: 'PADI3',
    Q9ULX3: 'NOB1',
    Q9ULX5: 'RNF112',
    Q9ULX6: 'AKAP8L',
    Q9ULX7: 'CA14',
    Q9ULX9: 'MAFF',
    Q9ULY5: 'CLEC4E',
    Q9ULZ1: 'APLN',
    Q9ULZ2: 'STAP1',
    Q9ULZ3: 'PYCARD',
    Q9ULZ9: 'MMP17',
    Q9UM00: 'TMCO1',
    Q9UM01: 'SLC7A7',
    Q9UM07: 'PADI4',
    Q9UM11: 'FZR1',
    Q9UM13: 'ANAPC10',
    Q9UM19: 'HPCAL4',
    Q9UM21: 'MGAT4A',
    Q9UM22: 'EPDR1',
    Q9UM44: 'HHLA2',
    Q9UM47: 'NOTCH3',
    Q9UM54: 'MYO6',
    Q9UM63: 'PLAGL1',
    Q9UM73: 'ALK',
    Q9UM82: 'SPATA2',
    Q9UMD9: 'COL17A1',
    Q9UMF0: 'ICAM5',
    Q9UMN6: 'KMT2B',
    Q9UMQ3: 'BARX2',
    Q9UMQ6: 'CAPN11',
    Q9UMR2: 'DDX19B',
    Q9UMR3: 'TBX20',
    Q9UMR5: 'PPT2',
    Q9UMR7: 'CLEC4A',
    Q9UMS0: 'NFU1',
    Q9UMS4: 'PRPF19',
    Q9UMS6: 'SYNPO2',
    Q9UMW8: 'USP18',
    Q9UMX0: 'UBQLN1',
    Q9UMX1: 'SUFU',
    Q9UMX2: 'OAZ3',
    Q9UMX3: 'BOK',
    Q9UMX5: 'NENF',
    Q9UMX6: 'GUCA1B',
    Q9UMX9: 'SLC45A2',
    Q9UMY4: 'SNX12',
    Q9UMZ2: 'SYNRG',
    Q9UMZ3: 'PTPRQ',
    Q9UN19: 'DAPP1',
    Q9UN36: 'NDRG2',
    Q9UN37: 'VPS4A',
    Q9UN42: 'ATP1B4',
    Q9UN72: 'PCDHA7',
    Q9UN73: 'PCDHA6',
    Q9UN74: 'PCDHA4',
    Q9UN76: 'SLC6A14',
    Q9UN79: 'SOX13',
    Q9UN81: 'L1RE1',
    Q9UN86: 'G3BP2',
    Q9UN88: 'GABRQ',
    Q9UNA0: 'ADAMTS5',
    Q9UNA1: 'ARHGAP26',
    Q9UNA3: 'A4GNT',
    Q9UNA4: 'POLI',
    Q9UNE0: 'EDAR',
    Q9UNE2: 'RPH3AL',
    Q9UNE7: 'STUB1',
    Q9UNF0: 'PACSIN2',
    Q9UNF1: 'MAGED2',
    Q9UNG2: 'TNFSF18',
    Q9UNH5: 'CDC14A',
    Q9UNH6: 'SNX7',
    Q9UNH7: 'SNX6',
    Q9UNI1: 'CELA1',
    Q9UNI6: 'DUSP12',
    Q9UNK0: 'STX8',
    Q9UNK4: 'PLA2G2D',
    Q9UNL4: 'ING4',
    Q9UNM6: 'PSMD13',
    Q9UNN5: 'FAF1',
    Q9UNN8: 'PROCR',
    Q9UNP4: 'ST3GAL5',
    Q9UNP9: 'PPIE',
    Q9UNQ0: 'ABCG2',
    Q9UNQ2: 'DIMT1',
    Q9UNS1: 'TIMELESS',
    Q9UNS2: 'COPS3',
    Q9UNT1: 'RABL2B',
    Q9UNU6: 'CYP8B1',
    Q9UNW1: 'MINPP1',
    Q9UNW8: 'GPR132',
    Q9UNW9: 'NOVA2',
    Q9UNY4: 'TTF2',
    Q9UNY5: 'ZNF232',
    Q9UNZ2: 'NSFL1C',
    Q9UP38: 'FZD1',
    Q9UP52: 'TFR2',
    Q9UP65: 'PLA2G4C',
    Q9UP79: 'ADAMTS8',
    Q9UP83: 'COG5',
    Q9UP95: 'SLC12A4',
    Q9UPA5: 'BSN',
    Q9UPE1: 'SRPK3',
    Q9UPG8: 'PLAGL2',
    Q9UPI3: 'FLVCR2',
    Q9UPM6: 'LHX6',
    Q9UPM8: 'AP4E1',
    Q9UPM9: 'B9D1',
    Q9UPN3: 'MACF1',
    Q9UPN4: 'CEP131',
    Q9UPN6: 'SCAF8',
    Q9UPN7: 'PPP6R1',
    Q9UPN9: 'TRIM33',
    Q9UPP1: 'PHF8',
    Q9UPP2: 'IQSEC3',
    Q9UPP5: 'BTBD8',
    Q9UPQ0: 'LIMCH1',
    Q9UPQ3: 'AGAP1',
    Q9UPQ4: 'TRIM35',
    Q9UPQ7: 'PDZRN3',
    Q9UPQ8: 'DOLK',
    Q9UPQ9: 'TNRC6B',
    Q9UPR0: 'PLCL2',
    Q9UPR3: 'SMG5',
    Q9UPR5: 'SLC8A2',
    Q9UPS6: 'SETD1B',
    Q9UPS8: 'ANKRD26',
    Q9UPT5: 'EXOC7',
    Q9UPT6: 'MAPK8IP3',
    Q9UPT8: 'ZC3H4',
    Q9UPT9: 'USP22',
    Q9UPU5: 'USP24',
    Q9UPU7: 'TBC1D2B',
    Q9UPU9: 'SAMD4A',
    Q9UPV0: 'CEP164',
    Q9UPV9: 'TRAK1',
    Q9UPW0: 'FOXJ3',
    Q9UPW5: 'AGTPBP1',
    Q9UPW6: 'SATB2',
    Q9UPW8: 'UNC13A',
    Q9UPX0: 'IGSF9B',
    Q9UPX6: 'MINAR1',
    Q9UPX8: 'SHANK2',
    Q9UPY3: 'DICER1',
    Q9UPY5: 'SLC7A11',
    Q9UPY6: 'WASF3',
    Q9UPY8: 'MAPRE3',
    Q9UPZ3: 'HPS5',
    Q9UPZ6: 'THSD7A',
    Q9UPZ9: 'CILK1',
    Q9UQ03: 'CORO2B',
    Q9UQ05: 'KCNH4',
    Q9UQ07: 'MOK',
    Q9UQ13: 'SHOC2',
    Q9UQ16: 'DNM3',
    Q9UQ26: 'RIMS2',
    Q9UQ35: 'SRRM2',
    Q9UQ49: 'NEU3',
    Q9UQ52: 'CNTN6',
    Q9UQ53: 'MGAT4B',
    Q9UQ80: 'PA2G4',
    Q9UQ84: 'EXO1',
    Q9UQ88: 'CDK11A',
    Q9UQ90: 'SPG7',
    Q9UQB3: 'CTNND2',
    Q9UQB8: 'BAIAP2',
    Q9UQB9: 'AURKC',
    Q9UQC2: 'GAB2',
    Q9UQC9: 'CLCA2',
    Q9UQD0: 'SCN8A',
    Q9UQE7: 'SMC3',
    Q9UQF0: 'ERVW-1',
    Q9UQF2: 'MAPK8IP1',
    Q9UQK1: 'PPP1R3C',
    Q9UQL6: 'HDAC5',
    Q9UQM7: 'CAMK2A',
    Q9UQN3: 'CHMP2B',
    Q9UQP3: 'TNN',
    Q9UQQ1: 'NAALADL1',
    Q9UQQ2: 'SH2B3',
    Q9UQR0: 'SCML2',
    Q9UQR1: 'ZNF148',
    Q9UQV4: 'LAMP3',
    Q9WJR5: 'ERVK-19',
    Q9Y210: 'TRPC6',
    Q9Y215: 'COLQ',
    Q9Y216: 'MTMR7',
    Q9Y217: 'MTMR6',
    Q9Y219: 'JAG2',
    Q9Y221: 'NIP7',
    Q9Y222: 'DMTF1',
    Q9Y223: 'GNE',
    Q9Y224: 'RTRAF',
    Q9Y225: 'RNF24',
    Q9Y226: 'SLC22A13',
    Q9Y227: 'ENTPD4',
    Q9Y228: 'TRAF3IP3',
    Q9Y230: 'RUVBL2',
    Q9Y231: 'FUT9',
    Q9Y232: 'CDYL',
    Q9Y233: 'PDE10A',
    Q9Y234: 'LIPT1',
    Q9Y235: 'APOBEC2',
    Q9Y237: 'PIN4',
    Q9Y238: 'DLEC1',
    Q9Y239: 'NOD1',
    Q9Y240: 'CLEC11A',
    Q9Y241: 'HIGD1A',
    Q9Y242: 'TCF19',
    Q9Y243: 'AKT3',
    Q9Y244: 'POMP',
    Q9Y247: 'FAM50B',
    Q9Y248: 'GINS2',
    Q9Y250: 'LZTS1',
    Q9Y251: 'HPSE',
    Q9Y252: 'RNF6',
    Q9Y253: 'POLH',
    Q9Y255: 'PRELID1',
    Q9Y256: 'RCE1',
    Q9Y257: 'KCNK6',
    Q9Y258: 'CCL26',
    Q9Y259: 'CHKB',
    Q9Y261: 'FOXA2',
    Q9Y262: 'EIF3L',
    Q9Y263: 'PLAA',
    Q9Y264: 'ANGPT4',
    Q9Y265: 'RUVBL1',
    Q9Y266: 'NUDC',
    Q9Y267: 'SLC22A14',
    Q9Y271: 'CYSLTR1',
    Q9Y272: 'RASD1',
    Q9Y274: 'ST3GAL6',
    Q9Y275: 'TNFSF13B',
    Q9Y276: 'BCS1L',
    Q9Y277: 'VDAC3',
    Q9Y278: 'HS3ST2',
    Q9Y279: 'VSIG4',
    Q9Y281: 'CFL2',
    Q9Y282: 'ERGIC3',
    Q9Y283: 'INVS',
    Q9Y284: 'WDR83OS',
    Q9Y285: 'FARSA',
    Q9Y286: 'SIGLEC7',
    Q9Y287: 'ITM2B',
    Q9Y289: 'SLC5A6',
    Q9Y294: 'ASF1A',
    Q9Y295: 'DRG1',
    Q9Y296: 'TRAPPC4',
    Q9Y297: 'BTRC',
    Q9Y2A7: 'NCKAP1',
    Q9Y2A9: 'B3GNT3',
    Q9Y2B0: 'CNPY2',
    Q9Y2B1: 'RXYLT1',
    Q9Y2B2: 'PIGL',
    Q9Y2B4: 'TP53TG5',
    Q9Y2B5: 'VPS9D1',
    Q9Y2C3: 'B3GALT5',
    Q9Y2C4: 'EXOG',
    Q9Y2C5: 'SLC17A4',
    Q9Y2C9: 'TLR6',
    Q9Y2D0: 'CA5B',
    Q9Y2D1: 'ATF5',
    Q9Y2D2: 'SLC35A3',
    Q9Y2D4: 'EXOC6B',
    Q9Y2D8: 'SSX2IP',
    Q9Y2E5: 'MAN2B2',
    Q9Y2E6: 'DTX4',
    Q9Y2F5: 'ICE1',
    Q9Y2F9: 'BTBD3',
    Q9Y2G0: 'EFR3B',
    Q9Y2G1: 'MYRF',
    Q9Y2G2: 'CARD8',
    Q9Y2G3: 'ATP11B',
    Q9Y2G5: 'POFUT2',
    Q9Y2G9: 'SBNO2',
    Q9Y2H0: 'DLGAP4',
    Q9Y2H1: 'STK38L',
    Q9Y2H2: 'INPP5F',
    Q9Y2H6: 'FNDC3A',
    Q9Y2H9: 'MAST1',
    Q9Y2I1: 'NISCH',
    Q9Y2I2: 'NTNG1',
    Q9Y2I6: 'NINL',
    Q9Y2I7: 'PIKFYVE',
    Q9Y2I9: 'TBC1D30',
    Q9Y2J0: 'RPH3A',
    Q9Y2J2: 'EPB41L3',
    Q9Y2J4: 'AMOTL2',
    Q9Y2J8: 'PADI2',
    Q9Y2K1: 'ZBTB1',
    Q9Y2K2: 'SIK3',
    Q9Y2K3: 'MYH15',
    Q9Y2K5: 'R3HDM2',
    Q9Y2K6: 'USP20',
    Q9Y2K7: 'KDM2A',
    Q9Y2K9: 'STXBP5L',
    Q9Y2L1: 'DIS3',
    Q9Y2L5: 'TRAPPC8',
    Q9Y2L9: 'LRCH1',
    Q9Y2M0: 'FAN1',
    Q9Y2M2: 'SSUH2',
    Q9Y2M5: 'KLHL20',
    Q9Y2N7: 'HIF3A',
    Q9Y2P0: 'ZNF835',
    Q9Y2P4: 'SLC27A6',
    Q9Y2P5: 'SLC27A5',
    Q9Y2P7: 'ZNF256',
    Q9Y2Q0: 'ATP8A1',
    Q9Y2Q3: 'GSTK1',
    Q9Y2Q5: 'LAMTOR2',
    Q9Y2R0: 'COA3',
    Q9Y2R2: 'PTPN22',
    Q9Y2S2: 'CRYL1',
    Q9Y2S7: 'POLDIP2',
    Q9Y2T1: 'AXIN2',
    Q9Y2T2: 'AP3M1',
    Q9Y2T3: 'GDA',
    Q9Y2T6: 'GPR55',
    Q9Y2T7: 'YBX2',
    Q9Y2U5: 'MAP3K2',
    Q9Y2U8: 'LEMD3',
    Q9Y2U9: 'KLHDC2',
    Q9Y2V0: 'CDIN1',
    Q9Y2V2: 'CARHSP1',
    Q9Y2V3: 'RAX',
    Q9Y2V7: 'COG6',
    Q9Y2W1: 'THRAP3',
    Q9Y2W2: 'WBP11',
    Q9Y2W3: 'SLC45A1',
    Q9Y2W6: 'TDRKH',
    Q9Y2W7: 'KCNIP3',
    Q9Y2X0: 'MED16',
    Q9Y2X3: 'NOP58',
    Q9Y2X7: 'GIT1',
    Q9Y2X8: 'UBE2D4',
    Q9Y2X9: 'ZNF281',
    Q9Y2Y0: 'ARL2BP',
    Q9Y2Y1: 'POLR3K',
    Q9Y2Y4: 'ZBTB32',
    Q9Y2Y6: 'TMEM98',
    Q9Y2Y8: 'PRG3',
    Q9Y2Y9: 'KLF13',
    Q9Y2Z0: 'SUGT1',
    Q9Y2Z2: 'MTO1',
    Q9Y2Z4: 'YARS2',
    Q9Y2Z9: 'COQ6',
    Q9Y303: 'AMDHD2',
    Q9Y314: 'NOSIP',
    Q9Y315: 'DERA',
    Q9Y316: 'MEMO1',
    Q9Y320: 'TMX2',
    Q9Y328: 'NSG2',
    Q9Y333: 'LSM2',
    Q9Y336: 'SIGLEC9',
    Q9Y337: 'KLK5',
    Q9Y342: 'PLLP',
    Q9Y345: 'SLC6A5',
    Q9Y365: 'STARD10',
    Q9Y366: 'IFT52',
    Q9Y371: 'SH3GLB1',
    Q9Y375: 'NDUFAF1',
    Q9Y376: 'CAB39',
    Q9Y383: 'LUC7L2',
    Q9Y385: 'UBE2J1',
    Q9Y388: 'RBMX2',
    Q9Y394: 'DHRS7',
    Q9Y397: 'ZDHHC9',
    Q9Y399: 'MRPS2',
    Q9Y3A0: 'COQ4',
    Q9Y3A2: 'UTP11',
    Q9Y3A3: 'MOB4',
    Q9Y3A4: 'RRP7A',
    Q9Y3A5: 'SBDS',
    Q9Y3A6: 'TMED5',
    Q9Y3B2: 'EXOSC1',
    Q9Y3B3: 'TMED7',
    Q9Y3B4: 'SF3B6',
    Q9Y3B6: 'EMC9',
    Q9Y3B7: 'MRPL11',
    Q9Y3B8: 'REXO2',
    Q9Y3C0: 'WASHC3',
    Q9Y3C4: 'TPRKB',
    Q9Y3C5: 'RNF11',
    Q9Y3C6: 'PPIL1',
    Q9Y3C7: 'MED31',
    Q9Y3C8: 'UFC1',
    Q9Y3D0: 'CIAO2B',
    Q9Y3D2: 'MSRB2',
    Q9Y3D3: 'MRPS16',
    Q9Y3D6: 'FIS1',
    Q9Y3D7: 'PAM16',
    Q9Y3D8: 'AK6',
    Q9Y3D9: 'MRPS23',
    Q9Y3E0: 'GOLT1B',
    Q9Y3E1: 'HDGFL3',
    Q9Y3E2: 'BOLA1',
    Q9Y3E5: 'PTRH2',
    Q9Y3E7: 'CHMP3',
    Q9Y3F4: 'STRAP',
    Q9Y3I0: 'RTCB',
    Q9Y3I1: 'FBXO7',
    Q9Y3L3: 'SH3BP1',
    Q9Y3L5: 'RAP2C',
    Q9Y3M2: 'CBY1',
    Q9Y3M8: 'STARD13',
    Q9Y3M9: 'ZNF337',
    Q9Y3P8: 'SIT1',
    Q9Y3P9: 'RABGAP1',
    Q9Y3Q0: 'NAALAD2',
    Q9Y3Q3: 'TMED3',
    Q9Y3Q4: 'HCN4',
    Q9Y3Q7: 'ADAM18',
    Q9Y3Q8: 'TSC22D4',
    Q9Y3R0: 'GRIP1',
    Q9Y3R4: 'NEU2',
    Q9Y3R5: 'DOP1B',
    Q9Y3S1: 'WNK2',
    Q9Y3S2: 'ZNF330',
    Q9Y3T9: 'NOC2L',
    Q9Y3U8: 'RPL36',
    Q9Y3V2: 'RWDD3',
    Q9Y3Y2: 'CHTOP',
    Q9Y3Y4: 'PYGO1',
    Q9Y3Z3: 'SAMHD1',
    Q9Y446: 'PKP3',
    Q9Y448: 'KNSTRN',
    Q9Y450: 'HBS1L',
    Q9Y458: 'TBX22',
    Q9Y462: 'ZNF711',
    Q9Y463: 'DYRK1B',
    Q9Y466: 'NR2E1',
    Q9Y467: 'SALL2',
    Q9Y468: 'L3MBTL1',
    Q9Y473: 'ZNF175',
    Q9Y478: 'PRKAB1',
    Q9Y483: 'MTF2',
    Q9Y484: 'WDR45',
    Q9Y487: 'ATP6V0A2',
    Q9Y490: 'TLN1',
    Q9Y493: 'ZAN',
    Q9Y496: 'KIF3A',
    Q9Y4A5: 'TRRAP',
    Q9Y4A8: 'NFE2L3',
    Q9Y4B4: 'RAD54L2',
    Q9Y4B5: 'MTCL1',
    Q9Y4B6: 'DCAF1',
    Q9Y4C0: 'NRXN3',
    Q9Y4C1: 'KDM3A',
    Q9Y4C2: 'TCAF1',
    Q9Y4C4: 'MFHAS1',
    Q9Y4C5: 'CHST2',
    Q9Y4C8: 'RBM19',
    Q9Y4D1: 'DAAM1',
    Q9Y4D2: 'DAGLA',
    Q9Y4D7: 'PLXND1',
    Q9Y4D8: 'HECTD4',
    Q9Y4E1: 'WASHC2C',
    Q9Y4E5: 'ZNF451',
    Q9Y4E8: 'USP15',
    Q9Y4F1: 'FARP1',
    Q9Y4F3: 'MARF1',
    Q9Y4F4: 'TOGARAM1',
    Q9Y4F9: 'RIPOR2',
    Q9Y4G2: 'PLEKHM1',
    Q9Y4G6: 'TLN2',
    Q9Y4G8: 'RAPGEF2',
    Q9Y4H2: 'IRS2',
    Q9Y4H4: 'GPSM3',
    Q9Y4I1: 'MYO5A',
    Q9Y4J8: 'DTNA',
    Q9Y4K0: 'LOXL2',
    Q9Y4K3: 'TRAF6',
    Q9Y4K4: 'MAP4K5',
    Q9Y4L1: 'HYOU1',
    Q9Y4L5: 'RNF115',
    Q9Y4P1: 'ATG4B',
    Q9Y4P8: 'WIPI2',
    Q9Y4P9: 'SPEF1',
    Q9Y4R7: 'TTLL3',
    Q9Y4R8: 'TELO2',
    Q9Y4U1: 'MMACHC',
    Q9Y4W2: 'LAS1L',
    Q9Y4W6: 'AFG3L2',
    Q9Y4X0: 'AMMECR1',
    Q9Y4X3: 'CCL27',
    Q9Y4X4: 'KLF12',
    Q9Y4X5: 'ARIH1',
    Q9Y4Y9: 'LSM5',
    Q9Y4Z0: 'LSM4',
    Q9Y4Z2: 'NEUROG3',
    Q9Y508: 'RNF114',
    Q9Y512: 'SAMM50',
    Q9Y520: 'PRRC2C',
    Q9Y530: 'OARD1',
    Q9Y535: 'POLR3H',
    Q9Y547: 'IFT25',
    Q9Y548: 'YIPF1',
    Q9Y561: 'LRP12',
    Q9Y566: 'SHANK1',
    Q9Y570: 'PPME1',
    Q9Y572: 'RIPK3',
    Q9Y574: 'ASB4',
    Q9Y575: 'ASB3',
    Q9Y576: 'ASB1',
    Q9Y577: 'TRIM17',
    Q9Y580: 'RBM7',
    Q9Y584: 'TIMM22',
    Q9Y586: 'MAB21L2',
    Q9Y587: 'AP4S1',
    Q9Y592: 'CEP83',
    Q9Y5A6: 'ZSCAN21',
    Q9Y5A7: 'NUB1',
    Q9Y5A9: 'YTHDF2',
    Q9Y5B0: 'CTDP1',
    Q9Y5B6: 'PAXBP1',
    Q9Y5B8: 'NME7',
    Q9Y5B9: 'SUPT16H',
    Q9Y5C1: 'ANGPTL3',
    Q9Y5E3: 'PCDHB6',
    Q9Y5E9: 'PCDHB14',
    Q9Y5F1: 'PCDHB12',
    Q9Y5H5: 'PCDHA9',
    Q9Y5H9: 'PCDHA2',
    Q9Y5I2: 'PCDHA10',
    Q9Y5I3: 'PCDHA1',
    Q9Y5I7: 'CLDN16',
    Q9Y5J3: 'HEY1',
    Q9Y5J5: 'PHLDA3',
    Q9Y5J6: 'TIMM10B',
    Q9Y5J7: 'TIMM9',
    Q9Y5K1: 'SPO11',
    Q9Y5K2: 'KLK4',
    Q9Y5K3: 'PCYT1B',
    Q9Y5K5: 'UCHL5',
    Q9Y5K6: 'CD2AP',
    Q9Y5K8: 'ATP6V1D',
    Q9Y5L0: 'TNPO3',
    Q9Y5L2: 'HILPDA',
    Q9Y5L3: 'ENTPD2',
    Q9Y5L4: 'TIMM13',
    Q9Y5N1: 'HRH3',
    Q9Y5N5: 'N6AMT1',
    Q9Y5N6: 'ORC6',
    Q9Y5P4: 'CERT1',
    Q9Y5P6: 'GMPPB',
    Q9Y5P8: 'PPP2R3B',
    Q9Y5Q0: 'FADS3',
    Q9Y5Q3: 'MAFB',
    Q9Y5Q5: 'CORIN',
    Q9Y5Q6: 'INSL5',
    Q9Y5Q8: 'GTF3C5',
    Q9Y5Q9: 'GTF3C3',
    Q9Y5R2: 'MMP24',
    Q9Y5R4: 'HEMK1',
    Q9Y5R5: 'DMRT2',
    Q9Y5R6: 'DMRT1',
    Q9Y5R8: 'TRAPPC1',
    Q9Y5S1: 'TRPV2',
    Q9Y5S2: 'CDC42BPB',
    Q9Y5S8: 'NOX1',
    Q9Y5S9: 'RBM8A',
    Q9Y5T4: 'DNAJC15',
    Q9Y5T5: 'USP16',
    Q9Y5U4: 'INSIG2',
    Q9Y5U5: 'TNFRSF18',
    Q9Y5U8: 'MPC1',
    Q9Y5U9: 'IER3IP1',
    Q9Y5V3: 'MAGED1',
    Q9Y5W3: 'KLF2',
    Q9Y5W5: 'WIF1',
    Q9Y5W7: 'SNX14',
    Q9Y5W8: 'SNX13',
    Q9Y5W9: 'SNX11',
    Q9Y5X0: 'SNX10',
    Q9Y5X1: 'SNX9',
    Q9Y5X2: 'SNX8',
    Q9Y5X3: 'SNX5',
    Q9Y5X4: 'NR2E3',
    Q9Y5X5: 'NPFFR2',
    Q9Y5X9: 'LIPG',
    Q9Y5Y0: 'FLVCR1',
    Q9Y5Y2: 'NUBP2',
    Q9Y5Y4: 'PTGDR2',
    Q9Y5Y5: 'PEX16',
    Q9Y5Y6: 'ST14',
    Q9Y5Y7: 'LYVE1',
    Q9Y5Y9: 'SCN10A',
    Q9Y5Z0: 'BACE2',
    Q9Y5Z4: 'HEBP2',
    Q9Y5Z6: 'B3GALT1',
    Q9Y5Z7: 'HCFC2',
    Q9Y5Z9: 'UBIAD1',
    Q9Y600: 'CSAD',
    Q9Y603: 'ETV7',
    Q9Y605: 'MRFAP1',
    Q9Y606: 'PUS1',
    Q9Y608: 'LRRFIP2',
    Q9Y613: 'FHOD1',
    Q9Y615: 'ACTL7A',
    Q9Y616: 'IRAK3',
    Q9Y617: 'PSAT1',
    Q9Y618: 'NCOR2',
    Q9Y619: 'SLC25A15',
    Q9Y620: 'RAD54B',
    Q9Y623: 'MYH4',
    Q9Y624: 'F11R',
    Q9Y625: 'GPC6',
    Q9Y639: 'NPTN',
    Q9Y644: 'RFNG',
    Q9Y646: 'CPQ',
    Q9Y653: 'ADGRG1',
    Q9Y657: 'SPIN1',
    Q9Y662: 'HS3ST3B1',
    Q9Y663: 'HS3ST3A1',
    Q9Y664: 'KPTN',
    Q9Y666: 'SLC12A7',
    Q9Y672: 'ALG6',
    Q9Y676: 'MRPS18B',
    Q9Y678: 'COPG1',
    Q9Y679: 'AUP1',
    Q9Y680: 'FKBP7',
    Q9Y691: 'KCNMB2',
    Q9Y692: 'GMEB1',
    Q9Y694: 'SLC22A7',
    Q9Y696: 'CLIC4',
    Q9Y697: 'NFS1',
    Q9Y698: 'CACNG2',
    Q9Y6A1: 'POMT1',
    Q9Y6A2: 'CYP46A1',
    Q9Y6A4: 'CFAP20',
    Q9Y6A5: 'TACC3',
    Q9Y6A9: 'SPCS1',
    Q9Y6B2: 'EID1',
    Q9Y6B6: 'SAR1B',
    Q9Y6B7: 'AP4B1',
    Q9Y6C2: 'EMILIN1',
    Q9Y6C5: 'PTCH2',
    Q9Y6D0: 'SELENOK',
    Q9Y6D5: 'ARFGEF2',
    Q9Y6D6: 'ARFGEF1',
    Q9Y6D9: 'MAD1L1',
    Q9Y6E0: 'STK24',
    Q9Y6E2: 'BZW2',
    Q9Y6E7: 'SIRT4',
    Q9Y6F1: 'PARP3',
    Q9Y6F6: 'IRAG1',
    Q9Y6F8: 'CDY1',
    Q9Y6F8: 'CDY1B',
    Q9Y6F9: 'WNT6',
    Q9Y6G1: 'TMEM14A',
    Q9Y6G3: 'MRPL42',
    Q9Y6G5: 'COMMD10',
    Q9Y6G9: 'DYNC1LI1',
    Q9Y6H1: 'CHCHD2',
    Q9Y6H3: 'ATP23',
    Q9Y6H5: 'SNCAIP',
    Q9Y6H6: 'KCNE3',
    Q9Y6H8: 'GJA3',
    Q9Y6I3: 'EPN1',
    Q9Y6I4: 'USP3',
    Q9Y6I7: 'WSB1',
    Q9Y6I9: 'TEX264',
    Q9Y6J0: 'CABIN1',
    Q9Y6J6: 'KCNE2',
    Q9Y6J8: 'STYXL1',
    Q9Y6J9: 'TAF6L',
    Q9Y6K0: 'CEPT1',
    Q9Y6K1: 'DNMT3A',
    Q9Y6K5: 'OAS3',
    Q9Y6K8: 'AK5',
    Q9Y6K9: 'IKBKG',
    Q9Y6L6: 'SLCO1B1',
    Q9Y6L7: 'TLL2',
    Q9Y6M0: 'PRSS21',
    Q9Y6M1: 'IGF2BP2',
    Q9Y6M4: 'CSNK1G3',
    Q9Y6M5: 'SLC30A1',
    Q9Y6M7: 'SLC4A7',
    Q9Y6M9: 'NDUFB9',
    Q9Y6N1: 'COX11',
    Q9Y6N5: 'SQOR',
    Q9Y6N6: 'LAMC3',
    Q9Y6N7: 'ROBO1',
    Q9Y6N8: 'CDH10',
    Q9Y6N9: 'USH1C',
    Q9Y6P5: 'SESN1',
    Q9Y6Q1: 'CAPN6',
    Q9Y6Q2: 'STON1',
    Q9Y6Q5: 'AP1M2',
    Q9Y6Q6: 'TNFRSF11A',
    Q9Y6Q9: 'NCOA3',
    Q9Y6R0: 'NUMBL',
    Q9Y6R1: 'SLC4A4',
    Q9Y6R4: 'MAP3K4',
    Q9Y6R7: 'FCGBP',
    Q9Y6R9: 'CCDC61',
    Q9Y6T7: 'DGKB',
    Q9Y6U3: 'SCIN',
    Q9Y6V0: 'PCLO',
    Q9Y6W3: 'CAPN7',
    Q9Y6W5: 'WASF2',
    Q9Y6W6: 'DUSP10',
    Q9Y6W8: 'ICOS',
    Q9Y6X0: 'SETBP1',
    Q9Y6X1: 'SERP1',
    Q9Y6X2: 'PIAS3',
    Q9Y6X3: 'MAU2',
    Q9Y6X5: 'ENPP4',
    Q9Y6X6: 'MYO16',
    Q9Y6X8: 'ZHX2',
    Q9Y6X9: 'MORC2',
    Q9Y6Y0: 'IVNS1ABP',
    Q9Y6Y1: 'CAMTA1',
    Q9Y6Y8: 'SEC23IP',
    Q9Y6Y9: 'LY96',
    Q9Y6Z7: 'COLEC10',
    A0A024RBG1: 'NUDT4B',
    A0A075B6Q5: 'IGHV3-64',
    A0A075B6R2: 'IGHV4-4',
    A0A087WSY4: 'IGHV4-30-2',
    A0A087WT01: 'TRAV27',
    A0A0A0MS14: 'IGHV1-45',
    A0A0A0MS15: 'IGHV3-49',
    A0A0A6YYK7: 'TRAV19',
    A0A0B4J1U7: 'IGHV6-1',
    A0A0B4J1V0: 'IGHV3-15',
    A0A0B4J1V1: 'IGHV3-21',
    A0A0B4J1V2: 'IGHV2-26',
    A0A0B4J1V6: 'IGHV3-73',
    A0A0B4J1V7: 'IGHV7-81',
    A0A0B4J1X5: 'IGHV3-74',
    A0A0B4J1X8: 'IGHV3-43',
    A0A0B4J1Y9: 'IGHV3-72',
    A0A0B4J2H0: 'IGHV1-69D',
    A0A0C4DH29: 'IGHV1-3',
    A0A0C4DH30: 'IGHV3-16',
    A0A0C4DH31: 'IGHV1-18',
    A0A0C4DH32: 'IGHV3-20',
    A0A0C4DH33: 'IGHV1-24',
    A0A0C4DH34: 'IGHV4-28',
    A0A0C4DH35: 'IGHV3-35',
    A0A0C4DH36: 'IGHV3-38',
    A0A0C4DH38: 'IGHV5-51',
    A0A0C4DH39: 'IGHV1-58',
    A0A0C4DH41: 'IGHV4-61',
    A0A0C4DH42: 'IGHV3-66',
    A0A0C4DH43: 'IGHV2-70D',
    A0A0G2JMI3: 'IGHV1-69-2',
    A0A0J9YVY3: 'IGHV7-4-1',
    A0A0J9YX35: 'IGHV3-64D',
    A0A0J9YXX1: 'IGHV5-10-1',
    A0A0K0K1A5: 'TRBV6-5',
    A0A1B0GTB2: 'TUNAR',
    A0A1B0GTQ4: 'MYMX',
    A0A1B0GVQ0: 'SPAAR',
    A0AVI2: 'FER1L5',
    A0PJX0: 'CIB4',
    A0PJX4: 'SHISA3',
    A0PJZ3: 'GXYLT2',
    A0PK05: 'TMEM72',
    A1A5D9: 'BICDL2',
    A1L020: 'MEX3A',
    A1L188: 'NDUFAF8',
    A1YPR0: 'ZBTB7C',
    A2A2V5: 'SERTM1',
    A2A3K4: 'PTPDC1',
    A2RRD8: 'ZNF320',
    A2RUS2: 'DENND3',
    A2VDF0: 'FUOM',
    A3KN83: 'SBNO1',
    A4D1S5: 'RAB19',
    A4D2G3: 'OR2A25',
    A4FU01: 'MTMR11',
    A4FU49: 'SH3D21',
    A4FU69: 'EFCAB5',
    A5A3E0: 'POTEF',
    A5D6W6: 'FITM1',
    A6NC51: 'TMEM150B',
    A6NCE7: 'MAP1LC3B2',
    A6NCW0: 'USP17L3',
    A6ND48: 'OR14I1',
    A6NDA9: 'LRIT2',
    A6NDP7: 'MYADML2',
    A6NDU8: 'RIMOC1',
    A6NEQ0: 'RBMY1E',
    A6NF83: 'NUPR2',
    A6NFD8: 'HELT',
    A6NFK2: 'GRXCR2',
    A6NFN3: 'RBFOX3',
    A6NFR6: 'C5orf60',
    A6NG13: 'MGAT4D',
    A6NGB9: 'WIPF3',
    A6NGC4: 'TLCD2',
    A6NGE7: 'URAD',
    A6NGY5: 'OR51F1',
    A6NH00: 'OR2T8',
    A6NHC0: 'CAPN8',
    A6NHL2: 'TUBAL3',
    A6NHN0: 'OTOL1',
    A6NHQ2: 'FBLL1',
    A6NHQ4: 'EPOP',
    A6NHX0: 'CASTOR2',
    A6NI28: 'ARHGAP42',
    A6NI79: 'CCDC69',
    A6NJB7: 'PRR19',
    A6NJT0: 'UNCX',
    A6NJW9: 'CD8B2',
    A6NK97: 'SLC22A20P',
    A6NKF1: 'SAC3D1',
    A6NLJ0: 'C2CD4B',
    A6NLX3: 'SPDYE4',
    A6NMB1: 'SIGLEC16',
    A6NMN3: 'FAM170B',
    A6NNA5: 'DRGX',
    A6NND4: 'OR2AT4',
    A6NNE9: 'MARCHF11',
    A6NNS2: 'DHRS7C',
    A6NNW6: 'ENO4',
    A6QL63: 'ABTB3',
    A6XGL0: 'YJEFN3',
    A6ZKI3: 'RTL8C',
    A7E2F4: 'GOLGA8A',
    A7MBM2: 'DISP2',
    A8K855: 'EFCAB7',
    A8K979: 'ERI2',
    A8MPP1: 'DDX11L8',
    A8MQT2: 'GOLGA8B',
    A8MTL9: 'HMSD',
    A8MUK1: 'USP17L5',
    A8MV81: 'HIGD1C',
    A8MWY0: 'ELAPOR2',
    A9QM74: 'KPNA7',
    A9Z1Z3: 'FER1L4',
    B1APH4: 'ZNF487',
    B2RNN3: 'C1QTNF9B',
    B2RU33: 'POTEC',
    B2RXH8: 'HNRNPCL2',
    B3EWF7: 'EPM2A',
    B3EWG5: 'FAM25C',
    B4DS77: 'SHISA9',
    B8ZZ34: 'SHISA8',
    B9A064: 'IGLL5',
    C0HLU2: 'ZNF689',
    C0HM02: 'PRKCH',
    E9PAV3: 'NACA',
    E9PQX1: 'TMEM262',
    G9CGD6: 'CNK3/IPCEF1',
    L0R8F8: 'MIEF1',
    M5A8F1: 'ERVH48-1',
    O00178: 'GTPBP1',
    O00295: 'TULP2',
    O00321: 'ETV2',
    O00398: 'P2RY10',
    O00399: 'DCTN6',
    O00458: 'IFRD1',
    O00515: 'LAD1',
    O00534: 'VWA5A',
    O00570: 'SOX1',
    O00624: 'SLC17A2',
    O00634: 'NTN3',
    O14513: 'NCKAP5',
    O14545: 'TRAFD1',
    O14548: 'COX7A2L',
    O14599: 'BPY2',
    O14599: 'BPY2B',
    O14599: 'BPY2C',
    O14602: 'EIF1AY',
    O14626: 'GPR171',
    O14668: 'PRRG1',
    O14709: 'ZNF197',
    O14718: 'RRH',
    O14753: 'OVOL1',
    O14804: 'TAAR5',
    O15016: 'TRIM66',
    O15034: 'RIMBP2',
    O15037: 'KHNYN',
    O15063: 'GARRE1',
    O15069: 'NACAD',
    O15090: 'ZNF536',
    O15213: 'WDR46',
    O15218: 'GPR182',
    O15235: 'MRPS12',
    O15321: 'TM9SF1',
    O15335: 'CHAD',
    O15375: 'SLC16A5',
    O15403: 'SLC16A6',
    O15417: 'TNRC18',
    O15432: 'SLC31A2',
    O15539: 'RGS5',
    O43301: 'HSPA12A',
    O43345: 'ZNF208',
    O43347: 'MSI1',
    O43414: 'ERI3',
    O43448: 'KCNAB3',
    O43555: 'GNRH2',
    O43638: 'FOXS1',
    O43657: 'TSPAN6',
    O43677: 'NDUFC1',
    O43692: 'PI15',
    O43736: 'ITM2A',
    O43908: 'KLRC4',
    O43930: 'PRKY',
    O43934: 'MFSD11',
    O60225: 'SSX5',
    O60234: 'GMFG',
    O60245: 'PCDH7',
    O60262: 'GNG7',
    O60279: 'SUSD5',
    O60299: 'LZTS3',
    O60330: 'PCDHGA12',
    O60403: 'OR10H2',
    O60404: 'OR10H3',
    O60412: 'OR7C2',
    O60422: 'ONECUT3',
    O60516: 'EIF4EBP3',
    O60522: 'TDRD6',
    O60542: 'PSPN',
    O60676: 'CST8',
    O60765: 'ZNF354A',
    O60774: 'FMO6P',
    O60811: 'PRAMEF2',
    O71037: 'ERVK-19',
    O75064: 'DENND4B',
    O75095: 'MEGF6',
    O75123: 'ZNF623',
    O75153: 'CLUH',
    O75325: 'LRRN2',
    O75335: 'PPFIA4',
    O75346: 'ZNF253',
    O75352: 'MPDU1',
    O75363: 'BCAS1',
    O75388: 'GPR32',
    O75394: 'MRPL33',
    O75437: 'ZNF254',
    O75459: 'PAGE1',
    O75493: 'CA11',
    O75541: 'ZNF821',
    O75570: 'MTRF1',
    O75596: 'CLEC3A',
    O75628: 'REM1',
    O75635: 'SERPINB7',
    O75678: 'RFPL2',
    O75683: 'SURF6',
    O75690: 'KRTAP5-8',
    O75711: 'SCRG1',
    O75715: 'GPX5',
    O75764: 'TCEA3',
    O75820: 'ZNF189',
    O75830: 'SERPINI2',
    O75901: 'RASSF9',
    O75947: 'ATP5PD',
    O75953: 'DNAJB5',
    O75956: 'CDK2AP2',
    O75964: 'ATP5MG',
    O75973: 'C1QL1',
    O75995: 'SASH3',
    O76001: 'OR2J3',
    O76002: 'OR2J2',
    O76009: 'KRT33A',
    O76038: 'SCGN',
    O76099: 'OR7C1',
    O94772: 'LY6H',
    O94854: 'MACF1',
    O94889: 'KLHL18',
    O94892: 'ZNF432',
    O94903: 'PLPBP',
    O94913: 'PCF11',
    O94988: 'FAM13A',
    O95007: 'OR6B1',
    O95025: 'SEMA3D',
    O95076: 'ALX3',
    O95084: 'PRSS23',
    O95164: 'UBL3',
    O95190: 'OAZ2',
    O95199: 'RCBTB2',
    O95222: 'OR6A2',
    O95260: 'ATE1',
    O95336: 'PGLS',
    O95371: 'OR2C1',
    O95411: 'MYO18A',
    O95455: 'TGDS',
    O95620: 'DUS4L',
    O95625: 'ZBTB11',
    O95661: 'DIRAS3',
    O95685: 'PPP1R3D',
    O95755: 'RAB36',
    O95757: 'HSPA4L',
    O95759: 'TBC1D8',
    O95780: 'ZNF682',
    O95800: 'GPR75',
    O95838: 'GLP2R',
    O95841: 'ANGPTL1',
    O95847: 'SLC25A27',
    O95918: 'OR2H2',
    O95965: 'ITGBL1',
    O95976: 'IGSF6',
    P01599: 'IGKV1-17',
    P01601: 'IGKV1D-16',
    P01614: 'IGKV2D-40',
    P01624: 'IGKV3-15',
    P01703: 'IGLV1-40',
    P01714: 'IGLV3-19',
    P01715: 'IGLV3-1',
    P01717: 'IGLV3-25',
    P01718: 'IGLV3-27',
    P01733: 'TRBV12-3',
    P03979: 'TRGV3',
    P03986: 'TRGC2',
    P04211: 'IGLV7-43',
    P04430: 'IGKV1-16',
    P04433: 'IGKV3-11',
    P04435: 'TRBV7-9',
    P04437: 'TRAV29DV5',
    P04808: 'RLN1',
    P05015: 'IFNA16',
    P06310: 'IGKV2-30',
    P06315: 'IGKV5-2',
    P07311: 'ACYP1',
    P07316: 'CRYGB',
    P09001: 'MRPL3',
    P09093: 'CELA3A',
    P09105: 'HBQ1',
    P09630: 'HOXC6',
    P0C0E4: 'RAB40AL',
    P0C1H6: 'H2BW2',
    P0C263: 'SBK2',
    P0C617: 'OR5AL1',
    P0C626: 'OR5G3',
    P0C645: 'OR4E1',
    P0C6T2: 'OST4',
    P0C7M3: 'SFTA3',
    P0C7M4: 'RHOXF2B',
    P0C7M7: 'ACSM4',
    P0C7P1: 'RBMY1D',
    P0C7T4: 'HMSD',
    P0C7U0: 'ELFN1',
    P0C7U3: 'ZDHHC11B',
    P0C862: 'C1QTNF9',
    P0C8F1: 'PATE4',
    P0CE72: 'OCM',
    P0CF51: 'TRGC1',
    P0CG13: 'CHTF8',
    P0CG21: 'NHLRC4',
    P0CG29: 'GSTT2',
    P0CG34: 'TMSB15A',
    P0CI25: 'TRIM49',
    P0CJ72: 'MTRNR2L5',
    P0CW23: 'AKAIN1',
    P0DJ07: 'PET100',
    P0DJD4: 'RBMY1C',
    P0DN87: 'CGB7',
    P0DP01: 'IGHV1-8',
    P0DP02: 'IGHV3-30-3',
    P0DP04: 'IGHV3-43D',
    P0DP06: 'IGHV4-30-4',
    P0DP07: 'IGHV4-31',
    P0DP08: 'IGHV4-38-2',
    P0DP74: 'DEFB130A',
    P0DUQ2: 'PRAMEF9',
    P10072: 'ZNF875',
    P10266: 'ERVK-10',
    P10915: 'HAPLN1',
    P12872: 'MLN',
    P14621: 'ACYP2',
    P15088: 'CPA3',
    P15621: 'ZNF44',
    P16260: 'SLC25A16',
    P17019: 'ZNF708',
    P17025: 'ZNF182',
    P17026: 'ZNF22',
    P17029: 'ZKSCAN1',
    P17030: 'ZNF25',
    P17031: 'ZNF26',
    P17032: 'ZNF37A',
    P17035: 'ZNF28',
    P17038: 'ZNF43',
    P17039: 'ZNF30',
    P17097: 'ZNF7',
    P17098: 'ZNF8',
    P17538: 'CTRB1',
    P19961: 'AMY2B',
    P20382: 'PMCH',
    P21506: 'ZNF10',
    P22090: 'RPS4Y1',
    P22531: 'SPRR2E',
    P22532: 'SPRR2D',
    P22676: 'CALB2',
    P27482: 'CALML3',
    P29377: 'S100G',
    P29762: 'CRABP1',
    P30408: 'TM4SF1',
    P30953: 'OR1E1',
    P30954: 'OR10J1',
    P31267: 'HOXA6',
    P31277: 'HOXD11',
    P32314: 'FOXN2',
    P33552: 'CKS2',
    P34820: 'BMP8B',
    P35325: 'SPRR2B',
    P35542: 'SAA4',
    P35663: 'CYLC1',
    P36537: 'UGT2B10',
    P36915: 'GNL1',
    P40205: 'MYCNOS',
    P40313: 'CTRL',
    P42696: 'RBM34',
    P43116: 'PTGER2',
    P43308: 'SSR2',
    P43363: 'MAGEA10',
    P43627: 'KIR2DL2',
    P46095: 'GPR6',
    P47775: 'GPR12',
    P47874: 'OMP',
    P47883: 'OR3A4P',
    P47887: 'OR1E2',
    P47888: 'OR3A3',
    P47893: 'OR3A2',
    P47972: 'NPTX2',
    P48060: 'GLIPR1',
    P48741: 'HSPA7',
    P49406: 'MRPL19',
    P50120: 'RBP2',
    P51504: 'ZNF80',
    P51508: 'ZNF81',
    P51522: 'ZNF83',
    P51689: 'ARSD',
    P51815: 'ZNF75D',
    P51911: 'CNN1',
    P52737: 'ZNF136',
    P52741: 'ZNF134',
    P52746: 'ZNF142',
    P54792: 'DVL1P1',
    P54793: 'ARSF',
    P54826: 'GAS1',
    P55082: 'MFAP3',
    P55103: 'INHBC',
    P55808: 'XG',
    P56179: 'DLX6',
    P56277: 'CMC4',
    P56378: 'ATP5MJ',
    P56385: 'ATP5ME',
    P56749: 'CLDN12',
    P56880: 'CLDN20',
    P57058: 'HUNK',
    P57077: 'MAP3K7CL',
    P57723: 'PCBP4',
    P57738: 'TCTA',
    P57773: 'GJA9',
    P57775: 'FBXW4',
    P58062: 'SPINK7',
    P58166: 'INHBE',
    P58173: 'OR2B6',
    P58182: 'OR12D2',
    P58294: 'PROK1',
    P58317: 'ZNF121',
    P58557: 'YBEY',
    P58658: 'EVA1C',
    P58872: 'RHBDL3',
    P59025: 'RTP1',
    P59045: 'NLRP11',
    P59074: 'CHMP4BP1',
    P59282: 'TPPP2',
    P59533: 'TAS2R38',
    P59534: 'TAS2R39',
    P59535: 'TAS2R40',
    P59537: 'TAS2R43',
    P59538: 'TAS2R31',
    P59540: 'TAS2R46',
    P59543: 'TAS2R20',
    P59768: 'GNG2',
    P59796: 'GPX6',
    P59797: 'SELENOV',
    P59826: 'BPIFB3',
    P60153: 'RNASE9',
    P60331: 'KRTAP10-1',
    P60369: 'KRTAP10-3',
    P60413: 'KRTAP10-12',
    P60509: 'ERVPABLB-1',
    P60608: 'ERVFC1-1',
    P60827: 'C1QTNF8',
    P60893: 'GPR85',
    P60983: 'GMFB',
    P61366: 'OSTN',
    P61550: 'ERVS71-1',
    P61565: 'ERVK-21',
    P61566: 'ERVK-24',
    P61567: 'ERVK-7',
    P62683: 'ERVK-21',
    P62684: 'HERVK_113',
    P62685: 'ERVK-8',
    P63123: 'ERVK-18',
    P63129: 'ERVK-24',
    P63130: 'ERVK-7',
    P63132: 'HERVK_113',
    P63133: 'ERVK-8',
    P63135: 'ERVK-7',
    P63136: 'ERVK-25',
    P63145: 'ERVK-24',
    P63215: 'GNG3',
    P63313: 'TMSB10',
    P68543: 'UBXN2A',
    P69849: 'NOMO3',
    P78312: 'FAM193A',
    P78414: 'IRX1',
    P80748: 'IGLV3-21',
    P81133: 'SIM1',
    P81408: 'ENTREP3',
    P81877: 'SSBP2',
    P82663: 'MRPS25',
    P82673: 'MRPS35',
    P82675: 'MRPS5',
    P82914: 'MRPS15',
    P82921: 'MRPS21',
    P82932: 'MRPS6',
    P82933: 'MRPS9',
    P82970: 'HMGN5',
    P82980: 'RBP5',
    P83859: 'QRFP',
    P84101: 'SERF2',
    P86791: 'CCZ1',
    P87889: 'ERVK-10',
    P98169: 'ZXDB',
    P98173: 'FAM3A',
    Q01459: 'CTBS',
    Q01995: 'TAGLN',
    Q02045: 'MYL5',
    Q02338: 'BDH1',
    Q02386: 'ZNF45',
    Q02509: 'OC90',
    Q03169: 'TNFAIP2',
    Q03701: 'CEBPZ',
    Q03828: 'EVX2',
    Q03936: 'ZNF92',
    Q05048: 'CSTF1',
    Q05952: 'TNP2',
    Q05D32: 'CTDSPL2',
    Q06732: 'ZNF33B',
    Q07507: 'DPT',
    Q08ER8: 'ZNF543',
    Q0D2J5: 'ZNF763',
    Q12765: 'SCRN1',
    Q12788: 'TBL3',
    Q12796: 'PNRC1',
    Q12829: 'RAB40B',
    Q12872: 'SFSWAP',
    Q12926: 'ELAVL2',
    Q12950: 'FOXD4',
    Q12988: 'HSPB3',
    Q12999: 'TSPAN31',
    Q13103: 'SPP2',
    Q13106: 'ZNF154',
    Q13203: 'MYBPH',
    Q13368: 'MPP3',
    Q13401: 'PMS2P3',
    Q13434: 'MKRN4P',
    Q13442: 'PDAP1',
    Q13606: 'OR5I1',
    Q13607: 'OR2F1',
    Q13938: 'CAPS',
    Q13939: 'CCIN',
    Q14093: 'CYLC2',
    Q14094: 'CCNI',
    Q14201: 'BTG3',
    Q14206: 'RCAN2',
    Q14324: 'MYBPC2',
    Q14409: 'GK3',
    Q14439: 'GPR176',
    Q14568: 'HSP90AA2P',
    Q14576: 'ELAVL3',
    Q14590: 'ZNF235',
    Q14593: 'ZNF273',
    Q14641: 'INSL4',
    Q14667: 'BLTP2',
    Q14681: 'KCTD2',
    Q14728: 'MFSD10',
    Q14952: 'KIR2DS3',
    Q14C87: 'TMEM132D',
    Q15034: 'HERC3',
    Q15035: 'TRAM2',
    Q15048: 'LRRC14',
    Q15198: 'PDGFRL',
    Q15238: 'PSG5',
    Q15270: 'NKX1-1',
    Q15390: 'MTFR1',
    Q15391: 'P2RY14',
    Q15404: 'RSU1',
    Q15486: 'GUSBP1',
    Q15612: 'OR1Q1',
    Q15617: 'OR8G1',
    Q15620: 'OR8B8',
    Q15695: 'ZRSR2P1',
    Q15760: 'GPR19',
    Q15847: 'ADIRF',
    Q15884: 'ENTREP1',
    Q15937: 'ZNF79',
    Q16378: 'PRR4',
    Q16538: 'GPR162',
    Q16557: 'PSG3',
    Q16589: 'CCNG2',
    Q16609: 'LPAL2',
    Q16661: 'GUCA2B',
    Q17RB0: 'RTL8B',
    Q17RF5: 'ODAPH',
    Q17RN3: 'FAM98C',
    Q17RR3: 'PNLIPRP3',
    Q17RY6: 'LY6K',
    Q19AV6: 'ZSWIM7',
    Q1L6U9: 'MSMP',
    Q1ZZU3: 'SWI5',
    Q2KJY2: 'KIF26B',
    Q2L4Q9: 'PRSS53',
    Q2M1V0: 'ISX',
    Q2M2H8: 'MGAM2',
    Q2M3G4: 'SHROOM1',
    Q2M3X9: 'ZNF674',
    Q2MJR0: 'SPRED3',
    Q2NKX9: 'C2orf68',
    Q2NL68: 'PROSER3',
    Q2NL82: 'TSR1',
    Q2NL98: 'VMAC',
    Q2T9K0: 'TMEM44',
    Q2T9L4: 'INSYN1',
    Q2TAC6: 'KIF19',
    Q2TAP0: 'GOLGA7B',
    Q2TBC4: 'PRICKLE4',
    Q2TV78: 'MST1L',
    Q2VIR3: 'EIF2S3B',
    Q2VPB7: 'AP5B1',
    Q2VWP7: 'PRTG',
    Q2VYF4: 'LETM2',
    Q30KP8: 'DEFB136',
    Q32M78: 'ZNF699',
    Q32ZL2: 'PLPPR5',
    Q3B726: 'POLR1F',
    Q3B8N2: 'LGALS9B',
    Q3BBV0: 'NBPF1',
    Q3I5F7: 'ACOT6',
    Q3KNT7: 'NSUN5P1',
    Q3KNT9: 'TMEM95',
    Q3KP22: 'MAJIN',
    Q3KPI0: 'CEACAM21',
    Q3KQU3: 'MAP7D1',
    Q3LI77: 'KRTAP13-4',
    Q3LIE5: 'ADPRM',
    Q3MIN7: 'RGL3',
    Q3MJ13: 'WDR72',
    Q3SX64: 'CIMAP1D',
    Q3SY17: 'SLC25A52',
    Q3SY52: 'ZIK1',
    Q3SY77: 'UGT3A2',
    Q3ZCN5: 'OTOGL',
    Q3ZCQ3: 'FAM174B',
    Q3ZCT1: 'ZNF260',
    Q3ZCX4: 'ZNF568',
    Q494W8: 'CHRFAM7A',
    Q495N2: 'SLC36A3',
    Q496Y0: 'LONRF3',
    Q49AA0: 'ZFP69',
    Q49AH0: 'CDNF',
    Q49B96: 'COX19',
    Q49SQ1: 'GPR33',
    Q4G0A6: 'MINDY4',
    Q4G0M1: 'ERFE',
    Q4G0T1: 'SCART1',
    Q4G148: 'GXYLT1',
    Q4G1C9: 'GLIPR1L2',
    Q4LEZ3: 'AARD',
    Q4U2R6: 'MRPL51',
    Q4VNC0: 'ATP13A5',
    Q4VX76: 'SYTL3',
    Q4ZIN3: 'TMEM259',
    Q504T8: 'MIDN',
    Q52MB2: 'CCDC184',
    Q52WX2: 'SBK1',
    Q53G44: 'IFI44L',
    Q53GI3: 'ZNF394',
    Q53HC5: 'KLHL26',
    Q53QW1: 'TEX44',
    Q53QZ3: 'ARHGAP15',
    Q53RD9: 'FBLN7',
    Q53T59: 'HS1BP3',
    Q562R1: 'ACTBL2',
    Q567V2: 'MPV17L2',
    Q569H4: 'PRR16',
    Q587J7: 'TDRD12',
    Q58FF7: 'HSP90AB3P',
    Q58FF8: 'HSP90AB2P',
    Q58FG1: 'HSP90AA4P',
    Q58G82: 'SYT14P1',
    Q5BIV9: 'SPRN',
    Q5BN46: 'PIERCE1',
    Q5DT21: 'SPINK9',
    Q5FWE3: 'PRRT3',
    Q5FWF6: 'ZNF789',
    Q5FYB0: 'ARSJ',
    Q5GAN6: 'RNASE10',
    Q5H9L4: 'TAF7L',
    Q5H9T9: 'FSCB',
    Q5H9U9: 'DDX60L',
    Q5HY92: 'FIGN',
    Q5HYI7: 'MTX3',
    Q5HYJ1: 'TECRL',
    Q5HYM0: 'ZC3H12B',
    Q5J5C9: 'DEFB121',
    Q5JQC4: 'CT47A1',
    Q5JQC4: 'CT47A10',
    Q5JQC4: 'CT47A11',
    Q5JQC4: 'CT47A12',
    Q5JQC4: 'CT47A2',
    Q5JQC4: 'CT47A3',
    Q5JQC4: 'CT47A4',
    Q5JQC4: 'CT47A5',
    Q5JQC4: 'CT47A6',
    Q5JQC4: 'CT47A7',
    Q5JQC4: 'CT47A8',
    Q5JQC4: 'CT47A9',
    Q5JR12: 'PPM1J',
    Q5JRM2: 'CXorf66',
    Q5JSL3: 'DOCK11',
    Q5JSZ5: 'PRRC2B',
    Q5JT82: 'KLF17',
    Q5JTY5: 'ZNG1C',
    Q5JU67: 'CFAP157',
    Q5JU69: 'TOR2A',
    Q5JUW0: 'KRBOX4',
    Q5JUX0: 'SPIN3',
    Q5JXA9: 'SIRPB2',
    Q5M9Q1: 'NKAPL',
    Q5MAI5: 'CDKL4',
    Q5MJ09: 'SPANXN3',
    Q5MJ68: 'SPDYC',
    Q5QJ74: 'TBCEL',
    Q5SRI9: 'MANEA',
    Q5SRN2: 'TSBP1',
    Q5SXM8: 'DNLZ',
    Q5SY80: 'CATSPERE',
    Q5SZJ8: 'BEND6',
    Q5T013: 'HYI',
    Q5T0D9: 'TPRG1L',
    Q5T0L3: 'SPATA46',
    Q5T1Q4: 'SLC35F1',
    Q5T2E6: 'ARMH3',
    Q5T3F8: 'TMEM63B',
    Q5T4T1: 'TMEM170B',
    Q5T4T6: 'SYCP2L',
    Q5T5A4: 'CFAP276',
    Q5T653: 'MRPL2',
    Q5T6L9: 'ERMARD',
    Q5T7N2: 'L1TD1',
    Q5T848: 'GPR158',
    Q5T871: 'LELP1',
    Q5T8P6: 'RBM26',
    Q5T9C2: 'EEIG1',
    Q5TAH2: 'SLC9C2',
    Q5TBC7: 'BCL2L15',
    Q5TC79: 'ZBTB37',
    Q5TDP6: 'LGSN',
    Q5TEC6: 'H3-7',
    Q5TFQ8: 'SIRPB1',
    Q5TGS1: 'HES3',
    Q5TH74: 'STPG1',
    Q5TIA1: 'MEI1',
    Q5TID7: 'CCDC181',
    Q5TYM5: 'FAM72A',
    Q5TYW1: 'ZNF658',
    Q5U5R9: 'HECTD2',
    Q5U623: 'ATF7IP2',
    Q5VT97: 'SYDE2',
    Q5VTE0: 'EEF1A1P5',
    Q5VTH9: 'DNAI4',
    Q5VTQ0: 'TTC39B',
    Q5VTT2: 'CFAP95',
    Q5VU97: 'CACHD1',
    Q5VUJ9: 'EFCAB2',
    Q5VUM1: 'SDHAF4',
    Q5VV17: 'OTUD1',
    Q5VV52: 'ZNF691',
    Q5VV63: 'ATRNL1',
    Q5VVH5: 'IRAK1BP1',
    Q5VVW2: 'GARNL3',
    Q5VW32: 'BROX',
    Q5VW36: 'FOCAD',
    Q5VXH4: 'PRAMEF6',
    Q5VXJ0: 'LIPK',
    Q5VXT5: 'SYPL2',
    Q5VXU1: 'NKAIN2',
    Q5VYS4: 'MEDAG',
    Q5VYY2: 'LIPM',
    Q5VZB9: 'DMRTA1',
    Q5VZP5: 'STYXL2',
    Q5W0U4: 'BSPRY',
    Q5XG92: 'CES4A',
    Q5XX13: 'FBXW10',
    Q63HK3: 'ZKSCAN2',
    Q63HM1: 'AFMID',
    Q641Q3: 'METRNL',
    Q658Y4: 'FAM91A1',
    Q66K14: 'TBC1D9B',
    Q66K41: 'ZNF385C',
    Q66K66: 'TMEM198',
    Q66LE6: 'PPP2R2D',
    Q68BL7: 'OLFML2A',
    Q68BL8: 'OLFML2B',
    Q68CR1: 'SEL1L3',
    Q68D51: 'DENND2C',
    Q68DU8: 'KCTD16',
    Q68DY1: 'ZNF626',
    Q69YN2: 'CWF19L1',
    Q69YU5: 'UQCC6',
    Q6A1A2: 'PDPK2P',
    Q6A555: 'TXNDC8',
    Q6AZW8: 'ZNF660',
    Q6B0K9: 'HBM',
    Q6BDS2: 'BLTP3A',
    Q6DHY5: 'TBC1D3G',
    Q6DWJ6: 'GPR139',
    Q6ECI4: 'ZNF470',
    Q6EKJ0: 'GTF2IRD2B',
    Q6GPH6: 'ITPRIPL1',
    Q6H9L7: 'ISM2',
    Q6IEE7: 'TMEM132E',
    Q6IFH4: 'OR6B2',
    Q6IMI4: 'SULT6B1',
    Q6IPR1: 'ETFRF1',
    Q6IPR3: 'TYW3',
    Q6IPT4: 'CYB5RL',
    Q6IQ32: 'ADNP2',
    Q6ISS4: 'LAIR2',
    Q6JEL2: 'KLHL10',
    Q6MZT1: 'RGS7BP',
    Q6MZW2: 'FSTL4',
    Q6MZZ7: 'CAPN13',
    Q6N063: 'OGFOD2',
    Q6NSX1: 'CCDC70',
    Q6NSZ9: 'ZSCAN25',
    Q6NT32: 'CES5A',
    Q6NUJ1: 'PSAPL1',
    Q6NUK4: 'REEP3',
    Q6NUM6: 'TYW1B',
    Q6NUM9: 'RETSAT',
    Q6NUS8: 'UGT3A1',
    Q6NVV7: 'CDPF1',
    Q6NVV9: 'ADAM5',
    Q6NW34: 'NEPRO',
    Q6NXE6: 'ARMC6',
    Q6NXR0: 'IRGC',
    Q6NXT1: 'ANKRD54',
    Q6NY19: 'KANK3',
    Q6NZ67: 'MZT2B',
    Q6P161: 'MRPL54',
    Q6P1K8: 'GTF2H2C',
    Q6P1K8: 'GTF2H2C_2',
    Q6P1L8: 'MRPL14',
    Q6P1R4: 'DUS1L',
    Q6P1S2: 'C3orf33',
    Q6P3S6: 'FBXO42',
    Q6P444: 'MTFR2',
    Q6P461: 'ACSM6',
    Q6P499: 'NIPAL3',
    Q6P4D5: 'PABIR3',
    Q6P4E1: 'GOLM2',
    Q6P4F7: 'ARHGAP11A',
    Q6P582: 'MZT2A',
    Q6P5S2: 'LEG1',
    Q6P996: 'PDXDC1',
    Q6P9G4: 'TMEM154',
    Q6P9H5: 'GIMAP6',
    Q6PCB8: 'EMB',
    Q6PDA7: 'SPAG11A',
    Q6PEY0: 'GJB7',
    Q6PF04: 'ZNF613',
    Q6PI73: 'LILRA6',
    Q6PII3: 'CCDC174',
    Q6PJ21: 'SPSB3',
    Q6PJ69: 'TRIM65',
    Q6PJG2: 'MIDEAS',
    Q6PJQ5: 'FOXR2',
    Q6PK18: 'OGFOD3',
    Q6PKH6: 'DHRS4L2',
    Q6Q0C1: 'SLC25A47',
    Q6Q8B3: 'CD200R1L',
    Q6QEF8: 'CORO6',
    Q6R2W3: 'SCAND3',
    Q6RSH7: 'VHLL',
    Q6S8J3: 'POTEE',
    Q6SJ96: 'TBPL2',
    Q6T310: 'RASL11A',
    Q6T4P5: 'PLPPR3',
    Q6TDP4: 'KLHL17',
    Q6TDU7: 'DNAI7',
    Q6UQ28: 'PLET1',
    Q6UW32: 'IGFL1',
    Q6UW49: 'SPESP1',
    Q6UWD8: 'C16orf54',
    Q6UWJ1: 'TMCO3',
    Q6UWL2: 'SUSD1',
    Q6UWM5: 'GLIPR1L1',
    Q6UWM7: 'LCTL',
    Q6UWN8: 'SPINK6',
    Q6UWQ7: 'IGFL2',
    Q6UWT4: 'C5orf46',
    Q6UWV2: 'MPZL3',
    Q6UWW9: 'TMEM207',
    Q6UX07: 'DHRS13',
    Q6UX52: 'C17orf99',
    Q6UX53: 'TMT1B',
    Q6UX73: 'C16orf89',
    Q6UXA7: 'C6orf15',
    Q6UXC1: 'MAMDC4',
    Q6UXH9: 'PAMR1',
    Q6UXI7: 'VIT',
    Q6UXK5: 'LRRN1',
    Q6UXN2: 'TREML4',
    Q6UXU4: 'GSG1L',
    Q6UXX5: 'ITIH6',
    Q6UY11: 'DLK2',
    Q6V1P9: 'DCHS2',
    Q6VUC0: 'TFAP2E',
    Q6W3E5: 'GDPD4',
    Q6WBX8: 'RAD9B',
    Q6X784: 'ZPBP2',
    Q6XPR3: 'RPTN',
    Q6XYB7: 'LBX2',
    Q6YFQ2: 'COX6B2',
    Q6YI46: 'TMEM64',
    Q6ZMB5: 'TMEM184A',
    Q6ZMD2: 'SPNS3',
    Q6ZMK1: 'TMEM276',
    Q6ZMK1: 'ZFTRAF1',
    Q6ZMP0: 'THSD4',
    Q6ZMR3: 'LDHAL6A',
    Q6ZMV9: 'KIF6',
    Q6ZMY3: 'SPOCD1',
    Q6ZN11: 'ZNF793',
    Q6ZN28: 'MACC1',
    Q6ZN54: 'DEF8',
    Q6ZN66: 'GBP6',
    Q6ZNB6: 'NFXL1',
    Q6ZNW5: 'GDPGP1',
    Q6ZP65: 'BICDL1',
    Q6ZPB5: 'SDIM1',
    Q6ZR52: 'ZNF493',
    Q6ZRH7: 'CATSPERG',
    Q6ZS27: 'ZNF662',
    Q6ZS72: 'PEAK3',
    Q6ZS81: 'WDFY4',
    Q6ZS82: 'RGS9BP',
    Q6ZSG2: 'INSYN2A',
    Q6ZTA4: 'TRIM67',
    Q6ZTI6: 'RFLNA',
    Q6ZTQ3: 'RASSF6',
    Q6ZTR7: 'CIBAR2',
    Q6ZTW0: 'TPGS1',
    Q6ZUB1: 'SPATA31E1',
    Q6ZUT9: 'DENND5B',
    Q6ZUV0: 'ACOT7L',
    Q6ZUX3: 'TOGARAM2',
    Q6ZVH7: 'ESPNL',
    Q6ZVX7: 'NCCRP1',
    Q6ZVX9: 'PAQR9',
    Q6ZW05: 'PTCHD4',
    Q6ZWE6: 'PLEKHM3',
    Q6ZWJ8: 'KCP',
    Q6ZWK6: 'TMPRSS11F',
    Q701N2: 'KRTAP5-5',
    Q70EK8: 'USP53',
    Q70Z53: 'FRA10AC1',
    Q711Q0: 'CEFIP',
    Q717R9: 'CYS1',
    Q76B58: 'BRINP3',
    Q76KP1: 'B4GALNT4',
    Q7L0R7: 'RNF44',
    Q7L1V2: 'MON1B',
    Q7L2K0: 'TEDC2',
    Q7L3S4: 'ZNF771',
    Q7L3T8: 'PARS2',
    Q7L9B9: 'EEPD1',
    Q7LDI9: 'ERVK-6',
    Q7M4L6: 'SHF',
    Q7RTM1: 'OTOP1',
    Q7RTR8: 'TAS2R42',
    Q7RTS5: 'OTOP3',
    Q7RTU9: 'STRC',
    Q7RTV2: 'GSTA5',
    Q7RTV3: 'ZNF367',
    Q7RTY5: 'PRSS48',
    Q7RTY7: 'OVCH1',
    Q7RTY8: 'TMPRSS7',
    Q7RTY9: 'PRSS41',
    Q7RTZ2: 'USP17L1',
    Q7Z2G1: 'H2BW1',
    Q7Z2K8: 'GPRIN1',
    Q7Z2T5: 'TRMT1L',
    Q7Z2W9: 'MRPL21',
    Q7Z340: 'ZNF551',
    Q7Z398: 'ZNF550',
    Q7Z3D4: 'LYSMD3',
    Q7Z3D6: 'DGLUCY',
    Q7Z3G6: 'PRICKLE2',
    Q7Z3H4: 'SAMD7',
    Q7Z3Q1: 'SLC46A3',
    Q7Z3T1: 'OR2W3',
    Q7Z3V4: 'UBE3B',
    Q7Z3Z3: 'PIWIL3',
    Q7Z408: 'CSMD2',
    Q7Z444: 'ERAS',
    Q7Z4G4: 'TRMT11',
    Q7Z4H3: 'HDDC2',
    Q7Z4J2: 'GLT6D1',
    Q7Z4L9: 'PPP1R42',
    Q7Z4W2: 'LYZL2',
    Q7Z553: 'MDGA2',
    Q7Z5A4: 'PRSS42P',
    Q7Z5H4: 'VN1R5',
    Q7Z5H5: 'VN1R4',
    Q7Z5M8: 'ABHD12B',
    Q7Z601: 'GPR142',
    Q7Z692: 'CEACAM19',
    Q7Z695: 'ADCK2',
    Q7Z6J2: 'TAMALIN',
    Q7Z6K4: 'NRARP',
    Q7Z6Z6: 'PNPLA5',
    Q7Z713: 'ANKRD37',
    Q7Z745: 'MROH2B',
    Q7Z7A3: 'CTU1',
    Q7Z7B7: 'DEFB132',
    Q7Z7F7: 'MRPL55',
    Q7Z7J5: 'DPPA2',
    Q7Z7J7: 'LHFPL4',
    Q7Z7L7: 'ZER1',
    Q7Z7L9: 'ZSCAN2',
    Q7Z7M1: 'ADGRD2',
    Q86SG7: 'LYG2',
    Q86SP6: 'GPR149',
    Q86SX3: 'TEDC1',
    Q86TA1: 'MOB3B',
    Q86TD4: 'SRL',
    Q86TJ5: 'ZNF554',
    Q86TN4: 'TRPT1',
    Q86U38: 'NOP9',
    Q86UA1: 'PRPF39',
    Q86UB2: 'BIVM',
    Q86UB9: 'TMEM135',
    Q86UE3: 'ZNF546',
    Q86UP6: 'CUZD1',
    Q86UP8: 'GTF2IRD2',
    Q86UW8: 'HAPLN4',
    Q86UY8: 'NT5DC3',
    Q86V21: 'AACS',
    Q86V35: 'CABP7',
    Q86VH4: 'LRRTM4',
    Q86VI1: 'EXOC3L1',
    Q86VR7: 'VSIG10L',
    Q86VX2: 'COMMD7',
    Q86VZ1: 'P2RY8',
    Q86W11: 'ZSCAN30',
    Q86W28: 'NLRP8',
    Q86W33: 'TPRA1',
    Q86W67: 'FAM228A',
    Q86WC6: 'PPP1R27',
    Q86WI0: 'LHFPL1',
    Q86WK7: 'AMIGO3',
    Q86WK9: 'PAQR7',
    Q86WN2: 'IFNE',
    Q86WS5: 'TMPRSS12',
    Q86WW8: 'COA5',
    Q86X10: 'RALGAPB',
    Q86X19: 'TMEM17',
    Q86X27: 'RALGPS2',
    Q86X76: 'NIT1',
    Q86X83: 'COMMD2',
    Q86XD5: 'FAM131B',
    Q86XH1: 'IQCA1',
    Q86XI6: 'PPP1R3B',
    Q86XP6: 'GKN2',
    Q86XR2: 'NIBAN3',
    Q86XR5: 'PRIMA1',
    Q86XT9: 'TMEM219',
    Q86XW9: 'NME9',
    Q86Y22: 'COL23A1',
    Q86Y25: 'ZNF354C',
    Q86YE8: 'ZNF573',
    Q86YH2: 'ZNF280B',
    Q86YL5: 'TDRP',
    Q86YN1: 'DOLPP1',
    Q86YV6: 'MYLK4',
    Q8IUC0: 'KRTAP13-1',
    Q8IUE0: 'TGIF2LY',
    Q8IUE1: 'TGIF2LX',
    Q8IUZ0: 'LRRC49',
    Q8IVV2: 'LOXHD1',
    Q8IVW1: 'ARL17A',
    Q8IVW1: 'ARL17B',
    Q8IW03: 'SIAH3',
    Q8IW36: 'ZNF695',
    Q8IW93: 'ARHGEF19',
    Q8IWA0: 'WDR75',
    Q8IWB9: 'TEX2',
    Q8IWF6: 'DENND6A',
    Q8IWP9: 'CCDC28A',
    Q8IWR0: 'ZC3H7A',
    Q8IWY8: 'ZSCAN29',
    Q8IX06: 'REXO1L1P',
    Q8IX18: 'DHX40',
    Q8IX29: 'FBXO16',
    Q8IXS6: 'PALM2',
    Q8IXT1: 'DDIAS',
    Q8IXY8: 'PPIL6',
    Q8IXZ3: 'SP8',
    Q8IY67: 'RAVER1',
    Q8IYD9: 'LAS2',
    Q8IYK8: 'REM2',
    Q8IYL2: 'TRMT44',
    Q8IYN2: 'TCEAL8',
    Q8IYS0: 'GRAMD1C',
    Q8IYS4: 'DNAAF8',
    Q8IYS8: 'BOD1L2',
    Q8IYT1: 'GARIN4',
    Q8IYU4: 'UBQLNL',
    Q8IYW2: 'CFAP46',
    Q8IYX0: 'ZNF679',
    Q8IZ08: 'GPR135',
    Q8IZ26: 'ZNF34',
    Q8IZ40: 'RCOR2',
    Q8IZ57: 'NRSN1',
    Q8IZ73: 'RPUSD2',
    Q8IZ83: 'ALDH16A1',
    Q8IZA3: 'H1-8',
    Q8IZD6: 'SLC22A15',
    Q8IZF4: 'ADGRG5',
    Q8IZF5: 'ADGRF3',
    Q8IZF7: 'ADGRF2P',
    Q8IZJ4: 'RGL4',
    Q8IZM9: 'SLC38A6',
    Q8IZP7: 'HS6ST3',
    Q8IZS5: 'OFCC1',
    Q8IZS6: 'DYNLT2',
    Q8IZS7: 'CLECL1P',
    Q8IZS8: 'CACNA2D3',
    Q8IZT9: 'FAM9C',
    Q8IZU8: 'DSEL',
    Q8IZV2: 'CMTM8',
    Q8N0S6: 'CENPL',
    Q8N0T1: 'RBIS',
    Q8N0U2: 'TMEM61',
    Q8N0Y7: 'PGAM4',
    Q8N0Z8: 'PUSL1',
    Q8N103: 'TAGAP',
    Q8N109: 'KIR2DL5A',
    Q8N111: 'CEND1',
    Q8N112: 'LSMEM2',
    Q8N118: 'CYP4X1',
    Q8N128: 'FAM177A1',
    Q8N136: 'DAW1',
    Q8N143: 'BCL6B',
    Q8N145: 'LGI3',
    Q8N184: 'ZNF567',
    Q8N1D0: 'SLC22A18AS',
    Q8N1G4: 'LRRC47',
    Q8N1S5: 'SLC39A11',
    Q8N1T3: 'MYO1H',
    Q8N292: 'GAPT',
    Q8N2H3: 'PYROXD2',
    Q8N365: 'CIART',
    Q8N3D4: 'EHBP1L1',
    Q8N3J9: 'ZNF664',
    Q8N3X1: 'FNBP4',
    Q8N3X6: 'LCORL',
    Q8N436: 'CPXM2',
    Q8N442: 'GUF1',
    Q8N461: 'FBXL16',
    Q8N4G2: 'ARL14',
    Q8N4H5: 'TOMM5',
    Q8N4P2: 'IFT70B',
    Q8N4Q0: 'PTGR3',
    Q8N4T4: 'ARHGEF39',
    Q8N4W9: 'ZNF808',
    Q8N531: 'FBXL6',
    Q8N5C7: 'DTWD1',
    Q8N5I3: 'KCNRG',
    Q8N5L8: 'RPP25L',
    Q8N5M4: 'TTC9C',
    Q8N5N7: 'MRPL50',
    Q8N5R6: 'CCDC33',
    Q8N5S1: 'SLC25A41',
    Q8N628: 'OR2C3',
    Q8N6D5: 'ANKRD29',
    Q8N6S5: 'ARL6IP6',
    Q8N6T0: 'TOP6BL',
    Q8N729: 'NPW',
    Q8N7A1: 'KLHDC1',
    Q8N7B1: 'HORMAD2',
    Q8N7B9: 'EFCAB3',
    Q8N7K0: 'ZNF433',
    Q8N7M2: 'ZNF283',
    Q8N7P3: 'CLDN22',
    Q8N801: 'STPG4',
    Q8N806: 'UBR7',
    Q8N819: 'PPM1N',
    Q8N823: 'ZNF611',
    Q8N831: 'TSPYL6',
    Q8N859: 'ZNF713',
    Q8N883: 'ZNF614',
    Q8N8A2: 'ANKRD44',
    Q8N8A6: 'DDX51',
    Q8N8E3: 'CEP112',
    Q8N8F6: 'YIPF7',
    Q8N8G2: 'VGLL2',
    Q8N8J6: 'ZNF615',
    Q8N8K9: 'KIAA1958',
    Q8N8L2: 'ZNF491',
    Q8N8Q1: 'CYB561D1',
    Q8N8R5: 'C2orf69',
    Q8N8U2: 'CDYL2',
    Q8N8Y5: 'ZFP41',
    Q8N8Z8: 'ZNF441',
    Q8N907: 'DAND5',
    Q8N954: 'GPATCH11',
    Q8N9B8: 'RASGEF1A',
    Q8N9H8: 'EXD3',
    Q8N9L1: 'ZIC4',
    Q8N9S9: 'SNX31',
    Q8N9W4: 'GOLGA6L2',
    Q8N9Z0: 'ZNF610',
    Q8NA19: 'L3MBTL4',
    Q8NAT2: 'TDRD5',
    Q8NB25: 'FAM184A',
    Q8NBA8: 'DTWD2',
    Q8NBF6: 'AVL9',
    Q8NBH2: 'KY',
    Q8NBM8: 'PCYOX1L',
    Q8NBR0: 'TP53I13',
    Q8NBV4: 'PLPP7',
    Q8NBX0: 'SCCPDH',
    Q8NC44: 'RETREG2',
    Q8NC96: 'NECAP1',
    Q8NCA9: 'ZNF784',
    Q8NCF0: 'CLEC18C',
    Q8NCK3: 'ZNF485',
    Q8NCN2: 'ZBTB34',
    Q8NCN5: 'PDPR',
    Q8NCQ7: 'PROCA1',
    Q8NCR3: 'MFI',
    Q8NCU1: 'CCDC197',
    Q8NCY6: 'MSANTD4',
    Q8ND71: 'GIMAP8',
    Q8ND82: 'ZNF280C',
    Q8NDB6: 'FAM156A',
    Q8NDB6: 'FAM156B',
    Q8NDH2: 'CCDC168',
    Q8NDV2: 'GPR26',
    Q8NDX6: 'ZNF740',
    Q8NDX9: 'LY6G5B',
    Q8NE28: 'STKLD1',
    Q8NE62: 'CHDH',
    Q8NEB7: 'ACRBP',
    Q8NEE6: 'FBXL13',
    Q8NEF3: 'CCDC112',
    Q8NEF9: 'SRFBP1',
    Q8NEG0: 'GARIN6',
    Q8NEN0: 'ARMC2',
    Q8NEP9: 'ZNF555',
    Q8NET1: 'DEFB108B',
    Q8NEW7: 'TMIE',
    Q8NEX9: 'SDR9C7',
    Q8NF86: 'PRSS33',
    Q8NFI3: 'ENGASE',
    Q8NFJ8: 'BHLHE22',
    Q8NFK1: 'GJC3',
    Q8NFN8: 'GPR156',
    Q8NFU0: 'BEST4',
    Q8NG04: 'SLC26A10P',
    Q8NG48: 'LINS1',
    Q8NG68: 'TTL',
    Q8NGA0: 'OR7G1',
    Q8NGA4: 'GPR32P1',
    Q8NGC0: 'OR5AU1',
    Q8NGC7: 'OR11H6',
    Q8NGC8: 'OR11H7',
    Q8NGD0: 'OR4M1',
    Q8NGE3: 'OR10P1',
    Q8NGF0: 'OR52B6',
    Q8NGG2: 'OR5T2',
    Q8NGG7: 'OR8A1',
    Q8NGH7: 'OR52L1',
    Q8NGI2: 'OR52N4',
    Q8NGI8: 'OR5AN1',
    Q8NGJ2: 'OR52H1',
    Q8NGK2: 'OR52B4',
    Q8NGL1: 'OR5D18',
    Q8NGM9: 'OR8D4',
    Q8NGN3: 'OR10G4',
    Q8NGN6: 'OR10G7',
    Q8NGQ1: 'OR9G4',
    Q8NGR2: 'OR1L6',
    Q8NGR6: 'OR1B1',
    Q8NGS0: 'OR1N1',
    Q8NGS2: 'OR1J2',
    Q8NGS8: 'OR13C5',
    Q8NGV6: 'OR5H6',
    Q8NGW1: 'OR6B3',
    Q8NGW6: 'OR6K6',
    Q8NGX3: 'OR10T2',
    Q8NGY0: 'OR10X1',
    Q8NGY3: 'OR6K3',
    Q8NH06: 'OR1P1',
    Q8NH10: 'OR8U1',
    Q8NH19: 'OR10AG1',
    Q8NH43: 'OR4L1',
    Q8NH48: 'OR5B3',
    Q8NH59: 'OR51Q1',
    Q8NH67: 'OR52I2',
    Q8NH69: 'OR5W2',
    Q8NH85: 'OR8U3',
    Q8NH87: 'OR9G1',
    Q8NH92: 'OR1S1',
    Q8NH94: 'OR1L1',
    Q8NHC8: 'OR2T6',
    Q8NHK3: 'KIR2DL5B',
    Q8NHM4: 'PRSS3P2',
    Q8NHP1: 'AKR7L',
    Q8NHP7: 'EXD1',
    Q8NHQ8: 'RASSF8',
    Q8NHS0: 'DNAJB8',
    Q8NHU2: 'CFAP61',
    Q8NHY6: 'ZFP28',
    Q8NI29: 'FBXO27',
    Q8NI32: 'LYPD6B',
    Q8NI99: 'ANGPTL6',
    Q8TAA3: 'PSMA8',
    Q8TAA5: 'GRPEL2',
    Q8TAE6: 'PPP1R14C',
    Q8TAF7: 'ZNF461',
    Q8TAG6: 'VXN',
    Q8TAK5: 'GABPB2',
    Q8TAL6: 'FIBIN',
    Q8TAQ5: 'ZNF420',
    Q8TAQ9: 'SUN3',
    Q8TAV4: 'STOML3',
    Q8TB03: 'CXorf38',
    Q8TB96: 'ITFG1',
    Q8TBB5: 'KLHDC4',
    Q8TBF4: 'ZCRB1',
    Q8TBF5: 'PIGX',
    Q8TBP0: 'TBC1D16',
    Q8TBQ9: 'TMEM167A',
    Q8TBY0: 'RBM46',
    Q8TBZ0: 'CCDC110',
    Q8TBZ2: 'MYCBPAP',
    Q8TBZ5: 'ZNF502',
    Q8TC21: 'ZNF596',
    Q8TC26: 'TMEM163',
    Q8TC27: 'ADAM32',
    Q8TC56: 'GARIN3',
    Q8TC76: 'FAM110B',
    Q8TCB6: 'OR51E1',
    Q8TCC3: 'MRPL30',
    Q8TCD1: 'C18orf32',
    Q8TCD6: 'PHOSPHO2',
    Q8TCU3: 'SLC7A13',
    Q8TCV5: 'WFDC5',
    Q8TCW7: 'ZPLD1',
    Q8TCW9: 'PROKR1',
    Q8TD22: 'SFXN5',
    Q8TD94: 'KLF14',
    Q8TDE3: 'RNASE8',
    Q8TDM0: 'BCAS4',
    Q8TDM5: 'SPACA4',
    Q8TDN6: 'BRIX1',
    Q8TDV2: 'GPR148',
    Q8TDV5: 'GPR119',
    Q8TDW4: 'ST7L',
    Q8TDY8: 'IGDCC4',
    Q8TE59: 'ADAMTS19',
    Q8TE69: 'EOLA1',
    Q8TET4: 'GANC',
    Q8TF05: 'PPP4R1',
    Q8TF39: 'ZNF483',
    Q8TF64: 'GIPC3',
    Q8TF68: 'ZNF384',
    Q8WUA2: 'PPIL4',
    Q8WUF8: 'FAM172A',
    Q8WUH1: 'CHURC1',
    Q8WUN7: 'UBTD2',
    Q8WUT4: 'LRRN4',
    Q8WUU8: 'TMEM174',
    Q8WUX2: 'CHAC2',
    Q8WV07: 'LTO1',
    Q8WV48: 'CCDC107',
    Q8WV60: 'PTCD2',
    Q8WVE0: 'EEF1AKMT1',
    Q8WVF2: 'UCMA',
    Q8WVL7: 'ANKRD49',
    Q8WVZ7: 'RNF133',
    Q8WW27: 'APOBEC4',
    Q8WWW8: 'GAB3',
    Q8WWY7: 'WFDC12',
    Q8WX77: 'IGFBPL1',
    Q8WXA2: 'PATE1',
    Q8WXB4: 'ZNF606',
    Q8WXD9: 'CASKIN1',
    Q8WXH4: 'ASB11',
    Q8WXH6: 'RAB40A',
    Q8WXQ8: 'CPA5',
    Q8WY22: 'BRI3BP',
    Q8WYN3: 'CSRNP3',
    Q8WYQ4: 'C22orf15',
    Q8WYQ9: 'ZCCHC14',
    Q8WZ33: 'MAFIP',
    Q8WZ60: 'KLHL6',
    Q8WZ64: 'ARAP2',
    Q8WZ79: 'DNASE2B',
    Q8WZ84: 'OR8D1',
    Q8WZ92: 'OR5P2',
    Q8WZ94: 'OR5P3',
    Q902F8: 'ERVK-8',
    Q902F9: 'HERVK_113',
    Q92561: 'PHYHIP',
    Q92617: 'NPIPB3',
    Q92664: 'GTF3A',
    Q92747: 'ARPC1A',
    Q92771: 'DDX12P',
    Q92806: 'KCNJ9',
    Q92828: 'CORO2A',
    Q92901: 'RPL3L',
    Q92914: 'FGF11',
    Q92928: 'RAB1C',
    Q93073: 'SECISBP2L',
    Q969E1: 'LEAP2',
    Q969I3: 'GLYATL1',
    Q969M1: 'TOMM40L',
    Q969M2: 'GJA10',
    Q969N4: 'TAAR8',
    Q969Q0: 'RPL36AL',
    Q969Q4: 'ARL11',
    Q969Q5: 'RAB24',
    Q969T3: 'SNX21',
    Q969V1: 'MCHR2',
    Q969W8: 'ZNF566',
    Q96A00: 'PPP1R14A',
    Q96A04: 'TSACC',
    Q96A05: 'ATP6V1E2',
    Q96A23: 'CPNE4',
    Q96A28: 'SLAMF9',
    Q96A35: 'MRPL24',
    Q96A46: 'SLC25A28',
    Q96A47: 'ISL2',
    Q96A73: 'KIAA1191',
    Q96A84: 'EMID1',
    Q96A99: 'PTX4',
    Q96AC6: 'KIFC2',
    Q96AM1: 'MRGPRF',
    Q96B23: 'ARK2N',
    Q96B45: 'BORCS7',
    Q96B77: 'TMEM186',
    Q96BH3: 'ELSPBP1',
    Q96BN6: 'FAM149B1',
    Q96BU1: 'S100PBP',
    Q96BV0: 'ZNF775',
    Q96BW9: 'TAMM41',
    Q96C19: 'EFHD2',
    Q96C28: 'ZNF707',
    Q96C34: 'RUNDC1',
    Q96CM4: 'NXNL1',
    Q96CW6: 'SLC7A6OS',
    Q96CX2: 'KCTD12',
    Q96CX3: 'ZNF501',
    Q96DA0: 'ZG16B',
    Q96DB5: 'RMDN1',
    Q96DC8: 'ECHDC3',
    Q96DD7: 'SHISA4',
    Q96DN6: 'MBD6',
    Q96DX4: 'RSPRY1',
    Q96DY7: 'MTBP',
    Q96E40: 'SPACA9',
    Q96EF9: 'ZHX1-C8orf76',
    Q96EK7: 'FAM120B',
    Q96EN9: 'REX1BD',
    Q96EY9: 'ADAT3',
    Q96FC7: 'PHYHIPL',
    Q96FN9: 'DTD2',
    Q96FV2: 'SCRN2',
    Q96GA3: 'LTV1',
    Q96GC5: 'MRPL48',
    Q96GE9: 'DMAC1',
    Q96GX2: 'ATXN7L3B',
    Q96GX8: 'C16orf74',
    Q96GY0: 'ZC2HC1A',
    Q96H78: 'SLC25A44',
    Q96HE9: 'PRR11',
    Q96HJ3: 'CCDC34',
    Q96HJ9: 'FMC1',
    Q96HL8: 'SH3YL1',
    Q96HP8: 'TMEM176A',
    Q96HQ0: 'ZNF419',
    Q96HQ2: 'CDKN2AIPNL',
    Q96HU8: 'DIRAS2',
    Q96I36: 'COX14',
    Q96I82: 'KAZALD1',
    Q96IG2: 'FBXL20',
    Q96IK0: 'TMEM101',
    Q96IQ7: 'VSIG2',
    Q96IX9: 'ANKRD36BP1',
    Q96J86: 'CYYR1',
    Q96J88: 'EPSTI1',
    Q96JA4: 'MS4A14',
    Q96JC4: 'ZNF479',
    Q96JK4: 'HHIPL1',
    Q96JN8: 'NEURL4',
    Q96JP2: 'MYO15B',
    Q96JQ2: 'CLMN',
    Q96JT2: 'SLC45A3',
    Q96K49: 'TMEM87B',
    Q96K58: 'ZNF668',
    Q96KC2: 'ARL5B',
    Q96KE9: 'BTBD6',
    Q96KJ9: 'COX4I2',
    Q96KN1: 'LRATD2',
    Q96KN9: 'GJD4',
    Q96KR1: 'ZFR',
    Q96KS9: 'FAM167A',
    Q96KX0: 'LYZL4',
    Q96KX2: 'CAPZA3',
    Q96L15: 'ART5',
    Q96L33: 'RHOV',
    Q96L94: 'SNX22',
    Q96LA9: 'MRGPRX4',
    Q96LB4: 'ATP6V1G3',
    Q96LD1: 'SGCZ',
    Q96LL3: 'FIMP',
    Q96LR9: 'APOLD1',
    Q96LU5: 'IMMP1L',
    Q96LW2: 'RSKR',
    Q96LW9: 'ZSCAN31',
    Q96LY2: 'CCDC74B',
    Q96M27: 'PRRC1',
    Q96M69: 'LRGUK',
    Q96M83: 'CCDC7',
    Q96MA1: 'DMRTB1',
    Q96MB7: 'HARBI1',
    Q96MG8: 'PCMTD1',
    Q96MI6: 'PPM1M',
    Q96MM6: 'HSPA12B',
    Q96MT1: 'RNF145',
    Q96MX6: 'DNAAF10',
    Q96N03: 'VSTM2L',
    Q96N06: 'SPATA33',
    Q96N23: 'CFAP54',
    Q96N28: 'PRELID3A',
    Q96N38: 'ZNF714',
    Q96ND0: 'FAM210A',
    Q96NJ3: 'ZNF285',
    Q96NL0: 'RUNDC3B',
    Q96NL1: 'TMEM74',
    Q96NL3: 'ZNF599',
    Q96NU0: 'CNTNAP3B',
    Q96NX9: 'DACH2',
    Q96P50: 'ACAP3',
    Q96P68: 'OXGR1',
    Q96P69: 'GPR78',
    Q96P88: 'GNRHR2',
    Q96PB8: 'LRRC3B',
    Q96PE2: 'ARHGEF17',
    Q96PE5: 'OPALIN',
    Q96PE6: 'ZIM3',
    Q96PL1: 'SCGB3A2',
    Q96PL2: 'TECTB',
    Q96PQ7: 'KLHL5',
    Q96PU9: 'CIMAP1A',
    Q96PX9: 'PLEKHG4B',
    Q96Q07: 'BTBD9',
    Q96QR1: 'SCGB3A1',
    Q96QS1: 'TSPAN32',
    Q96QU6: 'ACCS',
    Q96R08: 'OR5B12',
    Q96R48: 'OR2A5',
    Q96RA2: 'OR7D2',
    Q96RC9: 'OR8B4',
    Q96RI9: 'TAAR9',
    Q96RJ0: 'TAAR1',
    Q96RK1: 'CITED4',
    Q96RP8: 'KCNA7',
    Q96RV3: 'PCNX1',
    Q96S79: 'RASL10B',
    Q96S82: 'UBL7',
    Q96S90: 'LYSMD1',
    Q96S95: 'CAMK2N2',
    Q96S96: 'PEBP4',
    Q96SE0: 'ABHD1',
    Q96SE7: 'ZNF347',
    Q96SK3: 'ZNF607',
    Q96SL8: 'FIZ1',
    Q96SM3: 'CPXM1',
    Q96SN7: 'ORAI2',
    Q96SR6: 'ZNF382',
    Q96SY0: 'INTS14',
    Q96T25: 'ZIC5',
    Q96T92: 'INSM2',
    Q99218: 'AMELY',
    Q99442: 'SEC62',
    Q99445: 'GML',
    Q99463: 'NPY6R',
    Q99525: 'H4C7',
    Q99614: 'TTC1',
    Q99618: 'CDCA3',
    Q99666: 'RGPD5',
    Q99666: 'RGPD6',
    Q99742: 'NPAS1',
    Q99805: 'TM9SF2',
    Q99811: 'PRRX2',
    Q99819: 'ARHGDIG',
    Q99865: 'SPIN2A',
    Q99954: 'SMR3A',
    Q9BPW4: 'APOL4',
    Q9BPX5: 'ARPC5L',
    Q9BPY3: 'FAM118B',
    Q9BQ08: 'RETNLB',
    Q9BQC6: 'MRPL57',
    Q9BQI7: 'PSD2',
    Q9BQI9: 'NRIP2',
    Q9BQQ7: 'RTP3',
    Q9BQR3: 'PRSS27',
    Q9BQS6: 'HSPB9',
    Q9BQW3: 'EBF4',
    Q9BQY9: 'DBNDD2',
    Q9BR61: 'ACBD6',
    Q9BR84: 'ZNF559',
    Q9BRJ2: 'MRPL45',
    Q9BRP4: 'PAAF1',
    Q9BRQ4: 'CFAP300',
    Q9BRQ5: 'ORAI3',
    Q9BRT6: 'LLPH',
    Q9BRT8: 'ZNG1A',
    Q9BRU2: 'TCEAL7',
    Q9BRY0: 'SLC39A3',
    Q9BS18: 'ANAPC13',
    Q9BS31: 'ZNF649',
    Q9BSE5: 'AGMAT',
    Q9BSF4: 'TIMM29',
    Q9BSF8: 'BTBD10',
    Q9BSG0: 'PRADC1',
    Q9BSG5: 'RTBDN',
    Q9BSH3: 'NICN1',
    Q9BSH5: 'HDHD3',
    Q9BSJ5: 'C17orf80',
    Q9BSK1: 'ZNF577',
    Q9BSN7: 'TMEM204',
    Q9BT23: 'LIMD2',
    Q9BT76: 'UPK3B',
    Q9BTM1: 'H2AJ',
    Q9BTT6: 'LRRC1',
    Q9BTV6: 'DPH7',
    Q9BU70: 'TRMO',
    Q9BUA3: 'SPINDOC',
    Q9BUG6: 'ZSCAN5A',
    Q9BUK0: 'CHCHD7',
    Q9BUN1: 'MENT',
    Q9BUT9: 'MCRIP2',
    Q9BUV8: 'RAB5IF',
    Q9BV19: 'C1orf50',
    Q9BV29: 'CCDC32',
    Q9BV99: 'LRRC61',
    Q9BVC5: 'C2orf49',
    Q9BW30: 'TPPP3',
    Q9BW72: 'HIGD2A',
    Q9BWM7: 'SFXN3',
    Q9BWU0: 'SLC4A1AP',
    Q9BWV7: 'TTLL2',
    Q9BWW8: 'APOL6',
    Q9BX82: 'ZNF471',
    Q9BX93: 'PLA2G12B',
    Q9BXA9: 'SALL3',
    Q9BXC1: 'GPR174',
    Q9BXE9: 'VN1R3',
    Q9BXG8: 'SPZ1',
    Q9BXK1: 'KLF16',
    Q9BXL5: 'HEMGN',
    Q9BXT2: 'CACNG6',
    Q9BY10: 'SLC46A2',
    Q9BY21: 'GPR87',
    Q9BY60: 'GABARAPL3',
    Q9BYC2: 'OXCT2',
    Q9BYC8: 'MRPL32',
    Q9BYC9: 'MRPL20',
    Q9BYD1: 'MRPL13',
    Q9BYD2: 'MRPL9',
    Q9BYD3: 'MRPL4',
    Q9BYD6: 'MRPL1',
    Q9BYN8: 'MRPS26',
    Q9BYQ9: 'KRTAP4-8',
    Q9BYX7: 'POTEKP',
    Q9BZ76: 'CNTNAP3',
    Q9BZD7: 'PRRG3',
    Q9BZE1: 'MRPL37',
    Q9BZI1: 'IRX2',
    Q9BZJ4: 'SLC25A39',
    Q9BZJ6: 'GPR63',
    Q9BZW2: 'SLC13A1',
    Q9C009: 'FOXQ1',
    Q9C010: 'PKIB',
    Q9C075: 'KRT23',
    Q9C099: 'LRRCC1',
    Q9C0B6: 'BRINP2',
    Q9C0D3: 'ZYG11B',
    Q9C0D7: 'ZC3H12C',
    Q9C0E2: 'XPO4',
    Q9C0H5: 'ARHGAP39',
    Q9GZK4: 'OR2H1',
    Q9GZK6: 'OR2J1',
    Q9GZM6: 'OR8D2',
    Q9GZN6: 'SLC6A16',
    Q9GZP1: 'NRSN2',
    Q9GZP4: 'PITHD1',
    Q9GZP7: 'VN1R1',
    Q9GZQ3: 'COMMD5',
    Q9GZR7: 'DDX24',
    Q9GZT6: 'CCDC90B',
    Q9GZZ0: 'HOXD1',
    Q9H009: 'NACA2',
    Q9H019: 'MTFR1L',
    Q9H061: 'TMEM126A',
    Q9H069: 'DRC3',
    Q9H091: 'ZMYND15',
    Q9H094: 'NBPF3',
    Q9H0C3: 'TMEM117',
    Q9H0H3: 'KLHL25',
    Q9H0I3: 'CCDC113',
    Q9H0I9: 'TKTL2',
    Q9H0U9: 'TSPYL1',
    Q9H0X4: 'FAM234A',
    Q9H158: 'PCDHAC1',
    Q9H159: 'CDH19',
    Q9H175: 'CSRNP2',
    Q9H1A3: 'METTL9',
    Q9H1C0: 'LPAR5',
    Q9H1N7: 'SLC35B3',
    Q9H1U4: 'MEGF9',
    Q9H205: 'OR2AG1',
    Q9H207: 'OR10A5',
    Q9H209: 'OR10A4',
    Q9H210: 'OR2D2',
    Q9H213: 'MAGEH1',
    Q9H2A3: 'NEUROG2',
    Q9H2P9: 'DPH5',
    Q9H2T7: 'RANBP17',
    Q9H2W6: 'MRPL46',
    Q9H2X8: 'IFI27L2',
    Q9H2Y9: 'SLCO5A1',
    Q9H320: 'VCX',
    Q9H330: 'TMEM245',
    Q9H336: 'CRISPLD1',
    Q9H339: 'OR51B5',
    Q9H340: 'OR51B6',
    Q9H341: 'OR51M1',
    Q9H342: 'OR51J1',
    Q9H347: 'UBQLN3',
    Q9H3C7: 'GGNBP2',
    Q9H3E2: 'SNX25',
    Q9H3G5: 'CPVL',
    Q9H3M9: 'ATXN3L',
    Q9H3S5: 'PIGM',
    Q9H426: 'RIMS4',
    Q9H446: 'RWDD1',
    Q9H4A4: 'RNPEP',
    Q9H4B8: 'DPEP3',
    Q9H4G1: 'CST9L',
    Q9H4I8: 'SERHL2',
    Q9H4Q3: 'PRDM13',
    Q9H501: 'ESF1',
    Q9H511: 'KLHL31',
    Q9H5L6: 'THAP9',
    Q9H609: 'ZNF576',
    Q9H665: 'IGFLR1',
    Q9H6A9: 'PCNX3',
    Q9H6D8: 'FNDC4',
    Q9H6F2: 'TMEM38A',
    Q9H6F5: 'CCDC86',
    Q9H6K4: 'OPA3',
    Q9H6V9: 'LDAH',
    Q9H6X4: 'TMEM134',
    Q9H6X5: 'C19orf44',
    Q9H756: 'LRRC19',
    Q9H7C9: 'AAMDC',
    Q9H7R0: 'ZNF442',
    Q9H7U1: 'CCSER2',
    Q9H7X7: 'IFT22',
    Q9H898: 'ZMAT4',
    Q9H8H0: 'NOL11',
    Q9H8S5: 'CCNP',
    Q9H8Y1: 'VRTN',
    Q9H939: 'PSTPIP2',
    Q9H967: 'WDR76',
    Q9H9H5: 'MAP6D1',
    Q9H9Y2: 'RPF1',
    Q9HA64: 'FN3KRP',
    Q9HA77: 'CARS2',
    Q9HA92: 'RSAD1',
    Q9HAH1: 'ZNF556',
    Q9HAS0: 'C17orf75',
    Q9HAT1: 'LMAN1L',
    Q9HAY2: 'MAGEF1',
    Q9HB09: 'BCL2L12',
    Q9HB40: 'SCPEP1',
    Q9HBA9: 'FOLH1B',
    Q9HBF5: 'ST20',
    Q9HBL6: 'LRTM1',
    Q9HBQ8: 'GOLGA2P5',
    Q9HBR0: 'SLC38A10',
    Q9HBU9: 'POPDC2',
    Q9HBV1: 'POPDC3',
    Q9HC38: 'GLOD4',
    Q9HC56: 'PCDH9',
    Q9HCC6: 'HES4',
    Q9HCG1: 'ZNF160',
    Q9HCI6: 'KIAA1586',
    Q9HCL0: 'PCDH18',
    Q9HCN2: 'TP53AIP1',
    Q9HCN8: 'SDF2L1',
    Q9HCT0: 'FGF22',
    Q9HD33: 'MRPL47',
    Q9HD64: 'XAGE1A',
    Q9HD64: 'XAGE1B',
    Q9HDB9: 'ERVK-5',
    Q9NNX1: 'TUFT1',
    Q9NP08: 'HMX1',
    Q9NP92: 'MRPS30',
    Q9NPA3: 'MID1IP1',
    Q9NPB8: 'GPCPD1',
    Q9NPH6: 'OBP2B',
    Q9NQ03: 'SCRT2',
    Q9NQ33: 'ASCL3',
    Q9NQ34: 'TMEM9B',
    Q9NQ60: 'EQTN',
    Q9NQE7: 'PRSS16',
    Q9NQN1: 'OR2S2',
    Q9NQS1: 'AVEN',
    Q9NQT6: 'FSCN3',
    Q9NR64: 'KLHL1',
    Q9NRG7: 'SDR39U1',
    Q9NRH1: 'YAE1',
    Q9NRJ1: 'C8orf17',
    Q9NRJ5: 'PAPOLB',
    Q9NRM2: 'ZNF277',
    Q9NRN5: 'OLFML3',
    Q9NRR1: 'CYTL1',
    Q9NRU3: 'CNNM1',
    Q9NRV9: 'HEBP1',
    Q9NRX1: 'PNO1',
    Q9NRY5: 'FAM114A2',
    Q9NS25: 'SPANXB1',
    Q9NS26: 'SPANXA1',
    Q9NS26: 'SPANXA2',
    Q9NS28: 'RGS18',
    Q9NS66: 'GPR173',
    Q9NS67: 'GPR27',
    Q9NS93: 'TM7SF3',
    Q9NS98: 'SEMA3G',
    Q9NSI2: 'SLX9',
    Q9NSI5: 'IGSF5',
    Q9NSP4: 'CENPM',
    Q9NSY0: 'NRBP2',
    Q9NTI7: 'INKA2',
    Q9NTU4: 'CATSPERZ',
    Q9NTU7: 'CBLN4',
    Q9NTX5: 'ECHDC1',
    Q9NTZ6: 'RBM12',
    Q9NU02: 'ANKEF1',
    Q9NUA8: 'ZBTB40',
    Q9NUG6: 'PDRG1',
    Q9NUP1: 'BLOC1S4',
    Q9NUP7: 'TRMT13',
    Q9NUQ6: 'SPATS2L',
    Q9NUQ8: 'ABCF3',
    Q9NUZ1: 'ACOXL',
    Q9NV66: 'TYW1',
    Q9NV72: 'ZNF701',
    Q9NVG8: 'TBC1D13',
    Q9NVK5: 'FGFR1OP2',
    Q9NVL8: 'CCDC198',
    Q9NVQ4: 'FAIM',
    Q9NVR7: 'TBCCD1',
    Q9NVS2: 'MRPS18A',
    Q9NVX7: 'KBTBD4',
    Q9NVZ3: 'NECAP2',
    Q9NW68: 'BSDC1',
    Q9NWB6: 'ARGLU1',
    Q9NWC5: 'TMEM45A',
    Q9NWH7: 'SPATA6',
    Q9NWV4: 'CZIB',
    Q9NWW0: 'HCFC1R1',
    Q9NX08: 'COMMD8',
    Q9NX20: 'MRPL16',
    Q9NX38: 'ABITRAM',
    Q9NX45: 'SOHLH2',
    Q9NX78: 'TMEM260',
    Q9NXF1: 'TEX10',
    Q9NXF7: 'DCAF16',
    Q9NXG2: 'THUMPD1',
    Q9NXH3: 'PPP1R14D',
    Q9NXJ0: 'MS4A12',
    Q9NXK6: 'PAQR5',
    Q9NXL2: 'ARHGEF38',
    Q9NXL6: 'SIDT1',
    Q9NXZ2: 'DDX43',
    Q9NY35: 'CLDND1',
    Q9NY37: 'ASIC5',
    Q9NY43: 'BARHL2',
    Q9NY57: 'STK32B',
    Q9NYF5: 'FAM13B',
    Q9NYL4: 'FKBP11',
    Q9NYM9: 'BET1L',
    Q9NYN1: 'RASL12',
    Q9NYV8: 'TAS2R14',
    Q9NYV9: 'TAS2R13',
    Q9NYW2: 'TAS2R8',
    Q9NYW3: 'TAS2R7',
    Q9NYW6: 'TAS2R3',
    Q9NYW7: 'TAS2R1',
    Q9NZH5: 'PTTG2',
    Q9NZL6: 'RGL1',
    Q9NZQ0: 'DNAJC27',
    Q9NZQ9: 'TMOD4',
    Q9NZT2: 'OGFR',
    Q9NZW5: 'PALS2',
    Q9P015: 'MRPL15',
    Q9P031: 'CCDC59',
    Q9P055: 'JKAMP',
    Q9P0J6: 'MRPL36',
    Q9P0M4: 'IL17C',
    Q9P0M9: 'MRPL27',
    Q9P0S2: 'COX16',
    Q9P0V9: 'SEPTIN10',
    Q9P104: 'DOK5',
    Q9P1P5: 'TAAR2',
    Q9P1U0: 'POLR1H',
    Q9P1U1: 'ACTR3B',
    Q9P1W3: 'TMEM63C',
    Q9P1Y6: 'PHRF1',
    Q9P203: 'BTBD7',
    Q9P206: 'KIAA1522',
    Q9P242: 'NYAP2',
    Q9P244: 'LRFN1',
    Q9P260: 'RELCH',
    Q9P265: 'DIP2B',
    Q9P291: 'ARMCX1',
    Q9P299: 'COPZ2',
    Q9P2D8: 'UNC79',
    Q9P2E7: 'PCDH10',
    Q9P2F8: 'SIPA1L2',
    Q9P2H5: 'USP35',
    Q9P2J8: 'ZNF624',
    Q9P2J9: 'PDP2',
    Q9P2N2: 'ARHGAP28',
    Q9P2P1: 'NYNRIN',
    Q9P2T0: 'SPMAP2',
    Q9P2V4: 'LRIT1',
    Q9QC07: 'ERVK-18',
    Q9UBG7: 'RBPJL',
    Q9UBL0: 'ARPP21',
    Q9UBU2: 'DKK2',
    Q9UBU6: 'FAM8A1',
    Q9UDX5: 'MTFP1',
    Q9UEE9: 'CFDP1',
    Q9UF02: 'CACNG5',
    Q9UGF5: 'OR14J1',
    Q9UGQ2: 'CACFD1',
    Q9UH62: 'ARMCX3',
    Q9UHA3: 'RSL24D1',
    Q9UHE8: 'STEAP1',
    Q9UHF5: 'IL17B',
    Q9UHQ4: 'BCAP29',
    Q9UHR6: 'ZNHIT2',
    Q9UHV5: 'RAPGEFL1',
    Q9UHW5: 'GPN3',
    Q9UIF3: 'TEKT2',
    Q9UII5: 'ZNF107',
    Q9UIM3: 'FKBPL',
    Q9UJ04: 'TSPYL4',
    Q9UJ42: 'GPR160',
    Q9UJ99: 'CDH22',
    Q9UJG1: 'MOSPD1',
    Q9UJK0: 'TSR3',
    Q9UJU3: 'ZNF112',
    Q9UJW7: 'ZNF229',
    Q9UK08: 'GNG8',
    Q9UK11: 'ZNF223',
    Q9UK13: 'ZNF221',
    Q9UK85: 'DKKL1',
    Q9UKB3: 'DNAJC12',
    Q9UKD2: 'MRTO4',
    Q9UKH3: 'ERVK-9',
    Q9UKJ0: 'PILRB',
    Q9UKJ3: 'GPATCH8',
    Q9UKL2: 'OR52A1',
    Q9UKL4: 'GJD2',
    Q9UKR3: 'KLK13',
    Q9UKU9: 'ANGPTL2',
    Q9UKY3: 'CES1P1',
    Q9UL36: 'ZNF236',
    Q9UL58: 'ZNF215',
    Q9ULB4: 'CDH9',
    Q9ULE3: 'DENND2A',
    Q9ULE6: 'PALD1',
    Q9ULF5: 'SLC39A10',
    Q9ULI4: 'KIF26A',
    Q9ULJ7: 'ANKRD50',
    Q9ULK2: 'ATXN7L1',
    Q9ULK6: 'RNF150',
    Q9ULL5: 'PRR12',
    Q9ULR5: 'PAIP2B',
    Q9ULS5: 'TMCC3',
    Q9ULS6: 'KCNS2',
    Q9ULZ0: 'TP53TG3',
    Q9ULZ0: 'TP53TG3B',
    Q9ULZ0: 'TP53TG3C',
    Q9ULZ0: 'TP53TG3D',
    Q9ULZ0: 'TP53TG3E',
    Q9ULZ0: 'TP53TG3F',
    Q9UMY1: 'NOL7',
    Q9UN30: 'SCML1',
    Q9UN66: 'PCDHB8',
    Q9UN67: 'PCDHB10',
    Q9UN70: 'PCDHGC3',
    Q9UN71: 'PCDHGB4',
    Q9UN75: 'PCDHA12',
    Q9UNK9: 'ANGEL1',
    Q9UNL2: 'SSR3',
    Q9UNN4: 'GTF2A1L',
    Q9UNX9: 'KCNJ14',
    Q9UPU3: 'SORCS3',
    Q9UPV7: 'PHF24',
    Q9UQ10: 'DHDH',
    Q9UQ72: 'PSG11',
    Q9UQG0: 'ERVK-11',
    Q9Y2A4: 'ZNF443',
    Q9Y2C2: 'UST',
    Q9Y2D5: 'AKAP2',
    Q9Y2D9: 'ZNF652',
    Q9Y2E8: 'SLC9A8',
    Q9Y2G4: 'ANKRD6',
    Q9Y2H8: 'ZNF510',
    Q9Y2I8: 'WDR37',
    Q9Y2L6: 'FRMD4B',
    Q9Y2L8: 'ZKSCAN5',
    Q9Y2Q1: 'ZNF257',
    Q9Y2Q9: 'MRPS28',
    Q9Y2R4: 'DDX52',
    Q9Y2R5: 'MRPS17',
    Q9Y2R9: 'MRPS7',
    Q9Y2T4: 'PPP2R2C',
    Q9Y2T5: 'GPR52',
    Q9Y2U2: 'KCNK7',
    Q9Y305: 'ACOT9',
    Q9Y330: 'ZBTB12',
    Q9Y334: 'VWA7',
    Q9Y3C1: 'NOP16',
    Q9Y3X0: 'CCDC9',
    Q9Y421: 'FAM32A',
    Q9Y471: 'CMAHP',
    Q9Y4F5: 'CEP170B',
    Q9Y4I5: 'TESMIN',
    Q9Y4K1: 'CRYBG1',
    Q9Y4P3: 'TBL2',
    Q9Y543: 'HES2',
    Q9Y573: 'IPP',
    Q9Y585: 'OR1A2',
    Q9Y597: 'KCTD3',
    Q9Y5E1: 'PCDHB9',
    Q9Y5E2: 'PCDHB7',
    Q9Y5E4: 'PCDHB5',
    Q9Y5E5: 'PCDHB4',
    Q9Y5E6: 'PCDHB3',
    Q9Y5E7: 'PCDHB2',
    Q9Y5E8: 'PCDHB15',
    Q9Y5F0: 'PCDHB13',
    Q9Y5F2: 'PCDHB11',
    Q9Y5F3: 'PCDHB1',
    Q9Y5F6: 'PCDHGC5',
    Q9Y5F7: 'PCDHGC4',
    Q9Y5F8: 'PCDHGB7',
    Q9Y5F9: 'PCDHGB6',
    Q9Y5G0: 'PCDHGB5',
    Q9Y5G1: 'PCDHGB3',
    Q9Y5G2: 'PCDHGB2',
    Q9Y5G3: 'PCDHGB1',
    Q9Y5G4: 'PCDHGA9',
    Q9Y5G5: 'PCDHGA8',
    Q9Y5G6: 'PCDHGA7',
    Q9Y5G7: 'PCDHGA6',
    Q9Y5G8: 'PCDHGA5',
    Q9Y5G9: 'PCDHGA4',
    Q9Y5H0: 'PCDHGA3',
    Q9Y5H1: 'PCDHGA2',
    Q9Y5H2: 'PCDHGA11',
    Q9Y5H3: 'PCDHGA10',
    Q9Y5H4: 'PCDHGA1',
    Q9Y5H6: 'PCDHA8',
    Q9Y5H7: 'PCDHA5',
    Q9Y5H8: 'PCDHA3',
    Q9Y5I0: 'PCDHA13',
    Q9Y5I1: 'PCDHA11',
    Q9Y5I4: 'PCDHAC2',
    Q9Y5J1: 'UTP18',
    Q9Y5J9: 'TIMM8B',
    Q9Y5M8: 'SRPRB',
    Q9Y5P1: 'OR51B2',
    Q9Y5P3: 'RAI2',
    Q9Y5U2: 'TSSC4',
    Q9Y5Y3: 'GPR45',
    Q9Y661: 'HS3ST4',
    Q9Y673: 'ALG5',
    Q9Y689: 'ARL5A',
    Q9Y6C9: 'MTCH2',
    Q9Y6I0: 'ERVK-6',
    Q9Y6I8: 'PXMP4',
    Q9Y6N3: 'CLCA3P',
    Q9Y6Q3: 'ZFP37',
    Q9Y6S9: 'RPS6KL1',
    Q9Y6V7: 'DDX49',
    Q9YNA8: 'ERVK-19',
    U3KPV4: 'A3GALT2',
    W5XKT8: 'SPACA6',
    W6CW81: 'PYDC5',
    A0A075B6H7: 'IGKV3-7',
    A0A075B6H8: 'IGKV1D-42',
    A0A075B6H9: 'IGLV4-69',
    A0A075B6I0: 'IGLV8-61',
    A0A075B6I1: 'IGLV4-60',
    A0A075B6I3: 'IGLV11-55',
    A0A075B6I4: 'IGLV10-54',
    A0A075B6I6: 'IGLV1-50',
    A0A075B6I7: 'IGLV5-48',
    A0A075B6I9: 'IGLV7-46',
    A0A075B6J1: 'IGLV5-37',
    A0A075B6J2: 'IGLV2-33',
    A0A075B6J6: 'IGLV3-22',
    A0A075B6J9: 'IGLV2-18',
    A0A075B6K0: 'IGLV3-16',
    A0A075B6K2: 'IGLV3-12',
    A0A075B6K4: 'IGLV3-10',
    A0A075B6K5: 'IGLV3-9',
    A0A075B6K6: 'IGLV4-3',
    A0A075B6L2: 'TRGV11',
    A0A075B6L6: 'TRBV7-3',
    A0A075B6N2: 'TRBV20-1',
    A0A075B6N3: 'TRBV24-1',
    A0A075B6N4: 'TRBV25-1',
    A0A075B6R0: 'TRGV2',
    A0A075B6R9: 'IGKV2D-24',
    A0A075B6S2: 'IGKV2D-29',
    A0A075B6S4: 'IGKV1D-17',
    A0A075B6S5: 'IGKV1-27',
    A0A075B6S6: 'IGKV2D-30',
    A0A075B6S9: 'IGKV1-37',
    A0A075B6T6: 'TRAV12-2',
    A0A075B6T7: 'TRAV6',
    A0A075B6T8: 'TRAV9-1',
    A0A075B6U4: 'TRAV7',
    A0A075B6V5: 'TRAV36DV7',
    A0A075B6W5: 'TRAV23DV6',
    A0A075B6X5: 'TRAV18',
    A0A075B759: 'PPIAL4E',
    A0A075B767: 'PPIAL4H',
    A0A087WSX0: 'IGLV5-45',
    A0A087WSY6: 'IGKV3D-15',
    A0A087WSZ0: 'IGKV1D-8',
    A0A087WSZ9: 'TRAV30',
    A0A087WT02: 'TRAV9-2',
    A0A087WT03: 'TRAV26-1',
    A0A087WV62: 'TRBV16',
    A0A087WVF3: 'TBC1D3D',
    A0A087WXM9: 'MEIKIN',
    A0A087X0K7: 'TRBV17',
    A0A087X0M5: 'TRBV18',
    A0A087X179: 'TBC1D3E',
    A0A096LP55: 'UQCRHL',
    A0A0A0MRZ7: 'IGKV2D-26',
    A0A0A0MRZ8: 'IGKV3D-11',
    A0A0A0MRZ9: 'IGLV5-52',
    A0A0A0MS00: 'IGLV3-32',
    A0A0A0MS01: 'TRGV10',
    A0A0A0MS02: 'TRGV1',
    A0A0A0MS03: 'TRBV5-3',
    A0A0A0MS04: 'TRBV6-7',
    A0A0A0MS05: 'TRBV5-7',
    A0A0A0MS06: 'TRBV23-1',
    A0A0A0MT36: 'IGKV6D-21',
    A0A0A6YYC5: 'TRAV14DV4',
    A0A0A6YYD4: 'TRBV13',
    A0A0A6YYG2: 'TRBV6-6',
    A0A0A6YYG3: 'TRBV6-8',
    A0A0A6YYJ7: 'TRAV8-3',
    A0A0A6YYK1: 'TRAV8-1',
    A0A0A6YYK4: 'TRBV7-1',
    A0A0A6YYK6: 'TRAV16',
    A0A0A6YYL3: 'POTEB',
    A0A0B4J1U3: 'IGLV1-36',
    A0A0B4J1U4: 'TRGV5',
    A0A0B4J1U6: 'TRBV9',
    A0A0B4J1Y8: 'IGLV9-49',
    A0A0B4J1Z2: 'IGKV1D-43',
    A0A0B4J234: 'TRAV2',
    A0A0B4J235: 'TRAV13-2',
    A0A0B4J237: 'TRAV8-2',
    A0A0B4J238: 'TRAV1-2',
    A0A0B4J240: 'TRAV10',
    A0A0B4J241: 'TRAV13-1',
    A0A0B4J244: 'TRAV3',
    A0A0B4J245: 'TRAV12-1',
    A0A0B4J248: 'TRAV1-1',
    A0A0B4J249: 'TRAV5',
    A0A0B4J262: 'TRAV8-6',
    A0A0B4J263: 'TRAV39',
    A0A0B4J264: 'TRAV38-1',
    A0A0B4J265: 'TRAV26-2',
    A0A0B4J266: 'TRAV41',
    A0A0B4J268: 'TRAV4',
    A0A0B4J271: 'TRAV12-3',
    A0A0B4J272: 'TRAV24',
    A0A0B4J273: 'TRAV34',
    A0A0B4J274: 'TRAV20',
    A0A0B4J275: 'TRAV17',
    A0A0B4J276: 'TRAV25',
    A0A0B4J277: 'TRAV22',
    A0A0B4J279: 'TRAV21',
    A0A0B4J280: 'TRAV40',
    A0A0B4J2A2: 'PPIAL4C',
    A0A0B4J2D5: 'GATD3B',
    A0A0B4J2D9: 'IGKV1D-13',
    A0A0B4J2E0: 'TRBV12-4',
    A0A0C4DH24: 'IGKV6-21',
    A0A0C4DH25: 'IGKV3D-20',
    A0A0C4DH26: 'IGKV6D-41',
    A0A0C4DH27: 'TRGV8',
    A0A0C4DH28: 'TRGV4',
    A0A0C4DH55: 'IGKV3D-7',
    A0A0C4DH59: 'TRBV5-4',
    A0A0C4DH67: 'IGKV1-8',
    A0A0C4DH68: 'IGKV2-24',
    A0A0C4DH69: 'IGKV1-9',
    A0A0C4DH72: 'IGKV1-6',
    A0A0C4DH73: 'IGKV1-12',
    A0A0G2JS06: 'IGLV5-39',
    A0A0J9YX75: 'TRBV6-9',
    A0A0J9YXY3: 'TRBV6-2',
    A0A0K0K1A3: 'TRBV10-1',
    A0A0K0K1B3: 'TRBV30',
    A0A0K0K1C0: 'TRBV11-1',
    A0A0K0K1C4: 'TRBV27',
    A0A0K0K1D8: 'TRBV6-1',
    A0A0K0K1E9: 'TRBV7-7',
    A0A0K0K1G6: 'TRBV10-3',
    A0A0K0K1G8: 'TRBV10-2',
    A0A0U1RQF7: 'DPEP2NB',
    A0A1B0GUS4: 'UBE2L5',
    A0A1B0GX31: 'TRBV7-6',
    A0A1B0GX49: 'TRBV6-4',
    A0A1B0GX51: 'TRBV7-8',
    A0A1B0GX56: 'TRDV1',
    A0A1B0GX68: 'TRBV2',
    A0A1B0GX78: 'TRBV12-5',
    A0A1B0GX95: 'TRBV7-4',
    A0A1B0GXF2: 'TRBV7-2',
    A0A1W2PPM1: 'CPHXL',
    A0A1W2PR19: 'GSTT4',
    A0A1W2PR82: 'PERCC1',
    A0A2R8Y619: 'H2BK1',
    A0A2Z4LIS9: 'FOXO3B',
    A0A3B3IS91: 'POLGARF',
    A0A3B3IT33: 'TRIM51G',
    A0A455ZAR2: 'LINC-PINT',
    A0A494C1R9: 'TSPY9',
    A0A539: 'TRBV4-2',
    A0A576: 'TRBV3-1',
    A0A577: 'TRBV4-1',
    A0A578: 'TRBV5-1',
    A0A584: 'TRBV11-2',
    A0A589: 'TRBV4-3',
    A0A597: 'TRBV5-5',
    A0A599: 'TRBV5-6',
    A0A5A2: 'TRBV5-8',
    A0A5A6: 'TRBV11-3',
    A0A5B0: 'TRBV14',
    A0A5B6: 'TRBV28',
    A0A5B7: 'TRBV29-1',
    A0AUZ9: 'KANSL1L',
    A0JD36: 'TRDV2',
    A0JD37: 'TRDV3',
    A0PJE2: 'DHRS12',
    A0PJW6: 'TMEM223',
    A0PJW8: 'DAPL1',
    A0ZSE6: 'TMEM30CP',
    A1A4F0: 'SLC66A1L',
    A1A4V9: 'CFAP119',
    A1A580: 'KRTAP23-1',
    A1L3X4: 'MT1DP',
    A1L453: 'PRSS38',
    A2A3N6: 'PIPSL',
    A2AJT9: 'BCLAF3',
    A2CJ06: 'DYTN',
    A2NJV5: 'IGKV2-29',
    A2RRH5: 'WDR27',
    A2RRL7: 'TMEM213',
    A2RTY3: 'HEATR9',
    A2RU48: 'SMCO3',
    A2RU54: 'HMX2',
    A2RUR9: 'CCDC144A',
    A2RUU4: 'CLPSL1',
    A2VCK2: 'DCDC2B',
    A3KFT3: 'OR2M5',
    A4D0V7: 'CPED1',
    A4D1E1: 'ZNF804B',
    A4D1S0: 'KLRG2',
    A4D1U4: 'DENND11',
    A4D2H0: 'CTAGE15',
    A4D2P6: 'GRID2IP',
    A4FU28: 'CTAGE9',
    A4QPB2: 'LRP5L',
    A4QPH2: 'PI4KAP2',
    A5PL33: 'KRBA1',
    A5PLK6: 'RGSL1',
    A5PLN7: 'FAM149A',
    A6H8M9: 'CDHR4',
    A6NC42: 'DPPA5',
    A6NC78: 'GOLGA8IP',
    A6NC86: 'PINLYP',
    A6NCC3: 'GOLGA8O',
    A6NCI4: 'VWA3A',
    A6NCK2: 'TRIM43B',
    A6NCL1: 'GMNC',
    A6NCN2: 'KRT87P',
    A6NCV1: 'OR6C74',
    A6NCW7: 'USP17L4',
    A6NDD5: 'SYNDIG1L',
    A6NDH6: 'OR5H15',
    A6NDI0: 'TRIM49B',
    A6NDL8: 'OR6C68',
    A6NDN3: 'GOLGA6B',
    A6NDR6: 'MEIS3P1',
    A6NDS4: 'TBC1D3B',
    A6NDX5: 'ZNF840P',
    A6NDY0: 'PABPN1L',
    A6NE52: 'WDR97',
    A6NEC2: 'NPEPPSL1',
    A6NEL2: 'SOWAHB',
    A6NER0: 'TBC1D3F',
    A6NES4: 'MROH2A',
    A6NET4: 'OR5K3',
    A6NF34: 'ANTXRL',
    A6NF89: 'OR6C6',
    A6NFC5: 'TMEM235',
    A6NFC9: 'OR2W5P',
    A6NFI3: 'ZNF316',
    A6NFQ7: 'DPRX',
    A6NGD5: 'ZSCAN5C',
    A6NGJ6: 'TRIM64',
    A6NH21: 'SERINC4',
    A6NH52: 'TVP23A',
    A6NH57: 'ARL5C',
    A6NHA9: 'OR4C46',
    A6NHG9: 'OR5H14',
    A6NHJ4: 'ZNF860',
    A6NHM9: 'MOXD2P',
    A6NHT5: 'HMX3',
    A6NI03: 'TRIM64B',
    A6NI72: 'NCF1B',
    A6NIE9: 'PRSS29P',
    A6NIJ9: 'OR6C70',
    A6NIM6: 'SLC15A5',
    A6NIR3: 'AGAP5',
    A6NIZ1: 'RAP1BL',
    A6NJG6: 'ARGFX',
    A6NJL1: 'ZSCAN5B',
    A6NJW4: 'LRRC3C',
    A6NJZ3: 'OR6C65',
    A6NJZ7: 'RIMBP3C',
    A6NK02: 'TRIM75',
    A6NK53: 'ZNF233',
    A6NK59: 'ASB14',
    A6NK75: 'ZNF98',
    A6NKD2: 'TSPY2',
    A6NKD9: 'CCDC85C',
    A6NKF2: 'ARID3C',
    A6NKG5: 'RTL1',
    A6NKK0: 'OR5H1',
    A6NKQ9: 'CGB1',
    A6NKT7: 'RGPD3',
    A6NL08: 'OR6C75',
    A6NL26: 'OR5B21',
    A6NL99: 'AQP7P3',
    A6NLI5: 'TRIM64C',
    A6NLP5: 'TTC36',
    A6NLU0: 'RFPL4A',
    A6NLW8: 'DUXA',
    A6NM03: 'OR2AG2',
    A6NM10: 'AQP12B',
    A6NM11: 'LRRC37A2',
    A6NM28: 'ZFP92',
    A6NM43: 'CCT8L1P',
    A6NM45: 'CLDN24',
    A6NM76: 'OR6C76',
    A6NMD0: 'IFITM10',
    A6NMS3: 'OR5K4',
    A6NMS7: 'LRRC37A',
    A6NMT0: 'DBX1',
    A6NMU1: 'OR52A4P',
    A6NMX2: 'EIF4E1B',
    A6NMZ5: 'OR4C45',
    A6NN14: 'ZNF729',
    A6NN92: 'GJE1',
    A6NNF4: 'ZNF726',
    A6NNM3: 'RIMBP3B',
    A6NNN8: 'SLC38A8',
    A6NNP5: 'CCDC169',
    A6NP11: 'ZNF716',
    A6PVL3: 'KNCN',
    A6PVS8: 'LRRIQ3',
    A6QL64: 'ANKRD36',
    A8K0R7: 'ZNF839',
    A8K0S8: 'MEIS3P2',
    A8K830: 'POU2AF3',
    A8MPS7: 'YDJC',
    A8MPX8: 'PP2D1',
    A8MQ11: 'PMS2P5',
    A8MT65: 'ZNF891',
    A8MT70: 'ZBBX',
    A8MTI9: 'PRSS47P',
    A8MTY7: 'KRTAP9-7',
    A8MUH7: 'PDZK1P1',
    A8MUM7: 'LGALS16',
    A8MUV8: 'ZNF727',
    A8MUZ8: 'ZNF705G',
    A8MV23: 'SERPINE3',
    A8MVA2: 'KRTAP9-6',
    A8MVS5: 'HIDE1',
    A8MVU1: 'NCF1C',
    A8MVW0: 'FAM171A2',
    A8MVX0: 'ARHGEF33',
    A8MVZ5: 'BTNL10P',
    A8MW92: 'PHF20L1',
    A8MWA4: 'ZNF705EP',
    A8MWD9: 'SNRPGP15',
    A8MWK0: 'FADS2B',
    A8MX76: 'CAPN14',
    A8MXE2: 'B3GALT9',
    A8MXK1: 'VSTM5',
    A8MXU0: 'DEFB108A',
    A8MXU0: 'DEFB108C',
    A8MXY4: 'ZNF99',
    A8MXZ3: 'KRTAP9-1',
    A8MYP8: 'CIMAP1B',
    A8MYV0: 'DCDC2C',
    A8MYZ6: 'FOXO6',
    A8MZ26: 'EFCAB9',
    A8MZ36: 'EVPLL',
    B1AH88: 'TSPO',
    B1AJZ9: 'FHAD1',
    B1AKI9: 'ISM1',
    B2CW77: 'KLLN',
    B2RN74: 'OR11H12',
    B2RPK0: 'HMGB1P1',
    B2RXH4: 'BTBD18',
    B3SHH9: 'TMEM114',
    B4DU55: 'ZNF879',
    B5ME19: 'EIF3CL',
    B7ZAP0: 'RABGAP1L',
    B7ZBB8: 'PPP1R3G',
    B7ZC32: 'KIF28P',
    B9EJG8: 'TMEM150C',
    C0HLZ6: 'HOXB-AS3',
    C0HM01: 'SEPTIN14P20',
    C9J069: 'AJM1',
    C9J1S8: 'TRIM49D1',
    C9J1S8: 'TRIM49D2',
    C9J2P7: 'USP17L15',
    C9J798: 'RASA4B',
    C9JCN9: 'HSBP1L1',
    C9JDP6: 'CLDN25',
    C9JH25: 'PRRT4',
    C9JJH3: 'USP17L10',
    C9JLJ4: 'USP17L13',
    C9JLR9: 'ZFTA',
    C9JPN9: 'USP17L12',
    C9JSJ3: 'MEIOSIN',
    C9JUS6: 'ADM5',
    C9JVI0: 'USP17L11',
    D6R901: 'USP17L21',
    D6R9N7: 'USP17L18',
    D6RA61: 'USP17L22',
    D6RBQ6: 'USP17L17',
    D6RCP7: 'USP17L19',
    D6RIA3: 'C4orf54',
    D6RJB6: 'USP17L20',
    E2RYF6: 'MUC22',
    E2RYF7: 'HCG22',
    E7ETH6: 'ZNF587B',
    E9PB15: 'PTGES3L',
    E9PQ53: 'NDUFC2-KCTD14',
    F5H284: 'PPIAL4D',
    F7VJQ1: 'PRNP',
    G3V0H7: 'SLCO1B7',
    G5E9R7: 'KRTAP4-16',
    H3BQB6: 'STMND1',
    H3BSY2: 'GOLGA8M',
    H3BV60: 'TGFBR3L',
    H7C241: 'CLDN34',
    I0J062: 'PANO1',
    I1YAP6: 'TRIM77',
    I3L273: 'GFY',
    I3L3R5: 'CCER2',
    L0R819: 'ASDURF',
    O00110: 'OVOL3',
    O00479: 'HMGN4',
    O14498: 'ISLR',
    O14562: 'UBFD1',
    O14581: 'OR7A17',
    O14598: 'VCY',
    O14598: 'VCY1B',
    O14604: 'TMSB4Y',
    O14715: 'RGPD8',
    O14921: 'RGS13',
    O14990: 'PPP1R2C',
    O15050: 'TRANK1',
    O15172: 'PSPHP1',
    O15255: 'RTL8C',
    O15442: 'MPPED1',
    O15482: 'TEX28',
    O15482: 'TEX28P1',
    O15482: 'TEX28P2',
    O43246: 'SLC7A4',
    O43247: 'CIMIP4',
    O43325: 'LYRM1',
    O43361: 'ZNF749',
    O43423: 'ANP32CP',
    O43824: 'GTPBP6',
    O43869: 'OR2T1',
    O60224: 'SSX4',
    O60224: 'SSX4B',
    O60268: 'KIAA0513',
    O60287: 'URB1',
    O60290: 'ZNF862',
    O60309: 'LRRC37A3',
    O60320: 'ENTREP2',
    O60347: 'TBC1D12',
    O60361: 'NME2P1',
    O60431: 'OR1I1',
    O60518: 'RANBP6',
    O60637: 'TSPAN3',
    O60732: 'MAGEC1',
    O60739: 'EIF1B',
    O75157: 'TSC22D2',
    O75200: 'NPIPB7',
    O75290: 'ZNF780A',
    O75333: 'TBX10',
    O75373: 'ZNF737',
    O75426: 'FBXO24',
    O75467: 'ZNF324',
    O75474: 'FRAT2',
    O75526: 'RBMXL2',
    O75794: 'CDC123',
    O75949: 'NALF2',
    O75954: 'TSPAN9',
    O76000: 'OR2B3',
    O76087: 'GAGE7',
    O76100: 'OR7A10',
    O94819: 'KBTBD11',
    O94880: 'PHF14',
    O94952: 'FBXO21',
    O94967: 'WDR47',
    O95006: 'OR2F2',
    O95013: 'OR4F21',
    O95081: 'AGFG2',
    O95156: 'NXPH2',
    O95157: 'NXPH3',
    O95158: 'NXPH4',
    O95170: 'FBXW10B',
    O95221: 'OR5F1',
    O95424: 'DEXI',
    O95478: 'NSA2',
    O95502: 'NPTXR',
    O95521: 'PRAMEF1',
    O95744: 'PMS2P2',
    O95825: 'CRYZL1',
    O95857: 'TSPAN13',
    O95969: 'SCGB1D2',
    O96001: 'PPP1R17',
    P01737: 'TRAV8-4',
    P09131: 'SLC10A3',
    P0C025: 'NUDT17',
    P0C091: 'FREM3',
    P0C0P6: 'NPS',
    P0C5J1: 'FAM86B2',
    P0C5Y4: 'KRTAP1-4',
    P0C604: 'OR4A8',
    P0C623: 'OR4Q2',
    P0C628: 'OR5AC1',
    P0C629: 'OR10J4',
    P0C646: 'OR52Z1P',
    P0C6A0: 'ZGLP1',
    P0C6S8: 'LINGO3',
    P0C7A2: 'FAM153B',
    P0C7H9: 'USP17L7',
    P0C7I0: 'USP17L8',
    P0C7N1: 'OR8U8',
    P0C7N5: 'OR8U9',
    P0C7N8: 'OR9G9',
    P0C7P4: 'UQCRFS1P1',
    P0C7Q2: 'ARMS2',
    P0C7Q6: 'SLC35G6',
    P0C7T2: 'OR2T7',
    P0C7T3: 'OR56A5',
    P0C7U1: 'ASAH2B',
    P0C7V7: 'SEC11B',
    P0C7X1: 'TBC1D3H',
    P0C851: 'PIRT',
    P0C860: 'MSL3P1',
    P0CB33: 'ZNF735',
    P0CB38: 'PABPC4L',
    P0CG00: 'ZSCAN5DP',
    P0CG12: 'DERPC',
    P0CG22: 'DHRS4L1',
    P0CG31: 'ZNF286B',
    P0CG36: 'CFC1B',
    P0CG38: 'POTEI',
    P0CG39: 'POTEJ',
    P0CG40: 'SP9',
    P0CG41: 'CTAGE8',
    P0CH99: 'ZNF705D',
    P0CI00: 'ZNF705B',
    P0CI26: 'TRIM49C',
    P0CK97: 'SLC35E2A',
    P0CV98: 'TSPY3',
    P0CV99: 'TSPY4',
    P0CW00: 'TSPY8',
    P0CW20: 'LIMS4',
    P0DJD0: 'RGPD1',
    P0DJD1: 'RGPD2',
    P0DKB5: 'TPBGL',
    P0DKV0: 'SPATA31C1',
    P0DM35: 'MT1HL1',
    P0DMP2: 'SRGAP2B',
    P0DMT0: 'MRLN',
    P0DMU2: 'OR8G3P',
    P0DMU9: 'CT45A10',
    P0DN37: 'PPIAL4G',
    P0DN80: 'OR5H8',
    P0DN81: 'OR13C7',
    P0DN82: 'OR12D1',
    P0DP72: 'VSIG10L2',
    P0DPB5: 'POLR1D',
    P0DPF3: 'NBPF9',
    P0DPF4: 'TRAV35',
    P0DPI2: 'GATD3',
    P0DPQ6: 'DDIT3',
    P0DTA3: 'SPDYE11',
    P0DTE1: 'IGHV3-38-3',
    P0DTE2: 'IGHV8-51-1',
    P0DTW3: 'IGHV1-38-4',
    P0DUH7: 'HRURF',
    P0DW28: 'RBM10',
    P10075: 'GLI4',
    P11465: 'PSG2',
    P11844: 'CRYGA',
    P12525: 'MYCLP1',
    P15421: 'GYPE',
    P16415: 'ZNF823',
    P16562: 'CRISP2',
    P17017: 'ZNF14',
    P20962: 'PTMS',
    P31275: 'HOXC12',
    P35410: 'MAS1L',
    P43359: 'MAGEA5P',
    P43362: 'MAGEA9',
    P43362: 'MAGEA9B',
    P43366: 'MAGEB1',
    P47881: 'OR3A1',
    P47884: 'OR1D4',
    P47890: 'OR1G1',
    P47944: 'MT4',
    P51523: 'ZNF84',
    P51786: 'ZNF157',
    P51861: 'CDR1',
    P52740: 'ZNF132',
    P52743: 'ZNF137P',
    P52943: 'CRIP2',
    P55822: 'SH3BGR',
    P57060: 'RWDD2B',
    P58170: 'OR1D5',
    P58180: 'OR4D2',
    P58181: 'OR10A3',
    P58511: 'SMIM11',
    P58549: 'FXYD7',
    P59536: 'TAS2R41',
    P59539: 'TAS2R45',
    P59541: 'TAS2R30',
    P59544: 'TAS2R50',
    P59551: 'TAS2R60',
    P59922: 'OR2B8P',
    P60673: 'PFN3',
    P60985: 'KRTDAP',
    P61129: 'ZC3H6',
    P61236: 'YPEL3',
    P61570: 'ERVK-25',
    P62502: 'LCN6',
    P63119: 'ERVK-21',
    P63120: 'ERVK-19',
    P63121: 'HERVK_113',
    P63122: 'ERVK-8',
    P63124: 'HERV-K104',
    P63125: 'ERVK-25',
    P63131: 'ERVK-7',
    P63302: 'SELENOW',
    P82664: 'MRPS10',
    P82909: 'MRPS36',
    P84157: 'MXRA7',
    P98182: 'ZNF200',
    Q008S8: 'ECT2L',
    Q02325: 'PLGLB1',
    Q02325: 'PLGLB2',
    Q03924: 'ZNF117',
    Q03938: 'ZNF90',
    Q05BV3: 'EML5',
    Q05DH4: 'FHIP1A',
    Q06250: 'WT1-AS',
    Q075Z2: 'BSPH1',
    Q08AF3: 'SLFN5',
    Q08AI6: 'SLC38A11',
    Q08AN1: 'ZNF616',
    Q09019: 'DMWD',
    Q09MP3: 'RAD51AP2',
    Q0P651: 'ABHD18',
    Q0P6D2: 'DIPK1C',
    Q0VDE8: 'ADIG',
    Q0VDG4: 'SCRN3',
    Q0VGE8: 'ZNF816',
    Q107X0: 'KLKP1',
    Q12767: 'TMEM94',
    Q12894: 'IFRD2',
    Q13046: 'PSG7',
    Q13066: 'GAGE2B',
    Q13066: 'GAGE2C',
    Q13069: 'GAGE5',
    Q13072: 'BAGE',
    Q13296: 'SCGB2A2',
    Q13536: 'MIR9-1HG',
    Q14146: 'URB2',
    Q14390: 'GGTLC2',
    Q14507: 'EDDM3A',
    Q14549: 'GBX1',
    Q14582: 'MXD4',
    Q14586: 'ZNF267',
    Q14588: 'ZNF234',
    Q14761: 'PTPRCAP',
    Q147U1: 'ZNF846',
    Q14CZ0: 'HAPSTR1',
    Q14DG7: 'TMEM132B',
    Q15032: 'R3HDM1',
    Q15181: 'PPA1',
    Q15195: 'PLGLA',
    Q15269: 'PWP2',
    Q15434: 'RBMS2',
    Q15527: 'SURF2',
    Q15615: 'OR4D1',
    Q15619: 'OR1C1',
    Q15622: 'OR7A5',
    Q15773: 'MLF2',
    Q16048: 'PMCHL1',
    Q16473: 'TNXA',
    Q16517: 'NNAT',
    Q16559: 'TAL2',
    Q16626: 'MEA1',
    Q17R31: 'TATDN3',
    Q17R55: 'FAM187B',
    Q17RC7: 'EXOC3L4',
    Q1A5X7: 'WHAMMP3',
    Q1AE95: 'TMEM183BP',
    Q1ED39: 'KNOP1',
    Q1KMD3: 'HNRNPUL2',
    Q1W4C9: 'SPINK13',
    Q1X8D7: 'LRRC36',
    Q1XH10: 'SKIDA1',
    Q1ZYL8: 'IZUMO4',
    Q24JQ0: 'TMEM241',
    Q2KHR3: 'QSER1',
    Q2M218: 'ZNF630',
    Q2M296: 'MTHFSD',
    Q2M2I3: 'FAM83E',
    Q2M2W7: 'C17orf58',
    Q2M3D2: 'EXOC3L2',
    Q2M3V2: 'SOWAHA',
    Q2M3W8: 'ZNF181',
    Q2M5E4: 'RGS21',
    Q2PZI1: 'DPY19L1',
    Q2QD12: 'RPEL1',
    Q2TAA2: 'IAH1',
    Q2TAA8: 'TSNAXIP1',
    Q2TAL5: 'SMTNL2',
    Q2TB10: 'ZNF800',
    Q2TBF2: 'WSCD2',
    Q2VY69: 'ZNF284',
    Q2WGJ9: 'FER1L6',
    Q2WGN9: 'GAB4',
    Q30KQ4: 'DEFB116',
    Q30KQ5: 'DEFB115',
    Q30KQ8: 'DEFB112',
    Q30KQ9: 'DEFB110',
    Q30KR1: 'DEFB109B',
    Q32MH5: 'ATOSA',
    Q32P51: 'HNRNPA1L2',
    Q3B7J2: 'GFOD2',
    Q3B7T3: 'BEAN1',
    Q3B8N5: 'PROX2',
    Q3C1V8: 'BSX',
    Q3KNW1: 'SNAI3',
    Q3KP31: 'ZNF791',
    Q3KQV9: 'UAP1L1',
    Q3KQZ1: 'SLC25A35',
    Q3LI61: 'KRTAP20-2',
    Q3LI67: 'KRTAP6-3',
    Q3LI73: 'KRTAP19-4',
    Q3LI83: 'KRTAP24-1',
    Q3MIS6: 'ZNF528',
    Q3MIX3: 'ADCK5',
    Q3SXZ3: 'ZNF718',
    Q3ZCQ2: 'ANXA2R',
    Q3ZCW2: 'LGALSL',
    Q400G9: 'AMZ1',
    Q494X3: 'ZNF404',
    Q495B1: 'ANKDD1A',
    Q495X7: 'TRIM60',
    Q496H8: 'NRN1L',
    Q499Z3: 'SLFNL1',
    Q499Z4: 'ZNF672',
    Q49A92: 'C8orf34',
    Q49AG3: 'ZBED5',
    Q49AR2: 'C5orf22',
    Q4AE62: 'GTDC1',
    Q4G0F5: 'VPS26B',
    Q4G0N0: 'GGTA1',
    Q4G0S7: 'CCDC152',
    Q4G0Z9: 'MCMDC2',
    Q4G112: 'HSF5',
    Q4KMZ1: 'IQCC',
    Q4KMZ8: 'NKAIN1',
    Q4VC39: 'HIGD2B',
    Q4VXA5: 'KHDC1',
    Q4VXU2: 'PABPC1L',
    Q504U0: 'C4orf46',
    Q50LG9: 'LRRC24',
    Q52LA3: 'LIN52',
    Q52LD8: 'RFTN2',
    Q52M58: 'LINC02914',
    Q52M93: 'ZNF585B',
    Q53EQ6: 'TIGD5',
    Q53EV4: 'LRRC23',
    Q53FE4: 'C4orf17',
    Q53RY4: 'KRTCAP3',
    Q53S08: 'RAB6D',
    Q53S58: 'TMEM177',
    Q53S99: 'C2orf83',
    Q53SF7: 'COBLL1',
    Q56A73: 'SPIN4',
    Q56VL3: 'OCIAD2',
    Q58FF3: 'HSP90B2P',
    Q58FF6: 'HSP90AB4P',
    Q58FG0: 'HSP90AA5P',
    Q5BJE1: 'CCDC178',
    Q5BKX6: 'SLC45A4',
    Q5CZA5: 'ZNF805',
    Q5EBL2: 'ZNF628',
    Q5EBM4: 'ZNF542P',
    Q5FYA8: 'ARSH',
    Q5GH70: 'XKR9',
    Q5GH73: 'XKR6',
    Q5GH77: 'XKR3',
    Q5H8A3: 'NMS',
    Q5H913: 'ARL13A',
    Q5H943: 'CT83',
    Q5H9E4: 'SLC25A53',
    Q5H9K5: 'ZMAT1',
    Q5H9L2: 'TCEAL5',
    Q5H9M0: 'PWWP3B',
    Q5H9R4: 'ARMCX4',
    Q5HY98: 'ZNF766',
    Q5HYK9: 'ZNF667',
    Q5HYR2: 'DMRTC1',
    Q5HYR2: 'DMRTC1B',
    Q5I0G3: 'MDH1B',
    Q5I0X7: 'TTC32',
    Q5JNZ3: 'ZNF311',
    Q5JPF3: 'ANKRD36C',
    Q5JPI3: 'C3orf38',
    Q5JQF8: 'PABPC1L2A',
    Q5JQF8: 'PABPC1L2B',
    Q5JQS5: 'OR2B11',
    Q5JQS6: 'GCSAML',
    Q5JRC9: 'FAM47A',
    Q5JRS4: 'OR10J3',
    Q5JRV8: 'TMEM255A',
    Q5JS37: 'NHLRC3',
    Q5JS54: 'PSMG4',
    Q5JSS6: 'MEIG1',
    Q5JTD7: 'LRRC73',
    Q5JU00: 'TCTE1',
    Q5JUK9: 'PAGE3',
    Q5JVG2: 'ZNF484',
    Q5JVG8: 'ZNF506',
    Q5JW98: 'CALHM4',
    Q5JWR5: 'DOP1A',
    Q5JX69: 'FAM209B',
    Q5JXM2: 'METTL24',
    Q5M8T2: 'SLC35D3',
    Q5M9N0: 'CCDC158',
    Q5MCW4: 'ZNF569',
    Q5PT55: 'SLC10A5',
    Q5QFB9: 'PAPPA-AS1',
    Q5R387: 'PLA2G2C',
    Q5R3K3: 'CALHM6',
    Q5RHP9: 'ERICH3',
    Q5RIA9: 'ZNG1E',
    Q5SNV9: 'C1orf167',
    Q5SRH9: 'TTC39A',
    Q5SSQ6: 'SAPCD1',
    Q5SV17: 'TMEM240',
    Q5SV97: 'PERM1',
    Q5SVQ8: 'ZBTB41',
    Q5SWX8: 'ODR4',
    Q5SXM1: 'ZNF678',
    Q5SY68: 'S100A7L2',
    Q5SYE7: 'NHSL1',
    Q5SZD1: 'C6orf141',
    Q5SZD4: 'GLYATL3',
    Q5SZI1: 'LDLRAD2',
    Q5T0B9: 'ZNF362',
    Q5T1A1: 'DCST2',
    Q5T1B0: 'AXDND1',
    Q5T1J5: 'CHCHD2P9',
    Q5T1N1: 'AKNAD1',
    Q5T1S8: 'NCMAP',
    Q5T215: 'TRAPPC3L',
    Q5T292: 'TMEM273',
    Q5T2L2: 'AKR1C8',
    Q5T3I0: 'GPATCH4',
    Q5T5D7: 'ZNF684',
    Q5T5J6: 'SWT1',
    Q5T5M9: 'CCNJ',
    Q5T5S1: 'CCDC183',
    Q5T681: 'C10orf62',
    Q5T6J7: 'IDNK',
    Q5T764: 'IFIT1B',
    Q5T7M9: 'DIPK1A',
    Q5TAG4: 'NBPF12',
    Q5TC12: 'ATPAF1',
    Q5TC63: 'GRTP1',
    Q5TEA3: 'DNAAF9',
    Q5TEA6: 'SEL1L2',
    Q5TEC3: 'ZNF697',
    Q5TF21: 'SOGA3',
    Q5TF39: 'MFSD4B',
    Q5TFE4: 'NT5DC1',
    Q5TFG8: 'ZC2HC1B',
    Q5TG30: 'ARHGAP40',
    Q5TGI0: 'FAXC',
    Q5TGY1: 'TMCO4',
    Q5TGY3: 'AHDC1',
    Q5THK1: 'PRR14L',
    Q5TI25: 'NBPF14',
    Q5TIE3: 'VWA5B1',
    Q5TZ20: 'OR2G6',
    Q5TZJ5: 'SPATA31A1',
    Q5UAW9: 'GPR157',
    Q5VIY5: 'ZNF468',
    Q5VSG8: 'MANEAL',
    Q5VT79: 'ANXA8L1',
    Q5VTE6: 'ANGEL2',
    Q5VTH2: 'CFAP126',
    Q5VTJ3: 'KLHDC7A',
    Q5VTL8: 'PRPF38B',
    Q5VTM2: 'AGAP9',
    Q5VTU8: 'ATP5F1EP2',
    Q5VU65: 'NUP210L',
    Q5VUD6: 'DIPK1B',
    Q5VUJ5: 'AGAP7P',
    Q5VUJ6: 'LRCH2',
    Q5VUY0: 'AADACL3',
    Q5VVM6: 'CCDC30',
    Q5VW22: 'AGAP6',
    Q5VWQ0: 'RSBN1',
    Q5VWW1: 'C1QL3',
    Q5VX52: 'SPATA1',
    Q5VXU3: 'CHIC1',
    Q5VYM1: 'C9orf131',
    Q5VYV0: 'FOXB2',
    Q5VYV7: 'SLX4IP',
    Q5VZ03: 'NXNL2',
    Q5VZ19: 'TDRD10',
    Q5VZ46: 'KIAA1614',
    Q5VZ52: 'MORN5',
    Q5VZ66: 'JAKMIP3',
    Q5VZ72: 'IZUMO3',
    Q5W041: 'ARMC3',
    Q5W0A0: 'ERICH6B',
    Q5W0B7: 'TMEM236',
    Q5W0V3: 'FHIP2A',
    Q5W186: 'CST9',
    Q5W5W9: 'RESP18',
    Q5XG99: 'LYSMD4',
    Q5XKK7: 'FAM219B',
    Q5XKL5: 'BTBD8',
    Q5XKR9: 'FAM104B',
    Q5XUX1: 'FBXW9',
    Q5YKI7: 'GGNBP1',
    Q63HM2: 'PCNX4',
    Q63HM9: 'PLCXD3',
    Q63ZE4: 'SLC22A10',
    Q64ET8: 'FRG2',
    Q658K8: 'EEF1DP3',
    Q658L1: 'SAXO2',
    Q68CQ7: 'GLT8D1',
    Q68DH5: 'LMBRD2',
    Q68DI1: 'ZNF776',
    Q68DN1: 'C2orf16',
    Q68DY9: 'ZNF772',
    Q69YU3: 'ANKRD34A',
    Q6AHZ1: 'ZNF518A',
    Q6AI08: 'HEATR6',
    Q6AI12: 'ANKRD40',
    Q6AW86: 'ZNF324B',
    Q6B0B8: 'TIGD3',
    Q6BEB4: 'SP5',
    Q6DD87: 'ZNF787',
    Q6DHV5: 'CC2D2B',
    Q6DKI1: 'RPL7L1',
    Q6EBC2: 'IL31',
    Q6F5E7: 'TXNRD3NB',
    Q6GPI1: 'CTRB2',
    Q6GV28: 'TMEM225',
    Q6ICC9: 'RTL6',
    Q6ICH7: 'ASPHD2',
    Q6IEE8: 'SLFN12L',
    Q6IEU7: 'OR5M10',
    Q6IEV9: 'OR4C11',
    Q6IEY1: 'OR4F16',
    Q6IEY1: 'OR4F29',
    Q6IEY1: 'OR4F3',
    Q6IEZ7: 'OR2T5',
    Q6IF00: 'OR2T2',
    Q6IF36: 'OR8G2P',
    Q6IF42: 'OR2A2',
    Q6IF63: 'OR52W1',
    Q6IF82: 'OR4A47',
    Q6IF99: 'OR10K2',
    Q6IFG1: 'OR52E8',
    Q6IFN5: 'OR7E24',
    Q6IN97: 'FRMPD2B',
    Q6IPT2: 'GARIN5A',
    Q6IPX3: 'TCEAL6',
    Q6IQ21: 'ZNF770',
    Q6IS14: 'EIF5AL1',
    Q6J272: 'CIMIP2A',
    Q6JVE6: 'LCN10',
    Q6JVE9: 'LCN8',
    Q6L8G5: 'KRTAP5-10',
    Q6L9T8: 'FAM72D',
    Q6NSI8: 'SANBR',
    Q6NSJ2: 'PHLDB3',
    Q6NSW5: 'DENND10P1',
    Q6NT04: 'TIGD7',
    Q6NT16: 'SLC18B1',
    Q6NT52: 'CGB2',
    Q6NT89: 'TRNP1',
    Q6NUN7: 'JHY',
    Q6NV75: 'GPR153',
    Q6NVV3: 'NIPAL1',
    Q6NW29: 'RWDD4',
    Q6NX49: 'ZNF544',
    Q6NXP0: 'EFCAB12',
    Q6NXP2: 'GARIN1A',
    Q6NZ63: 'STEAP1B',
    Q6P093: 'AADACL2',
    Q6P1N9: 'TATDN1',
    Q6P280: 'ZNF529',
    Q6P387: 'C16orf46',
    Q6P3R8: 'NEK5',
    Q6P3V2: 'ZNF585A',
    Q6P474: 'PDXDC2P',
    Q6P589: 'TNFAIP8L2',
    Q6P5X7: 'TMEM71',
    Q6P656: 'CFAP161',
    Q6P6B7: 'ANKRD16',
    Q6P995: 'FAM171B',
    Q6P9A1: 'ZNF530',
    Q6P9A3: 'ZNF549',
    Q6PB30: 'CSAG1',
    Q6PCB5: 'RSBN1L',
    Q6PEW0: 'PRSS54',
    Q6PEZ8: 'PODNL1',
    Q6PF15: 'KLHL35',
    Q6PG37: 'ZNF790',
    Q6PH81: 'C16orf87',
    Q6PI47: 'KCTD18',
    Q6PI97: 'HOATZ',
    Q6PID6: 'TTC33',
    Q6PII5: 'HAGHL',
    Q6PIS1: 'SLC23A3',
    Q6PJ61: 'FBXO46',
    Q6PJE2: 'POMZP3',
    Q6PK04: 'CCDC137',
    Q6PK81: 'ZNF773',
    Q6PP77: 'XKRX',
    Q6Q6R5: 'CRIP3',
    Q6S545: 'POTEH',
    Q6S5H5: 'POTEG',
    Q6S8J7: 'POTEA',
    Q6T423: 'SLC22A25',
    Q6TFL3: 'CCDC171',
    Q6U949: 'IGF2-AS',
    Q6UE05: 'TMEM270',
    Q6UW01: 'CBLN3',
    Q6UW02: 'CYP20A1',
    Q6UW10: 'SFTA2',
    Q6UWE3: 'CLPSL2',
    Q6UWF7: 'NXPE4',
    Q6UWH4: 'GASK1B',
    Q6UWI4: 'SHISA2',
    Q6UWJ8: 'CD164L2',
    Q6UWM9: 'UGT2A3',
    Q6UWN0: 'LYPD4',
    Q6UWP8: 'SBSN',
    Q6UWQ5: 'LYZL1',
    Q6UWS5: 'PET117',
    Q6UWT2: 'ENHO',
    Q6UWU2: 'GLB1L',
    Q6UWV7: 'SHISAL2A',
    Q6UWX4: 'HHIPL2',
    Q6UWY5: 'OLFML1',
    Q6UX68: 'XKR5',
    Q6UX72: 'B3GNT9',
    Q6UX82: 'LYPD8',
    Q6UXB1: 'IGFL3',
    Q6UXB3: 'LYPD2',
    Q6UXD7: 'SLC49A3',
    Q6UXE8: 'BTNL3',
    Q6UXF7: 'CLEC18B',
    Q6UXN7: 'TOMM20L',
    Q6UXT9: 'ABHD15',
    Q6UXU6: 'TMEM92',
    Q6UXV1: 'IZUMO2',
    Q6UXY8: 'TMC5',
    Q6UY01: 'LRRC31',
    Q6UY18: 'LINGO4',
    Q6UY27: 'PATE2',
    Q6V702: 'CFAP299',
    Q6V9R5: 'ZNF562',
    Q6X9E4: 'FBXW12',
    Q6XE38: 'SCGB1D4',
    Q6XLA1: 'CASC2',
    Q6Y2X3: 'DNAJC14',
    Q6ZMN7: 'PDZRN4',
    Q6ZMN8: 'CCNI2',
    Q6ZMS4: 'ZNF852',
    Q6ZMV5: 'PPP4R3C',
    Q6ZMW2: 'ZNF782',
    Q6ZMW3: 'EML6',
    Q6ZMY6: 'WDR88',
    Q6ZMY9: 'ZNF517',
    Q6ZN01: 'MAMSTR',
    Q6ZN06: 'ZNF813',
    Q6ZN08: 'ZNF66',
    Q6ZN19: 'ZNF841',
    Q6ZN32: 'ETV3L',
    Q6ZN68: 'DPY19L2P2',
    Q6ZN79: 'ZNF705A',
    Q6ZN84: 'CCDC81',
    Q6ZNA1: 'ZNF836',
    Q6ZNA5: 'FRRS1',
    Q6ZNC4: 'ZNF704',
    Q6ZNF0: 'ACP7',
    Q6ZNG1: 'ZNF600',
    Q6ZNI0: 'GCNT7',
    Q6ZNR0: 'TMEM91',
    Q6ZP01: 'RBM44',
    Q6ZPD9: 'DPY19L3',
    Q6ZQQ6: 'WDR87',
    Q6ZQR2: 'CFAP77',
    Q6ZR62: 'RTL4',
    Q6ZRF7: 'ZNF818P',
    Q6ZRI6: 'C15orf39',
    Q6ZRI8: 'ARHGAP36',
    Q6ZRR5: 'TLCD5',
    Q6ZRS4: 'ITPRID1',
    Q6ZS11: 'RINL',
    Q6ZS30: 'NBEAL1',
    Q6ZS86: 'GK5',
    Q6ZSI9: 'CAPN12',
    Q6ZSS3: 'ZNF621',
    Q6ZSU1: 'CYP2G1P',
    Q6ZT07: 'TBC1D9',
    Q6ZT77: 'ZNF826P',
    Q6ZTU2: 'EP400P1',
    Q6ZU65: 'UBN2',
    Q6ZU67: 'BEND4',
    Q6ZUJ4: 'C3orf62',
    Q6ZUK4: 'TMEM26',
    Q6ZUS6: 'CCDC149',
    Q6ZUT6: 'CCDC9B',
    Q6ZV50: 'RFX8',
    Q6ZV89: 'SH2D5',
    Q6ZVC0: 'NYAP1',
    Q6ZVF9: 'GPRIN3',
    Q6ZVL6: 'KIAA1549L',
    Q6ZVZ8: 'ASB18',
    Q6ZWB6: 'KCTD8',
    Q719I0: 'AHSA2P',
    Q71RC9: 'SMIM5',
    Q75NE6: 'MIR17HG',
    Q75VX8: 'GAREM2',
    Q765I0: 'UTS2B',
    Q76G19: 'PDZD4',
    Q76KD6: 'SPATC1',
    Q76KX8: 'ZNF534',
    Q7L0X2: 'ERICH6',
    Q7L211: 'ABHD13',
    Q7L311: 'ARMCX2',
    Q7L4S7: 'ARMCX6',
    Q7L945: 'ZNF627',
    Q7L985: 'LINGO2',
    Q7RTS6: 'OTOP2',
    Q7RTT3: 'SSX9P',
    Q7RTT4: 'SSX8P',
    Q7RTT5: 'SSX7',
    Q7RTT6: 'SSX6P',
    Q7RTU0: 'TCF24',
    Q7RTU5: 'ASCL5',
    Q7RTV5: 'PRXL2C',
    Q7RTX9: 'SLC16A14',
    Q7RTY3: 'PRSS45P',
    Q7Z2Q7: 'LRRC70',
    Q7Z2Y8: 'GVINP1',
    Q7Z304: 'MAMDC2',
    Q7Z309: 'PABIR2',
    Q7Z388: 'DPY19L4',
    Q7Z3E2: 'CCDC186',
    Q7Z3F1: 'GPR155',
    Q7Z3J3: 'RGPD4',
    Q7Z3V5: 'ZNF571',
    Q7Z402: 'TMC7',
    Q7Z404: 'TMC4',
    Q7Z422: 'SZRD1',
    Q7Z4H9: 'FAM220A',
    Q7Z4L0: 'COX8C',
    Q7Z4M0: 'REC114',
    Q7Z4Q2: 'HEATR3',
    Q7Z4R8: 'C6orf120',
    Q7Z4Y8: 'ATP5MGL',
    Q7Z572: 'SPATA21',
    Q7Z5A8: 'TAFA3',
    Q7Z5A9: 'TAFA1',
    Q7Z5J8: 'ANKAR',
    Q7Z5L0: 'VMO1',
    Q7Z5L3: 'C1QL2',
    Q7Z5L4: 'SPATA19',
    Q7Z5M5: 'TMC3',
    Q7Z5S9: 'TMEM144',
    Q7Z5Y7: 'KCTD20',
    Q7Z6M2: 'FBXO33',
    Q7Z6P3: 'RAB44',
    Q7Z6W1: 'TMCO2',
    Q7Z6W7: 'DNAJB7',
    Q7Z736: 'PLEKHH3',
    Q7Z7B8: 'DEFB128',
    Q7Z7J9: 'CAMK2N1',
    Q7Z7K0: 'CMC1',
    Q7Z7K2: 'ZNF467',
    Q86SM5: 'MRGPRG',
    Q86SM8: 'MRGPRE',
    Q86T20: 'SMIM29',
    Q86T29: 'ZNF605',
    Q86T75: 'NBPF11',
    Q86TE4: 'LUZP2',
    Q86TY3: 'ARMH4',
    Q86UF2: 'CTAGE6',
    Q86UP9: 'LHFPL3',
    Q86UV7: 'TRIM73',
    Q86V71: 'ZNF429',
    Q86V87: 'FHIP2B',
    Q86V88: 'MDP1',
    Q86VE3: 'SATL1',
    Q86VG3: 'IFTAP',
    Q86VR8: 'FJX1',
    Q86VS3: 'IQCH',
    Q86VU5: 'COMTD1',
    Q86VY9: 'TMEM200A',
    Q86W25: 'NLRP13',
    Q86W34: 'AMZ2',
    Q86WR7: 'PROSER2',
    Q86WS3: 'OOSP2',
    Q86WS4: 'C12orf40',
    Q86WT1: 'IFT70A',
    Q86WZ6: 'ZNF227',
    Q86X60: 'FAM72B',
    Q86XA9: 'HEATR5A',
    Q86XD8: 'ZFAND4',
    Q86XE3: 'MICU3',
    Q86XJ0: 'CALHM3',
    Q86XN6: 'ZNF761',
    Q86XS5: 'ANGPTL5',
    Q86XU0: 'ZNF677',
    Q86XZ4: 'SPATS2',
    Q86Y79: 'PTRH1',
    Q86YB7: 'ECHDC2',
    Q86YQ2: 'BPIFA4P',
    Q86YQ8: 'CPNE8',
    Q86YR6: 'POTED',
    Q8IUA0: 'WFDC8',
    Q8IUB2: 'WFDC3',
    Q8IUB3: 'WFDC10B',
    Q8IUB5: 'WFDC13',
    Q8IUH2: 'CREG2',
    Q8IUK8: 'CBLN2',
    Q8IUL8: 'CILP2',
    Q8IUS5: 'EPHX4',
    Q8IV03: 'LURAP1L',
    Q8IV13: 'CCNJL',
    Q8IV33: 'KIAA0825',
    Q8IV38: 'ANKMY2',
    Q8IV42: 'PSTK',
    Q8IV50: 'LYSMD2',
    Q8IVA1: 'PCP2',
    Q8IVC4: 'ZNF584',
    Q8IVE0: 'CROCCP3',
    Q8IVF6: 'ANKRD18A',
    Q8IVN3: 'MUSTN1',
    Q8IVN8: 'SBSPON',
    Q8IVU1: 'IGDCC3',
    Q8IVV8: 'NKAIN4',
    Q8IVY1: 'C1orf210',
    Q8IW50: 'FAM219A',
    Q8IW70: 'TMEM151B',
    Q8IW92: 'GLB1L2',
    Q8IWB4: 'SPATA31A7',
    Q8IX94: 'CTAGE4',
    Q8IX95: 'CTAGE3P',
    Q8IXE1: 'OR4N5',
    Q8IXF9: 'AQP12A',
    Q8IXQ4: 'GPALPP1',
    Q8IXS8: 'HYCC2',
    Q8IXT5: 'RBM12B',
    Q8IXU6: 'SLC35F2',
    Q8IXX5: 'TMEM183A',
    Q8IY42: 'C4orf19',
    Q8IY47: 'KBTBD2',
    Q8IY50: 'SLC35F3',
    Q8IY51: 'TIGD4',
    Q8IY85: 'EFCAB13',
    Q8IYA7: 'MKX',
    Q8IYB9: 'ZNF595',
    Q8IYL3: 'C1orf174',
    Q8IYM0: 'FAM186B',
    Q8IYN0: 'ZNF100',
    Q8IYP2: 'PRSS58',
    Q8IYS2: 'KIAA2013',
    Q8IYW4: 'ENTHD1',
    Q8IZ02: 'LRRC34',
    Q8IZ13: 'FAM200C',
    Q8IZ16: 'SPACDR',
    Q8IZ81: 'ELMOD2',
    Q8IZD0: 'SAMD14',
    Q8IZJ6: 'TDH',
    Q8IZM8: 'ZNF654',
    Q8IZN7: 'DEFB107A',
    Q8IZN7: 'DEFB107B',
    Q8IZP2: 'ST13P4',
    Q8IZY5: 'BLID',
    Q8N0U6: 'LINC00518',
    Q8N0V4: 'LGI2',
    Q8N0Y3: 'OR4N4',
    Q8N0Y5: 'OR8I2',
    Q8N0Z2: 'ABRA',
    Q8N0Z9: 'VSIG10',
    Q8N127: 'OR5AS1',
    Q8N129: 'CNPY4',
    Q8N141: 'ZFP82',
    Q8N146: 'OR8H3',
    Q8N148: 'OR6V1',
    Q8N162: 'OR8H2',
    Q8N1A6: 'C4orf33',
    Q8N1E2: 'LYG1',
    Q8N1L4: 'CYP4Z2P',
    Q8N1N0: 'CLEC4F',
    Q8N1W2: 'ZNF710',
    Q8N228: 'SCML4',
    Q8N283: 'ANKRD35',
    Q8N2E2: 'VWDE',
    Q8N2I2: 'ZNF619',
    Q8N2X6: 'EXOC3-AS1',
    Q8N309: 'LRRC43',
    Q8N323: 'NXPE1',
    Q8N336: 'ELMOD1',
    Q8N349: 'OR2L13',
    Q8N3F9: 'GPR137C',
    Q8N3H0: 'TAFA2',
    Q8N3R3: 'TCAIM',
    Q8N3S3: 'PHTF2',
    Q8N3T6: 'TMEM132C',
    Q8N3Z0: 'PRSS35',
    Q8N3Z3: 'GTPBP8',
    Q8N413: 'SLC25A45',
    Q8N431: 'RASGEF1C',
    Q8N434: 'SVOPL',
    Q8N456: 'LRRC18',
    Q8N468: 'MFSD4A',
    Q8N475: 'FSTL5',
    Q8N4B4: 'FBXO39',
    Q8N4F7: 'RNF175',
    Q8N4H0: 'SPATA6L',
    Q8N4S0: 'CCDC82',
    Q8N4U5: 'TCP11L2',
    Q8N4V2: 'SVOP',
    Q8N4Z0: 'RAB42',
    Q8N567: 'ZCCHC9',
    Q8N584: 'TTC39C',
    Q8N587: 'ZNF561',
    Q8N5C6: 'SRBD1',
    Q8N5H3: 'FAM89B',
    Q8N5I9: 'NOPCHAP1',
    Q8N5J4: 'SPIC',
    Q8N5T2: 'TBC1D19',
    Q8N5U1: 'MS4A15',
    Q8N5W9: 'RFLNB',
    Q8N5X7: 'EIF4E3',
    Q8N660: 'NBPF15',
    Q8N687: 'DEFB125',
    Q8N688: 'DEFB123',
    Q8N699: 'MYCT1',
    Q8N6I4: 'LYSET',
    Q8N6M5: 'ALLC',
    Q8N6M8: 'IQCF1',
    Q8N6M9: 'ZFAND2A',
    Q8N6N3: 'C1orf52',
    Q8N6N6: 'NATD1',
    Q8N6N7: 'ACBD7',
    Q8N6Q1: 'TMCO5A',
    Q8N6V9: 'TEX9',
    Q8N6Y1: 'PCDH20',
    Q8N6Y2: 'LRRC17',
    Q8N782: 'ZNF525',
    Q8N7C7: 'RNF148',
    Q8N7F7: 'UBL4B',
    Q8N7G0: 'POU5F2',
    Q8N7M0: 'DYNLT5',
    Q8N7P1: 'PLD5',
    Q8N7Q3: 'ZNF676',
    Q8N7R0: 'NANOGP1',
    Q8N7R1: 'POM121L12',
    Q8N7R7: 'CCNYL1',
    Q8N7S2: 'DNAJC5G',
    Q8N7X0: 'ADGB',
    Q8N7Z5: 'ANKRD31',
    Q8N815: 'CNTD1',
    Q8N878: 'FRMD1',
    Q8N8C0: 'ZNF781',
    Q8N8D1: 'PDCD7',
    Q8N8F7: 'LSMEM1',
    Q8N8M0: 'NAT16',
    Q8N8Q9: 'NIPA2',
    Q8N8U3: 'RTL3',
    Q8N8Z6: 'DCBLD1',
    Q8N944: 'AMER3',
    Q8N961: 'ABTB2',
    Q8N967: 'LRTM2',
    Q8N972: 'ZNF709',
    Q8N998: 'CCDC89',
    Q8N9F8: 'ZNF454',
    Q8N9K5: 'ZNF565',
    Q8N9M1: 'C19orf47',
    Q8N9N7: 'LRRC57',
    Q8N9T8: 'KRI1',
    Q8N9U0: 'TC2N',
    Q8N9V7: 'TOPAZ1',
    Q8N9W8: 'GARIN2',
    Q8N9Y4: 'FAM181A',
    Q8N9Z9: 'LMNTD1',
    Q8NA23: 'WDR31',
    Q8NA47: 'CCDC63',
    Q8NA69: 'SAXO5',
    Q8NA92: 'THAP8',
    Q8NAF0: 'ZNF579',
    Q8NB37: 'GATD1',
    Q8NB42: 'ZNF527',
    Q8NB46: 'ANKRD52',
    Q8NB50: 'ZFP62',
    Q8NBL3: 'TMEM178A',
    Q8NC74: 'RBBP8NL',
    Q8NCC5: 'SLC37A3',
    Q8NCI6: 'GLB1L3',
    Q8NCL9: 'APCDD1L',
    Q8NCQ5: 'FBXO15',
    Q8NCR9: 'CLRN3',
    Q8NCV1: 'ADAD2',
    Q8NCX0: 'CCDC150',
    Q8ND07: 'BBOF1',
    Q8ND61: 'C3orf20',
    Q8NDA2: 'HMCN2',
    Q8NDA8: 'MROH1',
    Q8NDD1: 'C1orf131',
    Q8NDW4: 'ZNF248',
    Q8NDY3: 'ADPRHL1',
    Q8NDY6: 'BHLHE23',
    Q8NDZ0: 'BEND2',
    Q8NDZ6: 'TMEM161B',
    Q8NE00: 'TMEM104',
    Q8NE18: 'NSUN7',
    Q8NE22: 'SETD9',
    Q8NE65: 'ZNF738',
    Q8NEA5: 'C19orf18',
    Q8NEC7: 'GSTCD',
    Q8NEG4: 'FAM83F',
    Q8NEG5: 'ZSWIM2',
    Q8NEG7: 'DENND6B',
    Q8NEK5: 'ZNF548',
    Q8NEM1: 'ZNF680',
    Q8NEM2: 'SHCBP1',
    Q8NEP7: 'KLHDC9',
    Q8NEY3: 'SPATA4',
    Q8NFI4: 'ST13P5',
    Q8NFQ5: 'BPIFB6',
    Q8NFQ6: 'BPIFC',
    Q8NFR7: 'CCDC148',
    Q8NFU4: 'FDCSP',
    Q8NFZ6: 'VN1R2',
    Q8NG35: 'DEFB105A',
    Q8NG35: 'DEFB105B',
    Q8NG41: 'NPB',
    Q8NG75: 'OR5T1',
    Q8NG76: 'OR2T33',
    Q8NG77: 'OR2T12',
    Q8NG78: 'OR8G5',
    Q8NG80: 'OR2L5',
    Q8NG81: 'OR2M7',
    Q8NG83: 'OR2M3',
    Q8NG84: 'OR2AK2',
    Q8NG85: 'OR2L3',
    Q8NG92: 'OR13H1',
    Q8NG94: 'OR11H1',
    Q8NG95: 'OR7G3',
    Q8NG97: 'OR2Z1',
    Q8NG99: 'OR7G2',
    Q8NGA1: 'OR1M1',
    Q8NGA2: 'OR7A2P',
    Q8NGA5: 'OR10H4',
    Q8NGA6: 'OR10H5',
    Q8NGA8: 'OR4F17',
    Q8NGB2: 'OR4C5',
    Q8NGB4: 'OR4S1',
    Q8NGB6: 'OR4M2',
    Q8NGB8: 'OR4F15',
    Q8NGB9: 'OR4F6',
    Q8NGC1: 'OR11G2',
    Q8NGC2: 'OR4E2',
    Q8NGC3: 'OR10G2',
    Q8NGC4: 'OR10G3',
    Q8NGC5: 'OR6J1',
    Q8NGC6: 'OR4K17',
    Q8NGC9: 'OR11H4',
    Q8NGD1: 'OR4N2',
    Q8NGD2: 'OR4K2',
    Q8NGD3: 'OR4K5',
    Q8NGD4: 'OR4K1',
    Q8NGD5: 'OR4K14',
    Q8NGE0: 'OR10AD1',
    Q8NGE1: 'OR6C4',
    Q8NGE2: 'OR2AP1',
    Q8NGE5: 'OR10A7',
    Q8NGE7: 'OR9K2',
    Q8NGE8: 'OR4D9',
    Q8NGE9: 'OR9Q2',
    Q8NGF1: 'OR52R1',
    Q8NGF3: 'OR51D1',
    Q8NGF4: 'OR5AP2',
    Q8NGF6: 'OR10W1',
    Q8NGF7: 'OR5B17',
    Q8NGF8: 'OR4B1',
    Q8NGF9: 'OR4X2',
    Q8NGG0: 'OR8J3',
    Q8NGG1: 'OR8J2',
    Q8NGG3: 'OR5T3',
    Q8NGG4: 'OR8H1',
    Q8NGG5: 'OR8K1',
    Q8NGG6: 'OR8B12',
    Q8NGG8: 'OR8B3',
    Q8NGH3: 'OR2D3',
    Q8NGH5: 'OR56A1',
    Q8NGH6: 'OR52L2P',
    Q8NGH8: 'OR56A4',
    Q8NGH9: 'OR52E4',
    Q8NGI0: 'OR52N2',
    Q8NGI1: 'OR56B2P',
    Q8NGI3: 'OR56B1',
    Q8NGI4: 'OR4D11',
    Q8NGI6: 'OR4D10',
    Q8NGI7: 'OR10V1',
    Q8NGI9: 'OR5A2',
    Q8NGJ0: 'OR5A1',
    Q8NGJ1: 'OR4D6',
    Q8NGJ3: 'OR52E1',
    Q8NGJ4: 'OR52E2',
    Q8NGJ5: 'OR51L1',
    Q8NGJ6: 'OR51A4',
    Q8NGJ7: 'OR51A2',
    Q8NGJ8: 'OR51S1',
    Q8NGJ9: 'OR51T1',
    Q8NGK0: 'OR51G2',
    Q8NGK1: 'OR51G1',
    Q8NGK3: 'OR52K2',
    Q8NGK4: 'OR52K1',
    Q8NGK5: 'OR52M1',
    Q8NGK6: 'OR52I1',
    Q8NGK9: 'OR5D16',
    Q8NGL0: 'OR5L2',
    Q8NGL2: 'OR5L1',
    Q8NGL3: 'OR5D14',
    Q8NGL4: 'OR5D13',
    Q8NGL6: 'OR4A15',
    Q8NGL7: 'OR4P4',
    Q8NGL9: 'OR4C16',
    Q8NGM1: 'OR4C15',
    Q8NGM8: 'OR6M1',
    Q8NGN0: 'OR4D5',
    Q8NGN1: 'OR6T1',
    Q8NGN2: 'OR10S1',
    Q8NGN4: 'OR10G9',
    Q8NGN5: 'OR10G8',
    Q8NGN7: 'OR10D4P',
    Q8NGN8: 'OR4A4P',
    Q8NGP0: 'OR4C13',
    Q8NGP2: 'OR8J1',
    Q8NGP3: 'OR5M9',
    Q8NGP4: 'OR5M3',
    Q8NGP6: 'OR5M8',
    Q8NGP8: 'OR5M1',
    Q8NGP9: 'OR5AR1',
    Q8NGQ2: 'OR6Q1',
    Q8NGQ3: 'OR1S2',
    Q8NGQ4: 'OR10Q1',
    Q8NGQ5: 'OR9Q1',
    Q8NGQ6: 'OR9I1',
    Q8NGR1: 'OR13A1',
    Q8NGR3: 'OR1K1',
    Q8NGR4: 'OR5C1',
    Q8NGR5: 'OR1L4',
    Q8NGR8: 'OR1L8',
    Q8NGR9: 'OR1N2',
    Q8NGS1: 'OR1J4',
    Q8NGS3: 'OR1J1',
    Q8NGS4: 'OR13F1',
    Q8NGS5: 'OR13C4',
    Q8NGS6: 'OR13C3',
    Q8NGS7: 'OR13C8',
    Q8NGS9: 'OR13C2',
    Q8NGT0: 'OR13C9',
    Q8NGT1: 'OR2K2',
    Q8NGT2: 'OR13J1',
    Q8NGT5: 'OR9A2',
    Q8NGT7: 'OR2A12',
    Q8NGT9: 'OR2A1',
    Q8NGT9: 'OR2A42',
    Q8NGU1: 'OR9A1P',
    Q8NGU2: 'OR9A4',
    Q8NGU4: 'OR2I1P',
    Q8NGU9: 'GPR150',
    Q8NGV0: 'OR2Y1',
    Q8NGV5: 'OR13D1',
    Q8NGV7: 'OR5H2',
    Q8NGX0: 'OR11L1',
    Q8NGX1: 'OR2T34',
    Q8NGX2: 'OR2T35',
    Q8NGX5: 'OR10K1',
    Q8NGX6: 'OR10R2',
    Q8NGX8: 'OR6Y1',
    Q8NGX9: 'OR6P1',
    Q8NGY1: 'OR10Z1',
    Q8NGY2: 'OR6K2',
    Q8NGY5: 'OR6N1',
    Q8NGY6: 'OR6N2',
    Q8NGY7: 'OR10J6P',
    Q8NGY9: 'OR2L8',
    Q8NGZ0: 'OR2AJ1',
    Q8NGZ2: 'OR14K1',
    Q8NGZ3: 'OR13G1',
    Q8NGZ4: 'OR2G3',
    Q8NGZ5: 'OR2G2',
    Q8NGZ6: 'OR6F1',
    Q8NGZ9: 'OR2T10',
    Q8NH00: 'OR2T4',
    Q8NH01: 'OR2T11',
    Q8NH02: 'OR2T29',
    Q8NH03: 'OR2T3',
    Q8NH04: 'OR2T27',
    Q8NH05: 'OR4Q3',
    Q8NH07: 'OR11H2',
    Q8NH08: 'OR10AC1',
    Q8NH09: 'OR8S1',
    Q8NH16: 'OR2L2',
    Q8NH18: 'OR5J2',
    Q8NH37: 'OR4C3',
    Q8NH40: 'OR6S1',
    Q8NH41: 'OR4K15',
    Q8NH42: 'OR4K13',
    Q8NH49: 'OR4X1',
    Q8NH50: 'OR8K5',
    Q8NH51: 'OR8K3',
    Q8NH53: 'OR52N1',
    Q8NH54: 'OR56A3',
    Q8NH55: 'OR52E5',
    Q8NH56: 'OR52N5',
    Q8NH57: 'OR52P1',
    Q8NH60: 'OR52J3',
    Q8NH61: 'OR51F2',
    Q8NH63: 'OR51H1',
    Q8NH64: 'OR51A7',
    Q8NH70: 'OR4A16',
    Q8NH72: 'OR4C6',
    Q8NH73: 'OR4S2',
    Q8NH74: 'OR10A6',
    Q8NH76: 'OR56B4',
    Q8NH79: 'OR6X1',
    Q8NH80: 'OR10D3',
    Q8NH81: 'OR10G6',
    Q8NH83: 'OR4A5',
    Q8NH89: 'OR5AK3P',
    Q8NH90: 'OR5AK2',
    Q8NH93: 'OR1L3',
    Q8NH95: 'OR13C6P',
    Q8NHA4: 'OR2AE1',
    Q8NHA6: 'OR2W6P',
    Q8NHA8: 'OR1F12P',
    Q8NHB1: 'OR2V1',
    Q8NHB7: 'OR5K1',
    Q8NHB8: 'OR5K2',
    Q8NHC5: 'OR14A16',
    Q8NHC6: 'OR14L1',
    Q8NHC7: 'OR14C36',
    Q8NHR7: 'TERB2',
    Q8NHR9: 'PFN4',
    Q8NHS2: 'GOT1L1',
    Q8NHS4: 'CLHC1',
    Q8NHU0: 'CT45A3',
    Q8NHV5: 'MOSMO',
    Q8NHW5: 'RPLP0P6',
    Q8NHW6: 'OTOS',
    Q8NHY5: 'HUS1B',
    Q8NHZ7: 'MBD3L2',
    Q8TA94: 'ZNF563',
    Q8TAA1: 'RNASE11',
    Q8TAI1: 'TYMSOS',
    Q8TAV0: 'FAM76A',
    Q8TAV5: 'KCNJ5-AS1',
    Q8TAW3: 'ZNF671',
    Q8TB22: 'SPATA20',
    Q8TB52: 'FBXO30',
    Q8TB69: 'ZNF519',
    Q8TBF8: 'FAM81A',
    Q8TBH0: 'ARRDC2',
    Q8TBP6: 'SLC25A40',
    Q8TBR7: 'TLCD3A',
    Q8TC17: 'GRAPL',
    Q8TC90: 'CCER1',
    Q8TCB0: 'IFI44',
    Q8TCN5: 'ZNF507',
    Q8TCP9: 'FAM200A',
    Q8TD55: 'PLEKHO2',
    Q8TD86: 'CALML6',
    Q8TDS7: 'MRGPRD',
    Q8TDU5: 'VN1R17P',
    Q8TE96: 'DQX1',
    Q8TEQ0: 'SNX29',
    Q8TF08: 'COX7B2',
    Q8TF20: 'ZNF721',
    Q8TF21: 'ANKRD24',
    Q8TF27: 'AGAP11',
    Q8TF32: 'ZNF431',
    Q8TF44: 'C2CD4C',
    Q8TF45: 'ZNF418',
    Q8TF61: 'FBXO41',
    Q8WTP9: 'XAGE3',
    Q8WTR8: 'NTN5',
    Q8WTU2: 'SSC4D',
    Q8WU76: 'SCFD2',
    Q8WUH6: 'TMEM263',
    Q8WUJ1: 'CYB5D2',
    Q8WUS8: 'SDR42E1',
    Q8WUT9: 'SLC25A43',
    Q8WUY8: 'NAT14',
    Q8WUY9: 'DEPDC1B',
    Q8WV15: 'TMEM255B',
    Q8WV83: 'SLC35F5',
    Q8WVC6: 'DCAKD',
    Q8WVE6: 'TMEM171',
    Q8WVI0: 'UQCC5',
    Q8WVI7: 'PPP1R1C',
    Q8WW14: 'SPMIP5',
    Q8WW18: 'C17orf50',
    Q8WW32: 'HMGB4',
    Q8WW36: 'ZCCHC13',
    Q8WW52: 'FAM151A',
    Q8WW62: 'TMED6',
    Q8WWA1: 'TMEM40',
    Q8WWF6: 'DNAJB3',
    Q8WWU7: 'ITLN2',
    Q8WWX0: 'ASB5',
    Q8WX39: 'LCN9',
    Q8WXE0: 'CASKIN2',
    Q8WXF5: 'CRYGN',
    Q8WXJ9: 'ASB17',
    Q8WXS4: 'TMEM37',
    Q8WXT5: 'FOXD4L4',
    Q8WYK1: 'CNTNAP5',
    Q8WZ71: 'TMEM158',
    Q8WZ82: 'OVCA2',
    Q8WZA0: 'LZIC',
    Q8WZA6: 'OR1E3',
    Q92527: 'ANKRD7',
    Q92545: 'TMEM131',
    Q92576: 'PHF3',
    Q92610: 'ZNF592',
    Q92670: 'ZNF75CP',
    Q93075: 'TATDN2',
    Q93083: 'MT1L',
    Q969E4: 'TCEAL3',
    Q969W3: 'FAM104A',
    Q969Y0: 'NXPE3',
    Q96A98: 'PTH2',
    Q96AB3: 'ISOC2',
    Q96AQ9: 'FAM131C',
    Q96B33: 'CLDN23',
    Q96BJ8: 'ELMO3',
    Q96BM0: 'IFI27L1',
    Q96BQ1: 'FAM3D',
    Q96BQ3: 'TRIM43',
    Q96BW5: 'PTER',
    Q96BX8: 'MOB3A',
    Q96C01: 'FAM136A',
    Q96C57: 'CUSTOS',
    Q96C90: 'PPP1R14B',
    Q96CD0: 'FBXL8',
    Q96CH1: 'GPR146',
    Q96CS4: 'ZNF689',
    Q96CT2: 'KLHL29',
    Q96DC7: 'TMCO6',
    Q96DD0: 'LRRC39',
    Q96DL1: 'NXPE2',
    Q96DN5: 'TBC1D31',
    Q96DS6: 'MS4A6E',
    Q96DU9: 'PABPC5',
    Q96DY2: 'IQCD',
    Q96E16: 'SMIM19',
    Q96E39: 'RBMXL1',
    Q96E66: 'LRRC51',
    Q96EH8: 'NEURL3',
    Q96EI5: 'TCEAL4',
    Q96EK2: 'PHF21B',
    Q96EL2: 'MRPS24',
    Q96ER3: 'SAAL1',
    Q96ES6: 'MFSD3',
    Q96ET8: 'TVP23C',
    Q96EV2: 'RBM33',
    Q96EX2: 'RNFT2',
    Q96EZ4: 'MYEOV',
    Q96FB5: 'METTL25B',
    Q96FN5: 'KIF12',
    Q96G27: 'WBP1',
    Q96GE5: 'ZNF799',
    Q96GE6: 'CALML4',
    Q96GK7: 'FAHD2A',
    Q96GT9: 'XAGE2',
    Q96GU1: 'PAGE5',
    Q96H12: 'MSANTD3',
    Q96H40: 'ZNF486',
    Q96H79: 'ZC3HAV1L',
    Q96HA4: 'C1orf159',
    Q96HP4: 'OXNAD1',
    Q96HV5: 'TMEM41A',
    Q96I13: 'ABHD8',
    Q96I23: 'PYURF',
    Q96IC2: 'REXO5',
    Q96ID5: 'IGSF21',
    Q96IM9: 'DYDC2',
    Q96J77: 'TPD52L3',
    Q96JF6: 'ZNF594',
    Q96JM4: 'LRRIQ1',
    Q96K17: 'BTF3L4',
    Q96K37: 'SLC35E1',
    Q96K62: 'ZBTB45',
    Q96K75: 'ZNF514',
    Q96KC9: 'CABS1',
    Q96KD3: 'GARIN1B',
    Q96KF2: 'PRAC1',
    Q96KJ4: 'MSLNL',
    Q96KT7: 'SLC35G5',
    Q96KV6: 'BTN2A3P',
    Q96KW9: 'SPACA7',
    Q96L11: 'LLCFC1',
    Q96LB0: 'MRGPRX3',
    Q96LK8: 'SPATA32',
    Q96LP2: 'FAM81B',
    Q96LQ0: 'PPP1R36',
    Q96LR4: 'TAFA4',
    Q96LT6: 'C1orf74',
    Q96LU7: 'MYRFL',
    Q96LW1: 'ZNF354B',
    Q96M20: 'CNBD2',
    Q96M34: 'TEX55',
    Q96M53: 'TBATA',
    Q96M89: 'CCDC138',
    Q96M93: 'ADAD1',
    Q96M95: 'CCDC42',
    Q96MC5: 'BMERB1',
    Q96MC6: 'MFSD14A',
    Q96ME1: 'FBXL18',
    Q96ME7: 'ZNF512',
    Q96MF6: 'COQ10A',
    Q96MK2: 'RIPOR3',
    Q96MN5: 'TCEANC2',
    Q96MR6: 'CFAP57',
    Q96MR9: 'ZNF560',
    Q96MS3: 'GLT1D1',
    Q96MU6: 'ZNF778',
    Q96MW1: 'CCDC43',
    Q96MY1: 'NOL4L',
    Q96N11: 'INTS15',
    Q96N20: 'ZNF75A',
    Q96N22: 'ZNF681',
    Q96N46: 'TTC14',
    Q96NA8: 'TSNARE1',
    Q96ND8: 'ZNF583',
    Q96NG8: 'ZNF582',
    Q96NI8: 'ZNF570',
    Q96NJ5: 'KLHL32',
    Q96NJ6: 'ZFP3',
    Q96NK8: 'NEUROD6',
    Q96NS5: 'ASB16',
    Q96NT1: 'NAP1L5',
    Q96NU7: 'AMDHD1',
    Q96P64: 'AGAP4',
    Q96P67: 'GPR82',
    Q96PG1: 'MS4A4E',
    Q96PG2: 'MS4A10',
    Q96PI1: 'SPRR4',
    Q96PT3: 'DUX5',
    Q96PT4: 'DUX3',
    Q96PX6: 'CCDC85A',
    Q96QA6: 'YPEL2',
    Q96QD5: 'DEPDC7',
    Q96QE4: 'LRRC37B',
    Q96QH8: 'SPACA5',
    Q96QH8: 'SPACA5B',
    Q96QK8: 'SMIM14',
    Q96QZ0: 'PANX3',
    Q96R05: 'RBP7',
    Q96R09: 'OR5B2',
    Q96R27: 'OR2M4',
    Q96R28: 'OR2M2',
    Q96R30: 'OR2V2',
    Q96R45: 'OR2A7',
    Q96R47: 'OR2A14',
    Q96R54: 'OR14A2',
    Q96R67: 'OR4C12',
    Q96R69: 'OR4F4',
    Q96R72: 'OR4K3',
    Q96R84: 'OR1F2P',
    Q96RB7: 'OR5M11',
    Q96RD0: 'OR8B2',
    Q96RD1: 'OR6C1',
    Q96RD2: 'OR52B2',
    Q96RD3: 'OR52E6',
    Q96RM1: 'SPRR2F',
    Q96RT6: 'CTAGE1',
    Q96RY5: 'CRAMP1',
    Q96S19: 'METTL26',
    Q96S86: 'HAPLN3',
    Q96SA4: 'SERINC2',
    Q96SF2: 'CCT8L2',
    Q96SK2: 'TMEM209',
    Q96T17: 'MAP7D2',
    Q96T75: 'DSCR8',
    Q96TA0: 'PCDHB18P',
    Q99457: 'NAP1L3',
    Q99470: 'SDF2',
    Q99603: 'TRGV9',
    Q99676: 'ZNF184',
    Q99679: 'GPR21',
    Q99680: 'GPR22',
    Q9BPW5: 'RASL11B',
    Q9BQ13: 'KCTD14',
    Q9BQ48: 'MRPL34',
    Q9BQ75: 'CMSS1',
    Q9BQD1: 'PMCHL2',
    Q9BQE6: 'LBHD1',
    Q9BQN1: 'FAM83C',
    Q9BQP9: 'BPIFA3',
    Q9BQY6: 'WFDC6',
    Q9BR09: 'NEURL2',
    Q9BR10: 'SPATA25',
    Q9BR26: 'OCSTAMP',
    Q9BR77: 'CCDC77',
    Q9BRH9: 'ZNF251',
    Q9BRN9: 'TM2D3',
    Q9BRP7: 'FDXACB1',
    Q9BRR8: 'GPATCH1',
    Q9BS91: 'SLC35A5',
    Q9BSC4: 'NOL10',
    Q9BSJ1: 'TRIM51',
    Q9BSK0: 'MARVELD1',
    Q9BSY4: 'CHCHD5',
    Q9BT73: 'PSMG3',
    Q9BTE0: 'NAT9',
    Q9BTF0: 'THUMPD2',
    Q9BTV7: 'CABLES2',
    Q9BTY7: 'HGH1',
    Q9BUA6: 'MYL10',
    Q9BUJ0: 'ABHD14A',
    Q9BUV0: 'RSRP1',
    Q9BUW7: 'BBLN',
    Q9BUY7: 'EFCAB11',
    Q9BV87: 'CNPPD1',
    Q9BV97: 'ZNF747',
    Q9BVM2: 'DPCD',
    Q9BVV8: 'FAM174C',
    Q9BWD3: 'RTL8A',
    Q9BWG4: 'SSBP4',
    Q9BWM5: 'ZNF416',
    Q9BWT6: 'MND1',
    Q9BWV2: 'SPATA9',
    Q9BWW9: 'APOL5',
    Q9BX69: 'CARD6',
    Q9BX73: 'TM2D2',
    Q9BXM9: 'FSD1L',
    Q9BXN6: 'SPANXD',
    Q9BXU3: 'TEX13A',
    Q9BXU8: 'FTHL17',
    Q9BXW7: 'HDHD5',
    Q9BXX2: 'ANKRD30B',
    Q9BXX3: 'ANKRD30A',
    Q9BXY0: 'MAK16',
    Q9BXY5: 'CAPS2',
    Q9BY19: 'MS4A8',
    Q9BY31: 'ZNF717',
    Q9BY71: 'LRRC3',
    Q9BYB4: 'GNB1L',
    Q9BYE4: 'SPRR2G',
    Q9BYG7: 'MRO',
    Q9BYJ0: 'FGFBP2',
    Q9BYT5: 'KRTAP2-2',
    Q9BYU5: 'KRTAP2-1',
    Q9BZE3: 'BARHL1',
    Q9BZK3: 'NACA4P',
    Q9BZW5: 'TM6SF1',
    Q9C0B2: 'CFAP74',
    Q9C0B7: 'TANGO6',
    Q9C0B9: 'ZCCHC2',
    Q9C0D4: 'ZNF518B',
    Q9C0H6: 'KLHL4',
    Q9C0I3: 'CCSER1',
    Q9C0I4: 'THSD7B',
    Q9C0I9: 'LRRC27',
    Q9C0K3: 'ACTR3C',
    Q9GIP4: 'SLC7A5P2',
    Q9GZK3: 'OR2B2',
    Q9GZK7: 'OR11A1',
    Q9GZM3: 'POLR2J2',
    Q9GZN8: 'ADISSP',
    Q9GZP8: 'IMUP',
    Q9GZU3: 'TMEM39B',
    Q9GZW5: 'SCAND2P',
    Q9GZY1: 'PBOV1',
    Q9H0K4: 'RSPH6A',
    Q9H0M5: 'ZNF700',
    Q9H0R4: 'HDHD2',
    Q9H114: 'CSTL1',
    Q9H195: 'MUC3B',
    Q9H1A7: 'POLR2J3',
    Q9H1C3: 'GLT8D2',
    Q9H1C7: 'CYSTM1',
    Q9H1E5: 'TMX4',
    Q9H1H1: 'GTSF1L',
    Q9H1K6: 'TLNRD1',
    Q9H1M0: 'NUP62CL',
    Q9H1M3: 'DEFB129',
    Q9H1Q7: 'PCED1A',
    Q9H1X3: 'DNAJC25',
    Q9H1Z4: 'WDR13',
    Q9H1Z9: 'TSPAN10',
    Q9H208: 'OR10A2',
    Q9H299: 'SH3BGRL3',
    Q9H2C5: 'OR52A5',
    Q9H2C8: 'OR51V1',
    Q9H2I8: 'LRMDA',
    Q9H2Z4: 'NKX2-4',
    Q9H321: 'VCX3B',
    Q9H322: 'VCX2',
    Q9H343: 'OR51I1',
    Q9H344: 'OR51I2',
    Q9H346: 'OR52D1',
    Q9H3H9: 'TCEAL2',
    Q9H3V2: 'MS4A5',
    Q9H3W5: 'LRRN3',
    Q9H3Y0: 'R3HDML',
    Q9H3Z7: 'ABHD16B',
    Q9H425: 'C1orf198',
    Q9H4G8: 'DPH3P1',
    Q9H4I0: 'RAD21L1',
    Q9H4K1: 'RIBC2',
    Q9H568: 'ACTL8',
    Q9H5J0: 'ZBTB3',
    Q9H628: 'RERGL',
    Q9H6A0: 'DENND2D',
    Q9H6N6: 'MYH16',
    Q9H6Y2: 'WDR55',
    Q9H6Y5: 'MAGIX',
    Q9H720: 'CWH43',
    Q9H765: 'ASB8',
    Q9H7J1: 'PPP1R3E',
    Q9H7L2: 'KIR3DX1',
    Q9H7R5: 'ZNF665',
    Q9H7T0: 'CATSPERB',
    Q9H7Y0: 'DIPK2B',
    Q9H841: 'NIPAL2',
    Q9H853: 'TUBA4B',
    Q9H857: 'NT5DC2',
    Q9H8G1: 'ZNF430',
    Q9H8G2: 'CAAP1',
    Q9H8J5: 'MANSC1',
    Q9H8M1: 'COQ10B',
    Q9H8U3: 'ZFAND3',
    Q9H920: 'RNF121',
    Q9H930: 'SP140L',
    Q9H963: 'ZNF702P',
    Q9H972: 'C14orf93',
    Q9H9L3: 'ISG20L2',
    Q9H9S3: 'SEC61A2',
    Q9H9S4: 'CAB39L',
    Q9H9Y4: 'GPN2',
    Q9HA72: 'CALHM2',
    Q9HA90: 'EFCC1',
    Q9HAE3: 'CLXN',
    Q9HB14: 'KCNK13',
    Q9HB15: 'KCNK12',
    Q9HB31: 'SEBOX',
    Q9HBJ0: 'PLAC1',
    Q9HBL7: 'PLGRKT',
    Q9HBT7: 'ZNF287',
    Q9HC44: 'GPBP1L1',
    Q9HC57: 'WFDC1',
    Q9HCE3: 'ZNF532',
    Q9HCJ3: 'RAVER2',
    Q9HCJ5: 'ZSWIM6',
    Q9HCJ6: 'VAT1L',
    Q9HCK1: 'ZDBF2',
    Q9HCL3: 'ZFP14',
    Q9HCM7: 'FBRSL1',
    Q9HCS5: 'EPB41L4A',
    Q9HCZ1: 'ZNF334',
    Q9HD45: 'TM9SF3',
    Q9HDB8: 'ERVK-5',
    Q9NNX9: 'VCX3A',
    Q9NNZ3: 'DNAJC4',
    Q9NNZ6: 'PRM3',
    Q9NPD7: 'NRN1',
    Q9NPI7: 'KRCC1',
    Q9NQ35: 'NRIP3',
    Q9NQ89: 'C12orf4',
    Q9NQF3: 'SERHL',
    Q9NQX6: 'ZNF331',
    Q9NQZ5: 'STARD7',
    Q9NRC9: 'OTOR',
    Q9NRD0: 'FBXO8',
    Q9NRP2: 'CMC2',
    Q9NS85: 'CA10',
    Q9NSJ1: 'ZNF355P',
    Q9NSY2: 'STARD5',
    Q9NUG4: 'CCM2L',
    Q9NV39: 'PRR34',
    Q9NVA4: 'TMEM184C',
    Q9NVE4: 'CCDC87',
    Q9NVM1: 'EVA1B',
    Q9NVM6: 'DNAJC17',
    Q9NVP4: 'DZANK1',
    Q9NVR0: 'KLHL11',
    Q9NW07: 'ZNF358',
    Q9NW61: 'PLEKHJ1',
    Q9NW82: 'WDR70',
    Q9NWL6: 'ASNSD1',
    Q9NWM3: 'CUEDC1',
    Q9NX05: 'FAM120C',
    Q9NX36: 'DNAJC28',
    Q9NX77: 'ERVK13-1',
    Q9NXD2: 'MTMR10',
    Q9NXH8: 'TOR4A',
    Q9NXN4: 'GDAP2',
    Q9NXP7: 'GIN1',
    Q9NXT0: 'ZNF586',
    Q9NXU5: 'ARL15',
    Q9NXZ1: 'SAGE1',
    Q9NY87: 'SPANXC',
    Q9NYF3: 'FAM53C',
    Q9NYJ1: 'COA4',
    Q9NYL9: 'TMOD3',
    Q9NYS7: 'WSB2',
    Q9NYT0: 'PLEK2',
    Q9NYT6: 'ZNF226',
    Q9NYW1: 'TAS2R9',
    Q9NZ32: 'ACTR10',
    Q9NZ63: 'C9orf78',
    Q9NZF1: 'PLAC8',
    Q9NZH4: 'PTTG3P',
    Q9NZP0: 'OR6C3',
    Q9NZP2: 'OR6C2',
    Q9NZP5: 'OR5AC2',
    Q9P016: 'THYN1',
    Q9P1A2: 'PPP4R1L',
    Q9P1P4: 'TAAR3P',
    Q9P1Q5: 'OR1A1',
    Q9P1Z9: 'CCDC180',
    Q9P215: 'POGK',
    Q9P227: 'ARHGAP23',
    Q9P255: 'ZNF492',
    Q9P281: 'BAHCC1',
    Q9P2B7: 'CFAP97',
    Q9P2C4: 'TMEM181',
    Q9P2D6: 'FAM135A',
    Q9P2F5: 'STOX2',
    Q9P2N5: 'RBM27',
    Q9P2S6: 'ANKMY1',
    Q9P2Z0: 'THAP10',
    Q9UBI9: 'HECA',
    Q9UBK7: 'RABL2A',
    Q9UC06: 'ZNF70',
    Q9UD57: 'NKX1-2',
    Q9UDX4: 'SEC14L3',
    Q9UF47: 'DNAJC5B',
    Q9UFN0: 'NIPSNAP3A',
    Q9UG63: 'ABCF2',
    Q9UGF6: 'OR5V1',
    Q9UGF7: 'OR12D3',
    Q9UGV2: 'NDRG3',
    Q9UH36: 'SRRD',
    Q9UH90: 'FBXO40',
    Q9UHA2: 'SS18L2',
    Q9UHP9: 'SMPX',
    Q9UI15: 'TAGLN3',
    Q9UIG5: 'PSORS1C1',
    Q9UJC5: 'SH3BGRL2',
    Q9UJH8: 'METRN',
    Q9UJJ7: 'RPUSD1',
    Q9UJN7: 'ZNF391',
    Q9UJT0: 'TUBE1',
    Q9UJV8: 'PURG',
    Q9UK10: 'ZNF225',
    Q9UK12: 'ZNF222',
    Q9UK28: 'TMEM59L',
    Q9UKI3: 'VPREB3',
    Q9UKQ9: 'KLK9',
    Q9UKR8: 'TSPAN16',
    Q9UKY7: 'CDV3',
    Q9UL59: 'ZNF214',
    Q9ULD9: 'ZNF608',
    Q9ULL0: 'KIAA1210',
    Q9ULL1: 'PLEKHG1',
    Q9ULM0: 'PLEKHH1',
    Q9UMS5: 'PHTF1',
    Q9UND3: 'NPIPA1',
    Q9UNX4: 'WDR3',
    Q9UPC5: 'GPR34',
    Q9UPR6: 'ZFR2',
    Q9UQ74: 'PSG8',
    Q9XRX5: 'ANKRD13C-DT',
    Q9Y236: 'OSGIN2',
    Q9Y291: 'MRPS33',
    Q9Y2B9: 'PKIG',
    Q9Y2E4: 'DIP2C',
    Q9Y2G7: 'ZFP30',
    Q9Y2G8: 'DNAJC16',
    Q9Y2H5: 'PLEKHA6',
    Q9Y2P8: 'RCL1',
    Q9Y2S6: 'TMA7',
    Q9Y312: 'AAR2',
    Q9Y324: 'FCF1',
    Q9Y343: 'SNX24',
    Q9Y3B1: 'PRELID3B',
    Q9Y3B9: 'RRP15',
    Q9Y3D5: 'MRPS18C',
    Q9Y3N9: 'OR2W1',
    Q9Y3P4: 'RHBDD3',
    Q9Y3T6: 'R3HCC1',
    Q9Y426: 'C2CD2',
    Q9Y485: 'DMXL1',
    Q9Y4A0: 'JRKL',
    Q9Y4A9: 'OR10H1',
    Q9Y4E6: 'WDR7',
    Q9Y519: 'TMEM184B',
    Q9Y534: 'CSDC2',
    Q9Y536: 'PPIAL4A',
    Q9Y581: 'INSL6',
    Q9Y5P0: 'OR51B4',
    Q9Y5P2: 'CSAG2',
    Q9Y5P2: 'CSAG3',
    Q9Y614: 'ACTL7B',
    Q9Y651: 'SOX21',
    Q9Y693: 'LHFPL6',
    Q9Y6F7: 'CDY2A',
    Q9Y6F7: 'CDY2B',
    Q9Y6R6: 'ZNF780B',
    Q9Y6U7: 'RNF215',
    Q9Y6X4: 'FAM169A',
    Q9Y6Z4: 'KIF25-AS1',
    A0A075B6S0: 'TRGJ1',
    A0A075B6Y3: 'TRAJ3',
    A0A075B6Y9: 'TRAJ42',
    A0A075B700: 'TRAJ31',
    A0A075B706: 'TRDJ1',
    A0A075B734: 'AQP7B',
    A0A087WTH1: 'TMEM265',
    A0A087WUL8: 'NBPF19',
    A0A087WXS9: 'TBC1D3I',
    A0A087X1G2: 'TBC1D3K',
    A0A096LNP1: 'DEFB131B',
    A0A096LP49: 'CCDC187',
    A0A096LPK9: 'OR4N4C',
    A0A0A0MT70: 'TRBJ2-6',
    A0A0A0MT76: 'IGLJ1',
    A0A0A0MT87: 'TRBJ2-4',
    A0A0A0MT89: 'IGKJ1',
    A0A0A0MT94: 'TRBJ2-2',
    A0A0A0MTA4: 'TRBJ2-5',
    A0A0A0MTA7: 'TRBJ2-1',
    A0A0B4J200: 'TRBJ2-3',
    A0A0C4DH62: 'IGHJ1',
    A0A0D9SF12: 'CCDC163',
    A0A0G2JMD5: 'PRAMEF33',
    A0A0J9YWL9: 'TEX13C',
    A0A0J9YWP8: 'TRBJ1-3',
    A0A0J9YWX3: 'TRBJ1-6',
    A0A0J9YX06: 'TRBJ1-2',
    A0A0J9YXA8: 'TRBJ1-1',
    A0A0J9YXG5: 'TRBJ1-4',
    A0A0J9YXM7: 'TRBJ1-5',
    A0A0J9YY54: 'TEX13D',
    A0A0U1RQE8: 'GLYATL1B',
    A0A0U1RQI7: 'KLF18',
    A0A0U1RR11: 'CENPVL1',
    A0A0U1RRA0: 'ZNF593OS',
    A0A0U1RRI6: 'CENPVL3',
    A0A0U1RRL7: 'MMP24OS',
    A0A0U1RRN3: 'MISFA',
    A0A0X1KG70: 'OR4M2B',
    A0A183: 'LCE6A',
    A0A1B0GTH6: 'CSNKA2IP',
    A0A1B0GTI8: 'TMEM272',
    A0A1B0GTL2: 'C20orf204',
    A0A1B0GTR0: 'EDDM13',
    A0A1B0GTS1: 'HSFX4',
    A0A1B0GTU1: 'ZC3H11B',
    A0A1B0GTY4: 'TEX50',
    A0A1B0GTZ2: 'CCDC196',
    A0A1B0GUA7: 'TEX51',
    A0A1B0GUI7: 'BRD3OS',
    A0A1B0GUV7: 'TEX48',
    A0A1B0GUW6: 'SPEM3',
    A0A1B0GUW7: 'SMIM27',
    A0A1B0GUY1: 'MARCOL',
    A0A1B0GV03: 'GOLGA6L7',
    A0A1B0GV85: 'REELD1',
    A0A1B0GVH4: 'PRSS51',
    A0A1B0GVK7: 'FAM240A',
    A0A1B0GVM6: 'C11orf97',
    A0A1B0GVN3: 'C2orf92',
    A0A1B0GVS7: 'MDFIC2',
    A0A1B0GVV1: 'SMIM35',
    A0A1B0GVX0: 'LITAFD',
    A0A1B0GVY4: 'SMIM31',
    A0A1B0GW35: 'EXOC1L',
    A0A1B0GW64: 'SMIM33',
    A0A1B0GWB2: 'PRRT1B',
    A0A1B0GWG4: 'SERTM2',
    A0A1B0GWH4: 'HSFX3',
    A0A1B0GWK0: 'PVALEF',
    A0A1W2PP81: 'TAF11L5',
    A0A1W2PPE2: 'TAF11L4',
    A0A1W2PPF3: 'DUXB',
    A0A1W2PPG7: 'GNG14',
    A0A1W2PPH5: 'TAF11L13',
    A0A1W2PPK0: 'CPHXL2',
    A0A1W2PPL8: 'TAF11L14',
    A0A1W2PPW3: 'TAF11L12',
    A0A1W2PQ09: 'TAF11L11',
    A0A1W2PQ73: 'ERFL',
    A0A1W2PQL4: 'ZNF722',
    A0A1W2PR48: 'TLE7',
    A0A1W2PR64: 'TAF11L9',
    A0A1W2PRP0: 'FOXL3',
    A0A1W2PRV1: 'TAF11L3',
    A0A1W2PS18: 'PMIS2',
    A0A286YEV6: 'SCYGR4',
    A0A286YEX9: 'SCYGR10',
    A0A286YEY9: 'SCYGR1',
    A0A286YF01: 'SCYGR7',
    A0A286YF18: 'SMIM44',
    A0A286YF46: 'SCYGR5',
    A0A286YF58: 'TMEM271',
    A0A286YF60: 'SCYGR3',
    A0A286YF77: 'SCYGR6',
    A0A286YFB4: 'SCYGR2',
    A0A286YFG1: 'SCYGR8',
    A0A2R8Y4L2: 'HNRNPA1L3',
    A0A2R8Y7D0: 'TINCR',
    A0A2R8YFL7: 'OOSP4A',
    A0A2R8YFM6: 'OOSP3',
    A0A3B3IRV3: 'MCTS2',
    A0A3B3IU63: 'H2AL3',
    A0A494BZU4: 'TMEM217B',
    A0A494C086: 'SPDYE21',
    A0A494C0Z2: 'SPDYE13',
    A0A5F9ZHS7: 'NFILZ',
    A0A6I8PU40: 'TUG1',
    A0PG75: 'PLSCR5',
    A0PJX2: 'TLDC2',
    A0PJX8: 'TMEM82',
    A0PJZ0: 'ANKRD20A5P',
    A1A4G5: 'LNP1',
    A1IGU5: 'ARHGEF37',
    A1L157: 'TSPAN11',
    A1L162: 'ERICH2',
    A1L168: 'C20orf202',
    A1L170: 'C1orf226',
    A1L1A6: 'IGSF23',
    A1L429: 'GAGE12B',
    A1L429: 'GAGE12C',
    A1L429: 'GAGE12D',
    A1L429: 'GAGE12E',
    A1L443: 'NUTM2F',
    A2A2Z9: 'ANKRD18B',
    A2A368: 'MAGEB16',
    A2A3L6: 'TTC24',
    A2RU37: 'LINC02872',
    A2RU67: 'FAM234B',
    A2RUQ5: 'TMEM132E-DT',
    A2RUT3: 'TMEM89',
    A3QJZ6: 'PRAMEF22',
    A3QJZ7: 'PRAMEF27',
    A4D0T7: 'SMIM30',
    A4D1F6: 'LRRD1',
    A4D1Z8: 'GRIFIN',
    A4D263: 'SPMIP7',
    A4IF30: 'SLC35F4',
    A4QMS7: 'CFAP90',
    A5PLL1: 'ANKRD34B',
    A5YM69: 'ARHGEF35',
    A6NC05: 'C5orf63',
    A6NC57: 'ANKRD62',
    A6NC97: 'FAM172BP',
    A6NCF5: 'KLHL33',
    A6NCF6: 'MAGEA13P',
    A6NCI5: 'LINC00862',
    A6NCI8: 'C2orf78',
    A6NCJ1: 'TEKTIP1',
    A6NCL2: 'LRCOL1',
    A6NCL7: 'ANKRD33B',
    A6NCM1: 'IQCA1L',
    A6NCQ9: 'RNF222',
    A6ND91: 'ASPDH',
    A6NDE8: 'GAGE12H',
    A6NDK9: 'GOLGA6C',
    A6NDL7: 'METTL21EP',
    A6NDY2: 'FAM90A10',
    A6NE01: 'FAM186A',
    A6NE02: 'BTBD17',
    A6NE82: 'MBD3L3',
    A6NEE1: 'PLEKHD1',
    A6NEF3: 'GOLGA6L4',
    A6NEH6: 'TMEM247',
    A6NEH8: 'ZNF503-AS2',
    A6NEK1: 'ARRDC5',
    A6NEL3: 'FAM86C2P',
    A6NEN9: 'CXorf65',
    A6NEQ2: 'FAM181B',
    A6NER3: 'GAGE12J',
    A6NEV1: 'PRR23A',
    A6NEY8: 'PRORSD1P',
    A6NF01: 'POM121B',
    A6NFA0: 'SPATA31F3',
    A6NFE2: 'SMCO2',
    A6NFF2: 'NAP1L6P',
    A6NFH5: 'FABP12',
    A6NFN9: 'ANKUB1',
    A6NFT4: 'CFAP73',
    A6NFU0: 'FAM187A',
    A6NFU8: 'PGPEP1L',
    A6NFY4: 'NEMP2',
    A6NFZ4: 'FAM24A',
    A6NGA9: 'TMEM202',
    A6NGB0: 'TMEM191C',
    A6NGB7: 'TMEM221',
    A6NGE4: 'DCAF8L1',
    A6NGH7: 'CCDC160',
    A6NGH8: 'ANKRD61',
    A6NGK3: 'GAGE10',
    A6NGN4: 'PRAMEF25',
    A6NGN9: 'IGLON5',
    A6NGR9: 'MROH6',
    A6NGS2: 'ERICH4',
    A6NGU7: 'LINC01546',
    A6NGW2: 'STRCP1',
    A6NGY1: 'FRG2C',
    A6NGZ8: 'SMIM9',
    A6NH11: 'GLTPD2',
    A6NH13: 'DNAJC9-AS1',
    A6NHG4: 'DDTL',
    A6NHN6: 'NPIPB15',
    A6NHP3: 'SPDYE2B',
    A6NHS7: 'MANSC4',
    A6NHY2: 'ANKDD1B',
    A6NHZ5: 'LRRC14B',
    A6NI47: 'POTEM',
    A6NI56: 'CCDC154',
    A6NI86: 'GOLGA6L10',
    A6NI87: 'CBY3',
    A6NIE6: 'RRN3P2',
    A6NIJ5: 'FAM90A20P',
    A6NIK2: 'LRRC10B',
    A6NIN4: 'RNF227',
    A6NIV6: 'LRRIQ4',
    A6NIY4: 'SPDYE5',
    A6NJ08: 'MBD3L5',
    A6NJ64: 'NPIPB2',
    A6NJ69: 'IGIP',
    A6NJ88: 'SAGE2P',
    A6NJG2: 'SOWAHD',
    A6NJJ6: 'C19orf67',
    A6NJQ4: 'FAM90A8',
    A6NJU9: 'NPIPB13',
    A6NJV1: 'CIMIP2C',
    A6NJY1: 'SLC9B1P1',
    A6NK44: 'GLOD5',
    A6NKC0: 'FAM90A7',
    A6NKC9: 'SH2D7',
    A6NKF7: 'TMEM88B',
    A6NKH3: 'RPL37AP8',
    A6NKL6: 'TMEM200C',
    A6NKN8: 'PCP4L1',
    A6NKP2: 'SDR42E2',
    A6NKU9: 'SPDYE3',
    A6NKW6: 'SHISAL2B',
    A6NKX4: 'SLC22A31',
    A6NL05: 'FAM74A7',
    A6NL82: 'CFAP144',
    A6NLC5: 'C3orf70',
    A6NLC8: 'TAF11L2',
    A6NLE4: 'SMIM23',
    A6NLU5: 'VSTM2B',
    A6NLX4: 'TMEM210',
    A6NM36: 'LRRC30',
    A6NM62: 'LRRC53',
    A6NMA1: 'TRPC5OS',
    A6NMB9: 'FIGNL2',
    A6NMD2: 'GOLGA8J',
    A6NMK7: 'CPSF4L',
    A6NMK8: 'INSYN2B',
    A6NMZ2: 'SNTN',
    A6NN73: 'GOLGA8CP',
    A6NN90: 'C2orf81',
    A6NNA2: 'SRRM3',
    A6NNJ1: 'FAM90A9',
    A6NNL0: 'NUTM2B',
    A6NNL5: 'C15orf61',
    A6NNT2: 'C16orf96',
    A6NNV3: 'SPDYE16',
    A6NP61: 'ZAR1L',
    A6PVI3: 'NCBP2L',
    A6PVY3: 'FAM177B',
    A7E2S9: 'ANKRD30BL',
    A7E2U8: 'CFAP96',
    A8K010: 'LINC00473',
    A8K5M9: 'C15orf62',
    A8MQ14: 'ZNF850',
    A8MQB3: 'LINC02693',
    A8MRT5: 'NPIPB5',
    A8MSI8: 'LYRM9',
    A8MT19: 'RHPN2P1',
    A8MT33: 'SYCE1L',
    A8MTB9: 'CEACAM18',
    A8MTJ6: 'FOXI3',
    A8MTL3: 'RNF212B',
    A8MTT3: 'CEBPZOS',
    A8MTY0: 'ZNF724',
    A8MUL3: 'ADARB2-AS1',
    A8MUP6: 'GSG1L2',
    A8MUU1: 'FABP5P3',
    A8MUX0: 'KRTAP16-1',
    A8MV57: 'MPTX1',
    A8MWA6: 'FAM90A22',
    A8MWL7: 'TMEM14DP',
    A8MWV9: 'SMIM34',
    A8MX19: 'FAM90A12P',
    A8MX34: 'KRTAP29-1',
    A8MXJ8: 'FAM90A5P',
    A8MXQ7: 'IQANK1',
    A8MXT2: 'MAGEB17',
    A8MXV6: 'CDRT15L2',
    A8MXZ1: 'FAM90A23',
    A8MYA2: 'CXorf49',
    A8MYA2: 'CXorf49B',
    A8MYB1: 'TMCO5B',
    A8MYZ0: 'MINDY4B',
    A8MZ97: 'C2orf74',
    A8MZA4: 'GOLGA6L6',
    A8MZH6: 'OOSP1',
    B0FP48: 'UPK3BL1',
    B1AK76: 'SNURFL',
    B1AL46: 'NUTM2E',
    B1ANH7: 'IBA57-DT',
    B1ANS9: 'WDR64',
    B1ANY3: 'FAM220BP',
    B1ATL7: 'PRR32',
    B2RBV5: 'MRFAP1L2',
    B2RC85: 'RSPH10B2',
    B2RD01: 'CENPBD1P',
    B2RV13: 'CFAP97D1',
    B2RXF0: 'TMEM229A',
    B3GLJ2: 'PATE3',
    B3KS81: 'SRRM5',
    B4DH59: 'NBPF26',
    B4DJY2: 'TMEM233',
    B4DX44: 'ZNF736',
    B4DXR9: 'ZNF732',
    B4DYI2: 'SPATA31C2',
    B4DZS4: 'TCP11X1',
    B4E2M5: 'ANKRD66',
    B5MCN3: 'SEC14L6',
    B5MCY1: 'TDRD15',
    B5MD39: 'GGTLC3',
    B6SEH8: 'ERVV-1',
    B6SEH9: 'ERVV-2',
    B7Z1M9: 'C2CD4D',
    B7Z368: 'LINC02881',
    B7Z6K7: 'ZNF814',
    B7ZW38: 'HNRNPCL3',
    B9A6J9: 'TBC1D3L',
    C0HLS1: 'SCRIB',
    C9J202: 'ALG1L2',
    C9J3V5: 'TEX22',
    C9J7I0: 'UMAD1',
    C9JBD0: 'KRBOX1',
    C9JG80: 'NPIPB4',
    C9JI98: 'TMEM238',
    C9JJ37: 'BTBD19',
    C9JL84: 'HHLA1',
    C9JN71: 'ZNF878',
    C9JQI7: 'TMEM232',
    C9JTQ0: 'ANKRD63',
    C9JVW0: 'INAFM1',
    C9JXX5: 'FREY1',
    D3DTV9: 'PRAC2',
    D6RBM5: 'USP17L23',
    D6REC4: 'CFAP99',
    D6RF30: 'GOLGA8K',
    D6RGX4: 'FAM90A26',
    E5RG02: 'PRSS46P',
    E5RHQ5: 'NPIPB11',
    E5RJ46: 'LINC02906',
    E5RJM6: 'ANKRD65',
    E5RQL4: 'FTCDNL1',
    E7ERA6: 'RNF223',
    E7EW31: 'PROB1',
    E9PGG2: 'ANHX',
    E9PI22: 'PRR23D1',
    E9PIF3: 'NPIPA2',
    E9PJ23: 'NPIPB6',
    E9PJI5: 'NPIPA7',
    E9PKD4: 'NPIPA5',
    E9PQR5: 'NPIPB8',
    F2Z333: 'FNDC10',
    F5GYI3: 'UBAP1L',
    F5H4A9: 'C3orf80',
    F5H4B4: 'FAM227A',
    F8VTS6: 'RFPL4AL1',
    F8W0I5: 'NPIPB12',
    F8W1W9: 'NPIPB9',
    F8WBI6: 'GOLGA8N',
    F8WCM5: 'INS-IGF2',
    F8WFD2: 'NPIPA3',
    G3V211: 'LINC01619',
    H0UI37: 'TSTD3',
    H0Y354: 'FAM72C',
    H0Y7S4: 'PRAMEF26',
    H0YKK7: 'GOLGA6L19',
    H0YM25: 'GOLGA6L22',
    H3BPF8: 'GOLGA8S',
    H3BPM6: 'MKRN2OS',
    H3BQJ8: 'LY6L',
    H3BQL2: 'GOLGA8T',
    H3BR10: 'SMLR1',
    H3BRN8: 'PIERCE2',
    H3BS89: 'TMEM178B',
    H3BTG2: 'TEX46',
    H3BU77: 'CCDC179',
    H3BV12: 'GOLGA8Q',
    H7BZ55: 'CROCC2',
    H7C350: 'CCDC188',
    I3L0S3: 'PYCARD-AS1',
    I6L899: 'GOLGA8R',
    K7EIQ3: 'ZNF561-AS1',
    L0R6Q1: 'SLC35A4',
    M0QZC1: 'RNF225',
    O00193: 'SMAP',
    O14603: 'PRY',
    O14603: 'PRY2',
    O14603: 'PRYP3',
    O14603: 'PRYP4',
    O14609: 'XKRY',
    O14683: 'TP53I11',
    O15428: 'PIN1P1',
    O15480: 'MAGEB3',
    O43261: 'DLEU1',
    O43304: 'SEC14L5',
    O60397: 'COX7A2P2',
    O60575: 'SPINK4',
    O60688: 'YPEL1',
    O60809: 'PRAMEF10',
    O60810: 'PRAMEF4',
    O60813: 'PRAMEF11',
    O75071: 'EFCAB14',
    O75264: 'SMIM24',
    O75368: 'SH3BGRL',
    O75391: 'SPAG7',
    O76042: 'ERC2-IT1',
    O95177: 'GAS8-AS1',
    O95397: 'PLEKHA8P1',
    O95473: 'SYNGR4',
    O95522: 'PRAMEF12',
    O95561: 'C1orf105',
    O95567: 'C22orf31',
    O95626: 'ANP32D',
    O95873: 'C6orf47',
    O96002: 'CXorf1',
    P09565: 'GIG44',
    P0C221: 'CCDC175',
    P0C2L3: 'FAM163B',
    P0C2S0: 'CTXN2',
    P0C2W7: 'CT47B1',
    P0C2Y1: 'NBPF7P',
    P0C671: 'BNIP5',
    P0C672: 'TSPAN19',
    P0C6C1: 'ANKRD34C',
    P0C6P0: 'NBEAP1',
    P0C7I6: 'CCDC159',
    P0C7L1: 'SPINK8',
    P0C7M6: 'IQCF3',
    P0C7M8: 'CLEC2L',
    P0C7N4: 'TMEM191B',
    P0C7P2: 'RFPL3S',
    P0C7Q5: 'SLC35G4',
    P0C7T7: 'FRMD6-AS1',
    P0C7T8: 'TMEM253',
    P0C7V0: 'AHI1-DT',
    P0C7V4: 'FAM90A15P',
    P0C7V6: 'SUPT20HL2',
    P0C7V8: 'DCAF8L2',
    P0C7V9: 'METTL15P1',
    P0C7W0: 'PRR29',
    P0C7W8: 'FAM90A13P',
    P0C7W9: 'FAM90A14',
    P0C7X0: 'FAM90A24P',
    P0C7X3: 'CCNYL3',
    P0C7X4: 'FTH1P19',
    P0C841: 'FAM66E',
    P0C853: 'BAALC-AS2',
    P0C854: 'CECR9',
    P0C864: 'DANCR',
    P0C866: 'LINC00869',
    P0C874: 'SPATA31D3',
    P0C881: 'RSPH10B',
    P0CAT3: 'TLX1NB',
    P0CB48: 'UBTFL6',
    P0CE71: 'OCM2',
    P0CF75: 'EBLN1',
    P0CG01: 'GKN3P',
    P0CG23: 'ZNF853',
    P0CG24: 'ZNF883',
    P0CG32: 'ZCCHC18',
    P0CG33: 'GOLGA6D',
    P0CI01: 'SPDYE6',
    P0CJ68: 'MTRNR2L1',
    P0CJ69: 'MTRNR2L2',
    P0CJ70: 'MTRNR2L3',
    P0CJ71: 'MTRNR2L4',
    P0CJ73: 'MTRNR2L6',
    P0CJ74: 'MTRNR2L7',
    P0CJ75: 'MTRNR2L8',
    P0CJ76: 'MTRNR2L9',
    P0CJ77: 'MTRNR2L10',
    P0CJ78: 'ZNF865',
    P0CJ79: 'ZNF888',
    P0CJ85: 'DUX4L2',
    P0CJ87: 'DUX4L4',
    P0CJ92: 'GOLGA8H',
    P0CK96: 'SLC35E2B',
    P0CL83: 'STAG3L1',
    P0CL84: 'STAG3L2',
    P0CL85: 'STAG3L3',
    P0CW21: 'SPART-AS1',
    P0CW24: 'PNMA6A',
    P0CW27: 'CCDC166',
    P0DI80: 'SMIM6',
    P0DJ93: 'SMIM13',
    P0DJG4: 'SPMAP2L',
    P0DJH9: 'RD3L',
    P0DJR0: 'GIMD1',
    P0DKB6: 'MPC1L',
    P0DKX0: 'ZNF728',
    P0DKX4: 'SMIM18',
    P0DL12: 'SMIM17',
    P0DMB2: 'C8orf88',
    P0DMQ5: 'INAFM2',
    P0DMR2: 'SCGB1C2',
    P0DMR3: 'ATXN8OS',
    P0DMU7: 'CT45A6',
    P0DMV1: 'CT45A8',
    P0DN25: 'C1GALT1C1L',
    P0DO92: 'CDIPTOSP',
    P0DP42: 'TMEM225B',
    P0DP75: 'MED14OS',
    P0DPA2: 'VSIG8',
    P0DPA3: 'SNHG28',
    P0DPD5: 'ZNF723',
    P0DPE3: 'TMDD1',
    P0DPF2: 'NBPF20',
    P0DSN6: 'TAS2R33',
    P0DSO1: 'FAM246C',
    P0DSO2: 'SCYGR9',
    P0DSO3: 'GAGE4',
    P0DTE0: 'TAS2R36',
    P0DTF9: 'PTTG1IP2',
    P0DTW1: 'GAGE1',
    P0DUX1: 'SPDYE12',
    P0DV75: 'FAM90A18',
    P0DV77: 'TPRX2',
    P49223: 'SPINT3',
    P56555: 'DSCR4',
    P58417: 'NXPH1',
    P58505: 'C21orf58',
    P58512: 'LINC01547',
    P58550: 'FXYD6P3',
    P59036: 'LINC00310',
    P59037: 'LINC00313',
    P59051: 'BRWD1-AS2',
    P59052: 'B3GALT5-AS1',
    P59090: 'TSPEAR-AS2',
    P59091: 'LINC00315',
    P59095: 'STARD6',
    P59646: 'FXYD4',
    P59773: 'MINAR2',
    P60002: 'ELOF1',
    P60606: 'CTXN1',
    P61568: 'ERVK11-1',
    P61571: 'ERVK-21',
    P61574: 'HERVK_113',
    P61575: 'ERVK-8',
    P61576: 'HERV-K104',
    P61578: 'ERVK-16',
    P61580: 'ERVK-10',
    P61581: 'ERVK-24',
    P61582: 'ERVK-7',
    P61583: 'ERVK-5',
    P86434: 'ADORA2A-AS1',
    Q05C16: 'LRRC63',
    Q08AI8: 'MAB21L4',
    Q08E93: 'FAM27E3',
    Q0D2K2: 'KLHL30',
    Q0D2K5: 'EGFEM1P',
    Q0IIN9: 'ZNF252P-AS1',
    Q0P5P2: 'C17orf67',
    Q0P641: 'C2orf80',
    Q0P670: 'SPEM2',
    Q0P6D6: 'CCDC15',
    Q0P6H9: 'TMEM62',
    Q0VAA2: 'LRRC74A',
    Q0VAA5: 'PLCXD2',
    Q0VAF6: 'SYCN',
    Q0VDI3: 'TMEM267',
    Q0VF49: 'KIAA2012',
    Q0VFZ6: 'CFAP210',
    Q0Z7S8: 'FABP9',
    Q12766: 'HMGXB3',
    Q13070: 'GAGE6',
    Q13278: 'RIG',
    Q13670: 'PMS2P11',
    Q14236: 'DIAPH2-AS1',
    Q14602: 'ID2B',
    Q147U7: 'SMCO1',
    Q14CX5: 'MFSD13A',
    Q15053: 'KIAA0040',
    Q156A1: 'ATXN8',
    Q15846: 'CLUL1',
    Q15940: 'ZNF726P1',
    Q17RG1: 'KCTD19',
    Q17RM4: 'CCDC142',
    Q17RP2: 'TIGD6',
    Q17RQ9: 'NKPD1',
    Q1A5X6: 'IQCJ',
    Q1W209: 'ESRG',
    Q2M238: 'RRN3P1',
    Q2M243: 'CCDC27',
    Q2M2D7: 'TBC1D28',
    Q2M2E5: 'C5orf64',
    Q2M329: 'CCDC96',
    Q2M3A8: 'MRGPRG-AS1',
    Q2TAM9: 'TUSC1',
    Q2TB18: 'ASTE1',
    Q2VPJ9: 'LRRC75B',
    Q2WGJ8: 'TMEM249',
    Q309B1: 'TRIM16L',
    Q30KP9: 'DEFB135',
    Q30KQ1: 'DEFB133',
    Q30KQ7: 'DEFB113',
    Q32M84: 'BTBD16',
    Q32M92: 'C15orf32',
    Q32NC0: 'C18orf21',
    Q3B7S5: 'SMIM21',
    Q3BBV2: 'NBPF8',
    Q3C1V0: 'MS4A18',
    Q3C1V1: 'C11orf91',
    Q3KRA6: 'C2orf76',
    Q3LHN0: 'KRTAP25-1',
    Q3LHN1: 'KRTAP21-3',
    Q3LI54: 'KRTAP19-8',
    Q3LI58: 'KRTAP21-1',
    Q3LI60: 'KRTAP20-3',
    Q3LI62: 'KRTAP20-4',
    Q3LI63: 'KRTAP20-1',
    Q3LI68: 'KRTAP22-2',
    Q3LI81: 'KRTAP27-1',
    Q3MIP1: 'ITPRIPL2',
    Q3MIV0: 'KRTAP22-1',
    Q3MJ40: 'CCDC144BP',
    Q3SXM0: 'DCAF4L1',
    Q3SY05: 'LINC00303',
    Q3SYA9: 'POM121L1P',
    Q3Y452: 'TDRG1',
    Q3ZCT8: 'KBTBD12',
    Q3ZCU0: 'GVQW3',
    Q3ZCV2: 'CIMAP2',
    Q3ZLR7: 'SUPT20HL1',
    Q494R0: 'FBXL19-AS1',
    Q495Y7: 'SPDYE7P',
    Q495Y8: 'SPDYE2',
    Q495Z4: 'ASB16-AS1',
    Q49A33: 'ZNF876P',
    Q49AM3: 'TTC31',
    Q49AS3: 'LRRC37A5P',
    Q4AC99: 'ACCSL',
    Q4G0G2: 'H1-10-AS1',
    Q4G0G5: 'SCGB2B2',
    Q4G0I0: 'UQCC4',
    Q4G0N7: 'FAM229B',
    Q4QY38: 'DEFB134',
    Q4UJ75: 'ANKRD20A4P',
    Q4V321: 'GAGE13',
    Q4V339: 'ZNG1F',
    Q4V348: 'ZNF658B',
    Q4VC31: 'MIX23',
    Q4VX62: 'LINC02901',
    Q4VXF1: 'FAM74A3',
    Q4W5G0: 'TIGD2',
    Q4W5P6: 'SMIM43',
    Q502W7: 'CCDC38',
    Q502X0: 'MORN2',
    Q52LC2: 'ATP6AP1L',
    Q537H7: 'SPATA45',
    Q538Z0: 'LUZP6',
    Q53LP3: 'SOWAHC',
    Q53RE8: 'ANKRD39',
    Q53SZ7: 'PRR30',
    Q569G3: 'C5orf47',
    Q569K6: 'CCDC157',
    Q587I9: 'SFT2D3',
    Q58A44: 'PCOTH',
    Q59GN2: 'RPL39P5',
    Q5BKU9: 'OXLD1',
    Q5BKY1: 'LRRC10',
    Q5BKY9: 'FAM133B',
    Q5BLP8: 'C4orf48',
    Q5CZ79: 'ANKRD20A8P',
    Q5EBN2: 'TRIM61',
    Q5FWF7: 'FBXO48',
    Q5GAN3: 'RNASE13',
    Q5GAN4: 'RNASE12',
    Q5GH72: 'XKR7',
    Q5H9B9: 'BMP2KL',
    Q5H9J9: 'TCP11X2',
    Q5HY64: 'FAM47C',
    Q5HYC2: 'KIAA2026',
    Q5HYL7: 'TMEM196',
    Q5HYW3: 'RTL5',
    Q5I0X4: 'C6orf226',
    Q5JNZ5: 'RPS26P11',
    Q5JPB2: 'ZNF831',
    Q5JQD4: 'PYY3',
    Q5JRK9: 'PAGE2B',
    Q5JSJ4: 'INTS6L',
    Q5JSQ8: 'KHDC1L',
    Q5JTB6: 'PLAC9',
    Q5JTN6: 'WDR38',
    Q5JTZ5: 'C9orf152',
    Q5JUQ0: 'FAM78A',
    Q5JUR7: 'TEX30',
    Q5JV73: 'FRMPD3',
    Q5JVX7: 'C1orf141',
    Q5JWF8: 'ACTL10',
    Q5JXB2: 'UBE2NL',
    Q5JXX7: 'TMEM31',
    Q5JYT7: 'KIAA1755',
    Q5K130: 'CLLU1-AS1',
    Q5K131: 'CLLU1',
    Q5MJ07: 'SPANXN5',
    Q5MJ08: 'SPANXN4',
    Q5MNV8: 'FBXO47',
    Q5NE16: 'CTSL3P',
    Q5QJ38: 'TCHHL1',
    Q5R3I4: 'TTC38',
    Q5RGS3: 'FAM74A1',
    Q5SQ80: 'ANKRD20A2P',
    Q5SQH8: 'C6orf136',
    Q5SQS7: 'SH2D4B',
    Q5SQS8: 'C10orf120',
    Q5SR53: 'PIK3CD-AS1',
    Q5SRD1: 'TIMM23B',
    Q5SVZ6: 'ZMYM1',
    Q5SWH9: 'TMEM69',
    Q5SWL7: 'PRAMEF14',
    Q5SWL8: 'PRAMEF19',
    Q5SY13: 'COL5A1-AS1',
    Q5SZB4: 'C9orf50',
    Q5T035: 'FAM120A2P',
    Q5T036: 'FAM120AOS',
    Q5T089: 'MORN1',
    Q5T0U0: 'CCDC122',
    Q5T0Z8: 'C6orf132',
    Q5T2N8: 'ATAD3C',
    Q5T2Q4: 'CCNYL2',
    Q5T319: 'FAM182B',
    Q5T4H9: 'MIR1915HG',
    Q5T4I8: 'C6orf52',
    Q5T5F5: 'ADAMTSL4-AS1',
    Q5T5N4: 'C6orf118',
    Q5T6C5: 'ATXN7L2',
    Q5T6M2: 'LINC00242',
    Q5T6R2: 'TPTE2P1',
    Q5T6V5: 'QNG1',
    Q5T6X4: 'FAM162B',
    Q5T742: 'ZNF22-AS1',
    Q5T750: 'KPLCE',
    Q5T8I3: 'EEIG2',
    Q5T8R8: 'DOCK8-AS1',
    Q5T953: 'IER5L',
    Q5T9S5: 'CCDC18',
    Q5T9Z0: 'TEDDM1',
    Q5TAA0: 'TTC22',
    Q5TBE3: 'C9orf153',
    Q5TBK1: 'N4BP2L1',
    Q5TC04: 'ATP1A1-AS1',
    Q5TC84: 'OGFRL1',
    Q5TF58: 'IFFO2',
    Q5TG53: 'SERTAD4-AS1',
    Q5TGI4: 'SAMD5',
    Q5TGJ6: 'HDGFL1',
    Q5TGL8: 'PXDC1',
    Q5TGP6: 'MROH9',
    Q5TYW2: 'ANKRD20A1',
    Q5TYX0: 'PRAMEF5',
    Q5U3C3: 'TMEM164',
    Q5U4N7: 'GDF5-AS1',
    Q5U4P2: 'ASPHD1',
    Q5U5X8: 'FAM222A',
    Q5U649: 'C12orf60',
    Q5VSP4: 'LCN1P1',
    Q5VSR9: 'SPANXN1',
    Q5VT03: 'NUTM2D',
    Q5VT28: 'FAM27B',
    Q5VT28: 'FAM27C',
    Q5VT98: 'PRAMEF20',
    Q5VTA0: 'PRAMEF17',
    Q5VTL7: 'FNDC7',
    Q5VU36: 'SPATA31A5',
    Q5VU69: 'CFAP141',
    Q5VU92: 'DCAF12L1',
    Q5VUR7: 'ANKRD20A3P',
    Q5VUY2: 'AADACL4',
    Q5VV16: 'FOXD4L5',
    Q5VVB8: 'TMEM244',
    Q5VVC0: 'SPO16',
    Q5VVP1: 'SPATA31A6',
    Q5VW00: 'DCAF12L2',
    Q5VWI1: 'TCERG1L',
    Q5VWK0: 'NBPF6',
    Q5VWM3: 'PRAMEF18',
    Q5VWM4: 'PRAMEF8',
    Q5VWM6: 'PRAMEF13',
    Q5VXD3: 'SAMD13',
    Q5VXH5: 'PRAMEF7',
    Q5VXM1: 'CDCP2',
    Q5VYP0: 'SPATA31A3',
    Q5VYY1: 'ANKRD22',
    Q5VZ18: 'SHE',
    Q5VZI3: 'TMEM268',
    Q5VZQ5: 'TEX36',
    Q5VZR2: 'NUTM2G',
    Q5VZR4: 'MFSD14CP',
    Q5W064: 'LIPJ',
    Q5W0N0: 'C9orf57',
    Q5W188: 'CST9LP1',
    Q629K1: 'TRIQK',
    Q63HN1: 'SPATA31F2P',
    Q658N2: 'WSCD1',
    Q658T7: 'FAM90A2P',
    Q67FW5: 'B3GNTL1',
    Q68CR7: 'LRRC66',
    Q68D20: 'PMS2CL',
    Q68D42: 'TMEM215',
    Q68EN5: 'MATCAP1',
    Q69YL0: 'NCBP2AS2',
    Q69YW2: 'STUM',
    Q69YZ2: 'TMEM200B',
    Q6B9Z1: 'IGFL4',
    Q6DCA0: 'AMMECR1L',
    Q6EEV4: 'POLR2M',
    Q6GMV3: 'PTRHD1',
    Q6ICG6: 'KIAA0930',
    Q6ICI0: 'LHFPL7',
    Q6IE37: 'OVOS1',
    Q6IE38: 'SPINK14',
    Q6IPW1: 'C11orf71',
    Q6JVE5: 'LCN12',
    Q6MZM9: 'PRR27',
    Q6MZN7: 'HCP5',
    Q6NSI1: 'ANKRD26P1',
    Q6NSI3: 'FAM53A',
    Q6NT46: 'GAGE2A',
    Q6NUI1: 'CCDC144NL',
    Q6NV74: 'CRACDL',
    Q6NVV0: 'MKRN9P',
    Q6NVV1: 'RPL13AP3',
    Q6NXN4: 'DPY19L2P1',
    Q6NXP6: 'NOXRED1',
    Q6P047: 'C8orf74',
    Q6P0A1: 'FAM180B',
    Q6P1M9: 'ARMCX5',
    Q6P1R3: 'MSANTD2',
    Q6P1X6: 'C8orf82',
    Q6P2C0: 'WDR93',
    Q6P2H8: 'TMEM53',
    Q6P2I3: 'FAHD2B',
    Q6P2I7: 'EBLN2',
    Q6P2S7: 'TTC41P',
    Q6P3W6: 'NBPF10',
    Q6P3X3: 'TTC27',
    Q6P3X8: 'PGBD2',
    Q6P575: 'GUSBP11',
    Q6P5R6: 'RPL22L1',
    Q6P6B1: 'ERICH5',
    Q6P7N7: 'TMEM81',
    Q6P9G0: 'CYB5D1',
    Q6PDB4: 'ZNF880',
    Q6PEV8: 'FAM199X',
    Q6PEX7: 'TEX38',
    Q6PGQ1: 'DRICH1',
    Q6PIV7: 'SLC25A34',
    Q6PIY5: 'ARMH1',
    Q6PK57: 'DNM1P34',
    Q6QAJ8: 'TMEM220',
    Q6T311: 'ARL9',
    Q6UDR6: 'SPINT4',
    Q6URK8: 'SPMIP8',
    Q6UWF9: 'FAM180A',
    Q6UWH6: 'TEX261',
    Q6UWW0: 'LCN15',
    Q6UXB0: 'FAM131A',
    Q6UXD1: 'HRCT1',
    Q6UXP3: 'TMEM14EP',
    Q6UXP7: 'FAM151B',
    Q6UXQ8: 'UNQ6190/PRO20217',
    Q6UXR4: 'SERPINA13P',
    Q6UXR6: 'UNQ6494/PRO21346',
    Q6UXS0: 'CLEC19A',
    Q6UXU0: 'UNQ9165/PRO28630',
    Q6UYE1: 'DLEU7',
    Q6WQI6: 'HEPN1',
    Q6WRX3: 'ZYG11A',
    Q6X4T0: 'C12orf54',
    Q6XXX2: 'LINC00114',
    Q6ZMT9: 'DTHD1',
    Q6ZMU1: 'C3P1',
    Q6ZMV8: 'ZNF730',
    Q6ZN03: 'LINC00322',
    Q6ZNB5: 'XNDC1N',
    Q6ZNG2: 'DBX2',
    Q6ZNG9: 'KRBA2',
    Q6ZNM6: 'SPMIP10',
    Q6ZNQ3: 'LRRC69',
    Q6ZQN5: 'FOXI2',
    Q6ZQQ2: 'SPATA31D1',
    Q6ZQV5: 'ZNF788P',
    Q6ZQY2: 'LRRC74B',
    Q6ZRC1: 'C4orf50',
    Q6ZRK6: 'CCDC73',
    Q6ZRP0: 'PRR23C',
    Q6ZRR7: 'LRRC9',
    Q6ZRT6: 'PRR23B',
    Q6ZS02: 'DNM1P46',
    Q6ZS62: 'COLCA1',
    Q6ZSB3: 'LINC00299',
    Q6ZSC3: 'RBM43',
    Q6ZSJ8: 'C1orf122',
    Q6ZST2: 'COL25A1-DT',
    Q6ZST4: 'LCNL1',
    Q6ZT52: 'FAM43B',
    Q6ZTB9: 'ZNF833P',
    Q6ZTZ1: 'MSANTD1',
    Q6ZU45: 'CLEC20A',
    Q6ZU69: 'SPATA31F1',
    Q6ZUA9: 'MROH5',
    Q6ZUB0: 'SPATA31D4',
    Q6ZUF6: 'LINC00336',
    Q6ZUL3: 'LINC03042',
    Q6ZUS5: 'CCDC121',
    Q6ZUU3: 'FOXL2NB',
    Q6ZV70: 'LANCL3',
    Q6ZV77: 'LINC02908',
    Q6ZV80: 'LINC02898',
    Q6ZVK1: 'TMEM179',
    Q6ZVN7: 'SEM1',
    Q6ZVS7: 'FAM183BP',
    Q6ZVT6: 'CFAP20DC',
    Q6ZVW7: 'IL17REL',
    Q6ZW13: 'C16orf86',
    Q6ZWI9: 'RFPL4B',
    Q71RG6: 'FP248',
    Q75LS8: 'FKBP9P1',
    Q75MW2: 'ZNF767P',
    Q7Z2F6: 'KRBOX5',
    Q7Z2R9: 'SSBP3-AS1',
    Q7Z2V1: 'C16orf82',
    Q7Z2X7: 'PAGE2',
    Q7Z3B0: 'SMIM15',
    Q7Z4B0: 'LINC00305',
    Q7Z4S9: 'SH2D6',
    Q7Z5D8: 'NANOGNB',
    Q7Z5U6: 'WDR53',
    Q7Z6I8: 'C5orf24',
    Q7Z6K3: 'PTAR1',
    Q7Z7L8: 'C11orf96',
    Q86SG4: 'HMGN2P46',
    Q86SH2: 'ZAR1',
    Q86SH4: 'PRNT',
    Q86SI9: 'IRX2-DT',
    Q86SY8: 'KTN1-AS1',
    Q86T23: 'CROCCP2',
    Q86TI4: 'WDR86',
    Q86TZ1: 'TTC6',
    Q86U02: 'LINC00596',
    Q86U17: 'SERPINA11',
    Q86UD1: 'OAF',
    Q86UD7: 'TBC1D26',
    Q86UF4: 'CCDC190',
    Q86UQ5: 'GTSCR1',
    Q86V59: 'PNMA8A',
    Q86V85: 'GPR180',
    Q86VQ1: 'GLCCI1',
    Q86VZ2: 'WDR5B',
    Q86WR6: 'CHCT1',
    Q86WZ0: 'HEATR4',
    Q86X40: 'LRRC28',
    Q86X53: 'ERICH1',
    Q86X59: 'LINC02875',
    Q86XG9: 'NBPF5P',
    Q86XI8: 'ZSWIM9',
    Q86XN7: 'PROSER1',
    Q86Y27: 'BAGE5',
    Q86Y28: 'BAGE4',
    Q86Y29: 'BAGE3',
    Q86Y30: 'BAGE2',
    Q86YG4: 'NT5DC4',
    Q8IU53: 'CASC2',
    Q8IUF1: 'ZNG1B',
    Q8IUI4: 'SNX29P2',
    Q8IV32: 'CCDC71',
    Q8IV35: 'WDR49',
    Q8IV56: 'PRR15',
    Q8IVB5: 'LIX1L',
    Q8IVF1: 'NUTM2A',
    Q8IVJ8: 'APRG1',
    Q8IVK1: 'GLYCAM1',
    Q8IVU9: 'CABCOCO1',
    Q8IWA6: 'CCDC60',
    Q8IWD5: 'MFSD6L',
    Q8IWF7: 'UBE2DNL',
    Q8IWF9: 'CCDC83',
    Q8IWN6: 'FAM223A',
    Q8IXL9: 'IQCF2',
    Q8IXM7: 'CIMAP1C',
    Q8IXP5: 'POU2AF2',
    Q8IXQ8: 'PDZD9',
    Q8IXR5: 'FAM178B',
    Q8IXR9: 'C12orf56',
    Q8IXS0: 'FAM217A',
    Q8IY45: 'AMN1',
    Q8IYA2: 'CCDC144CP',
    Q8IYD2: 'KLHDC8A',
    Q8IYK2: 'TEKTL1',
    Q8IYN6: 'UBALD2',
    Q8IYQ7: 'THNSL1',
    Q8IZ63: 'PRR22',
    Q8IZP6: 'RNF113B',
    Q8IZQ5: 'SELENOH',
    Q8IZU2: 'WDR17',
    Q8MH63: 'SLC7A5P1',
    Q8N0U4: 'FAM185A',
    Q8N0U7: 'C1orf87',
    Q8N0V1: 'ZNF295-AS1',
    Q8N0W5: 'IQCK',
    Q8N0W7: 'FMR1NB',
    Q8N123: 'CPXCR1',
    Q8N1D5: 'CFAP107',
    Q8N1P7: 'CRYBG2',
    Q8N239: 'KLHL34',
    Q8N268: 'LINC02910',
    Q8N2C3: 'DEPDC4',
    Q8N2G6: 'ZCCHC24',
    Q8N2R8: 'FAM43A',
    Q8N2U0: 'TMEM256',
    Q8N319: 'LINC03040',
    Q8N326: 'RPP38-DT',
    Q8N398: 'VWA5B2',
    Q8N412: 'STPG2',
    Q8N446: 'ZNF843',
    Q8N485: 'LIX1',
    Q8N4B5: 'PRR18',
    Q8N4C9: 'C17orf78',
    Q8N4E4: 'PDCL2',
    Q8N4K4: 'RPRML',
    Q8N4L1: 'TMEM151A',
    Q8N4L4: 'SPEM1',
    Q8N4P6: 'LRRC71',
    Q8N4S7: 'PAQR4',
    Q8N4W6: 'DNAJC22',
    Q8N535: 'LINC00471',
    Q8N5C1: 'CALHM5',
    Q8N5Q1: 'GARIN5B',
    Q8N5S3: 'C2orf73',
    Q8N5U0: 'C11orf42',
    Q8N5W8: 'FAM24B',
    Q8N614: 'TMEM156',
    Q8N6C7: 'MIR7-3HG',
    Q8N6G2: 'TEX26',
    Q8N6L7: 'TMEM252',
    Q8N6N2: 'TTC9B',
    Q8N6Q8: 'METTL25',
    Q8N6V4: 'C10orf53',
    Q8N755: 'SLC66A3',
    Q8N769: 'C14orf178',
    Q8N7C4: 'TMEM217',
    Q8N7L0: 'FAM216B',
    Q8N7N1: 'FAM86B1',
    Q8N7Q2: 'CELF2-AS1',
    Q8N7S6: 'ARIH2OS',
    Q8N7U9: 'LINC00469',
    Q8N7X1: 'RBMXL3',
    Q8N7X2: 'STPG3',
    Q8N7X8: 'SIGLECL1',
    Q8N7Y1: 'KIRREL3-AS3',
    Q8N7Z2: 'GOLGA6L1',
    Q8N808: 'SLC35G3',
    Q8N816: 'KRT10-AS1',
    Q8N888: 'BCORP1',
    Q8N8A8: 'FAM169BP',
    Q8N8D7: 'NKAIN3',
    Q8N8D9: 'IRF1-AS1',
    Q8N8E1: 'MAPKAPK5-AS1',
    Q8N8H1: 'ZNF321P',
    Q8N8I0: 'SAMD12',
    Q8N8I6: 'LINC00482',
    Q8N8J0: 'PI4KAP1',
    Q8N8J7: 'FAM241A',
    Q8N8L6: 'ARL10',
    Q8N8Z3: 'DIP2C-AS1',
    Q8N910: 'PAK6-AS1',
    Q8N945: 'PRELID2',
    Q8N957: 'ANKFN1',
    Q8N999: 'RLIG1',
    Q8N9B4: 'ANKRD42',
    Q8N9C0: 'IGSF22',
    Q8N9H9: 'C1orf127',
    Q8N9R0: 'LINC00304',
    Q8N9R6: 'CDRT4',
    Q8N9T2: 'NKAPP1',
    Q8N9V3: 'WDSUB1',
    Q8N9X5: 'LINC02912',
    Q8N9Z2: 'CCDC71L',
    Q8NA03: 'FSIP1',
    Q8NA57: 'C12orf50',
    Q8NA66: 'CNBD1',
    Q8NA70: 'FAM47B',
    Q8NA75: 'DCAF4L2',
    Q8NAA5: 'LRRC75A',
    Q8NAA6: 'LINC02694',
    Q8NAB2: 'KBTBD3',
    Q8NAJ2: 'LINC02913',
    Q8NAP1: 'CASTOR3P',
    Q8NAV2: 'C8orf58',
    Q8NBB2: 'ST20-AS1',
    Q8NBC4: 'C20orf203',
    Q8NBE8: 'KLHL23',
    Q8NBP0: 'TTC13',
    Q8NBP5: 'MFSD9',
    Q8NBR9: 'NDUFV1-DT',
    Q8NBT3: 'TMEM145',
    Q8NBZ9: 'NEXN-AS1',
    Q8NC38: 'ZNF436-AS1',
    Q8NC54: 'KCT2',
    Q8NCJ5: 'SPRYD3',
    Q8NCL8: 'TMEM116',
    Q8NCQ2: 'CSNK1G2-AS1',
    Q8NCQ3: 'LINC00301',
    Q8NCS4: 'TMEM35B',
    Q8NCT3: 'MATCAP2',
    Q8NCU4: 'CCDC191',
    Q8ND24: 'RNF214',
    Q8ND94: 'LRRN4CL',
    Q8NDY4: 'MDS2',
    Q8NDY8: 'TMEM52',
    Q8NEA4: 'FBXO36',
    Q8NEE0: 'KLHL30-AS1',
    Q8NEE8: 'TTC16',
    Q8NEG2: 'C7orf57',
    Q8NEL0: 'CCDC54',
    Q8NEQ5: 'C1orf162',
    Q8NET4: 'RTL9',
    Q8NEX5: 'WFDC9',
    Q8NEX6: 'WFDC11',
    Q8NF67: 'ANKRD20A12P',
    Q8NFP0: 'PXT1',
    Q8NFV5: 'SPDYE1',
    Q8NH21: 'OR4F5',
    Q8NHX4: 'SPATA3',
    Q8NI28: 'RNF32-DT',
    Q8TAC1: 'RFESD',
    Q8TAD7: 'OCC1',
    Q8TAF5: 'FLVCR1-DT',
    Q8TAL5: 'C9orf43',
    Q8TAY7: 'FAM110D',
    Q8TB05: 'UBALD1',
    Q8TBR4: 'STAG3L4',
    Q8TBR5: 'CIRBP-AS1',
    Q8TBZ9: 'TEX47',
    Q8TC99: 'FNDC8',
    Q8TCA0: 'LRRC20',
    Q8TCZ7: 'LINC00308',
    Q8TD33: 'SCGB1C1',
    Q8TD35: 'LKAAEAR1',
    Q8TD47: 'RPS4Y2',
    Q8TD90: 'MAGEE2',
    Q8TDY3: 'ACTRT2',
    Q8TE82: 'SH3TC1',
    Q8TEE9: 'SAP25',
    Q8TEF2: 'C10orf105',
    Q8WTQ4: 'C16orf78',
    Q8WTZ4: 'CA5BP1',
    Q8WU43: 'C2orf15',
    Q8WUB2: 'FAM216A',
    Q8WUD4: 'CCDC12',
    Q8WUR7: 'C15orf40',
    Q8WUY1: 'THEM6',
    Q8WVF5: 'KCTD4',
    Q8WW33: 'GTSF1',
    Q8WW59: 'SPRYD4',
    Q8WWF8: 'CAPSL',
    Q8WWM1: 'XAGE5',
    Q8WWR9: 'PPDPFL',
    Q8WZA9: 'IRGQ',
    Q8WZB0: 'ERCC6L2-AS1',
    Q92623: 'TTC9',
    Q92628: 'KIAA0232',
    Q969H9: 'DIRC1',
    Q96A19: 'CCDC102A',
    Q96A22: 'C11orf52',
    Q96AQ1: 'CCDC74A',
    Q96AQ2: 'TMEM125',
    Q96AT1: 'KIAA1143',
    Q96B54: 'ZNF428',
    Q96B70: 'LENG9',
    Q96CN7: 'ISOC1',
    Q96CP2: 'FLYWCH2',
    Q96CX6: 'LRRC58',
    Q96D70: 'R3HDM4',
    Q96DE9: 'EOLA2',
    Q96DM1: 'PGBD4',
    Q96EE4: 'CCDC126',
    Q96EH5: 'RPL39L',
    Q96EK9: 'KTI12',
    Q96EX1: 'SMIM12',
    Q96F63: 'CCDC97',
    Q96F83: 'CLBA1',
    Q96FA7: 'ZBED10P',
    Q96FF7: 'MISP3',
    Q96FQ7: 'LINC00526',
    Q96FV0: 'LRRC46',
    Q96GI7: 'FAM89A',
    Q96H35: 'RBM18',
    Q96HG1: 'SMIM10',
    Q96HH4: 'TMEM169',
    Q96HM7: 'PCED1B',
    Q96HZ7: 'URB1-AS1',
    Q96I45: 'TMEM141',
    Q96IR2: 'ZNF845',
    Q96IW2: 'SHD',
    Q96K31: 'C8orf76',
    Q96KF7: 'SMIM8',
    Q96KW2: 'POM121L2',
    Q96L03: 'SPATA17',
    Q96LI9: 'CXorf58',
    Q96LM9: 'C20orf173',
    Q96LP6: 'C12orf42',
    Q96LR7: 'C2orf50',
    Q96LS8: 'C2orf48',
    Q96LZ2: 'MAGEB10',
    Q96M19: 'LINC00477',
    Q96M43: 'NBPF4',
    Q96M60: 'FAM227B',
    Q96MC4: 'CEP295NL',
    Q96MD7: 'C9orf85',
    Q96MH6: 'TMEM68',
    Q96MP5: 'ZSWIM3',
    Q96MR7: 'OBSCN-AS1',
    Q96MU5: 'CD300LD-AS1',
    Q96MW7: 'TIGD1',
    Q96MZ0: 'GDAP1L1',
    Q96MZ4: 'FAM218A',
    Q96N35: 'LINC00052',
    Q96N53: 'PRDM10-DT',
    Q96NR7: 'WWC2-AS2',
    Q96NS1: 'YPEL4',
    Q96NS8: 'CLUHP3',
    Q96PP4: 'TSGA13',
    Q96PQ5: 'PPP1R2P1',
    Q96PY0: 'PSMG3-AS1',
    Q96QU4: 'FRG2B',
    Q96S07: 'PRR25',
    Q96SJ8: 'TSPAN18',
    Q99440: 'LINC01587',
    Q9BPW8: 'NIPSNAP1',
    Q9BPX7: 'C7orf25',
    Q9BQ49: 'SMIM7',
    Q9BQM9: 'C20orf144',
    Q9BR11: 'ZSWIM1',
    Q9BR46: 'SCP2D1-AS1',
    Q9BRJ6: 'C7orf50',
    Q9BRP1: 'PDCD2L',
    Q9BS92: 'NIPSNAP3B',
    Q9BTA0: 'FAM167B',
    Q9BTX7: 'TTPAL',
    Q9BU68: 'PRR15L',
    Q9BVG4: 'PBDC1',
    Q9BVR0: 'HERC2P3',
    Q9BVW6: 'SMIM2',
    Q9BWJ2: 'RHPN1-AS1',
    Q9BX51: 'GGTLC1',
    Q9BXJ2: 'C1QTNF7',
    Q9BXQ6: 'TMEM121B',
    Q9BXU2: 'TEX13B',
    Q9BY89: 'KIAA1671',
    Q9BYD9: 'ACTRT3',
    Q9BYL1: 'SAMD10',
    Q9BYS8: 'LRRC2',
    Q9BZ19: 'ANKRD60',
    Q9BZ68: 'FRMD8P1',
    Q9BZ81: 'MAGEB5',
    Q9BZ97: 'TTTY13',
    Q9BZA5: 'TXLNGY',
    Q9BZE7: 'C22orf23',
    Q9BZP3: 'LINC00470',
    Q9C002: 'NMES1',
    Q9C073: 'FAM117A',
    Q9GZL8: 'BPESC1',
    Q9GZU0: 'C6orf62',
    Q9H098: 'FAM107B',
    Q9H0H9: 'CYP4F30P',
    Q9H0P7: 'AGPAT4-IT1',
    Q9H0Q0: 'CYRIA',
    Q9H0V1: 'TMEM168',
    Q9H0W7: 'THAP2',
    Q9H106: 'SIRPD',
    Q9H1F0: 'WFDC10A',
    Q9H246: 'C1orf21',
    Q9H2J1: 'ARRDC1-AS1',
    Q9H3Y8: 'PPDPF',
    Q9H478: 'KCNQ1DN',
    Q9H489: 'TSPY26P',
    Q9H496: 'TOR1AIP2',
    Q9H4I3: 'TRABD',
    Q9H4R4: 'NCOR1P1',
    Q9H560: 'ANKRD19P',
    Q9H579: 'MROH8',
    Q9H606: 'PRORY',
    Q9H607: 'OCEL1',
    Q9H6B1: 'ZNF385D',
    Q9H6K5: 'PRR36',
    Q9H7B7: 'PKD1L1-AS1',
    Q9H7F4: 'TMEM185B',
    Q9H7M6: 'ZSWIM4',
    Q9H7X2: 'C1orf115',
    Q9H819: 'DNAJC18',
    Q9H8W3: 'FAM204A',
    Q9H8X3: 'LINC00574',
    Q9H9A6: 'LRRC40',
    Q9H9R9: 'DBNDD1',
    Q9HAH7: 'FBRS',
    Q9HAU6: 'TPT1P8',
    Q9HBX3: 'SND1-IT1',
    Q9HC47: 'CTAGE1',
    Q9HD87: 'C6orf50',
    Q9NPB0: 'SAYSD1',
    Q9NPU4: 'C14orf132',
    Q9NQ32: 'C11orf16',
    Q9NQ39: 'RPS10P5',
    Q9NQR7: 'CCDC177',
    Q9NRI6: 'PYY2',
    Q9NRJ2: 'GSN-AS1',
    Q9NRP4: 'SDHAF3',
    Q9NRX3: 'NDUFA4L2',
    Q9NSG2: 'FIRRM',
    Q9NSQ0: 'RRP7BP',
    Q9NU23: 'LYRM2',
    Q9NU53: 'GINM1',
    Q9NUB4: 'C20orf141',
    Q9NUC0: 'SERTAD4',
    Q9NUD7: 'C20orf96',
    Q9NUJ7: 'PLCXD1',
    Q9NUR3: 'TMEM74B',
    Q9NVV2: 'C19orf73',
    Q9NWW7: 'C2orf42',
    Q9NX00: 'TMEM160',
    Q9NX31: 'OSER1',
    Q9NXS3: 'KLHL28',
    Q9NYP8: 'C21orf62',
    Q9NZY2: 'FAM30A',
    Q9P1F3: 'ABRACL',
    Q9P1G2: 'RBM12B-AS1',
    Q9P1V8: 'SAMD15',
    Q9P217: 'ZSWIM5',
    Q9P298: 'HIGD1B',
    Q9P2W6: 'C11orf21',
    Q9P2X7: 'DELEC1',
    Q9P2X8: 'LINC00474',
    Q9UBP8: 'KAAG1',
    Q9UEU5: 'GAGE2D',
    Q9UEU5: 'GAGE8',
    Q9UFV1: 'TBC1D29P',
    Q9UH64: 'CDKN2A-DT',
    Q9UHL3: 'FAM153A',
    Q9UHQ7: 'TCEAL9',
    Q9UIY3: 'RWDD2A',
    Q9UJ72: 'ANXA10',
    Q9UJQ7: 'SCP2D1',
    Q9UK00: 'C3orf18',
    Q9ULE4: 'FAM184B',
    Q9ULG3: 'CFAP92',
    Q9ULI1: 'NWD2',
    Q9ULN7: 'PNMA8B',
    Q9UNX3: 'RPL26L1',
    Q9UNZ5: 'C19orf53',
    Q9Y442: 'YWHAH-AS1',
    Q9Y4M8: 'LINC00588',
    Q9Y546: 'LRRC42',
    Q9Y5L5: 'LENEP',
    Q9Y5M1: 'FAM215A',
    Q9Y5V0: 'ZNF706',
    Q9Y675: 'SNURF',
    Q9Y6J3: 'SMAD5-AS1',
    Q9Y6Z5: 'AFDN-DT',
    S4R3P1: 'MTRNR2L13',
    S4R3Y5: 'MTRNR2L11',
    A0A087WV53: 'SPEGNB',
    A0A087WWA1: 'P3R3URF',
    A0A096LP01: 'SMIM26',
    A0A096LPI5: 'CCDC28A-AS1',
    A0A0J9YX94: 'PNMA6F',
    A0A0J9YXQ4: 'PNMA6E',
    A0A0U1RQS6: 'TMEM275',
    A0A0U1RR37: 'C1orf232',
    A0A0U1RRK4: 'LBHD2',
    A0A1B0GTC6: 'C3orf85',
    A0A1B0GTD5: 'SPMIP11',
    A0A1B0GTI1: 'CCDC201',
    A0A1B0GTK4: 'FAM237A',
    A0A1B0GTK5: 'FAM236D',
    A0A1B0GTR3: 'CXorf51A',
    A0A1B0GTR4: 'SPRR5',
    A0A1B0GTU2: 'CTXND1',
    A0A1B0GU29: 'SMIM28',
    A0A1B0GU33: 'TEX53',
    A0A1B0GU71: 'CFAP97D2',
    A0A1B0GUA5: 'SMIM32',
    A0A1B0GUA6: 'CCDC195',
    A0A1B0GUA9: 'C13orf46',
    A0A1B0GUC4: 'MYOCOS',
    A0A1B0GUJ8: 'PNMA8C',
    A0A1B0GUQ0: 'FAM236A',
    A0A1B0GUS0: 'C19orf85',
    A0A1B0GUT2: 'C10orf143',
    A0A1B0GUU1: 'C17orf113',
    A0A1B0GUV1: 'C17orf114',
    A0A1B0GUX0: 'SPMIP1',
    A0A1B0GV90: 'CTXND2',
    A0A1B0GVD1: 'FAM237B',
    A0A1B0GVG4: 'CCDC194',
    A0A1B0GVG6: 'TEX54',
    A0A1B0GVH6: 'C13orf42',
    A0A1B0GVH7: 'IQCM',
    A0A1B0GVM5: 'ETDC',
    A0A1B0GVQ3: 'CCDC200',
    A0A1B0GVR7: 'FAM240C',
    A0A1B0GVT2: 'SMIM36',
    A0A1B0GVZ2: 'FAM240B',
    A0A1B0GVZ9: 'TMEM269',
    A0A1B0GW54: 'SMIM39',
    A0A1W2PP97: 'THSD8',
    A0A286YFK9: 'SMIM38',
    A0A2R8Y4Y8: 'OOSP4B',
    A0A2R8YCJ5: 'SMIM41',
    A0A3B3IT52: 'MSANTD5',
    A0A494C0N9: 'FAM246B',
    A0A494C0Y3: 'FAM246A',
    A0A590UK83: 'SMIM45',
    A0A5F9ZH02: 'SMIM42',
    A1L4L8: 'PLAC8L1',
    A4D0Y5: 'LINC03043',
    A4D250: 'BLACE',
    A4QN01: 'LINC01553',
    A6NC62: 'RBAKDN',
    A6NCN8: 'TEX52',
    A6NCS6: 'C2orf72',
    A6NDZ8: 'MBD3L4',
    A6NF36: 'CCDC182',
    A6NFE3: 'EFCAB10',
    A6NGG3: 'LINC03041',
    A6NGY3: 'C5orf52',
    A6NHR8: 'FAM47DP',
    A6NIU2: 'LINC01549',
    A6NJI1: 'C11orf86',
    A6NJI9: 'LRRC72',
    A6NJY4: 'TMEM238L',
    A6NKX1: 'FAM223B',
    A6NM66: 'LINC01548',
    A6NML5: 'TMEM212',
    A6NNH2: 'FAM90A27P',
    A6NNX1: 'RIIAD1',
    A8K554: 'ZNF815P',
    A8MTL0: 'IQCF5',
    A8MTZ7: 'C12orf71',
    A8MU93: 'C17orf100',
    A8MV24: 'SPMAP1',
    A8MWE9: 'EFCAB8',
    A8MY62: 'LACTBL1',
    A8MYJ7: 'TTC34',
    A8MYZ5: 'IQCF6',
    A8MZF0: 'PRR33',
    A8MZG2: 'C16orf90',
    B1AMM8: 'LINC00587',
    B9A014: 'C21orf140',
    C9J302: 'C4orf51',
    C9J3I9: 'C5orf58',
    C9J6K1: 'C19orf81',
    C9JC47: 'FAM157A',
    C9JFL3: 'PHGR1',
    E9PRG8: 'C11orf98',
    F2Z398: 'LMO7DN',
    F2Z3F1: 'C5orf67',
    F2Z3M2: 'LINC02876',
    H3BMG3: 'SMKR1',
    H3BNL1: 'C3orf84',
    H3BNL8: 'ARMH2',
    H3BQW9: 'FAM229A',
    I3L1E1: 'C19orf84',
    J3KSC0: 'LINC01387',
    O15225: 'INE1',
    O15544: 'LINC01565',
    O60384: 'ZNF861P',
    O60756: 'BCE1',
    P0C5K6: 'VENTXP1',
    P0C5K7: 'CT62',
    P0C7U9: 'FAM87A',
    P0C875: 'FAM228B',
    P0CE67: 'LINC02877',
    P0CF97: 'FAM200B',
    P0CG42: 'FAM157B',
    P0CG43: 'FAM157C',
    P0CH98: 'FAM106C',
    P0CZ25: 'DNAH10OS',
    P0DH78: 'RNF224',
    P0DKL9: 'ARL14EPL',
    P0DMQ9: 'C8orf89',
    P0DMW3: 'SMIM10L1',
    P0DMW4: 'SMIM10L2A',
    P0DO97: 'CCDC192',
    P0DPF5: 'C2orf27A',
    P0DPF6: 'CDRT15P3',
    P0DPP9: 'ETDB',
    P0DPQ3: 'PRR20G',
    P0DV60: 'LCE7A',
    P0DV73: 'FAM90A16',
    P0DV79: 'SPDYE18',
    P13985: 'HRES1',
    P58513: 'LINC00158',
    P59020: 'DSCR9',
    P59022: 'DSCR10',
    Q05BU3: 'FAM86JP',
    Q0P140: 'HSD52',
    Q0VDD5: 'MIR22HG',
    Q13166: 'CATR1',
    Q14695: 'KIAA0087',
    Q17RA5: 'C21orf62-AS1',
    Q17RH7: 'TPRXL',
    Q3B7I2: 'CNPY1',
    Q495D7: 'LINC01559',
    Q4KMX7: 'FAM106A',
    Q4W4Y0: 'C14orf28',
    Q52M75: 'LINC01554',
    Q53H64: 'ANKRD40CL',
    Q5JQF7: 'LINC01556',
    Q5STR5: 'SMIM40',
    Q5SVJ3: 'SPMIP3',
    Q5SY85: 'FAM201A',
    Q5T0J3: 'C1orf220',
    Q5T1J6: 'FAM182A',
    Q5T3Y7: 'BVES-AS1',
    Q5T7N8: 'FAM27D1',
    Q5T7P6: 'TMEM78',
    Q5T7R7: 'C1orf185',
    Q5T870: 'PRR9',
    Q5TEZ4: 'LINC01590',
    Q5TEZ5: 'C6orf163',
    Q5VT33: 'LINC01545',
    Q5VT40: 'FAM78B',
    Q5VUE5: 'C1orf53',
    Q5VVS0: 'C1orf140',
    Q68DL7: 'C18orf63',
    Q6IC83: 'C22orf42',
    Q6NUR6: 'RNF216P1',
    Q6UWF5: 'UNQ5815/PRO19632',
    Q6UXP9: 'UNQ9370/PRO34162',
    Q6UXQ4: 'C2orf66',
    Q6UXR8: 'UNQ6493/PRO21345',
    Q6UXV3: 'UNQ6126/PRO20091',
    Q6UY13: 'UNQ5830/PRO19650/PRO19816',
    Q6W349: 'LINC00575',
    Q6XCG6: 'PP632',
    Q6ZMV7: 'LEKR1',
    Q6ZP68: 'ATP11AUN',
    Q6ZR85: 'C17orf107',
    Q6ZRV3: 'LINC00696',
    Q6ZSK4: 'NTM-AS1',
    Q6ZTR6: 'ZNF516-DT',
    Q6ZTY9: 'LINC02902',
    Q6ZV60: 'LINC00173',
    Q71F78: 'LCA10',
    Q86TU6: 'LINC00523',
    Q86U37: 'LINC01551',
    Q8IXQ3: 'C9orf40',
    Q8N1I8: 'CACTIN-AS1',
    Q8N1L1: 'LINC00528',
    Q8N1V8: 'LINC01561',
    Q8N2A0: 'LINC00269',
    Q8N2C9: 'UMODL1-AS1',
    Q8N4M7: 'C10orf126',
    Q8N5N4: 'C3orf22',
    Q8N616: 'LINC00311',
    Q8N6U2: 'LINC00612',
    Q8N7H1: 'LINC01465',
    Q8N812: 'C12orf76',
    Q8N813: 'PRR23E',
    Q8N8G6: 'LINC02915',
    Q8N8V8: 'TMEM105',
    Q8N9P6: 'C9orf163',
    Q8N9U9: 'SPANXA2-OT1',
    Q8N9X3: 'LINC01356',
    Q8NA97: 'FER1L6-AS1',
    Q8NAE3: 'LINC01555',
    Q8TB33: 'LINC01560',
    Q8TEV8: 'SMCR5',
    Q8WU49: 'C7orf33',
    Q8WWF1: 'C1orf54',
    Q8WXQ3: 'LINC01599',
    Q8WY50: 'PLAC4',
    Q8WZ26: 'PP6455',
    Q8WZ69: 'C11orf40',
    Q8WZA8: 'GCRG224',
    Q96BQ5: 'CCDC127',
    Q96BT1: 'C3orf49',
    Q96CB5: 'C8orf44',
    Q96FK6: 'WDR89',
    Q96IT6: 'ARHGAP5-AS1',
    Q96KT0: 'FAM167A-AS1',
    Q96KT6: 'LINC00208',
    Q96KX1: 'C4orf36',
    Q96LM1: 'LINC00615',
    Q96M15: 'IGF2BP2-AS1',
    Q96M42: 'LINC00479',
    Q96M78: 'FER1L6-AS2',
    Q96MC9: 'IKBKE-AS1',
    Q96MF4: 'CCDC140',
    Q96MH7: 'C5orf34',
    Q96MT4: 'LINC01600',
    Q96N68: 'C18orf15',
    Q96PS1: 'FANCD2OS',
    Q96PS6: 'GAFA1',
    Q96T59: 'CDRT15',
    Q9BTD1: 'SHANK2-AS3',
    Q9BXW3: 'SNHG12',
    Q9BZ98: 'TTTY12',
    Q9BZA0: 'TTTY10',
    Q9BZK8: 'OCR1',
    Q9BZS9: 'PNAS-138',
    Q9H0A3: 'TMEM191A',
    Q9H1L0: 'MIR1-1HG',
    Q9H2U6: 'LINC00597',
    Q9H354: 'PRO1933',
    Q9H379: 'PRO3102',
    Q9H693: 'C16orf95',
    Q9H7T3: 'C10orf95',
    Q9H8Q6: 'HEXA-AS1',
    Q9H8W2: 'LINC00472',
    Q9HBI5: 'CEP15',
    Q9NRI7: 'PPY2P',
    Q9NZ38: 'IDI2-AS1',
    Q9P1C3: 'PRO2829',
    Q9P1D8: 'PRO2289',
    Q9P1J3: 'DHRS4-AS1',
    Q9UHT4: 'PRO1854',
    Q9UHU1: 'PRO1716',
    Q9UI25: 'PRO0461',
    Q9UI54: 'PRO0628',
    Q9UI72: 'PRO0255',
    Q9Y6C7: 'LINC00312',
    Q9Y6Z2: 'LINC01558',
    X6R8D5: 'CIMIP3',
    X6R8R1: 'SYT15B'
}